var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polygon2, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaboratoryAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-4",
    cx: 249.48,
    cy: 352.94,
    rx: 244.24,
    ry: 135.79,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M52.9,393.48l50.87,29.38a1.84,1.84,0,0,0,1.65,0l134.3-77.54a1.76,1.76,0,0,1,1.64,0l84.86,49a1.82,1.82,0,0,0,1.64,0l50.88-29.37a.5.5,0,0,0,0-.95L241.37,284.67a1.84,1.84,0,0,0-1.65,0L52.9,392.53A.5.5,0,0,0,52.9,393.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-4",
    cx: 249.92,
    cy: 414.67,
    rx: 53.4,
    ry: 30.83,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-4",
    cx: 298.48,
    cy: 393.07,
    rx: 38.51,
    ry: 22.24,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-4",
    cx: 420.39,
    cy: 400.55,
    rx: 44.47,
    ry: 25.67,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.74,39.68l.85.49V157.25c0,2.77-1.68,6-3.76,7.18L34.46,231a2.43,2.43,0,0,1-2.35.26c-.18-.09-.82-.48-1-.56a3.33,3.33,0,0,1-1.29-3V110.62Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.46,231l115.37-66.6c2.08-1.2,3.76-4.41,3.76-7.18V40.17l-122.88,71V228.19C30.71,231,32.39,232.23,34.46,231Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "52.27 175.17 105.12 144.65 105.12 84.46 52.27 114.98 52.27 175.17",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.43,174.49l-.24-.14a1.56,1.56,0,0,1-.7-1.22v-56.6a1.54,1.54,0,0,1,.7-1.22l51-29.48a1.51,1.51,0,0,1,1.4,0l.25.14a1.54,1.54,0,0,1,.7,1.22v56.6a1.56,1.56,0,0,1-.7,1.22l-51,29.48A1.59,1.59,0,0,1,54.43,174.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,116.53v56.6a1.56,1.56,0,0,0,.7,1.22l.24.14a1.59,1.59,0,0,0,1.25.07c-.32.09-.55-.09-.55-.48v-56.6a1.42,1.42,0,0,1,.21-.69l-1.65-1A1.51,1.51,0,0,0,53.49,116.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8,86.78l-51,29.48a1.57,1.57,0,0,0-.71,1.22v56.6c0,.45.32.63.71.41l51-29.48a1.56,1.56,0,0,0,.7-1.22V87.19C107.5,86.74,107.19,86.56,106.8,86.78Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.17 142.78 148.16 121.42 148.16 86.15 111.17 107.5 111.17 142.78",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,142.3l-.17-.1a1.07,1.07,0,0,1-.49-.85V108.58a1.1,1.1,0,0,1,.49-.85L148.17,87.1a1.15,1.15,0,0,1,1,0l.17.1a1.1,1.1,0,0,1,.49.85v32.77a1.07,1.07,0,0,1-.49.85L113.67,142.3A1.08,1.08,0,0,1,112.68,142.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,108.58v32.77a1.1,1.1,0,0,0,.49.86l.17.1a1.12,1.12,0,0,0,.88,0c-.23.07-.39-.06-.39-.33V109.25a1,1,0,0,1,.15-.48l-1.16-.67A1.1,1.1,0,0,0,112,108.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,87.77,113.67,108.4a1.08,1.08,0,0,0-.49.85V142c0,.31.22.44.49.28l35.66-20.63a1.07,1.07,0,0,0,.49-.85V88.05C149.82,87.74,149.6,87.61,149.33,87.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.13,133.27v.45l0,.29a1,1,0,0,1-.08.25.67.67,0,0,1-.13.22.65.65,0,0,1-.2.17.4.4,0,0,1-.21.07.19.19,0,0,1-.13-.07.38.38,0,0,1-.07-.17,1,1,0,0,1,0-.25,2.43,2.43,0,0,1,0-.44,1.43,1.43,0,0,1,0-.29,1.11,1.11,0,0,1,.07-.26,1.71,1.71,0,0,1,.13-.23,1.2,1.2,0,0,1,.21-.17.45.45,0,0,1,.2-.06.16.16,0,0,1,.13.06.43.43,0,0,1,.08.18C118.11,133.09,118.12,133.18,118.13,133.27Zm-.66.82a.45.45,0,0,0,0,.24s.09,0,.17,0a.42.42,0,0,0,.16-.19,1,1,0,0,0,.05-.32,2.21,2.21,0,0,0,0-.42.49.49,0,0,0-.05-.25s-.09,0-.16,0a.39.39,0,0,0-.17.19,1,1,0,0,0,0,.31c0,.07,0,.14,0,.22S117.47,134,117.47,134.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,132.51a.23.23,0,0,1-.19-.11.22.22,0,0,1,.08-.3L146,117.38a.22.22,0,0,1,.3.08.23.23,0,0,1-.08.3l-25.5,14.72A.2.2,0,0,1,120.58,132.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,126.89a.07.07,0,0,1,0,0s0,0,0,0l.35-.64,0,0,0,0,.13-.08h0s0,0,0,0v1.62a.07.07,0,0,1,0,0s0,0,0,0l-.13.08h0a.08.08,0,0,1,0,0v-1.25L117,127l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,126v.45l0,.28a1.12,1.12,0,0,1-.08.26.8.8,0,0,1-.13.22.82.82,0,0,1-.2.17.3.3,0,0,1-.2.06.18.18,0,0,1-.14-.06.38.38,0,0,1-.07-.17,1,1,0,0,1,0-.26v-.43a1.36,1.36,0,0,1,0-.29,1,1,0,0,1,.07-.26.88.88,0,0,1,.14-.23.67.67,0,0,1,.2-.17.29.29,0,0,1,.2-.06.16.16,0,0,1,.13.06.38.38,0,0,1,.08.17C118.48,125.83,118.49,125.91,118.5,126Zm-.66.81a.48.48,0,0,0,.06.25c0,.05.08.05.16,0a.4.4,0,0,0,.16-.2,1.22,1.22,0,0,0,.06-.31v-.42a.6.6,0,0,0-.06-.25c0-.05-.09-.05-.16,0a.35.35,0,0,0-.16.2.9.9,0,0,0-.06.31v.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,125.46a.22.22,0,0,1-.11-.41L146,110.33a.23.23,0,0,1,.3.08.22.22,0,0,1-.08.3l-25.5,14.72A.2.2,0,0,1,120.58,125.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,119.79a.58.58,0,0,0,.06-.15.62.62,0,0,0,0-.13.21.21,0,0,0,0-.15s-.07,0-.13,0a.25.25,0,0,0-.13.14.65.65,0,0,0-.06.21s0,0,0,.06,0,0,0,0l-.13.08h0a.06.06,0,0,1,0,0,2.23,2.23,0,0,1,0-.23.92.92,0,0,1,.09-.23,1.27,1.27,0,0,1,.13-.19.7.7,0,0,1,.16-.14.3.3,0,0,1,.17,0,.26.26,0,0,1,.13.06.61.61,0,0,1,.07.14.58.58,0,0,1,0,.19v.12a.69.69,0,0,1,0,.13,1.47,1.47,0,0,1-.06.14,1.07,1.07,0,0,1-.09.19l-.3.6.45-.26s0,0,0,0,0,0,0,0v.18s0,0,0,0a.08.08,0,0,1,0,0l-.76.44h0s0,0,0,0v-.16a.25.25,0,0,1,0-.08l0-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62,118.89a.31.31,0,0,1,0,.1v.24a.31.31,0,0,1,0,.1,2.64,2.64,0,0,1,0,.29,2,2,0,0,1-.08.26,1,1,0,0,1-.13.22,1.06,1.06,0,0,1-.2.17.32.32,0,0,1-.21.06.16.16,0,0,1-.13-.06.51.51,0,0,1-.08-.18,1.69,1.69,0,0,1,0-.25,1.34,1.34,0,0,1,0-.21,1.41,1.41,0,0,1,0-.22,2.64,2.64,0,0,1,0-.29,2.13,2.13,0,0,1,.08-.27,1,1,0,0,1,.13-.22.71.71,0,0,1,.21-.17.35.35,0,0,1,.2-.07.21.21,0,0,1,.13.07.54.54,0,0,1,.08.17A2,2,0,0,1,118.62,118.89Zm-.65.81a.49.49,0,0,0,0,.25s.09,0,.17,0a.34.34,0,0,0,.16-.19.91.91,0,0,0,.05-.31,1.48,1.48,0,0,0,0-.21,1.34,1.34,0,0,0,0-.21.49.49,0,0,0-.05-.25s-.09,0-.16,0a.42.42,0,0,0-.17.2.91.91,0,0,0,0,.31,1.41,1.41,0,0,0,0,.21A1.34,1.34,0,0,0,118,119.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,118.41a.22.22,0,0,1-.11-.41L146,103.28a.23.23,0,0,1,.3.08.22.22,0,0,1-.08.3l-25.5,14.72A.2.2,0,0,1,120.58,118.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,111.83a0,0,0,0,1,0,0s0,0,0,0v.18a.13.13,0,0,1,0,.06l0,0-.23.53a.2.2,0,0,1,.13,0,.13.13,0,0,1,.1,0,.35.35,0,0,1,.07.12.9.9,0,0,1,0,.18,1,1,0,0,1,0,.25,1.6,1.6,0,0,1-.1.23.85.85,0,0,1-.14.19.7.7,0,0,1-.17.13.59.59,0,0,1-.2.08.26.26,0,0,1-.14,0,.18.18,0,0,1-.09-.1.32.32,0,0,1,0-.14.13.13,0,0,1,0-.06l0,0,.13-.08h0l0,0s0,0,0,0a.05.05,0,0,0,0,0h.07l.1,0a.57.57,0,0,0,.16-.15.42.42,0,0,0,.06-.21c0-.08,0-.12-.06-.13a.21.21,0,0,0-.16,0l-.14.08a0,0,0,0,1,0,0s0,0,0,0v-.18a.13.13,0,0,1,0-.06s0,0,0,0l.23-.5-.45.26h0s0,0,0,0v-.18a.11.11,0,0,1,0,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.64,111.83v.45a1.33,1.33,0,0,1,0,.28,1.11,1.11,0,0,1-.07.26,1.16,1.16,0,0,1-.13.22.87.87,0,0,1-.21.17.29.29,0,0,1-.2.06.16.16,0,0,1-.13-.06.38.38,0,0,1-.08-.17,2,2,0,0,1,0-.26,1.34,1.34,0,0,1,0-.21,1.41,1.41,0,0,1,0-.22,2.64,2.64,0,0,1,0-.29,1.2,1.2,0,0,1,.08-.27,1,1,0,0,1,.13-.22.82.82,0,0,1,.2-.17.31.31,0,0,1,.21-.06.18.18,0,0,1,.13.06.38.38,0,0,1,.07.17A1,1,0,0,1,118.64,111.83Zm-.65.81a.49.49,0,0,0,.05.25s.09,0,.16,0a.42.42,0,0,0,.17-.2.91.91,0,0,0,0-.31c0-.07,0-.14,0-.21s0-.15,0-.21a.49.49,0,0,0,0-.25s-.09,0-.17,0a.4.4,0,0,0-.16.2.91.91,0,0,0-.05.31,1.41,1.41,0,0,0,0,.21A1.34,1.34,0,0,0,118,112.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,111.37a.23.23,0,0,1-.19-.11.22.22,0,0,1,.08-.3L146,96.23a.23.23,0,0,1,.3.09.21.21,0,0,1-.08.29l-25.5,14.73A.2.2,0,0,1,120.58,111.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,132.29V112.22s2.54-1.78,4.39,4.1,5.66,3.53,8.19-.72,3.66-8.56,6.38-10.13,4.69,3.94,6.54,2.88v9.22Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,132.29V112.22s2.54-1.78,4.39,4.1,5.66,3.53,8.19-.72,3.66-8.56,6.38-10.13,4.69,3.94,6.54,2.88v9.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,129.24s1.35-6.52,2.62-7.26c1.63-.94,1.85,5,4.67,3.33s3.56-16.17,6.46-17.85,3.35,6.51,5.49,5.28,2.64-5.84,6.26-7.93v12.76l-25.5,14.72Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.58,107.16c-1.55,2.16-2.25,4.7-3.76,5.58-1.35.78-2-2.19-3.07-4.07-1.11,2-2.11,4.43-3.59,6.93a12.73,12.73,0,0,1-2.63,3.23c-.73,3.12-1.53,5.83-2.66,6.48-2.82,1.64-3-4.27-4.67-3.33-1.27.74-2.62,7.26-2.62,7.26v3l25.5-14.72v-9.22C145.28,108.81,144.47,108.05,143.58,107.16Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.17 182.12 148.16 160.76 148.16 125.49 111.17 146.84 111.17 182.12",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,181.64l-.17-.1a1.07,1.07,0,0,1-.49-.85V147.92a1.1,1.1,0,0,1,.49-.85l35.66-20.63a1.15,1.15,0,0,1,1,0l.17.1a1.1,1.1,0,0,1,.49.85v32.77a1.07,1.07,0,0,1-.49.85l-35.66,20.63A1.08,1.08,0,0,1,112.68,181.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,147.92v32.77a1.1,1.1,0,0,0,.49.86l.17.1a1.12,1.12,0,0,0,.88,0c-.23.07-.39-.06-.39-.33V148.59a1,1,0,0,1,.15-.48l-1.16-.67A1.1,1.1,0,0,0,112,147.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,127.11l-35.66,20.63a1.08,1.08,0,0,0-.49.85v32.77c0,.31.22.44.49.28L149.33,161a1.07,1.07,0,0,0,.49-.85V127.39C149.82,127.08,149.6,127,149.33,127.11Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "34.16 226.79 106.98 184.81 106.98 149.53 34.16 191.51 34.16 226.79",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.68,226.32l-.17-.1a1.1,1.1,0,0,1-.49-.86V192.6a1.1,1.1,0,0,1,.49-.86L107,150.49a1.06,1.06,0,0,1,1,0l.17.1a1.1,1.1,0,0,1,.49.85v32.77a1.1,1.1,0,0,1-.49.85L36.66,226.32A1.12,1.12,0,0,1,35.68,226.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,192.6v32.77a1.07,1.07,0,0,0,.49.85l.17.1a1.14,1.14,0,0,0,.87.05c-.22.06-.38-.07-.38-.34V193.26a1,1,0,0,1,.14-.48l-1.15-.67A1,1,0,0,0,35,192.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.15,151.16,36.66,192.41a1.1,1.1,0,0,0-.49.85V226c0,.31.22.44.49.29l71.49-41.26a1.1,1.1,0,0,0,.49-.85V151.44C108.64,151.13,108.42,151,108.15,151.16Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "32.93 187.49 50.16 177.54 50.16 148.56 32.93 158.51 32.93 187.49",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.19,187.76l16.37-9.45a1,1,0,0,0,.43-.75v-28c0-.27-.19-.39-.43-.25l-16.37,9.45a1,1,0,0,0-.44.75v28C33.75,187.79,34,187.9,34.19,187.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,163l13.06-7.54a1,1,0,0,0,.48-.68c0-.22-.21-.27-.48-.12l-13.06,7.54a1,1,0,0,0-.48.68C35.36,163.12,35.58,163.17,35.84,163Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,165.08l13.06-7.54a.93.93,0,0,0,.48-.67c0-.22-.21-.28-.48-.12l-13.06,7.54a.94.94,0,0,0-.48.67C35.36,165.18,35.58,165.23,35.84,165.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,169.37l13.06-7.54a.93.93,0,0,0,.48-.68c0-.22-.21-.27-.48-.11l-13.06,7.53a1,1,0,0,0-.48.68C35.36,169.47,35.58,169.52,35.84,169.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,171.43l13.06-7.54a.91.91,0,0,0,.48-.67c0-.22-.21-.27-.48-.12l-13.06,7.54a1,1,0,0,0-.48.67C35.36,171.53,35.58,171.59,35.84,171.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,177.78l13.06-7.53a1,1,0,0,0,.48-.68c0-.22-.21-.27-.48-.12L35.84,177a1,1,0,0,0-.48.68C35.36,177.89,35.58,177.94,35.84,177.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,175.72l13.06-7.54a.93.93,0,0,0,.48-.68c0-.22-.21-.27-.48-.11l-13.06,7.53a1,1,0,0,0-.48.68C35.36,175.82,35.58,175.87,35.84,175.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pushpin--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.32,156.71l0,0s0,0-.06,0-.07,0-.11,0l-.32-.2-.47-.27-.52-.32c-.06,0,0-.21.1-.18s.37.2.54.29l.47.26.33.19s.08,0,.08.08a.17.17,0,0,1,0,.07Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.66,156.94c-.25.44-.67.68-1.1.45l0,0h0a.5.5,0,0,1-.18-.43A1.44,1.44,0,0,1,43,155.8a.46.46,0,0,1,.44-.06h0l0,0A.8.8,0,0,1,43.66,156.94Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.66,156.94c-.25.44-.67.68-1.1.45l0,0h0a.5.5,0,0,1-.18-.43A1.44,1.44,0,0,1,43,155.8a.46.46,0,0,1,.44-.06h0l0,0A.8.8,0,0,1,43.66,156.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.19,157.81l.5-.83a4.86,4.86,0,0,1-1-.72l0,0h0a.27.27,0,0,0-.32,0,1,1,0,0,0-.43.75.34.34,0,0,0,.12.28h0l.09,0A4.56,4.56,0,0,1,44.19,157.81Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.11,157.14a.52.52,0,0,0-.52-.52.52.52,0,0,0-.18,0h0l-.09,0a1.2,1.2,0,0,0-.52.91.59.59,0,0,0,.52.56.52.52,0,0,0,.52-.52v-.05A.52.52,0,0,0,45.11,157.14Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.11,157.14a.52.52,0,0,0-.52-.52.52.52,0,0,0-.18,0h0l-.09,0a1.2,1.2,0,0,0-.52.91.59.59,0,0,0,.52.56.52.52,0,0,0,.52-.52v-.05A.52.52,0,0,0,45.11,157.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.59,156.87c.29-.16.52,0,.52.31a1.13,1.13,0,0,1-.52.9c-.29.17-.52,0-.52-.3A1.17,1.17,0,0,1,44.59,156.87Z",
    style: {
      fill: "#7AC1FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.34 153.03 50.58 143.08 50.58 114.1 33.34 124.05 33.34 153.03",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,153.3,51,143.85a.94.94,0,0,0,.44-.75v-28c0-.28-.2-.39-.44-.25L34.6,124.33a.93.93,0,0,0-.43.75v28C34.17,153.33,34.36,153.44,34.6,153.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,128.56,49.31,121a.94.94,0,0,0,.49-.68c0-.22-.22-.27-.49-.11l-13.05,7.53a1,1,0,0,0-.49.68C35.77,128.66,36,128.71,36.26,128.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,130.62l13.05-7.53a1,1,0,0,0,.49-.68c0-.22-.22-.27-.49-.12l-13.05,7.54a.94.94,0,0,0-.49.68C35.77,130.72,36,130.78,36.26,130.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,134.91l13.05-7.54a.94.94,0,0,0,.49-.68c0-.21-.22-.27-.49-.11l-13.05,7.54a.93.93,0,0,0-.49.67C35.77,135,36,135.06,36.26,134.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,137l13.05-7.53a1,1,0,0,0,.49-.68c0-.22-.22-.27-.49-.12l-13.05,7.54a.94.94,0,0,0-.49.68C35.77,137.08,36,137.13,36.26,137Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,143.32l13.05-7.53a1,1,0,0,0,.49-.68c0-.22-.22-.27-.49-.12l-13.05,7.54a1,1,0,0,0-.49.68C35.77,143.43,36,143.48,36.26,143.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,141.26l13.05-7.54a.93.93,0,0,0,.49-.67c0-.22-.22-.28-.49-.12l-13.05,7.54a1,1,0,0,0-.49.67C35.77,141.36,36,141.42,36.26,141.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.74,122.25l0,0-.06,0s-.07,0-.11,0l-.33-.19-.46-.28-.53-.32s.05-.21.11-.18l.54.29.47.26.33.19s.08,0,.08.08,0,0,0,.08Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.08,122.49a.82.82,0,0,1-1.11.44l0,0h0a.46.46,0,0,1-.19-.42,1.45,1.45,0,0,1,.67-1.15.46.46,0,0,1,.44-.06h0l0,0A.81.81,0,0,1,44.08,122.49Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.08,122.49a.82.82,0,0,1-1.11.44l0,0h0a.46.46,0,0,1-.19-.42,1.45,1.45,0,0,1,.67-1.15.46.46,0,0,1,.44-.06h0l0,0A.81.81,0,0,1,44.08,122.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.61,123.36l.49-.84a4.88,4.88,0,0,1-1-.72l0,0h0a.3.3,0,0,0-.33,0,1,1,0,0,0-.43.75.3.3,0,0,0,.13.28h0l.08,0A4.07,4.07,0,0,1,44.61,123.36Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.52,122.68a.51.51,0,0,0-.51-.52.41.41,0,0,0-.19,0h0l-.08,0a1.13,1.13,0,0,0-.52.9.53.53,0,0,0,0,.13.52.52,0,0,0,1-.08.43.43,0,0,0,0,0A.52.52,0,0,0,45.52,122.68Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.52,122.68a.51.51,0,0,0-.51-.52.41.41,0,0,0-.19,0h0l-.08,0a1.13,1.13,0,0,0-.52.9.53.53,0,0,0,0,.13.52.52,0,0,0,1-.08.43.43,0,0,0,0,0A.52.52,0,0,0,45.52,122.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45,122.42c.29-.17.52,0,.52.3a1.17,1.17,0,0,1-.52.91c-.29.16-.53,0-.53-.31A1.14,1.14,0,0,1,45,122.42Z",
    style: {
      fill: "#7AC1FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1,114.75l-2.87-5L153,37.15h0a1.39,1.39,0,0,1,1.48.11,4.49,4.49,0,0,1,2,3.52,1.48,1.48,0,0,1-.55,1.29h0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.71,113.42a4.52,4.52,0,0,0-2-3.52c-1.12-.65-2-.12-2,1.18a4.51,4.51,0,0,0,2,3.52C29.79,115.25,30.71,114.72,30.71,113.42Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.87 93.24 129.1 83.29 129.1 54.31 111.87 64.26 111.87 93.24",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13,93.51l16.36-9.45a1,1,0,0,0,.44-.75v-28a.27.27,0,0,0-.44-.25l-16.36,9.45a1,1,0,0,0-.44.75v28C112.69,93.54,112.89,93.65,113.13,93.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,68.77l13.06-7.54a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.12L114.78,68a1,1,0,0,0-.48.68C114.3,68.87,114.51,68.92,114.78,68.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,70.83l13.06-7.54a1,1,0,0,0,.48-.67c0-.22-.22-.28-.48-.12L114.78,70a.91.91,0,0,0-.48.67C114.3,70.93,114.51,71,114.78,70.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,75.12l13.06-7.54a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.11l-13.06,7.53a1,1,0,0,0-.48.68C114.3,75.22,114.51,75.27,114.78,75.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,77.18l13.06-7.54a.94.94,0,0,0,.48-.67c0-.22-.22-.27-.48-.12l-13.06,7.54a.93.93,0,0,0-.48.67C114.3,77.28,114.51,77.34,114.78,77.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,83.53,127.84,76a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.12l-13.06,7.54a.93.93,0,0,0-.48.68C114.3,83.64,114.51,83.69,114.78,83.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,81.47l13.06-7.54a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.11l-13.06,7.53a1,1,0,0,0-.48.68C114.3,81.57,114.51,81.62,114.78,81.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.26,62.46l0,0s0,0-.06,0-.07,0-.11,0l-.33-.2-.46-.27-.53-.32s0-.21.11-.18l.54.29.47.26.33.19s.08,0,.08.08,0,0,0,.07Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,62.69c-.26.44-.67.68-1.11.45l0,0h0a.5.5,0,0,1-.18-.43,1.44,1.44,0,0,1,.66-1.14.46.46,0,0,1,.44-.06h0l0,0A.8.8,0,0,1,122.6,62.69Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6,62.69c-.26.44-.67.68-1.11.45l0,0h0a.5.5,0,0,1-.18-.43,1.44,1.44,0,0,1,.66-1.14.46.46,0,0,1,.44-.06h0l0,0A.8.8,0,0,1,122.6,62.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,63.56l.49-.83a5.15,5.15,0,0,1-1-.72l0,0h0a.27.27,0,0,0-.32,0,1,1,0,0,0-.44.75.32.32,0,0,0,.13.28h0l.08,0A4.51,4.51,0,0,1,123.13,63.56Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05,62.89a.52.52,0,0,0-.52-.52.58.58,0,0,0-.19,0h0l-.08,0a1.17,1.17,0,0,0-.52.91.54.54,0,0,0,.52.56.52.52,0,0,0,.52-.52.11.11,0,0,0,0,0A.51.51,0,0,0,124.05,62.89Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.05,62.89a.52.52,0,0,0-.52-.52.58.58,0,0,0-.19,0h0l-.08,0a1.17,1.17,0,0,0-.52.91.54.54,0,0,0,.52.56.52.52,0,0,0,.52-.52.11.11,0,0,0,0,0A.51.51,0,0,0,124.05,62.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.53,62.62c.29-.16.52,0,.52.31a1.13,1.13,0,0,1-.52.9c-.29.17-.53,0-.53-.3A1.18,1.18,0,0,1,123.53,62.62Z",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "114.74 65.28 116.15 64.47 116.15 59.09 114.74 59.9 114.74 65.28",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.76 81.75 149 71.8 149 42.82 131.76 52.77 131.76 81.75",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,82l16.37-9.45a1,1,0,0,0,.43-.75v-28c0-.27-.19-.38-.43-.25L133,53a1,1,0,0,0-.44.76v28C132.58,82.05,132.78,82.16,133,82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,57.28l13-7.54a.94.94,0,0,0,.49-.68c0-.22-.22-.27-.49-.11l-13,7.53a1,1,0,0,0-.49.68C134.19,57.38,134.41,57.43,134.68,57.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,59.34l13-7.54a.93.93,0,0,0,.49-.67c0-.22-.22-.27-.49-.12l-13,7.54a1,1,0,0,0-.49.67C134.19,59.44,134.41,59.5,134.68,59.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,63.63l13-7.54a.94.94,0,0,0,.49-.68c0-.22-.22-.27-.49-.11l-13,7.53a1,1,0,0,0-.49.68C134.19,63.73,134.41,63.78,134.68,63.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,65.69l13-7.53a1,1,0,0,0,.49-.68c0-.22-.22-.27-.49-.12l-13,7.54a.94.94,0,0,0-.49.68C134.19,65.8,134.41,65.85,134.68,65.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,72l13-7.53a1,1,0,0,0,.49-.68c0-.22-.22-.27-.49-.12l-13,7.54a.94.94,0,0,0-.49.68C134.19,72.15,134.41,72.2,134.68,72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,70l13-7.54a1,1,0,0,0,.49-.67c0-.22-.22-.28-.49-.12l-13,7.54a.93.93,0,0,0-.49.67C134.19,70.08,134.41,70.13,134.68,70Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pushpin--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.15,51l0,0s0,0-.06,0-.06,0-.11,0l-.32-.19-.47-.28-.52-.32c-.05,0,0-.21.1-.18s.37.2.54.29l.47.26.34.19s.07,0,.07.08a.25.25,0,0,1,0,.08Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,51.2c-.25.44-.67.68-1.1.45l0,0h0a.49.49,0,0,1-.18-.43,1.47,1.47,0,0,1,.66-1.14.46.46,0,0,1,.44-.06h0l0,0A.8.8,0,0,1,142.49,51.2Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.49,51.2c-.25.44-.67.68-1.1.45l0,0h0a.49.49,0,0,1-.18-.43,1.47,1.47,0,0,1,.66-1.14.46.46,0,0,1,.44-.06h0l0,0A.8.8,0,0,1,142.49,51.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143,52.08l.49-.84a4.86,4.86,0,0,1-1-.72l0,0h0a.3.3,0,0,0-.33,0,1,1,0,0,0-.43.75.32.32,0,0,0,.12.28h0l.09,0A4.41,4.41,0,0,1,143,52.08Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.94,51.4a.52.52,0,0,0-.52-.52.37.37,0,0,0-.18,0h0l-.08,0a1.14,1.14,0,0,0-.53.9.59.59,0,0,0,.53.56.51.51,0,0,0,.51-.52v0A.54.54,0,0,0,143.94,51.4Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.94,51.4a.52.52,0,0,0-.52-.52.37.37,0,0,0-.18,0h0l-.08,0a1.14,1.14,0,0,0-.53.9.59.59,0,0,0,.53.56.51.51,0,0,0,.51-.52v0A.54.54,0,0,0,143.94,51.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,51.13c.29-.16.52,0,.52.31a1.13,1.13,0,0,1-.52.9c-.29.17-.52,0-.52-.3A1.17,1.17,0,0,1,143.42,51.13Z",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.63 53.79 136.04 52.98 136.04 47.6 134.63 48.41 134.63 53.79",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Note--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.88 104.16 119.28 99.31 119.28 86.37 110.88 91.22 110.88 104.16",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--note--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.7,98.9l-5.81,3.25c-.65.36-1.07-.68-1.07-1.32-.65.42-2,.68-2-.15l-.54-7.33,8.74-5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.97 88.3 111.23 93.35 111.23 91.73 119.97 86.69 119.97 88.3",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.05 101.12 114.44 102.18 113.69 100.23 112.05 101.12",
    style: {
      fill: "#37474f"
    }
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.87,148.67,130,145.46l1.8-5.19,0,0,3.63-2.1,0,.1,1.8,3.1-1.8,5.2,0,0Zm-1.61-3.23,1.69,2.93,3.41-2,1.74-5-1.69-2.93-3.41,2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.18,149.69l-.06-.1-1.79-3.1,1.8-5.2,0,0,3.64-2.1,1.85,3.21-1.8,5.19,0,0Zm-1.61-3.23,1.69,2.93,3.41-2,1.73-5-1.68-2.93-3.41,2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.87,156.84l-1.85-3.2,1.8-5.2,0,0,3.63-2.1,1.85,3.21-1.8,5.19,0,0Zm-1.61-3.23,1.69,2.93,3.41-2,1.74-5-1.69-2.92-3.41,2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.56,164l-1.85-3.21,1.8-5.19,0,0,3.63-2.1,1.85,3.21-1.8,5.19,0,0Zm-1.6-3.23,1.68,2.93,3.41-2,1.74-5-1.69-2.93-3.4,2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.56,172.16,124.71,169l1.8-5.19,0,0,3.63-2.1,1.85,3.21-1.8,5.19,0,0Zm-1.6-3.23,1.68,2.93,3.41-2,1.74-5-1.69-2.93-3.4,2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.26,171.14l-.06-.1-1.79-3.11,1.8-5.19,0,0,3.64-2.1,1.85,3.2-1.8,5.2,0,0Zm-1.61-3.23,1.69,2.93,3.4-2,1.74-5-1.68-2.93-3.41,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.43,145.91a2.34,2.34,0,0,1-1,1.87c-.54.31-1,0-1-.74a2.34,2.34,0,0,1,1-1.87C136,144.86,136.43,145.19,136.43,145.91Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.2,140.8a2.34,2.34,0,0,1-1,1.87c-.54.31-1,0-1-.74a2.36,2.36,0,0,1,1-1.87C137.76,139.75,138.2,140.08,138.2,140.8Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.89,156.12a2.34,2.34,0,0,1-1,1.87c-.54.31-1,0-1-.74a2.33,2.33,0,0,1,1-1.86C132.45,155.07,132.89,155.4,132.89,156.12Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.58,163.27a2.34,2.34,0,0,1-1,1.87c-.54.31-1,0-1-.74a2.34,2.34,0,0,1,1-1.87C127.14,162.22,127.58,162.55,127.58,163.27Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81,160.21a2.35,2.35,0,0,1-1,1.87c-.54.31-1,0-1-.74a2.34,2.34,0,0,1,1-1.87C125.38,159.16,125.81,159.49,125.81,160.21Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,140.1a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83C132.15,139.63,132.34,139.78,132.34,140.1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,138.05a1,1,0,0,1-.43.83c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C135.69,137.59,135.88,137.74,135.88,138.05Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,145.2a1,1,0,0,1-.43.83c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C130.38,144.74,130.57,144.88,130.57,145.2Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,148.27a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83C132.15,147.8,132.34,148,132.34,148.27Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,139.07a1,1,0,0,1-.43.83c-.24.14-.44,0-.44-.33a1,1,0,0,1,.44-.82C141,138.61,141.19,138.76,141.19,139.07Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,142.14a1,1,0,0,1-.43.82c-.24.14-.44,0-.44-.32a1,1,0,0,1,.44-.83C142.76,141.67,143,141.82,143,142.14Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,147.25a1,1,0,0,1-.43.82c-.24.14-.44,0-.44-.33a1,1,0,0,1,.44-.82C141,146.78,141.19,146.93,141.19,147.25Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,149.29a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83C137.46,148.82,137.65,149,137.65,149.29Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,154.4a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83C135.69,153.93,135.88,154.08,135.88,154.4Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,153.37a1,1,0,0,1-.43.83c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C130.38,152.91,130.57,153.06,130.57,153.37Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,155.42a1,1,0,0,1-.44.82c-.23.14-.43,0-.43-.33a1.06,1.06,0,0,1,.43-.82C126.84,155,127,155.1,127,155.42Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,161.54a1,1,0,0,1-.43.83c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C130.38,161.08,130.57,161.23,130.57,161.54Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,164.61a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83C132.15,164.14,132.34,164.29,132.34,164.61Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57,169.71a1,1,0,0,1-.43.83c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C130.38,169.25,130.57,169.4,130.57,169.71Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,171.76a1,1,0,0,1-.44.82c-.23.14-.43,0-.43-.32a1.07,1.07,0,0,1,.43-.83C126.84,171.29,127,171.44,127,171.76Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,170.74a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83C121.54,170.27,121.73,170.42,121.73,170.74Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,168.69a1.07,1.07,0,0,1-.43.83c-.24.14-.44,0-.44-.33a1,1,0,0,1,.44-.82C125.07,168.23,125.27,168.38,125.27,168.69Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,162.57a1,1,0,0,1-.43.82c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C121.54,162.1,121.73,162.25,121.73,162.57Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,167.67a1,1,0,0,1-.43.83c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82C119.77,167.21,120,167.35,120,167.67Z",
    style: {
      fill: "#7AC1FB"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.12,124.33v-5.4a.4.4,0,0,1,.23-.34l.13-.08a.33.33,0,0,1,.14,0s.07,0,.09.09l1.17,2.73q.06.17.15.48l0,0a5.09,5.09,0,0,1,0-.55v-3.34a.4.4,0,0,1,.24-.35l.08,0c.16-.09.23-.07.23.07v5.4a.38.38,0,0,1-.23.34l-.11.06c-.12.07-.19.06-.22,0l-1.21-2.83a3.34,3.34,0,0,1-.14-.44l0,0a3.2,3.2,0,0,1,0,.52V124a.39.39,0,0,1-.24.34l-.08.05C81.2,124.49,81.12,124.47,81.12,124.33Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.15,133.25v-5.4a.4.4,0,0,1,.24-.35l.12-.07a.37.37,0,0,1,.15-.05.18.18,0,0,1,.09.1l1.16,2.73a2.92,2.92,0,0,1,.15.47l0,0a3.51,3.51,0,0,1,0-.55v-3.35a.4.4,0,0,1,.24-.34l.08,0c.16-.09.24-.06.24.07v5.4a.4.4,0,0,1-.24.35l-.11.06c-.12.07-.19.06-.22,0l-1.2-2.83a1.9,1.9,0,0,1-.14-.44l0,0a3.4,3.4,0,0,1,0,.53v3.43a.41.41,0,0,1-.23.34l-.08,0C70.23,133.41,70.15,133.38,70.15,133.25Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.15,146.56v-5.4a.39.39,0,0,1,.24-.34l.12-.08a.24.24,0,0,1,.15,0s.06,0,.09.09l1.16,2.73a2.77,2.77,0,0,1,.15.48l0,0a3.41,3.41,0,0,1,0-.55v-3.34a.4.4,0,0,1,.24-.35l.08,0c.16-.09.24-.07.24.07v5.4a.4.4,0,0,1-.24.34l-.11.06c-.12.07-.19.06-.22,0l-1.2-2.83a1.75,1.75,0,0,1-.14-.44l0,0a3.2,3.2,0,0,1,0,.52v3.43a.4.4,0,0,1-.23.34l-.08,0C70.23,146.72,70.15,146.7,70.15,146.56Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.66,134.53v-5.4a.39.39,0,0,1,.24-.34l.13-.08a.2.2,0,0,1,.14,0s.06,0,.09.09l1.16,2.73a2.77,2.77,0,0,1,.15.48l0,0a3.41,3.41,0,0,1,0-.55V128a.41.41,0,0,1,.24-.35l.08,0c.16-.09.24-.07.24.07v5.4a.39.39,0,0,1-.24.34l-.11.06c-.12.07-.19.06-.22,0l-1.2-2.83a1.75,1.75,0,0,1-.14-.44l0,0a3.23,3.23,0,0,1,0,.53v3.42a.38.38,0,0,1-.23.34l-.08,0C86.74,134.69,86.66,134.67,86.66,134.53Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.22,113.19a3.91,3.91,0,0,1-.35-2c0-2,.45-3.2,1.36-3.72s1.36.19,1.36,2.15-.46,3.22-1.36,3.74C94.78,113.6,94.44,113.55,94.22,113.19Zm1.58-1.47a6.37,6.37,0,0,0,.19-1.78,4.07,4.07,0,0,0-.19-1.54.35.35,0,0,0-.57-.19,1.35,1.35,0,0,0-.57.85,6.17,6.17,0,0,0-.19,1.76,4.23,4.23,0,0,0,.19,1.56.36.36,0,0,0,.57.2A1.34,1.34,0,0,0,95.8,111.72Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.71,156.17a4.09,4.09,0,0,1-.34-2c0-2,.47-3.2,1.37-3.72s1.36.22,1.35,2.18-.47,3.22-1.37,3.73C82.27,156.59,81.94,156.53,81.71,156.17Zm1.59-1.45a6.76,6.76,0,0,0,.2-1.78,4.13,4.13,0,0,0-.19-1.55.36.36,0,0,0-.57-.2,1.39,1.39,0,0,0-.57.84,6.52,6.52,0,0,0-.2,1.77,4.52,4.52,0,0,0,.18,1.56c.13.29.32.35.57.21A1.36,1.36,0,0,0,83.3,154.72Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.37,110.31a4.08,4.08,0,0,1-.34-2,6.79,6.79,0,0,1,.35-2.41,2.49,2.49,0,0,1,1.06-1.35l.28-.12a1.48,1.48,0,0,1,.24,0c.05,0,.08,0,.09.05a.35.35,0,0,1,0,.16A2.22,2.22,0,0,1,81,105c0,.15-.08.22-.14.2a.67.67,0,0,0-.42.1,1.46,1.46,0,0,0-.63.89,6.15,6.15,0,0,0-.2,1.74,4.06,4.06,0,0,0,.2,1.53c.13.27.34.33.63.17a1.71,1.71,0,0,0,.46-.44l0,0c.06,0,.1,0,.13.09a1,1,0,0,1,0,.33.61.61,0,0,1-.14.37,2.94,2.94,0,0,1-.25.25,2.43,2.43,0,0,1-.32.24C80,110.7,79.6,110.66,79.37,110.31Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.63,109.48v-5.4a.41.41,0,0,1,.24-.35l.12-.07c.15-.08.22-.06.22.08V106l1.28-.74V103a.39.39,0,0,1,.23-.35l.11-.06c.16-.09.24-.07.24.07v5.4a.39.39,0,0,1-.24.34l-.11.07c-.16.09-.23.06-.23-.07V106l-1.28.73v2.39a.38.38,0,0,1-.22.34l-.12.07C81.71,109.64,81.63,109.62,81.63,109.48Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.84,110.56a.42.42,0,0,1-.22,0,.1.1,0,0,1-.09-.11.67.67,0,0,1,0-.19c0-.09,0-.14.07-.15s0,0,.08,0a.38.38,0,0,0,.15,0,.44.44,0,0,0,.17-.06.78.78,0,0,0,.28-.31,1.19,1.19,0,0,0,.11-.53c0-.21,0-.34-.1-.39s-.18,0-.31,0l-.13.07s0,0-.05,0a.29.29,0,0,1,0-.12v-.07a.52.52,0,0,1,0-.14.18.18,0,0,1,.05-.07l.11-.06a.57.57,0,0,0,.21-.2,1.78,1.78,0,0,0,.12-.29,1.49,1.49,0,0,0,0-.28.41.41,0,0,0-.07-.27c0-.06-.13,0-.24,0a.74.74,0,0,0-.16.12l-.12.15a.45.45,0,0,1-.06.08s0,0-.08-.06a.34.34,0,0,1,0-.15.49.49,0,0,1,.16-.3,1.44,1.44,0,0,1,.34-.28c.18-.11.33-.12.44,0a.68.68,0,0,1,.16.52,1.28,1.28,0,0,1-.09.48,1.24,1.24,0,0,1-.22.39v0a.28.28,0,0,1,.27.15,1,1,0,0,1,.11.52,1.87,1.87,0,0,1-.09.59,1.34,1.34,0,0,1-.23.48,1.09,1.09,0,0,1-.34.31A1.07,1.07,0,0,1,84.84,110.56Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M95.82,136a4.23,4.23,0,0,1-.34-2,7,7,0,0,1,.35-2.41,2.55,2.55,0,0,1,1.07-1.35,1.69,1.69,0,0,1,.28-.12,1.2,1.2,0,0,1,.24,0,.11.11,0,0,1,.09,0,.37.37,0,0,1,0,.16,2.09,2.09,0,0,1,0,.42c0,.15-.08.22-.14.21a.64.64,0,0,0-.43.1,1.45,1.45,0,0,0-.62.89,5.8,5.8,0,0,0-.2,1.74,3.86,3.86,0,0,0,.2,1.53.39.39,0,0,0,.62.17,1.47,1.47,0,0,0,.46-.44.23.23,0,0,1,0,0s.1,0,.13.1a1,1,0,0,1,0,.32.52.52,0,0,1-.14.37,1.42,1.42,0,0,1-.24.26,1.72,1.72,0,0,1-.32.23C96.41,136.36,96.05,136.33,95.82,136Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.09,135.15v-5.4a.39.39,0,0,1,.23-.35l.12-.07c.16-.09.23-.06.23.08v2.24l1.27-.73v-2.25a.4.4,0,0,1,.24-.34l.11-.06c.16-.09.24-.07.24.07v5.4a.4.4,0,0,1-.24.34l-.11.06c-.16.1-.24.07-.24-.07v-2.38l-1.27.73v2.39a.36.36,0,0,1-.23.33l-.12.08C98.16,135.31,98.09,135.28,98.09,135.15Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.29,136.23a.42.42,0,0,1-.22,0,.11.11,0,0,1-.08-.11.68.68,0,0,1,0-.2.31.31,0,0,1,.08-.14h.23a.56.56,0,0,0,.17-.07.8.8,0,0,0,.27-.3,1.08,1.08,0,0,0,.12-.54.5.5,0,0,0-.11-.39c-.07-.05-.17,0-.31.05l-.12.07s0,0,0,0,0-.06,0-.13v-.06a.28.28,0,0,1,0-.14.18.18,0,0,1,0-.07l.1-.06a.47.47,0,0,0,.21-.21.74.74,0,0,0,.12-.29.93.93,0,0,0,0-.27.41.41,0,0,0-.07-.27c-.05-.06-.13-.06-.25,0a.44.44,0,0,0-.15.12.79.79,0,0,0-.12.15l-.07.08s0,0-.07-.06a.37.37,0,0,1,0-.16.47.47,0,0,1,.17-.29,1.44,1.44,0,0,1,.34-.28c.18-.11.33-.12.43,0s.16.26.16.52a1.27,1.27,0,0,1-.08.48,1.26,1.26,0,0,1-.23.39v0a.3.3,0,0,1,.28.15,1,1,0,0,1,.11.52,1.87,1.87,0,0,1-.09.59,1.66,1.66,0,0,1-.24.48,1.07,1.07,0,0,1-.33.31Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.92,163.91v-5.4a.41.41,0,0,1,.24-.35l.12-.07c.15-.08.22-.06.22.08v2.25l1.27-.74v-2.24a.4.4,0,0,1,.24-.35l.11-.06c.16-.09.24-.07.24.07v5.4a.39.39,0,0,1-.24.34l-.11.07c-.16.09-.24.06-.24-.07v-2.39l-1.27.73v2.39a.38.38,0,0,1-.22.34l-.12.07C62,164.07,61.92,164.05,61.92,163.91Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.13,165a.42.42,0,0,1-.22,0,.1.1,0,0,1-.09-.11.67.67,0,0,1,.05-.19c0-.09,0-.14.07-.15a.08.08,0,0,1,.07,0h.16a.44.44,0,0,0,.17-.06.78.78,0,0,0,.28-.31,1.19,1.19,0,0,0,.11-.53c0-.21,0-.34-.1-.39s-.18,0-.31,0l-.13.07s0,0,0,0a.29.29,0,0,1,0-.12v-.07a.52.52,0,0,1,0-.14.18.18,0,0,1,0-.07l.11-.06a.48.48,0,0,0,.2-.2,1.23,1.23,0,0,0,.13-.29,1.49,1.49,0,0,0,0-.28.41.41,0,0,0-.07-.27c0-.06-.13-.06-.24,0a.74.74,0,0,0-.16.12l-.12.15-.06.08s-.05,0-.08-.06a.34.34,0,0,1,0-.16.47.47,0,0,1,.16-.29,1.44,1.44,0,0,1,.34-.28c.18-.11.33-.12.44,0a.68.68,0,0,1,.16.52,1.28,1.28,0,0,1-.09.48,1.47,1.47,0,0,1-.22.39v0A.28.28,0,0,1,66,163a1,1,0,0,1,.11.52,1.87,1.87,0,0,1-.09.59,1.34,1.34,0,0,1-.23.48,1.09,1.09,0,0,1-.34.31A1.07,1.07,0,0,1,65.13,165Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.78,160.63a4.11,4.11,0,0,1-.34-2,6.79,6.79,0,0,1,.35-2.41,2.49,2.49,0,0,1,1.06-1.35l.28-.12a1.32,1.32,0,0,1,.24,0s.08,0,.09.05a.35.35,0,0,1,0,.16,3.68,3.68,0,0,1-.06.43c0,.15-.08.21-.14.2a.65.65,0,0,0-.43.1,1.45,1.45,0,0,0-.62.89,5.8,5.8,0,0,0-.2,1.74,3.86,3.86,0,0,0,.2,1.53.39.39,0,0,0,.62.17,1.6,1.6,0,0,0,.47-.44l0-.05c.06,0,.1,0,.13.1a1,1,0,0,1,0,.33.56.56,0,0,1-.14.36,2,2,0,0,1-.25.26,1.72,1.72,0,0,1-.32.23C67.36,161,67,161,66.78,160.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.62,139h-.05l-5.27-1.64a.16.16,0,0,1-.12-.16v-9.36a.17.17,0,0,1,0-.1L79.79,124a.16.16,0,0,1,.23,0,.17.17,0,0,1,0,.24l-2.54,3.73v9.19l5,1.57,3.26-4.79a.19.19,0,0,1,.24,0,.17.17,0,0,1,0,.23l-3.33,4.89A.21.21,0,0,1,82.62,139Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89,128.12a.18.18,0,0,1-.17-.17v-6.1l-2.46-.76a.18.18,0,0,1-.11-.21.17.17,0,0,1,.21-.11l2.58.8a.17.17,0,0,1,.11.16V128A.17.17,0,0,1,87.89,128.12Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,116.87a.16.16,0,0,1-.17-.16v-6.25a.17.17,0,0,1,.17-.17.17.17,0,0,1,.16.17v6.25A.16.16,0,0,1,82.35,116.87Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,120.56a.16.16,0,0,1-.09,0,.16.16,0,0,1-.05-.23l4.77-7.38a.17.17,0,0,1,.23,0,.16.16,0,0,1,.05.23l-4.77,7.38A.17.17,0,0,1,88.27,120.56Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.79,121.55a.14.14,0,0,1-.09,0,.16.16,0,0,1,0-.23l4.77-7.38a.17.17,0,0,1,.23,0,.16.16,0,0,1,0,.23l-4.77,7.39A.19.19,0,0,1,88.79,121.55Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.42,133.58h0l-4.18-1.18a.18.18,0,0,1-.12-.21.17.17,0,0,1,.21-.11l4.18,1.18a.16.16,0,0,1,.12.2A.16.16,0,0,1,94.42,133.58Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,149.35a.17.17,0,0,1-.17-.17v-8.71a.16.16,0,0,1,.17-.16.16.16,0,0,1,.16.16v8.71A.17.17,0,0,1,82.25,149.35Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.06,148.85a.17.17,0,0,1-.16-.17V140a.16.16,0,0,1,.16-.16.17.17,0,0,1,.17.16v8.71A.18.18,0,0,1,83.06,148.85Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,128a.18.18,0,0,1-.17-.17.17.17,0,0,1,.16-.17l3.81,0h0a.17.17,0,0,1,.17.16.16.16,0,0,1-.17.17l-3.8.06Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64,142a.19.19,0,0,1-.1,0,.18.18,0,0,1,0-.24l3.71-4.63a.16.16,0,0,1,.23,0,.16.16,0,0,1,0,.24l-3.71,4.63A.16.16,0,0,1,73.64,142Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.44,143.16a.15.15,0,0,1-.13-.07l-2.61-3.6a.16.16,0,0,1,0-.15L69,132.73a.17.17,0,0,1,.22-.1.17.17,0,0,1,.1.21L67,139.37l2.56,3.53a.17.17,0,0,1,0,.23A.19.19,0,0,1,69.44,143.16Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74,139.41h0a.16.16,0,0,1-.11-.21l1.94-5.54a.17.17,0,0,1,.22-.1.17.17,0,0,1,.1.21L67.9,139.3A.17.17,0,0,1,67.74,139.41Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.58,155.61a.1.1,0,0,1-.07,0,.17.17,0,0,1-.08-.22l3.64-7.45a.16.16,0,0,1,.22-.07.16.16,0,0,1,.08.22l-3.64,7.45A.16.16,0,0,1,65.58,155.61Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,162.44l13.06-7.53a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.12l-13.06,7.54a.93.93,0,0,0-.48.68C134.13,162.55,134.34,162.6,134.61,162.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,160.38l13.06-7.54a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.11l-13.06,7.53a1,1,0,0,0-.48.68C134.13,160.48,134.34,160.53,134.61,160.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.29,155.17l9.12-5.28a1,1,0,0,0,.48-.68c0-.22-.22-.27-.48-.12l-9.12,5.29a.94.94,0,0,0-.49.68C114.8,155.27,115,155.33,115.29,155.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.29,153.11l9.12-5.29a1,1,0,0,0,.48-.68c0-.21-.22-.27-.48-.11l-9.12,5.28a1,1,0,0,0-.49.68C114.8,153.21,115,153.26,115.29,153.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,154.15a.11.11,0,0,1-.11-.11v-2.71l-3.51-1.41a.11.11,0,0,1-.06-.15.11.11,0,0,1,.14-.06l3.58,1.44a.11.11,0,0,1,.07.11V154A.11.11,0,0,1,141.68,154.15Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81,155.63h0l-5.45-.87a.12.12,0,0,1-.09-.11V153.2a.11.11,0,0,1,.22,0v1.35l5.36.86a.11.11,0,0,1,.09.13A.12.12,0,0,1,125.81,155.63Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.33 188.69 57.33 188.69 57.33 188.69 57.33 188.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.56,174.16v0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.35,188.62l0,0v0h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,184.15s.08-.07.09-.09,0,0-.06-.06v0s-.06-.1-.12-.12a.06.06,0,0,0-.08,0l-.07.06,0,0s-.08,0-.09,0,0,0,0,0a.27.27,0,0,0-.1.06v0s0,0,0,.07h0s0,0,0,0v0h0l0,0s-.07.13-.1.19-.13.09-.06.15h0c-.05,0-.07.07-.06.13s0,.1,0,.13.06,0,.06,0-.08.08,0,.06,0,0,0,.05,0,0,0,0,0,0,0,.07h0s.06.06,0,.06,0,0,0,0c-.19.1,0,.08,0,.13h0v0c0,.07-.14.3,0,.19-.08.11.12,0,0,.09,0,0,0,.06.06.1s0,0,0,.06,0,0,.05,0,0,.17,0,.18a.09.09,0,0,0,.07,0s0,0,0,0a.14.14,0,0,0,.19,0s0,0,0,0h0s.07,0,.11,0,.07-.05.05-.14h0s0,.06,0,0h0a.35.35,0,0,1,0,.06c0-.07,0-.06,0-.1v0s0,0,0-.07v0s0,0,0,0v0h0l0-.08s0,0,0,0h0l0,0v-.06a.42.42,0,0,1,0-.1h0l0-.08s0-.05,0-.08h0v0h0s0,0,0,0a.59.59,0,0,0,0-.14.06.06,0,0,0,0,0v0s0-.07,0-.06h0a.21.21,0,0,0,.06-.2.74.74,0,0,0,0-.19S83,184.16,82.94,184.15Zm-.15.65,0,0h0l0,0h0l-.08,0a.23.23,0,0,0,0,.09h0l0-.07s0,.12,0,0c0,.14,0,.21-.09.23v0l0,0s0,0,0,0l0,0c0-.08,0,0,0,0h0v-.08c0,.08-.1.08-.11,0h0v0a.26.26,0,0,1-.06.09s0,0,0,0a.54.54,0,0,1,0-.19s0-.08-.09.06c.07-.09,0,0,0,0l0,.06s0,0,0,0a.3.3,0,0,0,.07-.08c-.11.1,0-.11-.09,0,.14-.17,0-.06,0-.06s0,0,.08-.12,0,0,0,0h0c.05,0,0,0,0,0s.06-.07,0-.06c.09,0,.08-.06,0-.08s0,0,0,0,.1-.07,0-.09c.08,0,0,0,0,0s.12,0,.07-.09,0,0,0-.05,0-.08,0-.06l0,.12s0-.06,0-.06.09,0,.07-.11l0,.09a.8.8,0,0,1,0-.11l0,0s0,0,0,.06,0-.11,0-.09,0,.05,0,.05l0,0,0,0c0,.11,0,0,0,.11,0-.09,0,0,.05-.11h0s0,0,0,0h0a.25.25,0,0,1,0,.07l0-.06a1,1,0,0,1,.11.25l0,0h0v0s0,.07-.06.1S82.78,184.73,82.79,184.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.82,193.45s0,0,0,0v.06l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.38,188.69h0s0,0,0-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,187.3v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,186.52l0,0-.06,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.72,184.91h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,184.85v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.57,174.21a0,0,0,0,1,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.28,184.85l0,0v0S82.29,184.86,82.28,184.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.32 188.69 57.32 188.68 57.32 188.69 57.32 188.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.45,173c.12-.07,0,0,0,0s.05,0,.07,0,0,0-.07.06l.08,0c-.06,0,0,0,0,0l-.07.05c.12-.07,0,0,.09,0,0,0,0,.07,0,.08l0,0c.06,0,0,.06,0,0h0c-.1.08-.07.09,0,.1v0s0,0,0,0-.07.09,0,.09l.07-.05s0,0,0,0h0l-.1.05s-.1.13,0,0h0s0,0,0,0h0l0,0,.08,0s-.07.07,0,0h0c-.09.06,0,0,0,0l0,0h0s-.07.06,0,0,0,0,0,0h0l0,0h0l0,0,0,0v0s-.06.05,0,0h0s0,0,0,0h0l0,0h0s0,0,0,0h0s0,0,0,0h0c-.06,0-.06.07-.05.09l0,0s0,0,0,0v0h0s0,0,0,0h0l0,0h0s0,0,0,0h0l-.06,0s0,.06,0,.07l.07-.06s0,0,0,0l0,0h0l0,0h0l0,0h0c-.07.06-.07.1,0,0-.09.07,0,0,0,0s-.11.17,0,.1c-.07.1,0,.08,0,0s.06-.06,0,0h0s0,0,0,.06h0s0,0,0,.05l.13-.07h0l.12-.07,0,0s.06-.08,0-.05l.07,0s-.14,0,0-.11l0,0s0,0,0,0,0,0,0,0h-.05c.06,0,0,0,.06,0-.06,0,0,0-.06,0h0s0,0,0,0,0,0,0,0h0s0-.06,0-.07h0a1.77,1.77,0,0,0,0-.23s0,0,0,0v-.06s.06-.06,0-.06h0s0,0,0,0,0,0,0,0,0,0,0-.08h0s0,0,0,0h0v0h0v0a.69.69,0,0,0,.13-.11h0l0,0s0,0,0,.06,0,0,0-.09h0s0,0,0,0h0v.06s0-.06,0-.07h0s0,0,0,0h0c0,.1,0,.05,0,0h0c0,.08,0-.08,0,.09,0-.08,0,.06,0,0v-.1h0c0,.09,0,.08,0,0,0,.13,0,.1,0,0,0,.1,0,0,0-.05,0,.11,0,.12,0,0,0,.14,0,.07,0,0,0,.15,0,.18,0,0,0,.13,0,.07,0,0s0-.11,0,0c0-.11,0,.05,0-.12,0,.06,0,.06,0,0,0,.13,0,.12,0,.05-.05.12,0,.06,0,0l0-.1c0,.05,0,0,0,0v0a3.12,3.12,0,0,0,0,.54s0,0,0,0l0,0s0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c-.07.07-.07.09,0,0-.16.15.16-.1,0,.08.07-.06,0,0,.08-.05,0,0,0,0,0,0s-.07.09,0,.08,0,0,0,0a.23.23,0,0,1,.07-.06s0,0,0,0,0,0,0,0l.05,0s0,0,0,0,.08-.07,0,0-.07.07-.07.06l.1-.08c0-.06,0,0,0-.06s.07-.12,0,0l0,0,.06-.06c.1-.13-.08,0,0-.11l-.06.05h0c.05-.05,0-.06,0,0h0c0-.06,0,0,0,0h0l.05,0-.05,0h0l0,0s0,0,0,0h0c.11-.12,0-.07,0,0v-.05c0-.06.1-.16,0-.06s0,0,0,0h0s0,0,0,0,0-.08,0-.07h0c.15-.18,0-.1,0-.12h0c0-.05.09-.14.06-.13l-.07.07h0l.07-.07s.08-.14-.07,0c0,0,.08-.08,0,0h0l.06,0-.06,0h0s0,0,0,0v0h0v0s0,0,0,0h0v0h0v0c0-.06,0-.1,0-.12v0s0-.06,0-.07,0,0,0-.06h0l0,0h0v-.06s0-.07,0-.08a.14.14,0,0,0,0-.07s0,0,0,0,0,0,0,0l0,0h0s0,0,0,0c.13-.12-.07,0,.06-.13l-.25.16s0,0,0,0-.06.08,0,0l-.07,0s.14,0,0,.14c.13-.07,0,0,0,0s.05,0,.07,0,0,0-.07.06l.08,0c-.06,0,0,0,0,0l-.07,0c.12-.07,0,0,.09,0h0s0,.06,0,.08v0l0,0s0,0,0,0h0v0h0a.22.22,0,0,1,0,.08.67.67,0,0,1-.23.38.55.55,0,0,1-.25.11h0c0-.1,0-.2,0-.31a0,0,0,0,0,0,0h0l0,0h0l0,0h0s0,0,0,0h0c.06,0,.05,0,0,0s0,0,0,0h0c0-.05.06-.06,0,0h0s0,0,0,0h0c0-.05,0-.07,0,0h0s0,0,0,0l0,0h0a.19.19,0,0,0,0-.08h0s0,0,0,0-.08,0-.09.08h0l0,0,0,0s0,0,0,0-.08.08,0,.05a.32.32,0,0,1,.07-.06l-.09.08s0,0,0,0l-.11.07,0,0s-.06.08,0,0l-.07.05S76.56,172.9,76.45,173Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.32 178.39 72.32 178.41 72.33 178.4 72.32 178.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.52,174.61h0a1,1,0,0,0,.07-.23c0-.07,0-.12,0,0,0-.07,0-.05,0,0s0,0,0-.07a.09.09,0,0,1-.1,0s0-.06-.09,0a.11.11,0,0,0,0-.08h0c0-.06,0-.07,0-.07v0a.88.88,0,0,0,.1-.3s-.07,0-.07,0,.08,0,.1,0l0-.18a.16.16,0,0,0,0-.1l0-.05a.11.11,0,0,0-.13,0,.89.89,0,0,0-.46.3c-.06,0,0,.17,0,.13l.12-.08s0,0,0,.05-.07.05-.06.08,0,0,0,.09l.22-.16h0a.08.08,0,0,1,0,0s0,0,0,0c0-.18,0-.05,0-.05a.28.28,0,0,0,0-.11c0,.11,0,0,0,.11,0-.1,0,0,0-.13,0,.09,0,.06,0,0l0,.11,0-.07h0s0,0,0-.06a.16.16,0,0,0,0,0h0s0,0,0,.06,0,0,0,.13c-.06-.1,0,0-.08-.07,0,.14,0,.1-.08.12h0v0h0s0,0-.07.12,0-.08,0,0,0,0,0,0,0,0,0,.12h0c0-.07,0-.07-.07,0v0c0-.1,0,.06,0,0v.15a.07.07,0,0,0,0,.08v.16c0-.12,0-.11,0-.08v-.06h0c0,.11,0,.19,0,0s0,.06,0,0v-.06h0v.12c0-.06,0-.22.07-.07,0,0,0-.06,0-.07h0s0,0,.05,0h.07s0,0,0,.08a.31.31,0,0,1,.07-.08.07.07,0,0,1,.06,0h0a.74.74,0,0,1,0,.15s0,0,0,0l0,.12a.14.14,0,0,0,0,.06s0,0,0,0a.21.21,0,0,1,0,.06c0-.06,0,0,0,.06,0-.11,0,0,0,0s0,.12,0,0c0,.11,0,0,0,.12,0-.06,0-.05,0,0,0-.13,0-.12-.05-.05,0-.13,0-.06,0,0s0,0,0,.11,0,0,0,0,0,0,0,.07l0,.07s0,0,.07,0,0,.13,0,.08,0-.13,0-.11,0,0,0,.14.11,0,.15,0,.09.08.1-.07v0h0s0,.05,0,.05.06,0,.09,0,0-.11.08-.08a.45.45,0,0,1,0-.08h0c0,.09.07,0,0-.05s0-.07,0,0,0,0,0,0,0,0,0-.07,0,.05,0,.05,0-.13,0-.06,0,0,0-.1.08,0,.08,0,0-.1,0-.13v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.24,179.89v0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,174.46s0,.08,0,.13,0,.09,0,.09,0,.19,0,.21.12,0,.14,0,0,.08,0,.11,0,0,.07,0a.54.54,0,0,0,0-.11s0,0,0-.05h0c0,.09,0,.12,0,.15s.07,0,.11,0,.07,0,.07-.15,0,.06,0,0,0,0,0,0,0,0,0-.14h0s.06,0,0-.06h0v0l.06-.07s0,0,0,0h0v0s0,0,0,0h0a1.21,1.21,0,0,0,.21-.53,0,0,0,0,0,0-.06v0a.29.29,0,0,0,.06-.21l0-.12s0,0,0-.08l0,0h0l.06-.07,0,0v0a.36.36,0,0,1,0-.11s0-.08,0-.11-.09-.09-.17,0h0c0-.1-.06-.07-.06-.09s0,0-.07,0-.07.09-.08.08l0-.08,0,.05s0,0,0-.07,0,0,0-.08,0,0-.06.08c0-.07,0-.1,0-.05s0,.05,0,.08h0s0,0,0-.1a.12.12,0,0,0-.09.08.69.69,0,0,0,0,.13s-.13.09-.06.16,0,0,0,0l-.06,0c-.06,0-.07.08-.07.13s0,.1,0,.12.06,0,.06,0-.08.07,0,.06,0,0,0,0,0,0,0,0,0,0,0,.08h-.05c.05,0,.06.05,0,0s0,0,.05.05c-.1,0-.11.05-.09.07s.07,0,.06.06,0,.1-.08.16,0,.09,0,.06C75.34,174.45,75.55,174.37,75.4,174.46Zm.5-.92s.06,0,0,.08c.07-.19,0,0,0,0a.29.29,0,0,0,.07-.08c0,.11,0,0,0,.1,0-.08,0,0,.07-.1,0,.08,0,.06,0,0l-.05.1c.05-.08.05-.07.05,0s0,0,0,0,0,.05,0,.06l0,0v0l0,0,0,.05s0,0,0,0,0,0,0,0v0s0,0-.06,0,.07,0,0,0,0,.06-.06.08a.08.08,0,0,0,0,.07.34.34,0,0,1,0,.1.06.06,0,0,0,0,0h0l0,0,0,0h0c-.09,0-.1,0-.08.12h0l0-.08s0,.14,0,0v0h0s0,0,0,0h0v0a.06.06,0,0,0,0,0c-.16.15-.24.1-.23-.17A2.66,2.66,0,0,1,75.9,173.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,192.29v0l0,0S63.68,192.27,63.68,192.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,178.52l0,0h0l.06-.06a.2.2,0,0,1-.09-.09l0-.05,0-.06,0,0-.07-.09,0,0s0,0-.06,0h0c0-.05,0-.08,0,0v0l0,0v0a0,0,0,0,0-.06,0c-.15,0-.31.08-.45.48,0,.06,0,.09,0,.09a.06.06,0,0,0,0,.07s0,.06-.05,0,0,0,0,0,0,0,0,.09,0,0,0,0,0,.11,0,.07,0,.05,0,.08-.1,0-.09.06,0,.07,0,.1a.13.13,0,0,1,0,.07h0a.75.75,0,0,0-.09.15s0,.07,0,.06,0,0,0,0,0,0,0,0a.3.3,0,0,1,0,.18c0,.06,0,.11.06.11s-.06.2,0,.22.12,0,.13,0l0,.13s0,.07.06.05h0l.09,0h0a.07.07,0,0,0,.06,0l.07,0A1.9,1.9,0,0,0,80.1,179v-.06a.33.33,0,0,0,0-.19A1,1,0,0,0,80.07,178.52Zm-.23.59c0,.07,0,.13,0,.21s0,.08,0,0l0,0h0c-.12,0-.13,0-.09.18,0,0,0-.07-.06-.09s0,.14,0,0h0v0a.31.31,0,0,1,0,.15s0,.05-.08.05v.11s0-.05,0-.05,0,0,0,.07h0c0-.1,0-.07,0,0h0s0,0,0-.08a.05.05,0,0,1,0,0,1.61,1.61,0,0,1-.1-.36,0,0,0,0,0,0,0v0s0-.07-.09,0c.08-.06,0-.05,0-.06s0,0,0,0,0,0,0,0l.07,0c-.06,0,0,0,0,0s0,0,0,0c.16-.08,0,0,0-.07s0-.07.09,0h0v0s.06,0,.06-.08h-.07s0,0,0,0,.07-.05,0-.08c.09,0,.08,0,.06-.07s0,0,0-.07h0s0,0,0-.05,0,0,0,.05a.29.29,0,0,1,0-.11,0,0,0,0,0,0,0s0,0,.07,0c0-.18,0,0,0,0l.06-.1c0,.11,0,0,0,.11,0-.09,0,0,0-.11,0,.08,0,.06,0,0s0,.1,0,.11,0-.07,0-.06,0,0,0,0,0,0,0,0,0,0,0,0l.06.06h0l0,0s0,0,0,.07,0,0,0,0v0s0,0-.07.07C80,178.93,79.87,179.05,79.84,179.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22,186.16l-.07.05c.08-.07.06-.09,0,0s0,0,0-.06,0,0,0,0,0,0,0,0l0,0c-.05,0-.07,0,0,0s0,0-.05,0c.18-.17,0,0,0-.08s.17-.26,0-.16c.09-.08-.11,0,0-.06-.07,0,0-.15-.06-.14.19-.21,0-.13,0-.21s0-.1.06-.14h0l-.06.06h0a.24.24,0,0,0,.09-.08s.09-.17-.06-.06c0,0,0-.05,0,0l0,0s0,0-.08,0,.07-.11,0,0c.14-.12,0,0,.06-.08-.08.06-.06,0,0,0l-.06,0c.07-.06.16-.15.06-.08s0,0,0,0,0,0-.1.06l.14-.11s-.13.05,0,0c-.13.07.06-.11,0-.08s-.07.06-.07.05l.06-.06h0s0,0,0,0,.06-.1,0-.08h0s.1-.1,0-.05c.09-.08.07-.12.06-.15s0-.08,0-.11l-.07.05s.08-.06.09-.07.06-.28-.13-.3C63,184,63,184,63,184s-.1,0-.09-.06l.05,0H62.9c.14-.12,0-.07.07-.15l-.26.15,0,0s0,.11,0,.08l-.07.05s0,0,.06.06l-.11.06h0s-.06.1,0,.07l-.07.05c0,.05.13.05,0,.17.12,0,0,0,0,.06s0,0,.06,0,0,0-.06.06,0,0,.07,0,0,0,0,0l-.07.05c.12-.05,0,0,.09,0-.05,0,0,.11,0,.15l0,0c.07,0-.05.12.09.08h0c-.08.05,0,0-.1.08.12,0,0,0,0,.11s0,.08,0,.11.07,0,0,0l0,0c-.11.1-.1.15,0,.11l-.1.05s.1,0,0,0,.08,0,.08.08v0a.18.18,0,0,1,0,.06l.07-.07s-.08.14,0,0-.09.1,0,0c-.13.11,0,.05,0,0l-.09.08s0,.08,0,.18c.12,0,0,.1-.05.22s0,.07.08,0c-.07,0,0,0,0,0l0,0s0,0,0,0l-.07,0c.12,0-.05.1.08,0-.15.11,0,0,0,.05s0,0-.09.08c.05,0,0,.06,0,.09s.07,0,.08,0,0,0,0,0-.05.08,0,0c-.09.08-.07.09,0,.08s0,.06,0,0-.07.14,0,0c-.09.09,0,.06,0,0s-.09.12-.07.13l0,.08.05-.07c-.06.12,0,.06,0,0s.07-.07,0,.06c.06-.1,0,0,.07-.09,0,.05,0,.06,0,0s0,.1,0,.12,0,0,.06,0c0,.13,0,.06.05,0h0a.1.1,0,0,1,.06,0s0,0,0,0,0,0,.05,0l0,0s0,0,0,0,.08-.06,0,0l-.07.05s0,0,.09-.07,0-.07,0-.1.08-.14,0-.08l-.05,0,.07-.06C63.33,186.2,63.14,186.26,63.22,186.16Zm-.3-1.5Zm-.05.59,0,0h0Zm0,0h0Zm.16,1.27h0l0,0Zm0-.19Zm0-.47h0s0,0,0,0Zm0,.06,0,0h0Zm0,.39Zm0-.21h0Zm0,.07,0,0v0h0Zm0,.16h0Zm0-.06-.06,0s0,0,0,0a.11.11,0,0,0,.06,0Zm0,.08h0v0h0Zm0,.18Zm0,.12v0h0Zm0-.08v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.16,178.07s0,0,0-.06l0,.11-.07,0c-.07,0-.07.18,0,.18h0v0h0s0,0,0,.07l.08,0h.08v.08a.27.27,0,0,1,0-.08h0s0,.07,0,.08.07-.05.07-.07,0,0,0,.11c0-.09,0,0,.07-.11,0,.08,0,.07,0,0l0,.11c.09-.16,0,0,.1-.1,0,.08,0,.06.1.06s0,.05,0,.07,0,.09.11,0h0c0,.05,0,0,0,.11.1-.18.06,0,.08,0s.07,0,.12,0l0,0h0c0,.07,0,.08.05,0h0a.14.14,0,0,0,0,.06l0-.05h0l0,.05,0,0,.1.07.31.14v.07c0-.06,0,0,0-.05l0,0v0l0,0h0c0,.05,0,0,0,0h0l0,.07c0-.06,0,.08,0,.08l0-.11c0,.08,0,.07,0,0,0,.09,0,.1,0,0-.05.14,0,.13,0,.07,0,.11,0,0,0,0s0,.1,0,.11h0s0,0,.06-.11c0,.14,0,.07,0,0,0,.15,0,.19,0,.07,0,.13,0,.06,0,0h0l0,0v0l0,0,.07,0s.05.05.07.07,0,.09.06.11l0,0a1.8,1.8,0,0,0,0,.22c0,.19,0,.4.06.6,0,0,0,.07,0,.1s0,.08,0,.07a.5.5,0,0,1,0,.12h0v.05s0,.09,0,.07h0c-.11.11,0,0,0,.08s.05.12-.09.14c.06.05,0,.13,0,.21l.07,0c0,.06,0,.06,0,0s-.06.16,0,.13c-.09.09-.07.15,0,.18s0,.14,0,.11c-.07.13-.08.23,0,.18-.09.09,0,.1,0,.07-.1.13-.11.23,0,.25-.16.15.16.08,0,.28.07,0,0,.06.08,0,0,0,0,.08,0,.09s-.06.19,0,.23,0,.08,0,.14,0-.07.06-.09,0,.05,0,0,0,0,0,0l0,0c0-.07,0-.09,0-.09s.08-.09,0-.06-.08.08-.07.06,0,0,.09-.1,0-.18,0-.27.07-.27,0-.22-.05.06-.05,0,.07-.06.07-.07c.1-.18-.09-.25,0-.4l-.08,0c.08-.08.06-.17,0-.11s0,0,0-.09,0,.05,0,0,0-.06,0-.12,0,0,0,0-.08-.06,0-.08,0-.07-.06-.05c.19-.17,0-.13,0-.23s.17-.44,0-.38c0,0,0-.05,0-.06v0a.05.05,0,0,1,0,0,.49.49,0,0,1,0-.11v-.14a.52.52,0,0,0,0-.14V180a.26.26,0,0,0,0-.29.65.65,0,0,1-.08-.17v-.05h0c0-.13.06-.28,0-.33l0,.05v0s0,0,0,0a.27.27,0,0,1,0-.11h0a.32.32,0,0,1,0-.1v0h0c0-.05,0-.1.08-.09s0-.07,0-.1,0-.11,0-.11,0,0,.06,0,0,0,0-.1,0,0,0-.06l0,.06c0-.12,0-.05,0-.15a.63.63,0,0,0,.1-.23s0,0,0,0,.11-.09,0-.26c.07.09,0,0,.1,0-.07-.12,0-.11.08-.15a.25.25,0,0,0,.05-.15l0,0s.07,0,.1-.06l.1-.2c0-.07.09-.15.13-.2s0,0,0,0v0s0,0,0,0a2.15,2.15,0,0,1,.3-.46,1.26,1.26,0,0,0,.26-.57c.06,0,.11-.08.14-.15l0,0a.64.64,0,0,1,0-.1s0-.09,0-.16a.37.37,0,0,1,.05-.2l0,.05c0-.05,0,0,0-.09s.11-.1.12-.17,0-.12.07-.13l-.24,0s0,0,0,0l0,.06s0,0,0,0,0,0,0,0,0,0,0,.08-.06,0,0,0l0,0s0,0-.07-.05,0,.1-.06.15-.11,0,0,.12l0,0,0-.05c-.06,0-.06.05-.07.11l0,0s0,.06,0,0,.05,0,.05.06-.07,0,0,.06,0,.06,0,0,0,0,0,0,0,0,0,.06,0,0,0,0,0,.12,0,.05,0,0,0,.09c-.14-.12,0,.06-.07.1s-.2,0-.11.15c-.07-.05,0,.13,0,0a.26.26,0,0,1,0,.14s-.05.05,0,.1-.11.05-.12.15l0,0s0,.06,0,.07-.12,0-.12.09l0,0a0,0,0,0,0,0,0s0-.06-.07-.06-.14.07,0,.19,0,0,0,0,0,0,0,0,0,0,0,.1-.09,0,0,.11c-.1-.09,0,0-.06,0s0,.08,0,.07a.09.09,0,0,1,0,0s-.13-.08-.06,0,0,0,0,0,0,0,0,.06h0L74,177.2s0,.05,0,.07v0l0,0c.07.14-.1.05-.06.15h0l-.1.07a1.25,1.25,0,0,0-.23.41c0,.06,0,.14-.06.06s0,0,0,.08-.07,0-.09,0-.12.08-.09,0l0,.11c0-.12,0-.12,0,0,0-.08,0,.06,0-.07s0,0,0,0,0,0,0,0l0-.07c0,.08-.08.1,0,0,0,.05,0,0-.06.07.11-.3,0,0-.06,0s0-.32-.06-.12c0-.14-.1.15,0-.07-.09.07-.07-.09-.14,0,.1-.32-.11-.05-.13-.12s0-.19,0-.16l-.05.11,0,0a.87.87,0,0,0,.06-.15s0-.19-.11,0c0,0,0-.05,0,0a.08.08,0,0,1,0,0c0,.06,0,0-.07.1,0-.09,0-.14-.07,0,.09-.21,0,0,0-.11,0,.13,0,.09,0,.06a.39.39,0,0,1,0,.09c0-.12.09-.27,0-.11,0,0,0-.06,0,0s0,0-.07.14l.09-.22s-.12.18-.06,0c-.1.19,0-.12-.08,0s0,.1,0,.11l0-.11,0,0s0-.05-.06,0c0-.13,0-.12,0,0,0-.07,0-.18,0,0,0-.15,0-.14,0-.15s-.09,0-.12,0a.37.37,0,0,1,0,.11s0-.13,0-.15c-.15.13-.13-.19-.34.05,0-.15,0-.12,0-.14s-.12.13-.14.1l0-.07s0,0,0,.07c0-.22-.12.05,0-.15l-.17.4,0-.07s0,.12.07,0a.76.76,0,0,1,0,.11s.18-.16.16,0c.08-.18,0,0,.06,0s.07,0,.07-.07,0,0,0,.11c0-.09,0,0,.06-.1,0,.08,0,.06,0,0a.51.51,0,0,0,0,.11c.08-.17,0,0,.09-.11,0,.08.07.06.13.05s0,0,0,.07,0,.13.16-.1c-.08.16,0,0-.06.18.1-.18.07,0,.08,0s.1,0,.14,0,.07-.09,0,0,0,0,0-.07c-.05.18,0,.2.08,0a1.14,1.14,0,0,0-.06.14s.09-.13,0,0c.1-.08.13-.12.16,0l.05-.1s0,.17.07,0c0,0,0,.14,0,0-.09.21,0,.08,0,0,0,.08,0,.05,0,.15s.1,0,.1.12c.14-.15.11,0,.13.16,0-.06,0,.08.08-.11,0,.12,0,0,0,0s0,0,0-.07,0,0,0,0l0,.1c.09-.16,0,.11.09-.1-.08.24,0,.07,0,0-.08.15.06,0,0,.14.06-.06,0,.08,0,.08s0-.1,0-.11,0,.07,0,0c0,.1,0,.11,0,0,0,.14,0,.12,0,.07,0,.11,0,0,.05,0,0,.13,0,.16.06,0,0,.13,0,.07,0,0a.87.87,0,0,0,0,.14v0a.18.18,0,0,0-.07.12c0,.06,0,.12,0,.17a.2.2,0,0,0,0,.08s0,0-.07,0,0-.11-.06,0h0c0-.11,0-.06-.06,0l0,0s0,0,0,0h0l-.06,0v0h0c0-.1,0-.06,0,0l-.06,0c0-.08,0-.18-.05,0,0-.08,0,0,0,0h0a.15.15,0,0,0,0-.07c-.08.08-.07-.08-.14,0,.09-.32-.11,0-.12-.11s0-.11,0-.14h0l0,.1s0,0,0,0,.06-.11.06-.14,0-.19-.11,0c0,0,0-.05,0,0l0,0c0,.07,0,0-.08.11,0-.09,0-.13,0,0h0c.06-.16,0,.06,0-.08l0,.07h0c0-.08,0-.13,0,0s0-.05,0,0v0h0l0-.08a.18.18,0,0,0,0,.07h0a.39.39,0,0,1,0-.06.09.09,0,0,0,0,0h0s0-.1,0,0h0l-.08-.06h0c0-.07,0-.06,0-.07H71.7l0,0v0l0,0-.12-.06,0,0-.12,0,0,0v0h0l0,0h0l0,0H71.2S71.18,178.06,71.16,178.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.23,186.42s0,0,0,0a.11.11,0,0,0,0,0h0l0-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.49,177.4a.15.15,0,0,1,0,.06s0,0,0,0h0S70.5,177.42,70.49,177.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.33,188.55h0v0a0,0,0,0,0,0-.05h0A0,0,0,0,1,57.33,188.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.89 191.34 63.89 191.34 63.88 191.34 63.89 191.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,179.8h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.05,178.37h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.27,186.48h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8,191.39v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51,192.83s0,0,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.87,191.25h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81,191.36h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,178.78s0,.05,0,0,0,0,0,0,0-.05,0-.15h0s.07,0,.09-.06,0-.06,0-.07h0s0,0,0,0l0-.07c0,.06.07,0,0,0h0l0,0s0,0,0,0l0,0h0v-.06l0,0s0,0,0-.07l.06,0s0,0,0-.05h0a0,0,0,0,1,0,0h0s.06,0,.09-.06,0,0,0-.07-.08-.07,0,0a.2.2,0,0,1,0-.11s0-.07,0-.09.11-.09.09-.13l0-.07a.14.14,0,0,0,0-.07c0-.05.08-.1.06-.12l-.05,0h0l.05,0s0-.06,0-.09,0-.06-.07,0,.08-.07,0,0h0a.1.1,0,0,1,0,0s0,0-.06,0h0s0-.07,0-.05h0l0,0,.05-.05s0,0,0,0,0-.05,0,0h0l0,0s0,0,0,0v0s0,0,0,0l0,0v0h0s0-.09,0,0h0s0,0,0,0,0-.06,0,0h0c0-.05,0-.13,0,0,.06-.14,0-.16,0-.17h-.11s0,.11,0,.11l0-.15s-.07.06-.09.06,0,0-.07,0l0,0h0c-.13,0-.24.15-.34.39,0,0,0,.08-.05.12h0a.93.93,0,0,1,0,.13h0a1.33,1.33,0,0,0,0,.19h0l0,.06h0v.08s0,0,0,.06h0c0,.09,0,.16,0,.22h0c0,.05,0,.08,0,.08a.17.17,0,0,0,0,.07h0a.7.7,0,0,0,0,.14s0,.08,0,.09-.06.19,0,.22.12,0,.13.07a.7.7,0,0,0,0,.14.05.05,0,0,0,.08,0h0s0-.06,0-.08h0v0h0s0,0,0,0,0,.12,0,.14.08,0,.12,0S70.61,178.88,70.59,178.78Zm-.27-.53,0-.06s0-.06,0,0h0s0,0,0,0v0l0,0h0v0s0,0,0,0h0c.06-.05,0,0,0,0h0v0h0s0,0,0,0,.05-.08,0-.12l-.07,0s0,0,0,0h0c.06,0,.06-.06,0-.06h0c.08,0,.06,0,0-.08s0,0,0-.06v0s.05,0,0-.07v-.06s0,0,0-.08v0s0,0,0,0h.1a.14.14,0,0,1,0,.07h0s.06-.05.07,0c.05-.2.05,0,.07,0a.26.26,0,0,0,.07-.1c0,.11,0,0,0,.11,0-.08,0,0,0-.08h0l0,0h0l0,0,0,0v0h0l0,0,0,0h0s0,0,0,0,0,0,0,0h0v0s0,0,0,0v0l0,0,0,0h0l0,0h0v0h0a.54.54,0,0,1,0,.18h0s0,.07,0,.1l0,0a.41.41,0,0,0,0,.19s0,.06,0,.08h0v0h0l0,0s0,0,0,.08h0s0,0,0,0h0l0,0a.1.1,0,0,1,0,0h0v0A.2.2,0,0,1,70.32,178.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.35,183.73s0,0,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,183.62h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,192.57l0,0a.19.19,0,0,0,.08-.07l0,0h0l-.06.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.41,176.38s0,0,0,0,0,0,0,0,0,0-.05,0h-.06s0,0,0,.05-.07,0,0,0,.07,0,.06,0,0,0-.08,0-.09.2-.12.3-.13.14-.1.21v0h0c-.06,0-.08.08-.1.15-.2.34-.39.7-.59,1-.29.5-.58,1-.86,1.5l0,.05v0s0,.05,0,.07l0,.05h0v0l0-.06s0,0,0,.05,0-.05,0,0v0a.3.3,0,0,1,0,.1l0,0h0l0,0s0-.17-.09-.08,0,.1,0,.1l0-.05,0-.06s0,0,0,0,0-.06-.09,0a.12.12,0,0,0,0-.09s0,0-.07,0,0-.19,0-.07c0-.15,0-.18-.09-.2a1.76,1.76,0,0,0-.2-.09s0,.11,0,.11,0-.12,0-.14-.18-.05-.26-.11a.23.23,0,0,0-.29,0l0,0c0-.12-.11-.11-.12-.14s0,0-.05,0l-.06,0s-.09.08-.05.12h0a.07.07,0,0,1-.06,0l0-.07s0,0-.06.06c0-.24-.19,0-.11-.19l-.18.39s0-.07,0-.07.07.15.14,0a.49.49,0,0,1,0,.11c.1,0,.28-.11.3.11.09-.18.07,0,.11,0s.11,0,.11-.06c0,.12,0,0,0,.12,0-.09,0,0,.08-.1h0c0,.07,0,.08,0,0h0s0,.07,0,.08l0-.06a3.74,3.74,0,0,0,.92.74c0,.21,0,.43,0,.65h0a.66.66,0,0,0,0,.14c0,.12,0,.25,0,.37s0,0,0,0v0l0,0s0,0,0,.05h0c.07.26-.08.68.11.89a.54.54,0,0,0-.07.33c0,.13.12.14.11.25h0s0,0,0,0c-.1.15,0,.22,0,.29l.17-.1c0-.08,0-.21,0-.2l.07,0c0-.17-.14-.28,0-.51-.13,0,0-.11,0-.18s0-.13-.06-.12,0-.05.06-.08,0,0-.07,0a.06.06,0,0,0,0-.11h0s.07,0,.07-.05,0-.1-.08-.1v0a.77.77,0,0,0,0-.34h0v-.06s0,0,0,0,.08-.29-.08-.32c.12,0,0-.09.12-.13-.12,0,0-.18,0-.3a.65.65,0,0,0,0-.24.26.26,0,0,0,0-.19h0l.16-.2a5.37,5.37,0,0,0,0,.57,0,0,0,0,0,0,0v0l0,.33-.07.25s0,.13.09.06c-.08.05,0,.09,0,.11a.09.09,0,0,1,0-.06v0s0,0-.07,0c.12,0,0,.2.09.1-.15.15,0,.07,0,.11s0,.11-.09.14c.06,0,0,.12,0,.2l.08-.05c-.05.07,0,.07,0,0s-.05.15,0,.12c-.09.09-.07.15,0,.17s0,.12,0,.1-.07.2,0,.17v0c0,.05,0,.06,0,.05v0c-.07.11-.08.2,0,.22-.08.07,0,.09,0,.12h0a.15.15,0,0,0,0,.07l0,.07s0,0,0,0l.18-.11h0v0c0-.05,0-.19,0-.2a.2.2,0,0,0,0-.07.38.38,0,0,0,0-.1,9,9,0,0,0,0-1.3c0-.15,0-.31,0-.47a.34.34,0,0,0,.06-.12v0c0-.13-.1-.24-.07-.36s.1-.25.07-.32l-.07.05s0,0,0,0,.08,0,.09-.07.1-.36-.06-.29c0,0,.07-.08,0-.05v0h0a.72.72,0,0,1,.23-.36c0-.3.16-.33.33-.5,0-.07.08-.07,0-.16s.06-.07.06-.09,0,0-.05,0,0,0,0,0,0,0,0,.05c-.06-.13.11-.11,0-.2.13.05,0,0,.06-.09.06.1,0-.16.1,0,0-.11.07-.06.1-.15s0,0,0-.05,0,0,0,0,.1-.07.05-.13.1-.05.1-.12.06-.11,0-.14.14-.11.08-.19.06,0,0-.07a.14.14,0,0,0,.13-.2c.09,0,0-.1,0-.18v0s0,0,.06,0,0,0,0-.08v0s0,0,0,0l0-.05c.06,0,.09-.08.09-.18a.07.07,0,0,0,.07,0,.68.68,0,0,0,0-.15S84.43,176.36,84.41,176.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,183.6l-.08,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.27 177.99 70.27 177.99 70.27 177.99 70.27 177.99 70.27 178 70.27 177.99 70.27 177.99",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.55 191.02 71.54 191.02 71.54 191.02 71.55 191.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.27 178 70.27 178 70.27 178 70.27 178",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81,191.35h0a.11.11,0,0,0,0-.05h-.07l0,0h0C53.81,191.34,53.79,191.23,53.81,191.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.85,191.24s0,0,0,0h0v0h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,179.87s0,0,0,0,0,0,0,0,0,0,0,.08-.07,0,0,0,.06,0,0,0,0,0-.07-.06,0,.06,0,.11h0a15.15,15.15,0,0,0-1,1.61h0a.09.09,0,0,0-.06.07h0s0,.06-.07.1a.07.07,0,0,0,0,.08l-.21.37a5.83,5.83,0,0,0-.72,1.51.92.92,0,0,0-.14.26h0v0h0v0s0-.12,0,0h0v0a2.81,2.81,0,0,0-.85-.27h0l-.15,0c0-.06,0-.12,0-.1a.34.34,0,0,1,0,.08h0a.45.45,0,0,0,0-.08s-.06-.17-.15,0h0s0-.09,0,0h0s0,0,0,0,0,0,0,0c-.36-.16-.77-.53-1.21-.42,0,0,0,0,0,0l-.1,0v0l0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0-.07v.07s0,0,0-.06,0,0,0-.06,0,0,0,.09,0-.07,0,0,0,.08,0,.08,0,0,0-.09-.08.11-.11.16-.12,0-.08.14,0,0,0,0h0l0,0c-.06,0-.08.07-.1.14l0,0h0a2.13,2.13,0,0,0-.18.22s0,0,0,0l-.15.2a.05.05,0,0,0,0,0c-.07.1-.14.22-.21.34s-.09.08-.11.17a1.09,1.09,0,0,1-.08.15s-.09,0-.1.08l0,0h0l0,0c0,.07-.14.08-.06.2h0s0,0,0,0h0s0,0,0,0,0,0,0,.06l0,.05s0,0,0,0-.19.34-.28.48c-.25.42-.61.92-.9,1.43h0c-.06.12-.13.24-.18.36l-.06,0s0,0,0,0h0a3.61,3.61,0,0,0-.16.42c0,.08,0,.16.08.07l0-.06h0v.22h0v.09c0,.25,0,.51,0,.76l-.14.09,0,0s-.06.13,0,.1l-.07,0c0,.07.15.08,0,.23.13-.06,0,0,0,.08s0,.05.07,0,0,0-.07.07,0,0,.08,0,0,.06,0,0l-.07.05c.12-.05,0,.06.08,0s0,.13,0,.19h0s0,0,0,0,0,.13.06.12v0s0,0-.07.07c.13,0,0,.07,0,.15h0v.08l.06.07s0,0,0,0v0l0,0h0a.33.33,0,0,0-.06.08v.06h.06l0,0v0s0,0,0,0v0l0,0h0s0,.05,0,.11h0v0h0v0s0,0,0,0v0a.17.17,0,0,0,0,.05h0s0,0,0,.08,0,.06,0,.07l0,0v.05l0,0h0a.29.29,0,0,1,0,.09l0,.18h0s0,0,0,0a1.21,1.21,0,0,0,0,.18c0,.09.06.2.09.31l.18,0,.06-.13a.89.89,0,0,0,.3.22c.28.07.55.16.82.24a4.68,4.68,0,0,1,.53.17s0,0,0,0,0,0,0,0h0l0,0s0,0,0-.05v.05h0s0,0,0,0a.08.08,0,0,0,0,0h0l.07,0h0v0l0,0,0,0a.13.13,0,0,0,0,.06l0,0v0h0a.51.51,0,0,0,0-.1c0,.11,0,.13.06,0s0,.07,0,.06l0-.07c0,.1,0,.11.07,0,0,.08,0,.09,0,.07s0,0,0,0c0,.11,0,0,.06,0,0,.11,0,.14.06,0h0c0,.06,0,0,0,0s0,.08,0,.06,0,0,0,0l.05,0c-.05.12,0,.08,0,0h.06a.35.35,0,0,0,0,.06c0-.1,0,0,0-.06h.06c0,.06,0,0,.07,0h0c0,.11,0,0,0,0a.24.24,0,0,1,0-.09h0v0s0,0,0,0h0l0,0,0,0,0,0h0l0,0c0-.06,0-.09,0-.11s0,0,0,0l.06-.07c0-.09,0-.26.14-.26-.06-.13,0-.09.07-.14s0-.16,0-.16,0-.07.07,0,0,0,0-.07h0s0,0,0-.08,0,.06,0,.06,0-.06,0-.17.09-.11.13-.22l0,0,0,0h0l0-.12a.17.17,0,0,0,0-.12h0v0h0s0,0,0,0a.2.2,0,0,1,0-.07s.08,0,.08-.1l0,0v0h0l0,0h0v0a.73.73,0,0,0,.08-.25l0,0,0,0h0l0-.05a.1.1,0,0,0,.07-.12h0a0,0,0,0,0,0,0h0l0,0a.15.15,0,0,0,0-.06h0l0,0v-.06l0-.08,0,0c.19-.5.41-1,.64-1.47.14-.28.32-.71.51-1.06h0a.56.56,0,0,1,0-.08h0l0,0h0a.22.22,0,0,0,0-.09h0c.06,0,0,0,0-.08h0l0,0s0-.07,0-.11a.1.1,0,0,1,0,0,5.17,5.17,0,0,1-.07-1,8.56,8.56,0,0,1,0-1h0v0s0,0,0,0h0l0,0v0h0l0,0h0c0-.05.06-.09,0,0s0,0,0,0h0v0l.05-.05s0,0-.06,0,0,0,0,0l0,0,0,0c0-.1,0-.21,0-.27a3.3,3.3,0,0,0,.13-.59.05.05,0,0,1,.05,0c-.09-.09,0-.08,0-.12a.24.24,0,0,0,0-.12s0,0,.06,0,0,0,0-.08,0,0,0-.05v0l.06,0c-.08-.09,0,0,0-.13s0,0,0-.05,0,0,0,0v0l0-.09.07,0c.06-.05.07-.18.1-.26v0l0,0s0,0,0,0,0,0,0,0,0,0,0-.06.12,0,.11-.11l0,0s0,0,0,0,0-.14,0,0c0-.18,0-.22.12-.31v0s.07-.08,0-.16h0l0,0s0-.06,0-.07l0,0h0a.3.3,0,0,1,.17-.24c0-.23.08-.23.21-.31,0-.05.06,0,0-.12s0,0,0-.05,0,0,0,0,0,0,0,0,0,0,0,.05.08-.05,0-.14c.13.07.05,0,.05-.05s0-.11.08,0c0-.08.06,0,.07-.07l0-.06s0,0,0,0h0c.05,0,.07,0,0-.09s.08,0,.07-.06,0-.06,0-.1.09,0,.07-.07a0,0,0,0,1,0,0h0s0,0,.06,0h0a.08.08,0,0,0,0-.07s0,0,0,0,0,0,0,0,0,0,0-.09,0-.07,0-.1.11,0,.07-.1h0s0,0,0,0h0s0,0,0,0,0,0,0-.1,0,0,0-.06,0-.11.06,0,0,0,0-.1,0,0,0-.06.06,0,.07,0a.11.11,0,0,0,0-.1c.07,0,0,0,.06-.07s0,0-.07,0S78.72,179.89,78.7,179.87Zm-2.37,7.44s0,0-.07,0,0,.06,0,.06v0s0,0,0,0h0c-.1,0,0,.06-.08.1.05,0,0,.08,0,.12l0,0h0c-.1,0,0,.25-.13.26s0,0,0,.05a0,0,0,0,0,0,0v0s0,.05,0,.06,0,.06,0,0,0,0,0,0,0,0,0,.08l0,0s0,.12,0,.06,0,0,0,.09c-.16-.07,0,.08-.08.15s-.23.11-.13.21c-.08,0,0,.14-.06,0,0,.17-.13.22-.12.34-.19,0-.13.29-.2.37s-.14.09-.14.17l.06,0a.06.06,0,0,0,0,0s0,0-.07,0h0c0,.06-.12.1,0,.2s0,0,0,0l0,0c0,.06,0,.05,0,.12s-.09,0,0,.13h0c-.06,0,0,0,0,0h0s-.07,0-.07.08h0v0h0c0,.08-.16.09-.07.23,0,0-.06-.05,0,0s0,0,0,0h0a.11.11,0,0,1,0-.05s0,.05,0,.07,0,0,0,.05-.06,0,0,.1h0c-.06-.06,0,.07-.05,0s0,0,0,.05a0,0,0,0,0,0,0s0,0,0,0,0,0,0,0a.08.08,0,0,0,0,.05h0l0-.05v.05a.07.07,0,0,0,0,.08h0l0,0v0a.22.22,0,0,0-.1.13l-.08.18a0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,.07h0s-.08,0-.11.06v0l0,0c0,.07-.07.16-.11.22s0,0,0,0v0l0-.06c0,.27-.27.3-.29.67-.08-.05-.13.08-.15.08s0,.12-.05.19a.08.08,0,0,0,0,0s0,0,0,0h0s0-.06,0-.06h-.05a1,1,0,0,0-.68-.22c0-.09,0-.07-.08,0h0s-.1.06-.11,0,0-.18-.07-.15a1,1,0,0,0,0,.11s0,0,0,0a.46.46,0,0,0,0-.15s0-.2-.14,0c0,0,0-.06,0,0a.06.06,0,0,1,0,0c0,.06,0,0-.08.11,0-.09,0-.14-.08,0,.07-.22,0,0,0-.11,0,.13-.06.1-.06.06a.24.24,0,0,1,0,.09h0c0-.12.06-.26,0-.11s0-.05,0,0,0,0,0,.1h0l.06-.17s-.11.18-.07,0c-.1.2,0-.12-.11,0s0,.1,0,.11,0-.1,0-.11,0,0,0,0,0-.05-.06,0c0-.13,0-.12-.06,0,0-.07,0-.18,0,0,0-.15,0-.14-.06-.15h-.14a.3.3,0,0,1,0,.11s0-.13,0-.15-.14,0-.21,0h0a.18.18,0,0,0-.15,0l-.06,0c0-.05-.06,0-.06-.06s0,0,0,0l-.11,0,.12-.25s0,.07,0,.07,0,0,0,0l-.27-.73v.1h0s0,0,0,0h0s0,0,0,0h0c.12-.09,0-.07,0-.08v-.07c0-.08.15-.22,0-.16.09-.07-.12,0,0-.07-.07-.05,0-.2,0-.22A.23.23,0,0,0,71,190c0-.06-.09-.08-.07-.14s.1-.17.07-.19l-.07,0h0c.06,0,.08,0,.1-.07s.09-.2-.06-.12c0,0,.06,0,0,0s0,0,0,0,0,0-.09,0,.08-.12,0-.06c.15-.1,0,0,.07-.07-.08,0-.07,0,0,0l0,0h0c.08-.05.16-.12.06-.07s0,0,0,0,0,0-.06,0h0l.1-.07s-.13,0,0-.07c-.14,0,.06-.14,0-.13s-.06,0-.07,0h0l.07-.05s0,0,0,0,0-.05,0,0c.09-.07.07-.12,0-.1s.11-.11,0-.07c.09-.09.08-.14.07-.19s0-.12,0-.18-.07.06-.07.05l.09-.06c-.08-.07,0-.22,0-.33h0a.14.14,0,0,0-.09-.13.23.23,0,0,0,.08-.19c0-.07-.06-.06-.08-.1v0h0a0,0,0,0,1,0,0,.41.41,0,0,1,.07-.11l.06.11,0,0s.1-.05.07-.14l0,.06c.06-.1,0-.31.17-.29a.18.18,0,0,1,0-.06h0v0s.06,0,.07,0a.12.12,0,0,0,0-.07l0-.05s0-.06,0,0,0,0,0-.07,0,0,0,0,0,0,0-.07v0s0,0,0,0l0,0c0-.05,0-.07,0-.08l0,.05s0-.05,0-.07h0s0,0,0-.07l0,0a.63.63,0,0,0,.11-.18h0a.07.07,0,0,1,0,0s0,0,0,0,.11-.09.08-.23,0,0,0,0a0,0,0,0,0,0,0s0,0,0,0c0-.14,0-.11.1-.16s.07-.17.09-.25,0,0,0-.05h0l0,0s0,0,0-.05.13,0,.1-.15l0,0v0l0,0s0-.13,0,0c0-.17,0-.21.11-.31h0l.1-.15h0v0l.12-.18,0,0v0l.11-.18.1,0s0,0,0-.11h0s0,0,0,0h0s0,0,0,0c-.05-.12,0,0,0-.13h0c.07.07,0,0,0,0h0c0,.09,0-.11.07,0,0-.09.06,0,.08-.06a.27.27,0,0,1,0-.07s0,0,0,0h0s.06,0,0-.08.07,0,.07,0,0-.05,0-.09.1,0,.06-.1h0c0,.06,0,0,0-.05s.1.05.09-.07c.08.16,0-.24.1-.08,0-.08,0,0,0-.11,0,0,0,0,0-.05s0,0,.06,0v0h0s0,0,0,0,0,0,0,.09.15-.11.13.06c.09-.18.05,0,.08,0s.08,0,.09-.06,0,0,0,.11c.05-.09,0,0,.07-.1,0,.07,0,.07,0,0h0a.49.49,0,0,0,0,.1h0c.08-.15,0,0,.09-.07h0s0,0,.09,0l0,0h0a2.65,2.65,0,0,1,.48.07,12.25,12.25,0,0,0,1.28.58s0,.07,0,.11v0h0l0,0,0,.07h0c.07-.11,0,.06.08-.07v0h0l0,.09,0,0h0l.09,0s0,0,0,.07,0,0,.06,0,0,0,.06,0v0c0,.05,0,0,0,.11s0,0,0,0l0,0c.13-.06,0,.06,0,.11a0,0,0,0,0,0,0v0l0,0h0v.09h0c0,.42,0,.82,0,1.24a3.69,3.69,0,0,0,.06.82.79.79,0,0,0,0,.09s0,.08.08,0h0c-.08.05,0,.06,0,.07l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.78,177.33v0h0v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.79,191.35h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.23,179.89h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.79,191.28c0,.06,0,.08,0,0a.21.21,0,0,1,0,.06h0v-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.78,186.55s0,.06.06,0,0,0-.07.07,0,0,.08,0,0,.05,0,.05-.07,0-.07.05,0,.06.09,0c-.05.06,0,.12,0,.17s0,0,0,0,0,.15.11.06c-.11.08,0,0-.11.12.13-.07,0,.05,0,.11s0,.09.06.12.07,0,0,0l0,0-.07.1v0s0,0,.09,0l-.09.08s.1-.05,0,0c.09,0,.12,0,.09.13l.07-.06s-.08.16,0,0c0,0-.09.1,0,.05h0c-.11.1,0,0,0,0l-.09.09s.05.08,0,.21c.13,0,0,.11,0,.26,0,0,0,.07.08,0-.07.06,0,0,0,.06s0,0,0,0,0,0,0,0l-.07,0c.12-.06,0,.1.09,0-.15.13,0,.05,0,.05s0,0-.08.1c0,0,0,.06,0,.09l.07,0s0,0,0,0,0,.08,0,0c-.09.08-.08.09,0,.09s0,.06,0,0-.09.12,0,.07c-.09.06,0,0,0,0s-.11.13,0,.11c-.16.11.15,0,0,.13.07,0,0,0,.08,0s0,.06,0,0a.14.14,0,0,0,0,.11s0,0,0,0a0,0,0,0,0,0,0s0,0,0,0h0s0,0,0,0h0v0s0,0,0,0,0,0,0,.1c0-.08,0,0,0-.06l.14-.1,0-.09,0,0s0-.05,0,0,.08-.09,0-.1a0,0,0,0,0,0,0s0,0,0,0l0,0s0,0,0-.05l-.08,0c.08-.06.07-.09,0,0s0,0,0-.06,0,0,0,0,0,0,0-.05l0,0c-.06,0-.08,0,0,0s0,0-.06,0c.19-.12,0-.05,0-.09s.18-.24,0-.18c.09-.06-.11,0,0-.06-.06,0,0-.13,0-.17l0-.08h0l.12-.21,0,0s0-.07,0-.05v0h0v0s0,0,0-.08c-.12.08,0,0,0,0s-.05,0-.06,0,0,0,.06-.05,0,0-.05,0l0,0h0s0,0,0,0h0a.21.21,0,0,0,0,.06v-.09l0,0s0-.07,0-.12,0-.11,0,0,0-.05,0-.07c0,.15,0,.12,0,0v.14s0-.16,0,0c0-.13,0-.17,0-.14a.46.46,0,0,1,0-.1s0,.12,0-.07h0s0,.11,0,0c0,.2,0,.06,0,0a.49.49,0,0,1,0,.13c0-.06,0-.08.06,0,0-.21,0-.08.08,0,0-.07,0,.06,0-.13,0,.11,0,0,0,0s0,0,0-.06,0,0,0,0,0,.05,0,.1c0-.18,0,.07,0-.14,0,.23,0,.07,0,0,0,.16,0-.07,0,.12,0-.08,0,.05,0,0a1,1,0,0,0,0-.11c0,.07,0,.06,0,0,0,.09,0,.07,0,0,0,.13,0,.09,0,0,0,.09,0,0,0-.06,0,.09,0,.09,0,0,0,.11,0,0,0,0,0,.12,0,.13,0,0,0,.2,0-.22,0,0,0-.09,0,0,0-.1,0,0,0,0,0,0h0l0,0s0,0,0,0v0s0,0,0,0h0l0,0v0h0s0,0,0,0l.05,0s-.08.16,0,0-.09.1,0,0c-.13.12,0,.06,0,0l-.09.08s.05.08,0,.2c.13,0,.05.1,0,.26,0,0,0,.08.09,0-.07.07,0,0,0,0l0,0s0,0,0,0,0,0-.07.06-.05.11.09,0c-.15.16,0,.06,0,.05s0,0-.08.11c0,0,0,.08,0,.1l.07-.07c0,.06,0,.06,0,0s0,.11,0,0c-.08.11,0,.12,0,.09s0,.05,0,0-.05.14,0,.11,0,.1,0,.05,0,.07,0,.05h0v0l0,.09h0c-.07.07,0,0,0,0l0,0,0,0,0,0h0s0,0,0,0h0l0,0h0c0,.08,0,.11,0,.08,0,.13,0,.09.07,0s0,0,0-.07h0s0,0,0,0h0a0,0,0,0,0,0,0s0,0,0,0,0,0,0-.07h0v0h0v0h0l0,0a.06.06,0,0,0,0-.06c.08-.07,0-.05,0-.07l0,0a0,0,0,0,0,0,0h0s0,0,0,0h0l0,0s0,0,0,0l0,0,0,0h0s0,0,0,0l0,0h0c.05,0,0,0,0-.06s0,0-.06,0l.06-.12s.06-.09,0,0c.09-.07-.1,0,0-.07-.07,0,0-.16,0-.18.1-.08.09-.14.07-.17s-.08,0-.06-.09.08-.17,0-.17l0,0h0l0,0s.07-.14,0-.08h0s0-.06,0,0,0,0,0,0h0s0,0,0,0h0l0,0h0a.07.07,0,0,1,0,0h0s0,0,0,0,0,0,0,0h0v-.06h0v-.07h0s0,0,0,0h0s0,0,0,0h0c.06-.07,0-.1,0-.08s.1-.11,0-.06a.16.16,0,0,0,.07-.16.93.93,0,0,1,0-.13l-.06.05h0l.08-.06c-.12,0,0-.28-.13-.32v0a.26.26,0,0,0,0-.15c0-.05,0,0-.08-.05v0l0,0h0v0c.07-.09-.08-.06,0-.14l-.11.07s0,0,0,0l.05,0s0,0-.06,0c.14-.14,0-.11.07-.19l-.26.15,0,0s0,.13,0,.1l-.07,0c0,.06.07.08.07.14l-.13.08.05,0s-.06.12,0,.09l-.07,0c0,.07.13.07,0,.2.12-.05,0,0,0,.07s0,0,.06,0,0,0-.06.06,0,0,.07,0,0,.05,0,0l-.07,0c.12,0,0,.06.09,0-.05.05,0,.12,0,.17l0,0c.07,0-.05.15.1.09-.1.06,0,.05-.11.1.12,0,0,.05,0,.12s0,.09,0,.12h0l0,0s-.05-.17-.06,0c0-.14,0,.18,0,0,0,.13-.07,0-.1.12,0-.14,0-.12-.07-.06s-.05.13-.07.12-.07-.09-.08,0,0,.07,0,.1v0a.56.56,0,0,0,0-.13c0,.07-.1-.06-.06.15,0,0,0-.08,0,0a.08.08,0,0,0,0,0c0,.07,0,0,0,.12,0-.06-.06-.06,0,.09,0-.17,0,.06,0-.07,0,.11,0,.1,0,.08a.08.08,0,0,0,0,0h0c0-.08-.06-.15,0,0s0,0,0,0,0,0,0,.1h0l0-.15c0,.06,0,.19,0,.06,0,.19-.06,0,0,.09a.14.14,0,0,0,0,.07h0l0-.06s0,0,0,0h0s0,0,0,0v0s0,0,0,.05h0v0h0s0,0,0,.05c0-.09,0-.06-.07,0s0,0,0-.07h0s-.06.05-.07,0l.07-.05h0s0-.05,0,0,.06-.12,0-.09.11-.11,0-.06a.18.18,0,0,0,.07-.17c0-.05,0-.09-.05-.13l-.07.06.1-.08c-.1,0,0-.21-.09-.28l0,.05h0l0,0,.09-.05h-.05a.19.19,0,0,0,.06-.17,0,0,0,0,0,0,0l-.07-.07a.33.33,0,0,0,0,.13.24.24,0,0,0,0,.07h0s0,0,0,0-.06,0-.06.06l-.07-.07v0h0a.18.18,0,0,0,.07-.1.07.07,0,0,1,0-.05s0,0,0,0-.06,0,0-.06h0s0,0,0,0c.14,0,0-.13.09-.14h-.19s-.08.1,0,.11h-.06s0,0,0,.05l0,.09a.21.21,0,0,1-.06.18C58.88,186.43,58.78,186.51,58.78,186.55ZM60.62,188h0Zm0-.06h0Zm-.05-1.35h0Zm0-.09h0v0Zm0,0v.05h0v0Zm0,0h0Zm0,.87v0h0Zm0-.32v0h0Zm0,1.05,0,0h0Zm0,0h0s0,0,0,0v0Zm-.06-1.47h0Zm-.11.4h0v0h0Zm0,0h0Zm0-.26h0Zm0,.31ZM60,187v0s0,0,0,0Zm-.18.05ZM59.7,187h0v0Zm-.29,1.18,0,0h0Zm-.14-.66Zm-.06,1.08h0Zm0-.05h0Zm0-.07h0s0,0,0,0S59.25,188.48,59.24,188.49Zm0-.42h0Zm0,.19v0S59.2,188.29,59.23,188.26Zm0,.2h0l0,0Zm0,.49h0ZM59,187.49l.08-.08h0Zm0,0,.06-.06h0s0,0,0,0Zm.09,0h0S59.13,187.49,59.16,187.46Zm0,0-.06,0h0l0,0Zm-.08-.45h0Zm0,.08,0,0s0,0,.09,0c-.11.07,0,0-.11.11s.07,0,0,0h0s0,0,0,0S59.12,187.09,59.06,187.12Zm0,.12h0l-.05,0Zm-.07-.43h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.36 173.35 87.36 173.35 87.36 173.35 87.36 173.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.59 186.62 60.59 186.62 60.59 186.62 60.59 186.62 60.59 186.61 60.59 186.61 60.59 186.61 60.59 186.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.52,187.91l0,0v0h0l0,.08h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,173.85a.06.06,0,0,0,0,0h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,173.86h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.59 186.6 60.59 186.6 60.59 186.6 60.59 186.6 60.59 186.6 60.59 186.61 60.6 186.6 60.59 186.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.33 188.68 57.33 188.69 57.33 188.68 57.32 188.69 57.33 188.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.05,185.17c0-.06,0-.12,0-.07s0,.12,0,.1,0,0,0-.14-.07,0-.11,0,0-.11-.06,0v0s0,0,0,0c-.19-.25-.59-.28-.82-.35s-.63-.17-.94-.28h0l-.11,0a.19.19,0,0,1,0-.07c0-.05,0-.08,0,0a.56.56,0,0,1,0,.08l-.13,0a0,0,0,0,0,0,0h0s0,0,0-.07a.18.18,0,0,0-.14,0h0s0,0,0,.06-.1.19-.06.25.1.09.18,0l0,0a2.44,2.44,0,0,0,1,.48,6.06,6.06,0,0,1,.75.27c.14.07.22.15.34.16v0c0,.06,0,0,0,0h0a.18.18,0,0,1,0,.06c0-.1,0,0,0-.07h0c0,.1,0,.11,0,.06,0,.12,0,.06,0,0s0,0,0-.11,0,.05,0,0,0,0,0-.07l0-.07S76.1,185.1,76.05,185.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,187.67s0,0,0,0,0,0,0,0l0,0s0,0,0,.07-.06,0,0,0l.06,0s0,0-.08,0,0,.09,0,.14-.11,0-.05.12l0,0,0,0s-.06,0-.07.09h0v.05s0,0,0,0l0,0c-.06,0-.07,0,0,.06s0,.05,0,0,0,0,0,0,0,0,0,.06,0,0,0,0,0,.1,0,0,0,0,0,.07c-.14-.1,0,.06-.06.1s-.2,0-.11.13c-.07-.05.05.13,0,0,0,.13-.1.14-.08.24-.17-.08-.09.19-.15.24s-.12,0-.12.08l0,0,0,0s0-.05-.07-.05-.14.06,0,.18,0,0,0,0h0s0,0,0,.09-.09,0,0,.11c-.11-.09,0,0-.06,0s0,.07,0,.07l0,0h0s-.11-.06,0,0,0,0,0,0,0,0,0,.05h0l-.06-.06c0,.06.06.15,0,.09.08.13-.09,0,0,.14s0,0,0,0h0l0,0s0,0,0,0,0,0,0,.08-.08,0,0,.08-.09,0,0,.05-.1,0-.12.08,0,.15-.07.2.06,0,.06,0-.06-.05-.08-.05c0,.2-.16.27-.14.5l0,.06,0,0a.33.33,0,0,1,0,.06s0,.08,0,.13l0,.05h0s0,0,0,0v0a.05.05,0,0,0,0,.07h0a.13.13,0,0,0,0,.06l0,0,0,0q0,.09.06.09a.22.22,0,0,0,.18-.13,1.42,1.42,0,0,0,.1-.29v0s0,0,0,0,0,0,0,0l0-.06h0s0,0,0,0a.14.14,0,0,0,0-.06h0v0h0v0A9.5,9.5,0,0,0,75,189.6c.15-.32.32-.65.48-1h0v0s0,0,.06,0l0,0v0h0v0s0,0,0,0v0s0,0,0-.07,0,0,0-.06v0s.07,0,0-.08h0s0,0,0,0h0c.06,0,.08,0,.05-.1.11.1-.06-.19.08-.1-.05-.05,0,0,0-.08s0,0,0,0,.09,0,.08-.08,0,0,0-.05S75.83,187.72,75.8,187.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.05,173.88l0,0S87,173.91,87.05,173.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,185.23v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.27,175.6s0,0,0,0,0,0,0,0,0,0,0-.05,0,0,0,.07,0-.07,0,0l0,.06s0,0-.06-.08,0,.07,0,.11-.07,0,0,.08,0,0,0,0l0-.08s0,0,0,0,0,.09,0,0a.84.84,0,0,1,0,.1c0-.1,0-.07,0,0,0-.06,0,.07,0,0s0,0,0,0,0,0,0,0v-.07s0,.06,0,.07h0v-.05s0,0,0,0h0v0h0c0-.06,0,0,0,0l-.05-.05h0a.63.63,0,0,1-.1-.25s0,0,0,0a.94.94,0,0,1,.21-.86s0,0,0,0,0,0,0,.06l.26-.2,0,0a0,0,0,0,1,0,0,.37.37,0,0,0,0-.08c0-.07,0-.08-.07,0l.05-.1s-.1,0-.14,0-.06,0,0-.07h0c-.06.19-.05,0-.1.05l0,.07a.12.12,0,0,0,0,.07c0-.09,0,.05,0-.07,0,.09,0,0,0,.13,0-.07-.05,0,0,.06s0-.07,0-.06,0,.07,0,.08,0,0,0,.07,0,0-.06.08a.78.78,0,0,0,0,.14s0,0,0,0-.1.13,0,.17c-.11,0,0,0-.12,0,.11,0,0,.08,0,.14a.1.1,0,0,0,0,.12v0s0,0,0,0,.07,0,0,0h0c-.12.1-.11.16,0,.12l-.09.06s.1,0,0,0c.09,0,.11,0,.09.14l.06-.06v0s0,.07,0,0v0c0,.07,0,0,0,0h0l0,.06s.07,0,0,.18c0,0,.07-.05.08,0v0a1.19,1.19,0,0,0,0,.19c0-.06,0,.06.07-.08h0s0,0,0,0h0a.05.05,0,0,1,0,0s0,0,0,0a.26.26,0,0,0,.11.08s0,0,0,0v0c.06,0,.12,0,.18-.14v0s0,0,0-.11c0,.1,0,0,0,0,0,.1.08.09.07,0,0,.08,0,0,0,0s0-.11,0,0c0-.07,0,0,0-.1,0,0,0,0,0,0s.08,0,.07,0,0,0,0,0S85.29,175.66,85.27,175.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.44,175.32v0h0l0,.08h0l0,0h0a.5.5,0,0,1,.07-.11s0-.07-.06-.14.06-.17,0-.18v0h0v0a.13.13,0,0,0,0-.14c0-.09,0-.17,0-.25s0-.08,0-.12h0v-.06h0s0-.07,0-.1,0-.07,0-.07h0a1.1,1.1,0,0,0,0-.18c0-.09.08-.18,0-.18a.25.25,0,0,0,0-.08h0s0,0,0-.06l0,0,0-.13c0-.1-.11,0-.13.08a.45.45,0,0,0,0,.16h0v0a1.82,1.82,0,0,0,0,.33h0l0,.06s0,0,0,.05h0a.07.07,0,0,0-.09,0c0,.05,0,.07,0,.1s0,0,0,.05,0-.12,0-.13-.2,0-.2.22c0,0,0-.06,0,0s0,0,0,0,0,.05,0,.06l0,.05s0,0,0,.08,0,0,0,0a.54.54,0,0,1,0-.13c0-.11-.13-.1-.11-.2l.05,0s0,0-.06,0c.14-.18-.06-.22.07-.31l-.27.15,0,0c0,.05-.06.21,0,.2l-.07.05a.74.74,0,0,0,.07.21.24.24,0,0,1,0,.12.31.31,0,0,1,0,.15c.07,0,.07,0,.06,0v0a.7.7,0,0,0,0,.12s.06.1.08.08,0,.05-.07.1,0,0,0,0,0,0,0,0v0l0,0a.1.1,0,0,0,0,0l0,0s.06,0,.06,0a.18.18,0,0,1,0,.07c.07,0,.06,0,0,.11s0,.11,0,.11,0,0,0,0h0l0,0s0,0,0,0,0,.09,0,.07h0l0,0,0,0h0c0,.05,0,.08,0,.08v0l0,0s0,0,0,0v0a.32.32,0,0,0-.05.16l.3-.17v-.09a1.57,1.57,0,0,0,0-.23.07.07,0,0,0,0,0v0h0l0,0a1.2,1.2,0,0,1-.08-.49h0s0,0,0-.05h0v0h0a.08.08,0,0,0,0-.05.44.44,0,0,1,.09-.11l0,0s0-.09,0-.1.14,0,.1-.13c0,0,0,.11,0,0,0,.2,0,.05,0,0s0,0,0,.12a.41.41,0,0,1,.17-.13h0c0,.06,0,.09,0,.09v0c0,.08,0,.13,0,.12v0h0v.06c0,.07,0,.12,0,.13v0s0,.06,0,.07v0l0,0,0,.08a.23.23,0,0,1,0,.07c.07-.05,0,.06.08,0s0,.09,0,.08a.26.26,0,0,0,0,.15.09.09,0,0,0,.08.06s0,0,0,.05h0l.15-.18s0,0,0-.09S86.44,175.31,86.44,175.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,193.08V193h0s0-.06,0,0v0h0s0,0,0,0h0v0s0,0,0,0,0,0,0,0v0l0,0h0s0,0,0,0,0,0,0,0,0,0,0,0h0c.14-.09,0,0,0-.07l0-.06h0c0-.07.11-.16,0-.12l0-.06s0,0,0,0a0,0,0,0,1,0,0h0v0s0,0,0,0h0s0,0,0,0a.06.06,0,0,0,0,0l0,0s0-.05,0-.07l-.07,0c.05,0,0,0,0,0s.05-.06,0-.05v0l0,0s0,0,0-.06,0,0,0,0h0s0,0,0,0h0c.07,0,.07-.07,0,0,.08-.06,0,0,0,0s.07-.14,0-.15l0,.05h0a.12.12,0,0,0,0,0s.08-.19-.07-.07c0,0,.07-.08,0,0h0l0,0s0,0,0,0,0-.1,0-.07h0s0,0,0,0l0,0s0,0-.06,0,0-.07,0-.05H62.9c.1-.07,0,0,0,0h0l0,0c-.1.07,0,0,0-.07s0,0,0,0h0l0,0s-.13.07,0,0c-.14.08,0-.12,0-.07l0,0h0l0,0h0s0,0,0,0a.2.2,0,0,0,0-.09v0s0,0,0,0v0c.06-.06,0-.1,0-.13l0-.12,0,0h0l.05,0c-.1,0,0-.22-.07-.29s0,0-.06,0a.21.21,0,0,0,.06-.16s0,0-.05,0h0s0,0,0,0l0,0s0,0,0,0l0-.05v0s.06-.16.06,0v-.32s0-.05-.06,0l-.17.34h0l-.07,0a.1.1,0,0,0,0,.07l0,0,0,0h0s0,.1,0,.09h0l0,0a.1.1,0,0,0,0,.07h0l0,0a.11.11,0,0,1,0,.05h0l0,.05c.07,0,.06,0,0,0h0l0,0s.05,0,.06,0,0,0-.06.06,0,0,.07,0,0,.05,0,0l-.07.05c.11,0,0,0,.06,0h0c0,.05,0,.1,0,.15l0,0h0s0,.08,0,.1v0a0,0,0,0,0,0,.05h0v.06c.07-.06,0,.06,0,.12s0,.06.07.07l0,0h0a.28.28,0,0,1,0,.08c0-.14,0,.17,0-.06,0,.12,0,0-.07.09,0-.31-.05,0-.07,0l0-.08v0h0v0c0,.05,0-.13,0,.1v-.07a.45.45,0,0,0,0,.13c0-.08,0-.1,0,.07,0-.21,0,.06,0-.09,0,.12,0,.1,0,.07v0h0c0-.1,0-.17,0,0h0v0h0v-.09s0,.21,0,0c0,.21,0-.08,0,0v0s0,0,0,0,0,0,0,.06c0-.12,0-.08,0,0,0-.07,0-.16,0,0,0-.13,0-.1,0-.08s0,.06,0,.07v0c0,.08,0,.09-.06.09l-.06.08s0,0,0,0v.06s0,0,0,0,0,0,0,0,0,0,0,.07h0l0,0h0l0,0s.09-.18-.06-.1c0,0,.08-.06,0,0h0v0l0,0h0s0-.06,0,0h0s0,0,0,0h0l0,0,0,0s.06-.09,0,0l0,0s0,0,0,0a.06.06,0,0,0,0-.08s0,0,0-.07v0h0c-.05,0-.05,0-.05-.09h0v0s0,0,0,0h0a.12.12,0,0,0,0-.14.5.5,0,0,0,0-.13s-.06,0-.07,0l.1-.06c-.12-.06.06-.31-.13-.35.09-.08,0-.14.06-.16s-.1,0-.09-.08l0,0s0,0-.06,0c.14-.13,0-.09.07-.17l-.26.15.05,0s-.05.12,0,.09l-.07.05c0,.06.14.07,0,.21.12-.05,0,0,0,.07s.05,0,.06,0,0,0-.07.06c.06,0,0,0,.08,0s0,0,0,0l-.07,0c.11,0,0,.06.08,0a.1.1,0,0,0,0,.07l-.09,0h0s-.05.1,0,.06l-.07.05s.14,0,0,.16c.12-.06,0,0,0,0s.05,0,.06,0,0,0-.06.05,0,0,.07,0h0s0,0,0,0h0l0,0,0,0a0,0,0,0,0,0,0h0l0,0s0,0,0,.05l-.05,0s0,0,0,0,0,.1,0,.09l0,0,0,0s.1,0,0,0l0,0a.17.17,0,0,0,0,.05s0,.06,0,.07v0l0,0h0s.07,0,0,0l0,0v0l0,.06h0s0,0,0,0l0,0v0h0s0,0,0,0h0l0,0a.28.28,0,0,1,0,.18c.12,0,0,.12,0,.26,0,0,0,.07.08,0-.07,0,0,0,0,0l0,0s0,0,0,0,0,0-.07,0c.12,0,0,.1.09,0-.15.12-.05,0,0,.06-.11,0,0,0-.09.08,0,0,0,.07,0,.09l.07,0s0,0,0,0-.06.08,0,.05c-.09.06-.07.08,0,.08s0,.06,0,0-.08.13,0,.07c-.09.07,0,.06,0,0-.1.08-.11.14,0,.12-.08.06,0,.06,0,.05s.07,0,0,.09c.07-.06,0,0,.07,0s0,.06,0,0,0,.15,0,.12c0,.12,0,.07,0,.06s0,0,0-.11,0,0,0,0a0,0,0,0,1,0,0h0a0,0,0,0,0,0,0s0,0,0-.07h0l0-.05,0-.07,0,0,0,0h0l0,0v0h0s0,0,0,0l0,0h0s.08-.08,0-.05l0,0,.07,0c.05,0,0-.05,0-.07s0,0,0-.06l-.07,0c.08,0,.07-.07,0,0s0,0,0,0,0,0,0,0,0,0,0,0l0,0s-.07,0,0,0,0,0-.06,0l.09-.07v-.07s-.08.06-.09,0,.15-.26,0-.13c.09-.1-.1.07,0-.07-.08,0,0-.11-.07-.08l0-.06h0c0-.06,0-.07,0-.08s0,0,0-.08h0s0,0,0,0h0v0l0,0v0s0,0,0,0h0v.07s0,0,0-.06h0s0,0,0,0,0,.05,0,.06,0-.06.06-.11,0-.12,0,0,0-.06,0-.08c0,.17,0,.15,0,0v.15s0-.16,0,0c0-.14,0-.18.07-.14a.31.31,0,0,1,0-.11s0,.13,0-.07h0v0s0,0,0,0h0c0,.15,0,0,0,0h0v.12s0-.05,0-.05h0s0,0,0,0l0,0c0-.21,0-.08.08,0,0-.07,0,.05,0-.13,0,.11,0,0,0,0a.15.15,0,0,1,0-.06v0s0,0,0,.11c0-.18,0,.05,0-.14,0,.2,0,0,0,0,0,.15,0-.07,0,.11,0-.08,0,.05,0,0a.46.46,0,0,1,0-.1c0,.07,0,0,0,0s0,.07,0,0c0,.13,0,.09,0,0,0,.09,0,0,0-.06s0,0,0,0h0s0,0,0,0,0,.13,0,.27c0,0,0,.07.08,0-.07.06,0,.05,0,.05a.12.12,0,0,1,0,0s0,0,0,0,0,0-.08,0c.12-.06-.05.11.09,0-.15.13,0,.05,0,.05s0,0-.08.1c0,0,0,.08,0,.1l.07,0s0,0,0,0,0,.1,0,.05c-.09.09-.07.1,0,.09s0,.06,0,0h0l0,0s0,0,0,0h0s0,.07,0,0h0s0,0,0,0h0c0,.07,0,.11,0,.08h0c0,.06,0,0,0,0h0l0,0,0,0h0c0,.07,0,.12,0,.09s0,.07,0,.06,0,0,0,0-.08.07-.08.09,0,.05,0,.07h0a.07.07,0,0,1,0,0h0l.05,0-.09.05h0l0,0h0l-.1.11s0,.06.07.06l0,0a.06.06,0,0,1,0,0,.05.05,0,0,0,0,0l0,.06a.12.12,0,0,1,.05-.05s0,0,0,0h0l0,.21.06-.34h0l0,0v0h0l.05-.28a0,0,0,0,0,0,0c.06-.05,0-.05,0-.05l0,0S63.08,193.09,63.06,193.08Zm-1.26.5Zm0-.46Zm0-.75Zm.07.29Zm0,0v0h0v0Zm0,0h0v0h0c0,.05,0,0,0,0h0Zm0-.38h0Zm.18-.12a.17.17,0,0,1,0,.08v-.09Zm.55-.51h0Zm0,.11h0Zm0,0a.22.22,0,0,1,0-.08h0v0h0v0h0v0A.1.1,0,0,0,62.7,191.75Zm0,.29h0Zm0,.06v0h0Zm0,0v0h0v0Zm.11-.6h0l0,0Zm.08,2h0Zm0,0h0v0S62.9,193.51,62.91,193.5Zm0-1.84h0Zm.05.11h0Zm0,1.09h0Zm0,.16h0l0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,189.26s0,0,.06,0c-.08.12-.08.14-.05.13s.08-.05.09,0,0,.11,0,.17,0,.05.08-.06c0,.08,0,0,0,0s0-.06,0,.06a.34.34,0,0,1,.12-.12.16.16,0,0,0,.07-.12c.06.09.11,0,.13-.06a1.29,1.29,0,0,1,.06-.22s.13-.09.13-.17h-.07s0,0,0,0,.06,0,.08,0a.71.71,0,0,1,0-.16c0-.06,0-.12,0-.1s0-.05,0,0,0,0,0,0,0-.06-.08,0,.06-.19-.05-.08c.12-.16,0,0,.05-.11-.08.09-.08.06-.07,0s0,.08-.05.08.11-.26,0-.12,0,0,0,0,0,0-.08.13l.1-.21-.07.06s0,0,0-.09c0,.1,0,.07,0,0h0v0s0,0,0,0,0,.11,0,.12,0-.11,0-.12,0,.05,0,.05,0,0-.06.06c0-.06,0-.07,0-.06a.13.13,0,0,0,0,.1s0-.06,0,0a.09.09,0,0,0,0,.11h0s0,0-.06.06h0c-.05,0-.05.14-.06.2s-.11.11,0,.15h0a.1.1,0,0,0-.05.13s0,.08,0,.12H57c-.08,0-.07.11,0,.06s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.05S57,189.2,57,189.26Zm.17-.25,0,0h0Zm.19.06a.17.17,0,0,0,.06-.06l0,0C57.42,189.07,57.37,189.09,57.33,189.07Zm0-.37s0,0,0,0l0,0s0,0,0-.06Zm.2,0a0,0,0,0,0,0,0l0,0s-.1.11,0,.09-.09,0,0,0c-.13,0-.05,0,0,0h-.09S57.54,188.67,57.55,188.66Zm0,.09v0l0,0a.15.15,0,0,1-.07.17.16.16,0,0,0,0-.12A.08.08,0,0,0,57.5,188.75Zm-.06,0h0A0,0,0,0,1,57.44,188.71Zm-.12-.22,0,0S57.31,188.49,57.32,188.49Zm0,0v0h0v0h0s0,0,0-.06l0,0h0s0,0,0,.06,0-.05,0-.07a.43.43,0,0,0,0,.15l0,0v.18h0l0,0v0a.06.06,0,0,1,0-.07l0,0h0s0,0,0,0l0,0h0a.13.13,0,0,1,0-.06h0s0,0,0,0h0S57.31,188.51,57.34,188.51Zm-.11.54h0l0,0v.09c0-.1,0,0,0,0v.06s0,0,0,0,0-.06,0-.11,0,.07,0,0,0,0,0,.09c0-.25,0-.07,0,0s0-.06,0-.06,0,0,0-.08,0,0,0,0Zm0,0v0l0,.06c0-.07,0,0,0,0s0-.09,0,0Zm0,0h0Zm0-.05h0Zm0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.91 178.33 70.91 178.33 70.91 178.33 70.91 178.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.35 188.62 57.35 188.62 57.35 188.62 57.35 188.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.59,190.88a.41.41,0,0,1,0-.08v0s0-.07,0,0,0,.05,0,0l.07-.06c.11-.13-.08-.09,0-.19l-.07.05c.08-.07.06-.11,0-.05s-.05,0,0-.06,0,0,0,0,0,0,0,0,0,0,0,0-.08,0,0,0,.06,0,.05,0c0-.2,0-.4,0-.6,0,0,0-.06,0-.08s0-.13,0-.2,0-.07,0-.08h0l0,0s.07-.17,0-.13h0s0,0,0,0h0c0-.61-.09-1.21-.15-1.78h0a1.79,1.79,0,0,1,0-.23h.1v0a.16.16,0,0,0-.1,0v-.08c0-.09-.11,0-.11.09h0v.05l0,0-.06.26s0,0,0,.05h0l-.07,0c0,.12.12.15,0,.31.12-.06,0,0,0,.09s0,0,.06,0,0,0-.07.07c.07,0,0,0,.08,0s0,.06,0,.05l-.07,0c.12-.06,0,.06.08,0a.12.12,0,0,0,0,.1.45.45,0,0,0,0,.11s0,0,0,0,0,.14.07.12h0s0,0-.08.08c.13,0,0,.08,0,.15s0,.12.07.16.07,0,0,.05l0,0h0c-.11.13-.1.19,0,.15h0l-.1.06s.11,0,0,0c.08,0,.11,0,.08.18h0s0,.08,0,.12h0l0,0s0,0,0,0,0,.05,0,.07a.65.65,0,0,1-.05.15c.07,0,.08,0,.06.09s0,0,0,.05,0,0,0,0a.61.61,0,0,0,0,.12s0,.07.08,0c-.07.06,0,0,0,.06s0,0,0-.05,0,0,0,0,0,0-.08.05c.12-.05,0,.11.09,0-.15.13,0,.05,0,.06s0,0-.09.1c0,0,0,.07,0,.11l.08-.05c0,.05,0,.05,0,0s-.06.09,0,0c-.1.08-.08.1,0,.1s0,.07,0,0-.08.14,0,.08c-.09.07,0,.06,0,0s-.1.16,0,.13c-.11.1,0,.05,0,.06s0,0-.06.05,0,0,.08,0c0,0,0,.05,0,.05s-.07.06-.07.09a.06.06,0,0,0,0,.07c0,.14,0,.12.09,0s0,0,0-.09,0,0,0,0,0,0,0-.06h0l0,0h0Zm-.32-3.37,0,0h0v-.05h0l0-.09a.08.08,0,0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.42 175.35 86.41 175.35 86.42 175.35 86.42 175.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.18,192.3s0,0,0-.05a.36.36,0,0,1,0-.09s0,0,0-.07,0-.08-.08,0a.27.27,0,0,0,0-.15s0,0-.06,0-.1.09-.12.06a.69.69,0,0,0,0-.1v0c.06,0,.08,0,0-.09s.1,0,0-.05.1-.06.12-.13a1,1,0,0,0,0-.3s-.06.05-.07,0,.08-.05.09-.06a1,1,0,0,0,0-.1.43.43,0,0,1,0-.07h0L64,191s0,0-.07,0a.1.1,0,0,0-.07.05.43.43,0,0,0-.08.14c0-.07,0-.08,0-.07l-.05,0s-.06.21-.09.21v-.07s0,0,0,.08c-.05-.17-.09.16-.11,0v.32s.07,0,.08-.09a.37.37,0,0,1,0,.11s.06-.1.09-.15,0-.07.07,0c0-.2,0-.05,0-.05a.36.36,0,0,0,0-.11c0,.11,0,0,0,.1,0-.1,0,0,0-.13,0,.09,0,.07,0,0l0,.11c0-.09,0-.08,0-.07s0,0,0-.06v0h0l0,0s0,0,0,0v0s0,0,0,.09,0,0-.1,0,0,.09-.06.12,0,.14-.05.21h0l0,0h0s0,0,0,0v0c-.07,0-.1,0-.07.12v0h0s0-.05,0-.05v0s0,.14,0,0c0,.1,0,.15,0,.2l-.07.23.1-.12a0,0,0,0,1,.07,0,.28.28,0,0,1,0-.09v.06c.06.05,0,0,0,0l0,0s0,0,0,0h0c0,.06,0,0,0,0h0a.35.35,0,0,0,0,.06c0-.07.1-.07.12,0,.11-.19.12,0,.08.13l.07-.09c-.06.09,0,0,0,0l0-.05s0,0,0,0,0,0-.07.06,0,0,0,0,0,0,.05,0c-.15,0,0,0,0,0s0,0,0,0,0,0-.05,0,0,0,0,0,0,0,0,0,.05,0,.05.05,0,0,0,0,0,0,0,.05h0v0s0,0,0,0,0,0,0,.07-.07,0,0,.08c0-.09,0,0,0,0-.05-.1-.06-.11-.07,0,0-.11,0,0,0,0s0,.13,0,0c0,.11,0,0,0,.13q0-.08,0,0c0-.11-.05-.09-.07,0,0-.12,0-.05,0,0s0,0,0,.1,0,0,0,0,0,0,0,.08v.07s0,0,0-.07c0,.07,0,.11,0,.06v-.1c0,.07,0,0,0,.13s.07-.06.11-.1h0s0,0,0-.09,0-.06,0-.06a.37.37,0,0,0,0,.09c0,.06.06,0,.08-.06s0-.12.07-.09l0-.08c0,.07.08,0,0-.06s0-.06,0,0,0,0,0,0,0,0,0-.07,0,0,0,0,0-.12,0-.05a.07.07,0,0,1,0-.05h0s0,0,0,0,.08,0,.07,0,0-.09,0-.12.07-.07.11-.14a.2.2,0,0,0,0-.08s0,0,0,0S64.2,192.31,64.18,192.3Zm-.45-.14h0s0,0,0,0h0v0Zm0,0h0Zm0,0h0Zm0,0h0v0Zm.06-.23h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.94,189.93s0,0,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,206.86h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.05 206.86 44.05 206.86 44.05 206.87 44.05 206.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7,207.7c.08-.06,0-.12,0-.14a.1.1,0,0,1,0,.08s0,0,0-.07,0,0,.07,0c-.12,0,0-.23-.1-.12.14-.18,0-.09,0-.14.11,0,0-.14.08-.16-.06-.06,0-.15,0-.24l-.07,0c0-.07,0-.08,0,0s0-.18,0-.15c.09-.1.06-.17,0-.2s0-.16,0-.13c.07-.15.08-.26,0-.22.08-.09,0-.1,0-.07.09-.13.1-.25,0-.3.16-.14-.15-.14,0-.33h0v0s0-.07-.06,0,0-.11,0-.09,0-.11,0-.12a.27.27,0,0,0,0-.12l0,0s0,0,0-.07,0,0,0,0,0,0,0-.08,0,0,0-.07-.05,0-.06,0l-.11.17v0l0,0s-.08.08,0,.06.08-.08.07-.05,0,.05-.09.09a.28.28,0,0,0,0,.09v0a.06.06,0,0,0,0,0,.14.14,0,0,0,0,.07s0,0,0,.06,0,0,0,0v0h0v0s0,.06,0,.1,0,.11,0,.09,0-.06,0,0l-.07.07a.32.32,0,0,0,0,.27.31.31,0,0,1,0,.23s.07,0,.08,0-.06.19,0,.12,0,0,0,.12,0-.06,0,0,0,.06,0,.14,0,0,0,0,.08.08,0,.1,0,.08.06.06c-.18.19,0,.15,0,.27a1.36,1.36,0,0,1-.06.33s0-.07,0-.07a.31.31,0,0,0,0,.1s0,0,0,0,.07-.09.07-.14,0-.31-.16-.16c0,0,0-.12,0,0a.05.05,0,0,1,0,.05.13.13,0,0,1,.05-.11c-.06,0,0-.05-.1,0,0-.09,0-.22-.1-.1.12-.18,0,0,0-.14-.08.09-.08,0-.08,0s0,.06,0,.06.13-.22,0-.13,0,0,0,0,0,0-.1.06l.13-.14c0-.06-.15,0-.05-.17-.14.05,0-.26-.09-.26s-.05.09-.07.07l.06-.1s0,0,0,0,0-.12-.08-.08a.23.23,0,0,0,0-.14s0,0-.07,0h0l0,0a.08.08,0,0,0,0-.1s-.08,0-.1.09-.07,0-.12.05a.64.64,0,0,0-.09.21.84.84,0,0,0,0,.26c0,.17,0,.31,0,.44s.06-.08.07-.05-.08.05-.1.08a1.49,1.49,0,0,1,0,.57.76.76,0,0,0,0,.15c0,.05,0,.11,0,.16a.94.94,0,0,0,.06.3.48.48,0,0,0-.07.26c0,.07,0,.14,0,.16s.08.19.1.29h0l0,0h0l-.05,0s0,0,0,0l0,0,.15.15c0-.05,0-.09,0-.09l.07-.06c0-.2-.13-.37,0-.64h0a0,0,0,0,1,0,0s0,0,0-.06,0-.11,0-.15,0-.17,0-.16,0-.08.07-.08,0-.06-.06-.06,0-.11,0-.16.07,0,.07,0,0-.17-.07-.18a1.45,1.45,0,0,0,0-.54s0,0,0,0,.06-.37-.1-.4c.08,0,.06-.06.08-.09a1.64,1.64,0,0,1,.16.18c0,.05.09,0,0,.11s0,0,.05,0c-.08.21-.05.35.08.33l-.09.09s.12,0,0,.06v0c.13.1.16.1.22.34,0,0,.06-.08.07-.08s0,.29.1.08c0,0,0,.17,0,.09-.11.18,0,.09,0,0s0,.06-.07.14a.35.35,0,0,1,.16.16.88.88,0,0,1,0,.24.47.47,0,0,1,.14.08v0h0v0a.14.14,0,0,0,.11,0h0l0-.11c0-.1,0-.21.07-.35S44.82,207.63,44.7,207.7Zm-1.12-1.44h0s0,0,0,0Zm0,.07h0Zm.39.6Zm.55.73h0l0,0a.11.11,0,0,1,0-.05h0C44.44,207.63,44.6,207.61,44.53,207.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.53,205.09h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.49 209.15 43.49 209.15 43.49 209.15 43.49 209.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.32,209.16a.34.34,0,0,1,0,.09l.07-.14-.11.06S43.32,209.15,43.32,209.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.41,209.23v0l.07-.06a.1.1,0,0,1,0-.12l-.13.07v.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4,209.1a.31.31,0,0,1,.05-.12h0l-.06.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,206.85h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 202.28 47.95 202.28 47.95 202.27 47.94 202.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1,201.33h0C47.13,201.26,47.16,201.13,47.1,201.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.89,202.34c0-.09,0-.11,0-.07C48,202,47.9,202.22,47.89,202.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,201.2a.27.27,0,0,1-.05.12h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.08,202l-.06.15c0-.09.06-.13.07-.13v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.48,199.14h0l.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,202.51h0s0,.08,0,.14A.24.24,0,0,1,47.93,202.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.29,198.41c0,.12,0,.18-.07.18a2.08,2.08,0,0,1,.12-.32c0-.06-.05.15-.05.09s0-.07.05-.14,0-.12,0,0,0,0,0-.06c-.1.3,0,0-.13.23a.7.7,0,0,1,0-.14c0,.06,0,0,0,0a1,1,0,0,0-.06.19c.05-.18,0,0,0-.1a.36.36,0,0,0,.05-.09s0,0-.05,0,0-.11,0,0a.63.63,0,0,1,0,.14c0,.05,0,0,0,.05s-.06.17-.07.19.05-.16,0-.2,0,.15-.06.15a1.35,1.35,0,0,0,.08-.24c0,.1,0-.24,0-.14s0,.1,0,0c-.06.17,0,.25-.07.29s0-.14.06-.29c0,.07,0,0-.05.05s0,0,0,.05,0,.13-.06.1a1.31,1.31,0,0,0,.07-.19c0-.05-.05.12-.06.14,0-.14.06-.28,0-.14s0,0,0,.09v0c0-.16,0-.24,0-.19v0c0-.12-.07,0-.08,0-.05.16,0,.06,0,.19,0,0,0,0,0,0a.82.82,0,0,1,0,.14c0,.06,0-.11-.06.11,0-.2,0,0,0-.14a1.65,1.65,0,0,1,.06-.24c0-.07-.05.21-.06.2s0-.21,0,0c0,0,0,0,0,0s0-.16,0,0c0-.25,0-.1-.06,0s0,0,0,0l0-.07s0,0,.06-.15l0-.14c0-.05,0-.08-.06.09.06-.14.09-.26.05-.15a1.77,1.77,0,0,1-.08.22c.05-.14,0,0,.1-.29,0-.12,0,0-.09,0s.06-.28-.07,0l-.05.14s.08-.2.08-.22c.11-.34-.15.18-.06-.09,0,.08-.08.2-.09.22.09-.24.05-.22,0,0,0-.15-.07.13,0-.14,0,0,0,.11,0,0s0-.05,0,0l.06-.14c-.07.15-.12.21,0,0-.06.11,0,0-.09.16.23-.6,0,0,0,0s.15-.6,0-.17c.11-.29-.15.31,0-.14-.12.19,0-.12-.15.07.1-.32.07-.32,0-.26s-.13.19-.13.13,0-.34,0-.25l-.07.22,0,.09a1.3,1.3,0,0,0,.08-.31c0,.1,0-.32-.12.14h0l0,0a.43.43,0,0,0,0,.05v0a1.78,1.78,0,0,0-.08.18c.13-.35,0-.09,0-.13h0c-.07.17-.06.12,0,.06l-.08.18c.1-.24.19-.53.06-.21,0,0,0-.11,0,0-.1.27,0,0-.12.3l.17-.45c0,.08-.18.4-.06,0-.17.41,0-.21-.08,0,0,.08-.07.21-.09.23l.08-.22s0,.08,0,.08,0-.08-.07.09c.09-.26,0-.22,0,0,.06-.14.11-.35,0-.06.09-.29,0-.26,0-.25s-.09.05-.12.05-.06.21-.07.23a1.75,1.75,0,0,1,.1-.3c0,.07-.07.1-.09.1l0,0h0v0h0l0,0h0s0,0,0,0h0s0,0,0,0v0h0s0,0,0,0h0v0h0a.23.23,0,0,0-.06-.18s.06-.07,0,0,0,0,0-.07,0,0,0,0-.05,0-.05,0,0-.07,0-.09,0,0,0,0,.08-.1,0,0,0-.06,0,0,0-.06,0-.12,0,0,0,0l0,0s.07-.07,0,0c.11-.07,0,0,.05-.07l-.08,0,.06,0c0-.05.06-.15,0-.14.1-.08,0,0,0-.09s0,0,0,0,0,0,0-.08l0,0,0,0s0,0,0,0,.05-.08,0-.1l0,0c.06-.08,0-.08,0-.14h0s-.05,0,0-.08,0,0,0,0,0,0-.07,0l.06,0s-.07,0,0-.09,0,0,0,0l0,0,0,0c0-.05,0-.08,0-.11s0,0,0,0a.16.16,0,0,0-.08,0c.08-.06,0,0,.07-.08h0c.06,0,0,0,0,0l0,0h0l0,0s0,0,0,0-.06,0,0,0l-.07,0,.1-.07s0,0,0,0l-.05,0s0,0,0,0,0,0,0,0l0,0-.07,0c.06,0,0,0,0-.06s0,0,0,0,0,0,0,0,0,0,0,0l.06,0s0,0,0,0-.06,0-.07,0,0,0,0,0l-.07,0h0l0,0s0,0,0,0l.06,0,.07-.05s0,0,0,0,0,0,0,0l0,0s0,0,0,0l0,0,0,0,0,0,0,0,0,0s0,0-.06,0,0,0,0,0h-.05l.1-.06s0,0-.06,0l0,0s0,0,0,0l-.1.05h0s0,0,.06,0-.05,0-.06,0l0,0c.09-.05,0,0,0-.05s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l0,0c-.06,0,0,0-.05,0s0,0,0,0h0l0,0s0,0,0,0a0,0,0,0,0,0,0c-.05,0,0,0-.07,0h0l0,0-.06,0h0s0,0,0,0l.06,0s0,0,0,0-.07,0-.08,0,0,0,0,0a.05.05,0,0,0,0,0l-.06,0h0l.08,0h0s0,0,0,0l-.05,0s0,0,0,0h0l0,0h.05s0,0-.06,0a0,0,0,0,1,0,0l0,0h.09s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0-.06h0s0,0,0,0,0,0,0,0,0,0,0,0l0,0c-.06,0,0,0-.05,0s0,0-.06,0h0l.06,0h0s0,0,0,0,0,0-.09,0,.06,0,.06,0l-.08,0h0s0,0,0,0,0,0,0,0,0,0,.06,0l-.09,0h0c.07-.06,0-.05,0-.07l0,0h0l-.16.09,0,0s-.05.11,0,.15l0,0v0l0,0a.35.35,0,0,0,0,.13.32.32,0,0,0,0,.15,1.2,1.2,0,0,1,0,.37,1.06,1.06,0,0,0,0,.26s0,0,0,0h0l0,0c.05,0,0,0,0,0l0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0h0l0,0h0v0l0,0h0v0s0,0,0,0h0c0,.06,0,.08,0,.12h0s0,0,0,0h0s0,0,0,0,0,0,0,0a.11.11,0,0,1,0,0s0,0,0,0h.06l0,0s0,0,0,0h0l0,0c.05,0,0,0,.05,0l0,0,0,0a.2.2,0,0,0,0,.08.22.22,0,0,1,0,.08h0s0,0,0,.06h0s0,0,0,0l0,0h0l0,0s0,0,0,0,.06,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0l0,0h0s0,.06,0,.06,0,0,0,0v0h0s0,0,0,0h0s0,0,0,0h0s-.05,0,0,0,0,0,0,0h0s-.07.06-.06.07,0,0,.07,0h0v0h0s0,0,0,0,0,0,0,0h0s0,0,0,0l0,0h0s0,0,0,0h0v0l0,0h0c-.07.05,0,0,0,0h0v0l0,0s-.08.06,0,.06,0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0-.06.1,0,.06,0,0,0,0h0a.11.11,0,0,0,0,0h0l0,0s0,0,0,0,0,0,0,0l.06,0h0l0,0h0l0,0s0,0,0,0,0,0,0,0,0,0,0,0h0a0,0,0,0,0,0,0h0s0,0,0,0h0l-.05,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0-.06,0a.18.18,0,0,1-.06-.08c0,.1,0,.07,0,.08v.07s0-.1,0,0v-.12h0s0,0,0-.09,0,.06,0,.07,0-.05,0-.12,0,.06,0,0a.11.11,0,0,0,0,0s0,0,0,0,0,0,0,0,0,0,0,.12l0,0s0,0,0,0,0,0,0,.05h0s0,0,0,0,0,0,0,0,0,0,0,0h0l0,0h0s0,0,0,0,0,0,0,0h0l0,0s0,0,0,0h0l0,0s0,0,0,.05h0s0,0,0,0h0s0,0,0,0h0v0s0,0,0,0h0s0,0,0,0l0-.06s0,0,0,.11a.37.37,0,0,0-.07-.1c0-.06,0,0-.05-.06s.05-.16,0-.06,0,0,0,0l.07-.08c0-.07,0-.08,0-.09s0,0,0,0h0s0,0,0,0h0a.12.12,0,0,1,0,0l0,0h0s0,0,0,0,0,0,0,0h0c0-.05,0,0,0,0h0l0,0h0s0,0,0,0h0s.08-.06,0,0v0s0,0,0,0h0l0,0h0v0s0-.05,0,0l.09-.05s0,0-.06,0,0,0,0,0h0c.09-.06,0,0,.08-.1s0,0,0,0h0v0h0l0,0s0,0,0,0h0l0,0a.27.27,0,0,0,0-.08c-.06,0,0,0-.07,0s0-.09,0-.09,0,0,0,0,0,0,.06,0h0l-.06,0s0,0,.06,0h0s0,0,0,0,0,0,0,0l-.06,0h0s0,0,0,0h0l0,0s0,0,0,0h0l0,0c.08-.08,0-.07,0-.08h0s0,0,0,0l0,0v-.06h0a0,0,0,0,0,0,0h0l0,0s0,0,0,0h0s0,0,0,0h0l0,0c-.06,0,0,0,0,0h0l0,0,0,0h0l0,0,0,0h0l0,0h0s0,0,0,0h0s.07-.05,0,0h0l0,0h0l0,0c.07,0,0,0,0,0h0l.06,0-.06,0h0l0,0s0,0,0-.05,0,0,0,0-.06,0,0,0l-.06,0h0l0,0,0,0-.08,0s0,0,0,0h0s0,0,0,0h0l.05,0h0l-.05,0h0l.05,0,0,0h0s0,0,0,0l0,0h0l0,0h0l0,0s.05,0,0,0l0,0,.06,0-.06,0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0l0,0h0l-.07,0h0l.06,0s-.06,0,0,0,0,0,0,0,0,0,0,0l0,0s0-.05,0-.05,0,0,0,0l-.07,0,.06-.05h0c.06,0,0,0,0,0l0,0h0s0,0,0,0-.06,0,0,0l-.07,0h0l.09-.07h0l0,0,0,0c-.08.05,0,0,0,0l0,0-.08,0c.06,0,0,0,0,0s0,0,0,0l0,0s0,0,0,0l.06,0s0,0,0,0l-.08,0h0l0,0-.08,0h0l.07-.05s0,0,0,0,0,0,0,0l0,0s0,0,0,0l0,0,0,0,0,0s0,0,0,0l0,0-.06,0s0,0,0,0h0l.07,0-.06,0h0l0,0s0,0,0,0l0,0h0c.08-.05,0,0,0,0s0,0,0,0h0l0,0,0,0h0s0,0,0,0h0v-.07s0,0,0,0a0,0,0,0,0-.06,0h0c.07-.05,0,0,.07-.06-.06,0,0,0-.08,0h0c.05,0,0,0,0,0h0l0,0c-.11,0,0-.06-.08,0h0a.14.14,0,0,0,0-.06l-.23.13a.64.64,0,0,1,0,.07v.06h0c.07,0-.06.16.1.12-.11.05,0,0-.11.08s.06,0,.06,0,0,0,0,0,0,0,0,0a.21.21,0,0,0,0,.07.08.08,0,0,0,0,0h0a.15.15,0,0,0,0,.07h0c0,.05,0,.11,0,.07l0,0c0,.07,0,.11,0,.1h0l-.08,0s.1,0,0,0c.07.07.09.07.05.2l.06,0h0s-.07.11,0,.07a0,0,0,0,0,0,0h0c-.1.05-.07.05,0,0h0l-.06,0s0,.12,0,.24c.13,0,0,.14,0,.3,0,0,0,.07.08,0-.07,0,0,0,0,.06s0,0,0,0,0,0,0,0,0,0-.08,0c.12,0,0,.11.09,0-.15.13,0,0,0,.06s0,0-.09.1c.06,0,0,.07,0,.11l.07-.06c0,.05,0,.05,0,0s-.06.1,0,.05c-.09.09-.06.1,0,.1s0,.06,0,0h0c0,.08-.06.12,0,.09a.22.22,0,0,0,0,.08s0,.05,0,.05h0s0,0,0,0h0s0,0,0,.05,0,0,0,0l0,0h0l0,0s0,0,0,.09,0,0,.05,0-.05,0,0,0h0a.12.12,0,0,0,0,.14c-.06,0,0,0,0,0l.07,0c-.07,0,0,0-.06.09s0,0,0,0,0,0,0,0l0,0h0l0,0s0,0,0,0c-.11-.16,0,.15,0,.18s-.28-.21-.14.06c-.1-.16.09.26-.06,0,0,.2-.12.09-.09.27-.24-.34-.09.19-.17.18s-.16-.11-.15,0l.08.13s0,0,0,.07a.89.89,0,0,0-.1-.18c0,.09-.18-.08,0,.23,0,0-.09-.14,0,0,0,0,0,0,0,0s-.05,0-.08-.12c0,.11,0,0,.06.19-.07-.1-.12-.08,0,.15-.15-.27,0,.08-.09-.1.09.16.06.15,0,.13a1.33,1.33,0,0,1,.06.12c-.09-.16-.2-.3-.09-.1,0,0,0-.08,0,0s0,.06.06.13h0l-.11-.2c0,.09.11.3,0,.1.12.3-.12,0-.05.16a1.32,1.32,0,0,1,.08.14,1.48,1.48,0,0,1-.08-.13s0,.07,0,.07-.05,0,0,.12c-.1-.13-.11,0-.06.07,0-.1-.14-.17,0,0-.12-.15-.14-.06-.16,0s0,.16-.07.21.09.11.09.13S51,200,50.93,200c0,.31-.18.21-.16.52a.08.08,0,0,0,0,0v.15c-.06,0-.07.06-.09.05s.07.29,0,.31l-.05-.09c0,.06,0,0,0,.12,0-.06-.08-.07-.09-.05l0,0v0s.14,0,0,.12l.21-.12v.15a.17.17,0,0,0,.11,0l0,.06v.08a.2.2,0,0,1,0,.07v0l0,0,0,0,0,.08a.25.25,0,0,1,0,.07,1,1,0,0,0,0-.19h0l0-.09v0l.06,0a.44.44,0,0,1-.05-.09v0h0l0,0s0,0,.06,0,0-.07,0-.12v0s0-.08.06.07c0-.11,0-.05,0-.12h0s0,0,0,0v0l0,.08,0-.1h0v0s0,0,0,0l.09-.19a.08.08,0,0,1,0,0l0,0a.15.15,0,0,1,0-.06l0,0,0,0v0h0l0,0,0,0,0-.05.07-.09h0s0-.07,0-.13l.05-.07.07-.1s0,0,0,0l0-.05v0a.08.08,0,0,0,0,0v0a2,2,0,0,0,.23-.58.08.08,0,0,0,.08,0h0s0,0,0-.09,0-.1.12-.06c-.1-.12,0,0,0,0a0,0,0,0,0,0,0l.08,0c0-.11.07,0-.06-.21.08.14,0,0,0,0l0,0v0h0a.75.75,0,0,0,.08.14c-.11-.24.09,0,0-.2h0c.14.21.07.09,0,0h0c0,.08,0,0,0,0h0s0,0,.06.1c0-.13.07,0,.08,0a.59.59,0,0,1-.07-.14c.06.09,0,.07,0,0,.08.1.1.06,0-.08.11.16.11.1.08,0,.07.09,0,0,0-.09h0c.08.08.12.06,0-.07v0c.05.06,0,0,0,0h0c.08.09.1.06.06-.07h0c.07.1,0,0,0,0a.05.05,0,0,1,0,0h0s0,0,0,0c-.06-.17.06,0,0-.13a0,0,0,0,1,0,0h0s.06,0,.05-.06,0,0,0,0,.06,0,.07,0h0s0-.06,0,0-.07-.16,0-.19a1.27,1.27,0,0,0,0,.14.11.11,0,0,1,.07,0V198l0,0h0v.1h0s0,0,0,0a.17.17,0,0,0,0,.07s0,.07,0,.07v-.09h0s0,0,.06-.08h0a.63.63,0,0,1,0,.13c.05-.12,0-.09.05-.1h0l0,0,0,.09a.34.34,0,0,1,0-.08h0l.07,0s0,0,0,0h0s0,.06,0,.18c0-.07.06-.1.08-.11l-.08.12s.07-.07.09-.11,0,.22.06.22l0,0h0a.07.07,0,0,1,0-.05c0,.2.16,0,.2.14a.17.17,0,0,1,0,0c0,.13.14-.14,0,.19,0-.07,0-.1,0,.05a.67.67,0,0,1,.11-.24,1.37,1.37,0,0,0-.05.19c.07-.12.16-.17.11.1.07-.16.06-.06.1-.15,0,.14,0,.17,0,.1a1.24,1.24,0,0,1,0-.15c0,.15,0,.2.13.15-.08.2,0,0,0,.14a.91.91,0,0,0,.1-.24c-.06.25,0,0,0,.24,0,0,0-.1,0-.1-.06.19,0,0,0,0s0,.07,0,.14,0-.07,0-.09a.46.46,0,0,1,0,.09s0,0,0,0h0s0,0,0,.06c.05-.2.08-.19.09-.12s0-.18.06-.23h0c0,.14,0,.14,0,.32,0,0,0-.07,0,0s0-.11,0-.14,0,.06,0,.13c.06-.25,0,.14.05-.1,0,0,0,.11,0,.14s.07-.26.09-.25c-.06.2,0,0,0,.18,0-.17,0,0,0,0,.06-.22,0,.11.06-.15,0,0,0,.09,0,0a1.93,1.93,0,0,0,0,.2s0,.09,0-.05c0,0,0-.21.06-.25s0,.11,0,.05a2.15,2.15,0,0,0,.06-.29s0,0,0,0c-.08.23,0-.07,0,0a.73.73,0,0,1-.07.2,1.39,1.39,0,0,0,0,.23s0,0,0,.06,0,0,0-.06,0-.06,0-.14,0,.11,0,.09,0-.14.05-.14l0,.14c0,.09,0,.1,0,.15s0-.13,0-.15,0,0,0,.14,0,0,.1-.19c0,0,0,0,0,0s0-.07.07-.15c-.08.27,0,.15-.08.34,0-.19,0-.12.09-.2l0,.15c0-.12,0,0,0,0a.89.89,0,0,1,.05-.13c-.09.28,0,.06,0,.09s0,.1,0-.05c0,.15,0,0,0,0,0,.11,0,0,0,.15,0,0,0-.13,0-.14a1.21,1.21,0,0,0,0,.14c.08-.19,0,0,.06-.19,0,.13.06-.15.09-.18s0,.08-.08.23c0-.05,0-.05,0,0s0,.06,0,.05C55.22,198.51,55.23,198.68,55.29,198.41Zm-.67-.07v0l0,0Zm-1.25-2.94,0,0c.06,0-.1.07-.06,0S53.34,195.42,53.37,195.4Zm-.11-.41s0,0,.05,0l-.06,0Zm0,.08Zm-.21,1.9h0Zm0-.34s0,0,0,0,0,0,0,0h0Zm-.53-.19,0,0s0,0,0,0Zm0,0h0l0,0h0l0,0,0,0h0Zm0,0Zm0,0h0Zm0,0h0Zm0-.31Zm.06-.63h0l0,0h0Zm0-.06-.05,0h0Zm-.06,0s0,0,0,0l0,0h0Zm0-.09Zm0,0,0,0h0Zm0,0h0Zm0,0h0Zm0,0Zm0,0h0Zm0,0h0Zm0,0h0l0,0s0,0,0,0Zm0,0h0l0,0h0Zm-.06.42h0l0,0Zm0,0h0Zm0,0h0l0,0Zm0,1h0Zm-1.62,3.87a.09.09,0,0,1,0,.05h0Zm0,.38h0l0,0h0Zm.93-1.82h0Zm.45-1.07Zm0,0h0S52.16,198.16,52.17,198.14Zm0,.07h0l0,0h0s0,0,0,0Zm0-.08h0l0,0h0Zm0,.06h0v0Zm0-.07h0Zm.07-.2s0,0,0,0h0Zm0,.09h0Zm0-.35Zm0,.36h0l0,0Zm0,.08Zm0,0h0Zm0,0h0S52.28,198.11,52.28,198.1Zm0,0h0Zm0,0Zm0,0h0Zm0-.11h0Zm0-.16h0Zm0,0Zm0-2h0Zm0,1.36v0h0v0Zm0,.06h0l0,0h0l0,0Zm0,.53Zm0,0h0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0-.23h0s0,0,0,0Zm0,.27h0Zm0,0h0v0Zm.15-.23c0-.05,0,0-.08-.12h0v0l.08.11Zm.07,0Zm0,0Zm0,0,0,0s0,0,0-.05,0,0,0,0,0,0,0,.06l0,0Zm0,0v0h0v0Zm.13-.33h0s0,0,0-.08l0,.08S52.86,197.37,52.86,197.39Zm.09.12v-.07s0,0,0,.08Zm0,.57V198S53,198,53,198.08Zm.07-.63Zm0,.57h0Zm0,0,0,0h0v0Zm0,0h0Zm.17-.78h0l0,0h0Zm0,.06Zm0,0Zm0,0h0Zm0,0h0Zm0-.1h0v0h0S53.28,197.23,53.25,197.25Zm0,0h0l0,0h0l0,0Zm0-1.91s0,0,0,0,0,0,0,0l0,0,0,0s0,0,0-.05l0,0S53.22,195.32,53.27,195.3Zm0,.28h0a.17.17,0,0,1,.07,0Zm0,0h0C53.31,195.54,53.28,195.56,53.25,195.59Zm0-.07s0,0,0,0Zm0,0h0l0,0s0,0,0,0Zm0,.2s0,0,0,0l-.08.06v0Zm0,0h0l0,0h0Zm0,0s0,0,0,0h0S53.23,195.71,53.23,195.7Zm0,.17h0Zm0,0h0l0,0S53.27,195.9,53.24,195.91Zm0,0h0Zm0,0,0,0h0l-.06,0Zm0-.08h0s0,0,0,0h0s0,0,0,0,0,0,0,0a0,0,0,0,1,0,0Zm0-.06,0,0v-.06h0s0,0,0,0h0c.1,0,0,0,.08,0C53.24,195.79,53.22,195.82,53.25,195.8Zm0-.31h0l.05,0S53.28,195.49,53.28,195.49Zm0-.06s0,0,0,0,0,0,0,0l0,0v0s0,0,0,0h0v0s0,0,0,0l0,0c-.06,0,0,0,0,0l0,0-.05,0C53.33,195.38,53.26,195.43,53.27,195.43Zm0-.06h0l0,0S53.33,195.35,53.29,195.37Zm0,0,0,0h0l0,0h0l0,0Zm0,.25s0,0,0,0l0,0a.05.05,0,0,1,0,0Zm0,.38h0l0,0h0s-.07.06-.06.07h0l0,0Zm0-.8h0l0,0h0l0,0h0Zm0,1.89v0h0v0Zm0,.08h0v0h0Zm0,0Zm0,0s0,0,0,0v0h0Zm0,0h0Zm0-.1Zm0,0h0l0,0Zm0-.11h0l0,0h0Zm0,.09Zm0-.35h0Zm0-.19h0Zm0,.21Zm0-.3h0l0,0h0S53.18,196.36,53.21,196.35Zm0,0h0Zm0,0h0Zm0,.16h0Zm0,.43h0Zm0-.61Zm0-.36Zm0,0h0Zm0,.9h0Zm0,.27,0,0h0l0,0h0s0,0,0,0Zm0,.08h0v0S53.19,197.2,53.2,197.18Zm0,0h0v0S53.2,197.18,53.2,197.17Zm0,0h0Zm0-.05,0,0h0Zm0-.93h0a0,0,0,0,1,0,0h0Zm0,.07h0Zm0,0Zm0,0h0l.05,0A.13.13,0,0,1,53.2,196.12Zm0,0h0Zm0,0s0,0,0,0,0,0,0,0Zm0,0h0Zm0-.09h0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0l0,0h0l0,0h0l0,0h0s0,0,0,0,0,0,0,0l0,0c.06,0,0,0,0,0Zm.05-.61h0Zm0-.13,0,0,0,0,0,0Zm-.1,0,0,0s0,0,0,0,0,0,0,0l0,0h0l0,0h0s0,0,0,0Zm0-.08Zm0,0Zm0,0h0s0,0,0,0Zm0,0,.06,0-.06.05h0Zm0,0h0Zm0-.2h0Zm0,.07h0Zm0-.07h0Zm0-.16Zm0-.09,0,0h0Zm0,0c-.05,0,0,0,0,0h0S53.2,194.73,53.2,194.74Zm0,0h0s0,0,0,0,0,0,.06,0,0,0-.06,0h0s0,0,0,0Zm0,2ZM53,194.89l0,0,0,0s0,.05,0,0,0,0,0,.08A.14.14,0,0,1,53,194.89Zm0,.11Zm0,.1a.07.07,0,0,0,0-.07h0Zm0,3h0Zm0-.07h0Zm0-2.5h0Zm0-.83Zm0,2.49h0l0,0h0Zm0,0Zm0,0h0Zm0,.06,0,0h0s0,0,0,0h0s0,0,0,0l0,0Zm0,0h0S53.2,197.29,53.2,197.3Zm0,0Zm0,0Zm0,0h0l0,0,0,0Zm0,0Zm0,0h0Zm0,0s0,0,0,0h0Zm0,0Zm0,0h0s0,0,0,0S53.25,197.35,53.23,197.37Zm.06-.05Zm.11.79,0,0s0,0,0-.07Zm0-.07a0,0,0,0,0,0,0s0,0,0,0Zm0-.25Zm.11.26v0s0,0,0,0a.69.69,0,0,0,0-.13h0A.11.11,0,0,1,53.55,198.05Zm.08,0V198A.09.09,0,0,0,53.63,198.09Zm.13-.05s0,0,0,.05,0,0,0-.05a.19.19,0,0,0,0,.09c0,.06,0,0,0,0s0,0,0,.05,0-.05,0-.05,0-.07,0-.11h0Zm0,.24c.06-.22.05-.3,0-.19,0-.14,0-.13,0-.14s0-.09,0-.1,0,.32.07-.11c0,0-.07.3,0,.06-.12.44,0,.14,0,0,0,.15,0,.09-.08.3,0-.1.09-.11.08,0S53.91,198,53.8,198.28Zm.24-.15h0l0,.13a.13.13,0,0,1,0,.06.69.69,0,0,1,0-.23Zm.05.19v-.06s0,0,0,0A.14.14,0,0,1,54.09,198.32Zm0-.1h0a1.28,1.28,0,0,1,0-.13s0,0,0,.07Zm0,0h0a1,1,0,0,0,0-.1Zm.2.36s0,0,0,.07,0,0,0,0,0,0,0-.15l0-.05h0Zm0-.23h0Zm.08.18s0,0,0,0v0h0v0A.22.22,0,0,1,54.44,198.54Zm.06-.11v0l0,0S54.5,198.42,54.5,198.43Zm.16,0c0,.11-.06.23-.07.2s0-.12,0-.15,0,0,0-.14S54.65,198.44,54.66,198.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.13,200.93s.09-.13-.05-.05l0,0,0,0s0,0-.08,0h0c.05,0,.07-.07,0,0h0s0,0,0,0h0l0,0,0,0v0s.05-.05,0,0h0l0,0h0v0l0,0h0v0s0,0,0,0h0v-.05h0v0h0l0,0v-.1s0,0,0,0a0,0,0,0,0,0,0,.22.22,0,0,1,0-.08.23.23,0,0,1,0-.07h0l0-.06s0,0-.06,0,0,0,.07,0h0l-.32.18s0,0,0,0,0,0,0,0-.07,0-.07.05,0,0,.08,0l0,0h0s0,0,0,0h0s0,0,0,0h0s-.08.05,0,0h0l0,0,0,0c-.2.12,0,0,0,0s-.1.06-.07.05l.07,0,0,0-.09.06.05,0s-.06,0,0,0h0l.08,0h0s0,0,0,0h0l0,0,0,0h0s0,0,0,0h0l0,0h0s0,0,0,0h0l-.09,0,0,0s-.06,0,0,0l-.07,0s.13-.07,0,0c.12-.07,0,0,0,0l0,0h0l0,0,0,0h0l0,0,0,0v0s0,0,0,.05h0l0,0h0a.09.09,0,0,0,0,0s0,0,0,.05a.41.41,0,0,1,0,.11s0,0,0,0v0h0c0,.17,0,.34,0,.51h0a1.28,1.28,0,0,1,0,.19s0,0,0,0h0v.15c0,.09.07.15.13.1h0c-.08.07-.07.09,0,.08s0,0,0,0,0,0,.07,0h0s0,0,0,0,0,0,.05,0,0,0,0,0,.08-.06.05,0l-.07.05s0,0,.09-.07,0-.05,0-.07.07-.12,0,0,0,0,0,0h0l.05,0c.1-.12-.08,0,0-.12l0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0v0h0v0h0v0c.07-.06,0,0,0,0h0v0c0-.05.1-.12,0-.06s0,0,0,0h0l0,0c-.06,0,0-.1,0-.1h0c.08-.08.08-.1.06-.11h0v0h0s0,0,0,0,.1-.11.07-.12l-.07,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.34,204.8h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.68 197.41 56.67 197.41 56.67 197.41 56.68 197.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.13,199.48l0,0,.06-.07h0l.11-.06v0h0v-.08l0,0s0-.05,0-.08h0c0-.11-.06-.2-.07-.32a.41.41,0,0,1,.05-.17h0l0-.06h-.06a.83.83,0,0,0,0-.15.08.08,0,0,0,0,0h0a.18.18,0,0,0,0-.1c0-.05,0-.05,0-.09s0,0,0,0h0s0,0,0,0a.06.06,0,0,0,0-.07l0,0,.07-.06h0s0-.13-.06-.1a.54.54,0,0,0,0-.19s0-.07,0-.11l0-.13s0,0,.05,0a.28.28,0,0,1,0-.18v0l.06,0s.08,0,0,.09,0,0,0,0a.29.29,0,0,0,0,.09v0c0,.15,0,.16.14.09l-.08.12s.12-.07,0,0a.37.37,0,0,1,.14.07l0,0,0,0h0v0l0,0,.05,0,0,.07,0,0c.06,0,.09.08.13.24l0-.07h0c0,.07,0,.19.06.1l0,0h0v0c-.05.08,0,.07,0,0v0l0,.06a.4.4,0,0,1,.12.11,1,1,0,0,1,.08.23h.06v0l0,0a.14.14,0,0,1,.13.07l0,.06,0-.12a1.15,1.15,0,0,1,.06-.17,1.8,1.8,0,0,0,.08-.21s0-.15-.07-.11c.07,0,0-.11,0-.13l0,.05V198s0,0,.07,0,.06-.21-.08-.13h0c.15-.14,0-.07,0-.13s0-.14.08-.13c-.05-.07,0-.13,0-.23a.07.07,0,0,1,0,0h0s0,0,0,0h0a.13.13,0,0,0,0-.11.15.15,0,0,0,0-.07l-.05,0c.08-.08.06-.14,0-.18s0-.12,0-.12a0,0,0,0,1,0,0c.06-.12.06-.21,0-.17.07-.07.06-.09,0-.08v0c.07-.11.08-.2,0-.23.1-.08,0-.11,0-.16s0,0,0,0a.27.27,0,0,1,.06-.09c-.07,0,0-.07-.08,0s0-.09,0-.11a.2.2,0,0,0,0-.25c.07-.09,0-.07,0-.14s0,.07-.07.08,0,0,0,0,0,0,0-.11,0,.07-.06.08,0,0,0,0,0,0,0,0,0,0-.05,0,0,.09,0,.1-.08.08,0,.06.07-.07.07-.05h0s0,0-.09.08a.6.6,0,0,0,0,.3c0,.07-.08.27,0,.23l0,0h0l-.05.05a.21.21,0,0,0,0,.23.23.23,0,0,1,0,.2l.07-.05h0c-.06.07-.05.15,0,.11s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,.11,0,0-.05,0,.08.06,0,.08,0,0,0,0h0c-.15.14,0,.12,0,.19s0,.1,0,.13a1.21,1.21,0,0,0-.05.14c0,.08,0,.13,0,.12s0,.06,0,.07v0h0a.33.33,0,0,1,0,.14h-.06s0,0,0,0v0h0v0s0-.12,0-.17,0-.15-.08-.16l0,.1h0a.24.24,0,0,0,0-.11s-.07-.07-.09-.1,0,0,0,0l0,0h0l0,0s0-.13,0,0,0,0,0,0h0a.14.14,0,0,1,0-.09s0,0,0,0,0-.14,0-.06,0,0,0,0l0,0v0l0-.07h0l-.07.08,0-.07v0h0s0,0,0-.1c-.14.1,0-.23-.11-.18s0,.09-.06.08l.05-.1s0,0,0,0,0-.1-.08-.05c0-.14,0-.21-.08-.14a.15.15,0,0,0,0-.11s0,0-.08,0v0s0,0,0-.07h0v0s0-.06,0-.05l-.12,0a.17.17,0,0,0,0,.07s-.05,0-.08.07A.35.35,0,0,0,56,197a1,1,0,0,0,0,.23v.12a1.76,1.76,0,0,0,0,.27s0,0,0,0v0l0,0a.71.71,0,0,1,.06.28v0s0,0,0,.06v.08c0,.06,0,.12,0,.17,0,.38,0,.78,0,1.14v0l-.06,0s0,0,0,0,0,.05,0,.09l.06,0s.06,0,.1,0Zm1.36-2.07h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,203.71v0s0,0,0,0S58,203.7,58,203.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,208.25l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.44,204.93s0,0,0,0,0,0,0-.06,0,0,0,0,0,0,0,.12-.06,0,0,0,.06,0,.05,0,0,0-.07,0a.2.2,0,0,0-.06.14s0,.1,0,.14,0,.06,0,.09,0,0,0,0l0,0h-.1v0h0s0,0,0,.06,0,.12-.06.1,0,.06,0,.07-.08,0,0,.07,0,.07,0,0,0,0,0,0,0,0,0,.08,0-.05,0-.05a.13.13,0,0,1,0,.09h0s0,0,0,0,0-.06,0,0,0,.06-.08.08,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0v0h0s0,0,0,0h0s0,0,0,0h0v0s0,0,0,0h0l0,0s0,0,0,0v0c0-.09,0-.09,0-.07s0-.05-.06,0,0-.14,0,0c.07-.14-.11.11,0-.08-.07,0,0-.09-.08-.08v0c.06-.11,0-.13,0-.14s-.09,0-.08,0,.08-.16,0-.16l-.07.07h0l.07-.08s0-.05,0-.08,0,0-.07,0,0,0,0,0l0,0s0,0-.08,0,.07-.09,0-.07a.08.08,0,0,0,0,0h0s0,0,0,0h0l0,0,0,0h0v0s.06-.05,0,0,0,0,0,0h0v0l.06,0s-.08,0-.07,0h0a.07.07,0,0,0,0-.06s0,0,0-.05,0,0,0-.06.09-.11.11-.17,0-.16,0-.22h0l0,0a.24.24,0,0,1,0-.17s.09-.05.13-.18a.05.05,0,0,0,0,0c0,.1.08,0,.09,0s0,0,.05-.08v0h0s0,0,.06,0h0s0,0,0,0h0a.08.08,0,0,1,0,0l0,0s0,0,0-.05c0,.12,0,.12,0,.14s0,0,0,.09l.26-.19-.05,0v-.12s0-.07,0-.09,0,0,0,0a.93.93,0,0,1,.05-.1.11.11,0,0,0-.1-.05v0H57a.2.2,0,0,1,0-.07h0v0l-.1,0h0c0,.21-.07.06-.12.08s-.09.13-.08.15,0,.06,0-.07c0,.09,0,0,0,.12h0c0-.06,0,0-.06.08h0v0s0-.06,0-.06,0,.1,0,.11,0,0,0,0h0v0l0,0a.1.1,0,0,0,0,.06,1.22,1.22,0,0,0-.07.17s0,0,0,0a.26.26,0,0,1,0,.14.06.06,0,0,0,0,.08l0,0s0,0-.06,0,0,.11-.05.18a.2.2,0,0,0,0,.17l0,.05a.25.25,0,0,0,0,.12v.06s0,0,0,0v0h0l0,0s.1,0,0,0l.05.06h0c-.09.12-.09.2,0,.2l-.09,0s.1,0,0,.05a.3.3,0,0,1,.09.29l.07-.06a.3.3,0,0,0,0,.1s0,0,.07-.05v0s0,.08,0,0h0c-.07.12,0,.09,0,0h0l-.05.08h0v0s0,0,0,0l0,0h0a.47.47,0,0,1,0,.14l0,0v0c.06,0,0,.08,0,.09l.06-.11c0,.09,0,.08,0,0,0,.09,0,.11,0,0h0c0,.13,0,.12,0,.07h0s0,.05,0,0a.08.08,0,0,1,0,.05c0-.07,0,.08.09-.12a.13.13,0,0,0,0,.05h0a.07.07,0,0,0,0,.05h0s0,0,0-.05h0c0,.06,0,0,0,0s0,0,0-.08,0,.06,0,.05v0s0,0,0,.08c.05-.1.05.05.11,0a.2.2,0,0,1,0-.11c0,.06,0,0,0,0s0,0,.06,0l0-.07s0,0,0,0,.07,0,.06,0,.05-.06,0-.1.11,0,.06-.12c.06.06,0,0,0-.05s.07,0,.09,0a.08.08,0,0,0,0-.05,0,0,0,0,0,0,0h0v0s.05,0,.05,0a.34.34,0,0,0,0-.09s0,0,0-.07,0,0,.06,0,0,0-.06-.05,0,0,0-.07.08,0,.07-.1,0,0,0,0S57.46,205,57.44,204.93ZM57,203.71h0l0,0Zm-.76,1.51h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.16 205.32 57.16 205.33 57.16 205.32 57.16 205.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,203.74h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.85 209.43 42.85 209.43 42.85 209.44 42.85 209.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,209.63s0,0,0,0,0,0,0,0l0,0s0,0,0,0-.06-.07,0,0l.05.06s0,0-.06-.07,0,0,0,0v.05s0-.09,0,.06c0,0,0,.06,0,.06v-.1c0-.07,0,0,0,0s0,.08,0,0v.11c0-.11,0-.08,0,0,0-.07,0,.07,0-.06h0c0-.07,0,0,0,0a.35.35,0,0,1,0-.07c0,.08,0,.13,0,0,0,.06,0,0,0,.09,0-.3,0,0,0,0s0,0,0-.05v0s0,0,0,0,0,0,0,0,.09,0,.08-.06-.05-.07,0-.08.1,0,.08-.07h-.06l0,0c.05,0,.06,0,.08,0v0l0,0s0,0,0,0,0,0,0,0,0,0,0-.09.09,0,0-.08c.11.07,0,0,.06,0s0-.06,0-.06l0,0c.06,0,.14,0,.06,0s0,0,0,0,0,0-.08-.05l.12.05c0-.05-.09-.09,0-.09-.06,0,0,0,0-.07s0-.06,0-.07-.06,0-.07,0l.07,0s0,0,0,0,0-.06,0,0a.21.21,0,0,0,.06-.09s0,0-.06,0,.09-.16,0-.06c.07-.14,0-.16,0-.17s-.08,0-.1,0a.83.83,0,0,0,0,.12,1.31,1.31,0,0,1,0-.15h0c0,.06-.07,0-.1,0s-.08,0-.14.15c0-.16-.05-.09-.05-.11s0,0,0,.07,0,.1,0,.1v-.08a.41.41,0,0,0,0,.09c0-.21-.07.12-.06-.08l0,.39a.35.35,0,0,1,0-.06s0,.07.05-.05v.11s.08-.23.07-.05c0-.1,0-.11,0-.09V209a.19.19,0,0,0,0-.09c0,.11,0,0,0,.11,0-.1,0,0,0-.13,0,.09,0,.06,0,0s0,.11,0,.11c0-.19,0,0,.06-.13,0,.07,0,0,.08,0l0,.07c0-.05,0,0,0,0s0,0,.08-.11c-.08.16,0,.05-.08.17,0-.09.06-.09,0-.06s0,.06,0,.08h.06s.06,0,0,0h.05c-.11,0-.11,0,0,.1l-.07,0s.07.07,0,0,0,.13,0,.17l.05,0h0s-.07,0,0,.07-.09,0,0,0c-.11,0,0,0,0,0s0,0-.08,0,0,.12-.08.18c.09.11,0,.11-.09.29,0,0,0,.09.09,0-.08.06,0,.06,0,.06s0,0,0-.06,0,0,0,0,0,0-.06.07,0,0,0,0,0,.05,0-.05c-.1.23,0,.08,0,.05s0,.07,0,.06,0,0,0,.09c.06-.07,0,.07.06,0a.89.89,0,0,0,0-.11c0,.08,0,.06,0,0,0,.1,0,.08,0,0,0,.15,0,.1,0,0,0,.09,0,0,0-.07,0,.1,0,.1,0-.05,0,.12,0,.05,0,0s0,.11,0,.11,0,0,0-.11c0,.12,0,.05,0,0s0-.11,0,0c0-.09,0,0,0-.12,0,0,0,0,0,0s.08,0,.07-.05,0,0,0,0S43.06,209.67,43,209.63Zm-.36-.8h0Zm0,.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.11,201.33h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.06,209.62c.06-.05.06-.13,0-.1.09-.08.08-.13,0-.15s0-.11,0-.09.08-.19,0-.14c.09-.08,0-.08,0-.06s.1-.19,0-.2c.16-.14-.16,0,0-.22-.07,0,0-.06-.08,0,0,0,0-.07,0-.07s.07-.17,0-.19,0-.07,0-.11a.11.11,0,0,1-.06.08s0,0,0,0,0,0,0,0h0s-.05,0,0-.07c-.13,0,.06-.15,0-.13s-.06.05-.07,0l.07-.06s0,0,0,0,0-.06,0,0,.06-.13,0-.11.1-.11,0-.07a.18.18,0,0,0,.06-.2c0-.07,0-.13,0-.19s-.06.06-.07,0a.36.36,0,0,1,.1-.07c-.12-.11.06-.41-.14-.5a.29.29,0,0,0,.07-.21c0-.08-.11-.06-.1-.12l0,0s0,0,0,0c.13-.15-.06-.14.07-.22l-.26.15s0,0,.05,0-.06.15,0,.12l-.07,0a.43.43,0,0,0,0,.05l-.13,0,0,.37c0,.05,0,.1,0,.09l-.06.06c0,.16.15.2,0,.42.12-.06,0,.08,0,.13s.05.09.07.07,0,0-.07.08c.06,0,0,0,.08,0s0,.06,0,.08v0h0l-.07.07c.12-.06,0,.09.09,0a.43.43,0,0,0,0,.22v0h0s0-.07,0,0c0-.13,0-.12,0-.07l0,.07s0,0,0,0,0-.1,0-.07,0,0,0,0v0s0-.07,0,0h0l-.09.08h0l0,.06h0a.41.41,0,0,1,0-.07s0,0,0,0,0,0,0,.07h0s0,0,0,0h0v0h0v0s0,0,0,.05h0v0h0v-.07a.38.38,0,0,1,0,.08c0-.05,0-.06,0,0h0v0s0-.07,0,0v0s0,0,0,0h0s0,0,0,0v0h0c0-.07,0,0,0,0s0-.15,0,0c0-.13,0-.09,0-.08l-.07.09s0,0,0,0h0v-.08c0,.14-.07.08-.11.13h0c.14-.08,0,0,.06-.06-.08,0-.06,0,0,0s-.05,0-.06,0,.16-.12.06-.06,0,0,0,0,0,0,0,0h0l.09,0s-.13,0,0-.06c-.14,0,.06-.11,0-.09l-.07,0,.07-.05h0s0,0,0,0,.06-.09,0-.07.1-.1,0,0h0c.09-.07.08-.11.07-.14a.5.5,0,0,0,0-.13l-.06,0h0l.09-.05c-.11,0,0-.26-.11-.3v0c.06-.07,0-.1,0-.12s0,0-.08-.05v0h0s0,0,0,0v0s0-.06,0-.07,0,0,0,0l0,0,0,0h0l.22-.12,0,0s0-.08,0-.11l-.07-.3-.12.12s0,0,0,.07v-.1l0,.05-.23.39,0,0a.16.16,0,0,1,0,.22c.12,0,0,.05,0,.09s0,.05.06,0,0,0-.06.07,0,0,.07,0,0,.05,0,.05l-.07.05c.12,0,0,.06.09,0-.05.06,0,.15,0,.22l0,0c.07,0-.05.18.1.13h0c-.1.06,0,.06-.11.1.12,0,0,.08,0,.16s0,.13,0,.18,0,0,0,0h0l0,0h0c-.09.1-.08.16,0,.14h0l-.07,0s.1,0,0,0l.06.06v.2s0,0,0,0l0,0v0s0,0,0,0h0s0,0,0,0h0c-.12.07-.06.05,0,0h0a.23.23,0,0,1-.07.06s0,0,0,0a.43.43,0,0,0,0,.07s0,0,0,0h0s0,0,0,0v0s0,0,0,0h0l0,.08,0,0s0,0,0,0-.05.06,0,.09l.07,0s0,0,0,0-.06.08,0,.06h0s0,.06,0,.06l0,.06s0,.07.05,0,0,.06,0,0h0l0,0h0l0,0-.06,0c.09,0,0,.07,0,.06v0h0c-.06,0,0,0,0,0s0,0-.08.1c0,0,0,.08,0,.12l.08,0s0,0,0,0,0,.11,0,.06c-.09.09-.07.12,0,.11s0,.08,0,0c-.06.12,0,.2.05.07-.06.14,0,.1,0,0,0,.08,0,.15.05.14h0l0,0h0l0,0,0,0a.28.28,0,0,0,0-.08c.07,0,.07-.08,0-.12s-.05-.06,0-.11c-.07,0,0,0-.08,0s0-.05,0-.06.08-.11,0-.13,0,0,0-.07a.14.14,0,0,1-.07.06s0,0,0,0v0h0s0,0,0-.08v-.07s0,0,0,.06c0-.08,0-.13,0-.07s0,.12,0,.11a.69.69,0,0,1,0-.15l0,0s0,0,0,0,0,0,0,0h0l0,0c0-.07,0-.06,0-.06s-.05,0,0,0l0,0h0s0,0,0,0v0s0,0,0,0v0l0,0h0v0h0s0,0,0,0h0c.08-.05.08-.06.06-.06a.11.11,0,0,0,0-.13s0-.05,0,0h0c.05,0,0,0,0,0h0l0,0s0-.08,0-.12a.16.16,0,0,0,0-.08s0-.07,0-.1l0,0h0l0-.07h0v0h0v0l0,0v0a.22.22,0,0,0,0-.08h0v.06c0-.1,0,0,0-.11h0v0c0,.07,0,0,0,.11a.28.28,0,0,1,0-.1v0a.19.19,0,0,0,0,.07s0,0,0-.07l0-.07v0h0c0,.12,0,.1.05,0h0a.25.25,0,0,1,0,.08v-.07h0v0s0-.07,0-.1v.05s0-.16,0,0a.62.62,0,0,1,0-.1h0v0s0,0,.05,0v0h0v0h0v0s0,0,0,0,0,0,0,.06a.56.56,0,0,1,0-.1s0,0,0,0,0,.07,0,.11,0,.05,0-.14c0,.12,0,0,0,0v-.06h0v.13c0-.16,0,0,0-.08h0v0l0,.05v0h0s0,.08,0,.06v-.09h0c0,.06,0,0,0,0s0,.08,0,0v0a.22.22,0,0,0,0,.06h0v0l0,0c.13,0,0,.12,0,.24a.47.47,0,0,0,.08.26s.08,0,0,.08,0,0,.06,0c-.11.17-.09.27,0,.25l-.09.07s.1,0,0,0l.08.11,0,0c.06,0,0,.09,0,.13l.07-.05c0,.06,0,.06,0,0s0,.11,0,.07c-.09.09-.06.11,0,.11s0,.08,0,0-.07.17,0,.09h0c-.06.07,0,.08,0,.06s-.06.16,0,.13h0s0,0,0,.06a.26.26,0,0,0,0,.15l.08,0v0l0,0,0,0v0s0,0,.05,0l.12.08-.06-.13.11-.1,0-.05,0,0c.06-.05,0-.05,0-.06h0l0-.05v0h0a.14.14,0,0,1,0-.06c0-.06.05-.12.07-.19s0-.08,0-.07h0c.06,0,0-.07,0-.09h0l0,0c-.11,0,0-.13,0-.1h0c.12-.09,0,0,0-.07s0-.11.09-.11c-.05-.05,0-.11,0-.18s-.07,0-.08,0S42.11,209.6,42.06,209.62Zm-1.47-.15v0Zm0-.34h0Zm0-1.63h0l0,0h0v.07c0-.05,0,0,0-.09s0,.06,0,.06,0,0,0,.06S40.6,207.53,40.59,207.5Zm.12,3h0Zm0,.15h0Zm0-.23Zm.09,0h0Zm0,.35Zm0,0h0Zm.08-1.45Zm.35-.59h0v0Zm0,0h0Zm0,0h0Zm.43-1.32s0,0,0,0v0Zm-.06-.35s0,0,0,.06a.06.06,0,0,0,0,0S41.58,207,41.58,207Zm0,.11s.05,0,.06,0,0,0,0,.06,0,0-.05,0A.16.16,0,0,0,41.55,207.15Zm0,.19s-.06,0-.06-.07l0,0c.05,0,0,0,.07,0s0,.06,0,.06Zm0,1.57v-.06h0v0c0,.05,0,.06,0,.05S41.6,208.89,41.58,208.91Zm0-.06h0a.13.13,0,0,1,0-.05h0Zm0,0h0Zm0-1.15s0,.05,0,.09a.1.1,0,0,0-.05,0,.32.32,0,0,0,.05-.17l0,.09S41.62,207.65,41.61,207.67Zm.06.17v0h0Zm.13.62h0Zm0,2h0Zm0-1.51Zm0,0h0l0,0h0l0-.06,0,0S41.78,208.92,41.79,208.92Zm.12.48h0l0,0S41.93,209.38,41.91,209.4Zm0-.49h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.34,198.32v0c-.09.23,0,0,0,.14s0,0,0,0a1.2,1.2,0,0,1-.07.19,1.17,1.17,0,0,0,.15-.32s0,0,0,0,0,.09.05-.09c0,0,0,0,0-.05A1.35,1.35,0,0,1,55.34,198.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.79 208.92 41.79 208.92 41.79 208.92 41.79 208.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.87,209.37l0,.06S42.9,209.4,42.87,209.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.55,207h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.86,205.13l.26-.12s0,0,0,0,0-.16,0-.22l.09-.05,0-.06c-.12.05,0,0,0-.05s0,0-.06,0,0,0,.06-.05,0,0-.07,0,0,0,0,0l.07,0c-.12,0,0,0-.09,0,.05,0,0-.09,0-.13l0,0c-.06,0,0-.09,0-.07v0s0,0,.06-.05h-.05l0-.07,0,0c0-.06,0-.07-.06-.09h0v0h0l0,0s0,0,0-.05v0h0v0h0s0-.1-.06-.09h0c.07-.06,0-.06.07-.09s0-.05-.08,0a.06.06,0,0,0,0-.1s0,0,0-.05h0l0,0c-.06,0,0,0,0-.08a.86.86,0,0,0,.07-.1s0-.06-.08,0c.07-.05,0,0,0,0l0,0v0h0s0,0,.07,0h0c.09-.12,0,0,.08,0h0a.17.17,0,0,0,0,.11l0-.06a.09.09,0,0,0,.1,0h0s-.05.08-.07.09.12,0,0,.06l.16.08v0l0,0a.35.35,0,0,1,.06.16h0a.09.09,0,0,0,.09.05h.09c0,.1,0,.09,0,.06s0,0,0,0a.82.82,0,0,1,0,.11h0s0,0,0,0l0,0a.08.08,0,0,1,0,0l0,0h0l0,0,0,0a.89.89,0,0,0,.14.13l.08-.09.05-.05v0a1.42,1.42,0,0,1,0-.31c0-.1.06-.21.09-.35s0-.14-.09-.07c.08-.06,0-.11,0-.12s0,0,0,.07,0,0,0-.07,0,0,.07,0c-.12,0,0-.2-.09-.1.15-.16,0-.08,0-.12s0-.14.08-.14c-.05-.06,0-.13,0-.22l-.07,0c0-.07,0-.07,0,0s.06-.17,0-.14.06-.16,0-.19,0-.15,0-.11c.07-.14.07-.24,0-.19.08-.09,0-.1,0-.06.09-.14.1-.24,0-.27s0-.08,0-.11-.07-.08,0-.17c-.07,0,0-.06-.08,0,0,0,0-.08,0-.1s.08-.19,0-.25,0-.07,0-.14,0,.07-.07.08,0-.05,0,0,0,0-.05,0l0,0c0,.07,0,.1,0,.11s-.07.08,0,.06.08-.08.07,0,0,0-.09.08a.36.36,0,0,0,0,.23h0s0,0,0,0l-.05,0c0,.05,0,.06,0,.06s-.08.07,0,.05.07-.07.07-.05,0,0-.09.07,0,.13,0,.19-.08.19,0,.15l.05,0,0,0,0,0c-.11.14.07.16,0,.27s.06,0,.07,0-.07.12,0,.07,0,0-.05.07,0,0,0,0,0,0,0,.07,0,0-.05,0,.08,0,0,0,0,.06.06,0c-.19.15,0,.1,0,.16s-.15.36,0,.25c-.09.09.11,0,0,.08.09,0,0,.23.06.26h0l0,0,0,0,0,.07a.27.27,0,0,0,0,.11c0,.06.09.09.08.15h0l0,0s-.06-.08-.11-.07,0,0-.06,0c.06-.15,0-.18,0-.21s-.09-.06-.12-.1h0a.08.08,0,0,1,0,0l0,0,0,0v0h0s0,0,0,0a.09.09,0,0,1-.11-.06v0l0,0,0-.06h0c0-.06,0-.13,0-.11l0,0h0l0-.06s0,0,0,0,0-.09-.07-.06c0-.13,0-.2-.06-.15s0-.21,0-.1a.2.2,0,0,0,0-.07l0-.08s0,.07,0,.07a.19.19,0,0,0,0-.08s0,0-.06,0,0,0,0,0a.1.1,0,0,0-.07,0l-.15.07v.3c0,.14,0,.27,0,.38l0,0h0a.22.22,0,0,0-.07.06,1.43,1.43,0,0,1,0,.52s0,.06,0,.08v.09s-.06.08,0,.09l.05,0h0l0,0s-.1.14,0,.07c0,0-.08.05,0,0h0l-.06,0s0,0,.06,0h0s0,.06,0,0h0c-.06.05.06,0,0,0l0,0v0h0s-.08.07,0,0,0,0,0,0h0l-.06,0s.12,0,0,0h0l0,0s0,0,0,0a2.14,2.14,0,0,1,0,.24c0,.08,0,.15.06.21l-.12.25h0s.07,0,.06.07h0C48.9,205,49,205.08,48.86,205.13ZM50,203.65v0h0Zm0-.91h0Zm0-.64Zm0,.35,0,0h0Zm0-.92h0l0,0Zm0,1.15,0,0v0h0s0,0,0,.06S50,202.71,50,202.68Zm-.07-1.43Zm-.17,2.1.08.09s0,0-.05,0,0-.06,0,0l0,0h0S49.73,203.36,49.73,203.35Zm-.24-.21a0,0,0,0,0,0,0l0,0A.08.08,0,0,1,49.49,203.14Zm-.33,0h0Zm-.08.13c.14-.1,0,0,0,0s0,0,0,0l0,0h0c0,.05,0,0,.05,0a.88.88,0,0,0-.05.1c-.11,0,.05-.07-.07,0Zm-.06-.75v0h0S49,202.5,49,202.49Zm-.06.12h0a.35.35,0,0,0,0,.07h0S49,202.62,49,202.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.52,207.11v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.49,202.27v-.05c-.09.23,0,.05,0,.15s0,0,0,0,0,.1-.07.19a1.54,1.54,0,0,0,.15-.33s0,0,0,0,0,.09,0-.09c0,0,0,0,0,0S48.5,202.26,48.49,202.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.78,198.56h0c0,.05,0,.08,0,.14A.22.22,0,0,1,54.78,198.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,202.36c0,.12-.06.18-.08.19.06-.14.06-.19.13-.33s-.06.15-.05.09a1.09,1.09,0,0,0,.05-.14s0-.12,0,0,0,0,0,0c-.1.3,0,0-.13.23a.77.77,0,0,1,0-.15c0,.06,0,0,0,0s0,.18-.06.19c.06-.17,0,0,0-.09l0-.1s0,.05,0,.05,0-.12,0-.05,0,.06,0,.14,0,0,0,0-.06.18-.07.19.05-.16,0-.19,0,.14-.06.14a1.55,1.55,0,0,0,.08-.23c0,.1,0-.24,0-.14s0,.09,0,0c-.06.17,0,.24-.08.28s0-.14.07-.28c0,.07,0,0-.05.05s0,0,0,0,0,.13-.06.09,0-.06.07-.19-.05.13-.07.15c0-.14.06-.29,0-.15s0,0,0,.1a.12.12,0,0,0,0,.05c0-.17,0-.24,0-.19h0c0-.12-.06,0-.07,0,0,.15,0,.06,0,.19,0-.06,0-.06,0,0a1,1,0,0,1,0,.14c0,.06,0-.11-.06.1,0-.19,0,0,0-.13a1.85,1.85,0,0,1,.06-.25c0-.07,0,.21-.06.2s0-.2,0,0c0,0,0,0,0,0s0-.15,0,0c0-.26,0-.1-.06,0s0,0,0,0l0-.07s0,0,.06-.15,0-.08,0-.15,0-.07-.06.09c.06-.14.09-.25,0-.14l-.08.22c0-.14,0,0,.1-.29,0-.13-.06,0-.09,0s.06-.27-.07,0l0,.15.08-.22c.11-.35-.15.18-.06-.1,0,.09-.08.21-.09.22.09-.24,0-.21,0,0,.06-.16-.06.12,0-.14,0,0,0,.1,0,0s0,0,0,0a.61.61,0,0,0,0-.15c-.06.16-.11.22,0,0-.06.12,0,0-.09.16.23-.59,0,0,0,0s.15-.6,0-.18c.11-.29-.15.32,0-.14-.12.19-.05-.12-.15.07.09-.31.06-.32,0-.26s-.12.2-.12.13,0-.33,0-.25,0,.17-.06.23a.44.44,0,0,1,0,.08,1.17,1.17,0,0,0,.08-.3c-.05.09,0-.33-.13.13h0l0,0s0,0,0,.05,0,0,0,0a1.78,1.78,0,0,0-.08.18c.13-.36,0-.1,0-.13h0v0c-.07.18-.06.12,0,.06s-.07.17-.08.19c.09-.25.18-.53.06-.21,0,0,0-.12,0,0-.1.28,0,0-.12.3l.16-.44c0,.07-.17.39,0,0-.17.41,0-.22-.08,0,0,.08-.07.2-.09.22l.08-.22s0,.08,0,.08,0-.08-.07.1c.09-.26,0-.22,0,0,.06-.14.11-.34,0-.05.1-.3,0-.26,0-.26s-.09.06-.12.06-.07.21-.08.22.09-.25.11-.29-.07.1-.09.1l0,0h0s0,0,0,0h0l0-.05h0s0,0,0,0,0,0,0,0h0s0,0,0,0v0h0a.23.23,0,0,0-.06-.18s.06-.06,0,0,0,0,0-.06,0,0,0,0-.05,0-.06,0,.05-.08.05-.1,0,0,0,0,.07-.09,0-.05,0,0,0,0,0-.06,0-.13,0,0,0,0l0,0s.07-.07,0,0c.11-.08,0,0,.05-.08l-.08,0,.06,0c0-.05.06-.15,0-.15s0-.05,0-.09,0,0,0,0,0,0,0-.09a.06.06,0,0,1,0,0l0,0h-.05s.06-.07,0-.09h0c.06-.07,0-.07,0-.14h0s0,0,0-.08,0,0,0,0l-.07,0,0,0s-.06,0,0-.08,0,0-.05,0l0,0,0,0s0-.08,0-.1,0,0,0,0l-.08,0c.08,0,0,0,.07-.07s0,0,0,0,0,0,0,0l0,0h0s0,0,0,0-.06,0,0,0l-.07.05a.36.36,0,0,1,.1-.07s0,0,0,0,0,0,0,0l0,0c-.07,0,0,0,0,0s0,0,0,0l-.07,0c.06,0,0,0,0-.06s0,0,0,0,0,0,0,0,0,0,0,0l.06,0s0,0,0,0-.06,0-.07,0,0,0,0,0l-.07.05h0l0,0h0l.06,0,.07-.05s0,0,0,0,0,0,0,0l0,0,0,0,0,0,0,0,0,0s0,0,0,0l0,0s0,0-.06,0,0,0,0,0,0,0-.05,0,0,0,.1-.07,0,0-.06,0l0,0s0,0,0,0-.07,0-.1.06h0l0,0h0l.06,0s-.05,0-.06,0h0c.1-.06,0,0,0-.05s0,0,0,0,0,0,0,0,0,0,0-.05l0,0,0,0c-.06,0,0,0,0,0s0,0,0,0a0,0,0,0,0,0,0l0,0h0l0,0c-.05,0,0,0-.07,0h0l0,0-.06,0h0s0,0,0,0l.06,0h0l-.07,0,0,0,0,0-.06,0h0l.08,0s0,0,0,0,0,0,0,0l0,0s0,0,0,0,0,0,0,0h.08s0,0,0,0h0s0,0-.05,0,0,0,0,0l0,0h0c.07,0,0,0,.09,0s0,0,0,0h0s0,0,0,0h0c.09,0,0-.05,0-.06s0,0,0,0,0,0,0,0,0,0,0,0h0l0,0c-.06,0,0,0,0,0s0,0-.06,0h0l.07,0s0,0,0,0l0,0c-.06,0,0,0-.09,0l.06,0-.08,0h0s0,0,0,0,0,0,0,0,0,0,.06,0,0,0-.09,0,0,0,0,0,0-.05,0-.08h0l-.16.09,0,0s0,.11,0,.14,0,0,0,0a0,0,0,0,1,0,0l0,0a.35.35,0,0,0,0,.12.37.37,0,0,0,0,.16,1.14,1.14,0,0,1,0,.37,1.1,1.1,0,0,0,0,.26s0,0,0,0h0l0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0a.09.09,0,0,1,0,0l0,0h0a0,0,0,0,1,0,0h0v0a.06.06,0,0,0,0,0v0c0,.07,0,.08,0,.12h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l.05,0h0l0,0s0,0,0,.05h0l0,.05c.05,0,0,0,.05,0l0,0,0,0s0,.06,0,.09,0,.06,0,.08h0c.05,0,0,0,.05,0s0,0,0,.05,0,0,0,0,0,0,0,0l-.05,0h0s0,0,0,0,.06,0,0,0h0s0,0,0,0h0l0,0s0,0,0,0a0,0,0,0,0,0,0l0,0h0s0,.05,0,.05l0,0h0s0,0,0,0,0,0,0,0,0,0,0,0h0s-.05.05,0,0l.05,0h0s-.06,0,0,.06,0,0,.07,0h0v0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0v0l0,0h0c-.07,0,0,0,0,0h0v0h0s-.08.06,0,.05,0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0-.06.11,0,.06c0,0,0,0,0,0h0a.09.09,0,0,0,0,.05h0l0,0h0l.06,0,0,0,0,0h0l0,0,0,0h0l0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0l0,0h0l-.05,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h-.06l-.06-.09c0,.11,0,.07,0,.09v.06s0-.09,0,0v-.13h0s0,0,0-.09,0,.05,0,.07a.42.42,0,0,1,0-.12s0,.05,0,.05,0,0,0-.05,0,0,0,0,0,0,0,0,0,0,0,.12l0,0s0,0,0,0l0,0h0s0,0,0,0a.08.08,0,0,0,0,0s0,0,0,0,0,0,0,0l0,0h0s0-.05,0,0l0,0h0l0,0,0,0h0l0,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0l0-.06s0,0,0,.12c0-.06-.06-.1-.07-.1s0,0-.05-.07.05-.15,0-.06,0,.06,0,.05l.07-.08c0-.07,0-.08,0-.09s0,0,0,0l0,0h0s0,0,0,0h0s0,0,0,0h0l0,0,0,0h0l0,0,0,0s0,0,0,0,0,0,0,0h0s0,0,0,0h0l0,0h0l0,0h0l0,0s0,0,0,0l0,0h0c.05,0,.08-.06,0,0h0s0,0,0,0h0l0,0s0,0,0,0h0v0s0,0,0,0a.2.2,0,0,0,.09,0l-.06,0c.06,0,0,0,0,0h0c.09-.06,0,0,.07-.09s0,0,0,0h0s0,0,0,0h0s0,0,0-.05l0,0v0h0l0,0s0-.06,0-.08,0,0-.07,0,0-.09,0-.08,0,0,0,0,0,0,.06-.05h0l-.06,0,.06,0a0,0,0,0,0,0,0h0l0,0h0l0,0v0h0l0,0,0,0h0l0,0c.09-.08,0-.08,0-.08h0s0,0,0,0h0a.13.13,0,0,1,0-.06h0v0h0a0,0,0,0,0,0,0h0l0,0h0s0,0,0,0h0l0,0h0s0,0,0,0h0l0,0c-.06,0,0,0,0,0h0l0,0,0,0h0s0,0,0,0h0l0,0,0,0h0s0,0,0,0h0s.07,0,0,0h0l0,0h0l0,0c.08-.05.06-.05,0,0h0l.06,0-.06,0h0s0,0,0,0h0s0,0,0,0l.06,0c-.07,0,0,0,0,0s-.06,0,0,0l-.06,0s0,0,0,0l0,0,0,0-.07,0s0,0,0,0h0s0,0,0,0h0c.07,0,0,0,0,0h0l0,0h0l0,0s0,0,0,0h0s0,0,0,0l-.05,0h0s.05,0,0,0l0,0s.07,0,.05,0l-.05,0s0,0,0,0h0l0,0s0,0,0,0h0s0,0,0,0h0a0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0l-.07,0h0l.06,0s-.07,0,0-.05l-.05,0c.05,0,.05,0,0,0l0,0s.05-.06,0-.06,0,0,0,0l-.08,0c.08-.05,0,0,.07-.06l0,0c.06,0,0,0,0,0l0,0h0l0,0h0c-.06,0-.06,0,0,0l-.07,0h0l.09-.06s0,0,0,0l0,0,0,0c-.08,0,0,0,0,0l0,0-.08,0c.06,0,0,0,.05,0h0c-.07,0,0,0-.05,0h0l.06,0s0,0,0,0l-.08,0s0,0,0,0l0,0-.08,0h0l.07,0h0l0,0s0,0,0,0l0,0,0,0,0,0s0,0,0,0l0,0s0,0-.06,0,0,0,0,0h0l.07-.05s0,0-.06,0h0l0,0s0,0,0,0l0,0h0c.08-.05,0,0,0,0h0s0,0,0,0h0l0,0,0,0h0v-.09s0-.05-.06-.05h0c.06,0,0,0,.07-.06-.06,0,0,0-.08,0h0s0,0,0,0h0l0,0c-.11.05,0-.05-.08,0h0a.14.14,0,0,0,0-.06l-.23.13a.19.19,0,0,0,0,.07v.06l0,0c.07,0-.06.15.1.11-.11,0,0,0-.11.09s0,0,0,0,0,0,0,0h0l0,.08v0h0a.09.09,0,0,0,0,.07h0s0,.11,0,.07l.05,0c-.06.07-.05.1,0,.1h0l-.08,0s.1,0,0,0c.07.06.09.06.05.19l.06,0h0s-.07.1,0,.07a0,0,0,0,0,0,0h0c-.1.06-.07.05,0,0h0l-.06,0s0,.12,0,.25c.13,0,0,.13,0,.29,0,0,0,.08.08,0-.07.06,0,.05,0,.06l0-.05s0,0,0,0,0,0-.07,0c.12-.05,0,.12.09,0-.15.14,0,.06,0,.06s0,0-.09.1c.06,0,0,.08,0,.11l.07-.05c-.05.05,0,.05,0,0s-.06.1,0,.05c-.09.09-.06.11,0,.1s0,.07,0,0h0c0,.07-.06.12,0,.09a.16.16,0,0,0,0,.07s0,0,0,.06h0s0,0,0,0h0s0,0,0,0,0,0,0,0h.07l-.06,0s.06,0,0,.09,0,0,.05,0l0,0,0,0a.14.14,0,0,0,0,.15c-.06,0,0,0,0,0s0,0,.07,0,0,.05-.06.1,0,0,0,0,0,0,0,0l0,0h0l0,0s0,0,0,0c-.11-.16,0,.14,0,.18s-.28-.21-.14.06c-.1-.17.09.25-.07,0,0,.21-.11.1-.08.27-.24-.33-.09.19-.17.18s-.16-.11-.15,0,.06.09.08.13,0,0,0,.06a1.76,1.76,0,0,0-.11-.18c0,.1-.18-.08,0,.23,0,0-.09-.14,0,0l0,0s-.05,0-.08-.13c0,.11,0,0,.06.2-.07-.1-.13-.09,0,.15-.16-.27,0,.08-.09-.11.09.17.05.16,0,.13a.52.52,0,0,1,.07.12c-.09-.15-.2-.29-.1-.09,0,0,0-.08,0,0s0,.06.06.13h0l-.11-.2c0,.09.11.31,0,.11.12.29-.12,0-.05.15s.08.12.08.15l-.08-.13s0,.07,0,.07,0,0,0,.12c-.1-.14-.11-.06-.06.06,0-.09-.14-.16,0,0-.11-.15-.13-.06-.15,0s0,.17-.07.22.09.11.08.13l-.1-.17c0,.3-.18.2-.16.52l0,0v.14c-.06,0-.07.06-.09.06s.07.29,0,.31l0-.09c0,.06,0,0,0,.11-.05-.06-.08-.06-.09,0l0,0v0c0,.05.15,0,0,.12l.21-.12v.16a.21.21,0,0,0,.11,0,.1.1,0,0,1-.05.06v.08h0v0a.1.1,0,0,1,0,.06v0l0,0s0,0,0,0l0,.07a.23.23,0,0,0,.05.07,1.05,1.05,0,0,0,0-.18h0l0-.09v0l.07,0a.88.88,0,0,1,0-.1h0l0,0s0,0,.06,0a.32.32,0,0,0,0-.13v0s0-.07.06.07c0-.1,0,0,0-.12h0s0,0,0,0v0l0,.07,0-.09v0h0s0,0,0,0l.08-.19,0-.05s0,0,0,0a.11.11,0,0,1,0,0v0l0,0v0h0l0,0s0,0,0,0l0-.06.07-.09h0s0-.06,0-.12l.05-.08a.86.86,0,0,0,.07-.1s0,0,0,0l0-.05,0,0a0,0,0,0,0,0,0v0a2.27,2.27,0,0,0,.23-.59.08.08,0,0,0,.08,0h0s0,0,0-.08,0-.1.12-.07c-.1-.12,0,0,0,0s0,0,0,0l.07,0c0-.1.08,0,0-.2.08.14,0,0,0,0l0,0v0h0s0,.06.07.14c-.1-.24.09,0,0-.2h0c.14.2.07.08,0,0h0c0,.08,0,0,0,0h0l.06.11c0-.13.07,0,.08,0l-.07-.14c.06.08,0,.06,0,0,.08.1.1.06,0-.08.11.16.11.09.08,0,.07.09,0,0,0-.09v0c.08.08.11.07,0-.07h0c.05.06,0,0,0,0h0c.08.08.1.06.05-.08h0c.07.09,0,0,0-.05a.07.07,0,0,1,0,0h0c-.06-.16.05,0,0-.13a0,0,0,0,1,0,0h0s.07,0,.06-.06,0,0,0,0,.06,0,.07,0v0s0-.05,0,0a.58.58,0,0,1-.06-.19.78.78,0,0,1,.05.14.09.09,0,0,1,.06,0V202l0,0h0v.1h0v0h0s0,0,0,0a.22.22,0,0,0,0,.08s0,.06,0,.06v-.09h0s0,0,.06-.07h0l0,.13c0-.12,0-.09.05-.11s0,0,0,0l0,0,0,.08,0-.08h0l.07,0s0,0,0,0l0,0s0,.07,0,.19l.07-.12-.07.12s.07-.06.09-.11c0,.12,0,.22.06.23l0,0h0s0,0,0-.05c0,.2.16,0,.2.15a.17.17,0,0,1,0,0c0,.12.14-.15,0,.19,0-.07,0-.1,0,0a.59.59,0,0,1,.11-.24.67.67,0,0,0,0,.19c.07-.12.16-.17.11.09.06-.16,0-.06.1-.14-.05.13,0,.16,0,.09s0-.13,0-.14c0,.15,0,.19.13.14-.07.2,0,0,0,.14a.83.83,0,0,0,.1-.23c-.06.25,0,0,0,.23,0,0,0-.09,0-.09-.06.18,0,0,0,0a1.09,1.09,0,0,0,0,.14s0-.07,0-.1,0,.06,0,.1l0,0h0a.15.15,0,0,0,0,.06c.05-.2.08-.19.09-.11a2.42,2.42,0,0,1,0-.24h0c0,.15,0,.14-.05.33,0,0,0-.08,0,0,0-.08,0-.12,0-.15s0,.07,0,.14c.06-.26,0,.13.05-.1,0,0,0,.11,0,.13a1,1,0,0,1,.08-.24c-.05.2,0,0,0,.18,0-.18,0,0,0,0,.06-.22,0,.12.05-.15,0,0,0,.09,0,0a1.24,1.24,0,0,0,0,.19s0,.09,0,0c0,0,0-.2.06-.24s0,.11,0,.05a2.52,2.52,0,0,0,.06-.29s0,.05,0,0c-.08.24,0-.06,0,.05a1.15,1.15,0,0,1-.07.19c0,.15,0,.13-.05.24s0,0,0,.05,0,.05,0-.05a.87.87,0,0,1,0-.14c0-.05,0,.1,0,.09s0-.14,0-.15l0,.15a.53.53,0,0,1,0,.14c0,.07,0-.13.06-.15s0,0,0,.15,0,0,.1-.2c0,0,0,0,0,0a1.16,1.16,0,0,0,.07-.15c-.08.26,0,.15-.08.33,0-.18,0-.11.09-.19l0,.14c.05-.12,0,0,0,0l0-.13c-.08.28,0,0,.05.08s0,.11,0,0c0,.14,0,0,0-.05,0,.11,0,0,0,.14,0,0,0-.12.05-.14a1.55,1.55,0,0,1,0,.15.93.93,0,0,0,.07-.19c0,.13.06-.15.09-.19s0,.09-.08.24c0-.06,0-.05,0,0s0,.07,0,0S48.37,202.64,48.44,202.36Zm-.68-.07,0,0s0,0,0,.05Zm-1.24-2.94h0l-.06,0S46.49,199.37,46.52,199.35Zm-.11-.41s0,0,.05,0l-.06,0Zm0,.09Zm-.21,1.9h0Zm0-.34h0s0,0,0,0h0Zm-.53-.19h0S45.67,200.39,45.67,200.4Zm0,0s0,0,0,0h0l0,0h0l0,0,0,0h0Zm0,0Zm0,0h0Zm0,0Zm0-.3h0Zm.05-.64s0,0,0,0,0,0,0,0h0Zm0-.05,0,0h0Zm0,0h0l0,0h0Zm0-.09h0Zm0,0,0,0h0l0,0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0l0,0h0Zm-.05.41h0l0,0Zm0,0h0Zm0,0Zm0,1h0Zm-1.61,3.88a.43.43,0,0,1,0,.05v-.05Zm0,.38h0l0,0h0Zm.93-1.82v0h0Zm.45-1.08Zm0,0h0S45.31,202.11,45.32,202.1Zm0,.07h0l0,0h0s0,0,0,0Zm0-.08h0l0,0h0Zm0,.06h0Zm0-.08Zm.07-.2s0,0,0,0h0Zm0,.1h0Zm0-.36h0Zm0,.36h0s0,0,0,0Zm0,.08Zm0,0h0Zm0,0Zm0,0Zm0,0h0v0h0Zm0,0Zm0-.1h0Zm0-.16,0,0h0Zm0,0h0Zm0-2h0Zm0,1.36v0h0s0,0,0,0Zm0,.06h0s0,0,0,0v0l0,0Zm0,.53Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0-.22h0v0Zm0,.26Zm0,0Zm.15-.24s0,0-.08-.11h0s0,0,0,0l.07.11Zm.07,0Zm0,0h0Zm0,0,0,0,0,0c0,.05,0,0,0,0s0,0,0,.06l0,0Zm0,0v0h0v0Zm.13-.34h0s0-.06,0-.08a.57.57,0,0,0,0,.07S46,201.32,46,201.34Zm.09.13v-.07s0,0,0,.07Zm0,.57V202S46.14,202,46.13,202Zm.07-.64Zm0,.58h0Zm0,0v0h0v0Zm0,0h0Zm.17-.79h0l0,0Zm0,.06Zm0,0Zm0,0Zm0,0Zm0-.09h0a0,0,0,0,1,0,0h0S46.42,201.19,46.4,201.21Zm0-.05h0l0,0,0,0,0,0Zm0-1.91h0s0,0,0,0l0,0,0,0s0,0,0,0h0S46.37,199.28,46.42,199.25Zm0,.28h0l.07,0Zm0,0,0,0C46.45,199.49,46.43,199.52,46.4,199.55Zm0-.08s0,0,0,.05A.17.17,0,0,1,46.4,199.47Zm0,0h0s0,0,0,0,0,0,0,0Zm0,.21.05,0a.14.14,0,0,1-.08.06v0Zm0,0h0l0,0s0,0,0,0Zm0,0s0,0,0,0h0A0,0,0,0,0,46.37,199.66Zm0,.17h0Zm0,0h0l0,0S46.42,199.85,46.39,199.87Zm0,0h0Zm0,0,0,0h0l-.05,0Zm0-.08h0s0,0,0,0h0l0,0s0,0,0,0l0,0h0Zm0-.06h0s0,0,0-.05h0s0,0,0,0v0c.1,0,0,.05.08,0C46.39,199.74,46.37,199.77,46.4,199.76Zm0-.32h0Zm0-.05h0l0,0v0l0,0h0s0,0,0,0,0,0,0,0l0,0c-.06,0,0,0,0,0l0,0-.05,0C46.48,199.33,46.4,199.39,46.41,199.39Zm0-.06s0,0,0,0l0,0S46.48,199.3,46.43,199.33Zm0,0,0,0v0h0l0,0S46.43,199.29,46.43,199.3Zm0,.25s0,0,0,0l0,0h0Zm0,.38h0l0,0s0,0,0,0h0s-.07.07-.06.07h0l0,0Zm0-.8h0Zm0,1.89h0Zm0,0Zm0,0h0Zm0,.05h0Zm0,0h0Zm0,0s0,0,0,0Zm0-.12Zm0,0h0Zm0-.1h0Zm0,.09Zm0-.35h0Zm0-.2Zm0,.21Zm0-.29h0l0,0h0S46.33,200.32,46.36,200.31Zm0,0h0Zm0,0v0h0Zm0,.16Zm0,.43h0Zm0-.6h0Zm0-.36h0Zm0,0h0Zm0,.9,0,0h0Zm0,.27,0-.05h0v0h0l0,0Zm0,.08h0v0S46.33,201.15,46.35,201.14Zm0,0h0Zm0-.06h0Zm0,0,0,0h0Zm0-.92h0s0,0,0,0h0Zm0,.06h0l0,0Zm0,0Zm0,0,0,0h0l0,0Zm0,0h0Zm0,0Zm0,0Zm0-.08h0l0,0s.05,0,0,0l0,0h0l0,0,0,0h0l0,0,0,0h0l0,0h0l0,0,0,0c.06,0,0,0,0,0s0,0,0,0S46.42,199.94,46.41,200Zm0-.62h0S46.47,199.34,46.45,199.34Zm.06-.12h0s0,0,0,0l0,0S46.52,199.2,46.51,199.22Zm-.1,0,0,0s0,0,0,0,0,0,0,0l-.05,0h0s0,0,0,0Zm0-.08h0Zm0,0Zm0,0h0s0,0,0,0Zm0,0,.06,0-.06,0h0Zm0,0h0Zm0-.2h0Zm0,.08h0Zm0-.07h0Zm0-.17Zm0-.08h0Zm0,0c-.05,0,0,0,0,0h0Zm0,0h0s0,0,0,0h.06s0,0-.06,0h0s0,0,0,0Zm0,2Zm-.11-1.92,0,0a.05.05,0,0,0,0,0s0,.05,0,0,0,0,0,.07A.19.19,0,0,1,46.19,198.84Zm0,.12h0S46.22,199,46.21,199Zm0,.1a.06.06,0,0,0,0-.07h0A.17.17,0,0,1,46.24,199.06Zm0,3Zm0-.07h0Zm0-2.49Zm0-.83Zm0,2.48h0l0,0v0Zm0,0Zm0,0Zm0,.06,0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0Zm0,0Zm0,.05h0Zm0,0h0Zm0,0h0l0,0Zm0,0h0Zm0,0h0Zm0,0s0,0,0,0h0Zm0,0Zm0,0h0s0,0,0,0Zm.06,0Zm.11.79,0,0s0,0,0-.07Zm0-.08h0l0,0Zm0-.25Zm.11.27v0s0,0,0,0h0s0,0,0,.05,0-.09,0-.12v0A.13.13,0,0,1,46.7,202Zm.07,0a0,0,0,0,0,0,0h0S46.78,202,46.77,202Zm.14,0s0,0,0,0,0,0,0,0a.22.22,0,0,0,0,.1s0,0,0,0,0,0,0,0,0,0,0,0a.81.81,0,0,1,0-.11h0Zm0,.24c.07-.21.06-.29,0-.19,0-.13,0-.13,0-.13a.29.29,0,0,1,0-.1c0,.08,0,.32.07-.12,0,0-.07.3,0,.06-.12.45,0,.15,0,0,0,.15,0,.09-.07.3.05-.09.08-.1.08,0S47.06,202,46.94,202.23Zm.25-.15h0a.69.69,0,0,1,0,.13s0,0,0,.06a.74.74,0,0,1,0-.24Zm.05.2a.2.2,0,0,0,0-.07s0,0,0,0Zm0-.1h0a1.28,1.28,0,0,1,0-.13s0,0,0,.06Zm0,0h0a.34.34,0,0,0,0-.1Zm.19.36a.35.35,0,0,0,0,.06s0,0,0,0,0,0,0-.16l0-.05h0Zm0-.24Zm.08.18v-.06h0v0A.42.42,0,0,0,47.59,202.49Zm.06-.1v0A.43.43,0,0,1,47.65,202.39Zm.16,0c0,.11-.06.22-.07.19a.53.53,0,0,1,0-.14c0-.09,0,0,0-.15S47.8,202.4,47.81,202.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.51 207.02 49.52 207.02 49.52 207.01 49.51 207.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,207.63c.11-.12-.07-.08,0-.17l-.07,0c.08-.06.06-.09,0,0s0,0,0-.06,0,0,0,0,0,0,0,0l0,0c-.06,0-.08,0,0,0s0,0-.06,0c.19-.16,0-.06,0-.09s.16-.26,0-.16c.09-.08-.11,0,0-.07-.07,0,0-.14,0-.14.19-.2,0-.13,0-.21s.09-.15.06-.15l-.07.05h0l.09-.07s.09-.16-.06-.07c0,0,0-.05,0,0l0,0c-.05,0,0,0-.08,0s.07-.1,0,0c.14-.09,0,0,.06-.06l0,0v0h0s.05-.05,0,0h0l0,0h0v0h0v-.06s0,0,0,0v0s0,0,0,.06v0h0V206s0,0,0,0h0s.11-.09,0-.05c.09-.08.08-.12.07-.15a.5.5,0,0,0,0-.13l-.07.05.1-.07c-.12-.05.06-.29-.13-.31.09-.09,0-.14.07-.16s-.11,0-.1-.07l0,0s0,0,0,0c.13-.13-.06-.08.06-.16l-.25.14,0,0s-.05.11,0,.08l-.07,0c0,.06.14.06,0,.2.12-.06,0,0,0,.06s0,0,.06,0,0,0-.07.06c.06,0,0,0,.08,0s0,0,0,0l-.07,0c.12,0,0,.06.08,0s0,.11,0,.16l-.05,0c.07,0,0,.13.08.09h0l0,0s0,0,0,0h0c0-.08,0,0,0,0h0s0,0,0,0v.1h0c0-.1,0-.07,0,0h0s0,0,0-.05,0,.05,0,0,0,0,0,0V206c0,.08,0,.12,0,0,0,.07,0,0,0,.09,0-.28,0,0,0,0v0a0,0,0,0,0,0,0c0-.06,0-.13,0,0,0-.13,0,.17,0-.05,0,.11,0,0-.06.09h0c0-.18,0-.06-.06,0s0,0,0,0h0s0-.13,0-.08v.15a.38.38,0,0,0,0-.14s0-.13,0,.1v-.06a.35.35,0,0,0,0,.12c0-.08,0-.1,0,.08,0-.21,0,.05,0-.1,0,.13,0,.11,0,.08v.09c0-.12,0-.25,0-.09,0,0,0-.06,0,0a.74.74,0,0,0,0,.15v-.21c0,.05,0,.2,0,0,0,.2,0-.08,0,0s0,.1,0,.11v-.06s0,0,0,.06c0-.11,0-.08,0,0,0-.07,0-.15,0,0,0-.13,0-.1,0-.08s0,.06-.05.07,0,.1,0,.11,0-.12,0-.14c0,.2-.09,0-.12.29a.18.18,0,0,1,0-.06h0a.08.08,0,0,0,0-.09s0,0,0,0a.32.32,0,0,0,0-.09h0a.07.07,0,0,1,0-.07s0-.07,0-.1,0-.09-.09-.1a.13.13,0,0,0,.06-.11h0v0s-.1,0-.1,0l0,0h0s0,0,0-.06,0,0,0,0,0,0,0,0h0l-.25.14,0,0h0s0,0,0,.06,0,0,0,0L49,206h0s.06.05.07.09,0,0,0,.08h0v0l.06,0s0,0,0,.07h0l0,0s0,0,0,0,0,0,0,0l0,0c.05,0,0,0,0,0h0s0,0,0,0l0,0,0,0,0,0h0s0,0,0,0v0a.29.29,0,0,0,0,.09l0,0h0l0,0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0s0,0,0,0l0,.08a0,0,0,0,0,0,0c0,.05,0,.06,0,.09h0c0,.06-.07.09,0,.09a.08.08,0,0,0,0,0h0l0,0h0s.1,0,0,0,.06,0,.07,0,0,0,0,0h0a.18.18,0,0,1,0,.06h0l0,0a.08.08,0,0,0,0,0s0,0,0,0h0l0,0a.06.06,0,0,1,0,.05h0a.21.21,0,0,1,0,.13h0s0,0,0,0,0,0,0,0a1.46,1.46,0,0,1-.09.18s0,.05.06,0h0s0,0,0,0l0,0h0l0,0h0s0,0,0,0,0,.06,0,0h0c-.11.1,0,0,0,0h0c-.1.06,0,0-.08.09,0,0,0,.07,0,.08l.06,0h0s0,0,0,0,0,.05,0,.07l.05,0h0c-.08.07-.06.08,0,.07s0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,.06,0,.05h0s0,0,0,0a.24.24,0,0,0,0,.08.17.17,0,0,0,0,.09s.08,0,.1-.08c0,.1,0,.08,0,0s0-.09,0-.1v0l0,0,0,0v-.05l0,0a0,0,0,0,0,0,0l0,0h-.06c.07,0,0,0,0,0s0-.05,0-.05,0,0,0,0l0,0h0v0h0s0,0,0,0h0c.11-.08,0-.05,0-.05l0,0s0,0,0,0h0c.07-.06.06-.07,0-.06s.09-.13,0-.07,0,0,0,0h0l0,0h0s0,0,0,0,0-.11,0-.1c.12-.12.08-.14,0-.16l0,0s0,0,0,0,.09-.13.06-.14l0,0h0l0,0s0-.1,0-.09v0l.07,0v0h0v0h0a.43.43,0,0,1,0-.05v0h0s0,0,0-.07c0,.06,0,0,.05-.07a.18.18,0,0,1,0,.06c0-.11.06,0,0-.18,0,.15,0,0,0,.14,0-.18,0-.06,0-.06s0-.09,0-.15h0c0,.09,0,.06,0-.08a1.05,1.05,0,0,1,0,.13s0-.15,0,0c0-.12,0-.17,0-.13v-.11s0,.11,0,0h0s0,.1,0,0c0,.2,0,.06,0,0v.13s0-.06,0-.05v0h0s0,0,0,.05c0-.21.05-.07.07,0,0-.07,0,.06,0-.13,0,.12,0,0,0,0s0,0,0,0h0a.59.59,0,0,1,0,.11c0-.18,0,.08,0-.14,0,.24,0,.07,0,0,0,.16,0-.07,0,.13,0-.08,0,.06,0,0s0-.11,0-.11h0c0,.06,0,.07,0,0h0c0,.08,0,.06,0,0h0c0,.05,0,0,0,0s0,0,0,.12l.07,0s-.09.14,0,0-.09.09,0,0c-.14.1-.05.05,0,0a.38.38,0,0,1-.09.08s0,.08,0,.2c.13,0,0,.11,0,.25,0,0,0,.07.08,0-.07.06,0,0,0,0l0,0s0,0,0,0,0,0-.08.05c.12-.07-.05.1.09,0-.15.14,0,.05,0,.05s0,0-.08.1c0,0,0,.06,0,.09l.08-.06c0,.05,0,.05,0,0s-.06.08,0,0c-.09.08-.07.09,0,.08s0,0,0,0-.08.12,0,.06c-.07.06-.06.06,0,0s0,0,0,0-.07.08,0,.08v0s0,0,0,0a.05.05,0,0,1,0,0s0,0,0,0l.21-.12h0s.05-.1,0-.06,0,0,0,0l0,0Zm-.11-1.56h0Zm0,.2h0Zm0,0h0v0h0v0a0,0,0,0,1,0,0Zm-1,.52h0Zm0,.06Zm0,0Zm0,0h0Zm0,0h0Zm0,0h0v0h0Zm0,1.14h0Zm0,0Zm0-.14h0Zm0-.95h0s0,0,0,0h0l0,0,0,0h0l0,0h0a.25.25,0,0,0,0,.07h0s0,0,0,0h0Zm0,0h0Zm0,0h0Zm0-.18v0Zm0,0a.11.11,0,0,1,0,0v0Zm0,0c0-.09,0,0,0-.09v0a.38.38,0,0,0,0,.1Zm.12-.22v0Zm0,0h0v0A.1.1,0,0,0,49.56,206.63Zm.09-.09Zm.05-.06Zm0,0h0Zm.09-.2s0,.07,0,.07v-.08Zm0,.1v0Zm0,0a0,0,0,0,0,0,0s0,0,0,.1l0-.11Zm0,.25s0,0,0,0Zm0,0v0h0Zm0-.27v0Zm.35.11Zm0,0Zm0-.42V206h0V206Zm.14.3Zm0,0h0Zm0-.27a0,0,0,0,1,0,0h0Zm0,.27h0Zm0,0h0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.52 207.01 49.52 207.01 49.52 207.01 49.52 207.01 49.52 207.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.54,207h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.54,207h0v0h0v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.93,198l-.06.16c.05-.09.06-.13.07-.14v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.55,207h0s0,0,0,0,0,0,0,0h0v.06s0-.08,0,0h0s0,0,0-.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.53 207.01 49.53 207.01 49.53 207.01 49.53 207.01",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.53 207 49.53 207 49.53 207.01 49.53 207 49.53 207",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.52,207h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.94,197.37h0a.68.68,0,0,1,0,.12v0A.22.22,0,0,1,53.94,197.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.36 201.03 46.36 201.03 46.36 201.03 46.36 201.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1,201.38v0h0a.2.2,0,0,0,0,.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.33,195.19h0l.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.94,198v.08h0v0S53,198,52.94,198Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06,201.41v0l0-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.08,201.32h0a.59.59,0,0,1,0,.11v0A.51.51,0,0,0,47.08,201.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,202V202h0V202Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.22 197.07 53.22 197.07 53.21 197.07 53.22 197.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.79 198.32 54.8 198.32 54.8 198.32 54.79 198.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,197.37h0C54,197.31,54,197.17,54,197.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,197.25c0,.1,0,.07-.05.12h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,197.42v0h0a.23.23,0,0,0,0,.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.74,198.38c0-.09,0-.1.06-.06C54.85,198.08,54.76,198.27,54.74,198.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,197.46v0l0-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,197.38h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.69,204.33h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,190.11s0,0,0,0,0,0-.06.06,0,0,.07,0,0,.05,0,.05l-.07.05c.12-.05,0,.06.09,0s0,.13,0,.19l-.05,0c.08,0,0,.16.11.09-.11.07,0,.05-.11.11.12-.05,0,.06,0,.13s0,.1.06.13.07,0,0,.05l0,0c0,.06-.08.1-.08.12s0,0,.07,0h0l-.07,0s.1,0,0,0,.07.05.07.08,0,0,0,.06l0,0h0l0,0s0,0,0,0,0,0,0,0h0s0,0,0,.07,0,0,0,0,0,.1,0,.18h0s0,0,0,0v0l-.05,0s0,0,0,0l0,0,0,0h0v0l0,0s0,0,0,.07,0,0,.05,0l0,0,0,0a.73.73,0,0,1-.1.2s0,.08.08,0c-.07,0,0,0,0,0h0l0,0c.11,0,0,.09.07,0h0c-.12.1-.05.05,0,.05h0s.06,0-.06.08c.05,0,0,.08,0,.11l.07-.05c-.05.05,0,.05,0,0s-.05.1,0,.05c-.09.09-.06.11,0,.1s0,.06,0,0-.07.16,0,.07c-.08.1,0,.07,0,0-.09.12-.09.18,0,.12s0,.05,0,.06l0,.11.25-.16s0-.07,0-.11,0-.06.06-.06,0,0,0,0h0s0,0,0-.06.08-.09,0-.11h0l0,0h0c.07-.06,0,0,0-.07s0,0,0,0h-.06s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0-.05h0c.07-.07,0,0-.05,0s0,0,0,0h0s0,0,0,0v0h0v0h0c0-.07.09-.14,0-.09.09-.06-.11,0,0-.06-.07,0,0-.16,0-.17.2-.16,0-.17,0-.26s.1-.14.08-.16l0,0h0l0,0s0-.1,0-.12l0,0v0s0,0,0,0,0,0,0,0l.16-.05h0v0c0,.06,0,0,0-.05v.05h0c0-.08,0,.07,0-.16a.81.81,0,0,0,0,.17c0-.19,0-.05,0,0s0-.06,0-.11,0-.11,0,0,0-.06,0-.08q0,.24,0,0v.15s0-.16,0,0a.7.7,0,0,0,0-.14v0h0v0l0,0v0s0,0,0,0v0s0,0,0,0h0s0,0,0,0v0h0s0,0,0,.06h0v0c0-.07,0-.11,0,0v0a.36.36,0,0,0,0,.1c0-.07,0,0,0-.11h0c0,.08,0,0,0,0h0v.06a.35.35,0,0,1,0-.06v0s0,.07,0,0h0c0,.13,0,.09,0,0v0s0,0,0,0h0v0h0v0h0v.07c0-.08,0,.07,0,0a.54.54,0,0,0,0-.11h0c0,.09,0,.08,0,0,0,.14,0,.11,0,0a.06.06,0,0,0,0,0h0s.05.05,0,.12l0,0,0,0s0,0,0,0v.06h0a.13.13,0,0,0,0,.06s0,0,0,0a.12.12,0,0,0,0,.1.16.16,0,0,1,0,.1h0s.07,0,0,.12,0,0,0,0,.05,0,.08-.05a.17.17,0,0,0-.06.06s.08,0,0,.1,0,0,0,0l0,0,0,0c0,.06,0,.09,0,.13s0,0-.05,0,0,0,.08,0,0,0-.08.09,0,0,0,0,0,0,0,0h-.05s0,0,0,0h0s0,0,0,0,.06,0,0,.06.06-.05.08-.05l-.1.09s0,0,0,0,0,0,.05,0,0,.05,0,.07,0,.09,0,0l0,.08.08-.06h0s0,.05,0,.06,0,0,0,.08,0,0,0,0,0,.06,0-.07,0,0,0,0,0,0,0,.1,0,0,0,0,0-.1,0-.11,0,0,0,0l.06-.14h0l0,0h0l0,0h0l0,0s0,0,0,0,0,0,0,0l0,0h0s0,0,0,0h0l0,0h0s0,0,0,0h0s0,0,0,0h0c.08,0,0,0,0-.07s0,0,0,0,0,0,0,0,0,0,0,0h0l0,0s0,0,0,0-.05,0-.06,0l.07,0s0,0,0,0,0,0,0,0,0,0-.09,0l.06,0-.09,0h0c.06,0,0,0,0,0s0,0,0,0,0,0,0,0,0,0-.1,0v0h0l0,0s0,0,.06,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.05l0,0h0l0,0h0s0,0,0,0,0,0,0-.08-.06,0-.07,0h0a.15.15,0,0,0,.07-.05c-.09,0,0,0,0,0s0,0,0,0,0,0-.06,0,0,0,.06-.07,0,0-.07,0l.08-.05s0,0,0,0,0,0,0,0,0,0-.05.05h0a.26.26,0,0,1,.09-.07s0,0,0-.05,0-.05,0-.05h0c.06,0,.08-.08.05-.07s0,0,.07-.08,0-.05-.05,0,0,0,.05-.06l0,0c.06,0,0,0,0,0s0,0,0,0h0s0,0,0,0,0,0,.07-.06l-.09.06h0a.22.22,0,0,0,.09-.07l-.06,0,0,0h0c.05,0,.08-.1.05-.1l0,0s0,0,0-.05,0,0,0,0h0l0,0,0,0s0,0,0,0,0,0,.06,0h0s0,0,0,0-.05,0,0,0h0s0-.05,0,0-.05,0-.05,0l0,0,0,0s.08-.07,0,0v0s0,0,0,0l.09,0s0,0,0,0,0,0,0,0,0-.1,0-.08h0l.06,0,0,0s0,0,0,0,.08-.06,0,0l-.07.05s0,0,.09-.07,0,0,0-.07.08-.1,0,0l0,0h0l.06,0c.07-.06,0-.06,0-.08v0h0v0s0,0,0,0h0s0,0,0,0l0,0s-.07,0,0,0,0,0,0,0h0c.15-.11,0,0,0-.06s0,0,0,0,.14-.16,0-.11h0s0,0,0,0v0l0,0h0s0,0,0,0,0-.07,0-.07,0,0,0,0c.15-.12,0-.09,0-.14s.09-.12.06-.13l-.07,0h0l.09-.06s.1-.14,0-.06c0,0,0,0,0,0h0c-.05,0,0,0-.08,0s.07-.08,0,0h0c.07-.05-.06,0,0,0l-.06,0s0,0,0,0v0l0,0h0c.07,0,.14-.1,0,0s0,0,0,0l0,0h0l.08,0s-.12,0,0,0c-.13.06.06-.09,0-.06a.09.09,0,0,0-.05,0h0l0,0h0s0,0,0,0h0c.06,0,0-.07,0,0s.1-.1,0,0c.09-.07.07-.1.07-.12a.32.32,0,0,1,0-.09l-.07,0h0l.09,0c-.12,0,0-.22-.13-.21h0c.08-.08,0-.1.06-.12s-.11,0-.1,0l0,0-.06,0c.14-.12-.06-.05.07-.13l-.1.06h0l-.12.08,0,0s-.06.1,0,.06l-.07,0c0,.05.14,0,0,.14.12-.06,0,0,0,.05s0,0,.07,0,0,0-.07.06l.08,0c-.06,0,0,0,0,0l-.07,0c.11,0,0,.05.08,0s0,.08,0,.11l0,0c.07,0,0,.11.09,0h0c-.08,0,0,0-.09.07s-.09-.1-.09-.16.12-.16,0-.08a.2.2,0,0,0,0,.26c.1.21,0,.51.13.7,0,0-.06.08,0,.06s0,0,0,.09,0,0,0,0,0,0,0,0h0l0,0a0,0,0,0,1,0,0s0,0,0,0a.17.17,0,0,1,0,.05h0a0,0,0,0,0,0,0l0,0h.05s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,.05,0,0,0,0,0,0,0,.08,0,.16,0,0,0,0,0,0,0,0-.06.06,0,.06h0c0-.06,0,0,0,0v.07s0,0,0,0h0v.06h0a.35.35,0,0,1,0-.06.23.23,0,0,0,0,.07h0a.43.43,0,0,0,0,0c0,.06,0,0,0,.07h0c0-.24,0,0,0,0s0-.27,0-.05c0-.15,0,.17,0-.06,0,.11,0,0-.05.08,0-.3,0,0,0,0s0-.15,0-.1v.13h0a.59.59,0,0,0,0-.11s0-.14,0,.09v-.06a.71.71,0,0,0,0,.12c0-.08,0-.11,0,.07,0-.22,0,.06,0-.1a.17.17,0,0,1,0,.08h0v0s0-.06,0,0,0,0,0,.07v-.06h0v-.07s0,.11,0,.11v-.07h0c0,.18,0-.09,0,0v0h0v0h0a.15.15,0,0,1,0-.06v0s0,0,0,0v.1c0-.09,0-.07,0-.06l0,0h0v0s0-.06,0,0a0,0,0,0,1,0,0v0h0s0,0,0-.05,0-.06,0,0v.06c0-.05,0-.1,0-.07s0,0,0,.1h0s0,0,0,0h0c0-.06,0,0,0,0s0,0,0,0v0h0s0-.06,0,0,0,0,0,.05h0c0-.05,0,0,0,0h0s0,0,0,0,0,0,0-.05,0-.06,0,.08c0-.07,0,0,0,0s0,0,0,0,0,0,0,0a.43.43,0,0,0,0,0c0,.09,0,0,0,.09,0-.09,0,0,0,0v0s0,0,0,.06,0,0-.05,0l-.06,0h0c.14-.08,0,0,.06-.06-.08,0-.06,0,0,0h0l0,0,0,0c.07,0,.14-.11,0-.06s0,0,0,0,0,0,0,0h0l.08-.05h0s0,0,0-.06c-.12,0,0-.09,0-.11s0,0,0,0,0,0-.06,0v0a0,0,0,0,0,0-.05s0,0,0,0,0,0,0,0l0,0h0s0,0,0,0h0s0-.07,0-.07h0v0h0l0,0,0,0h0s0,0,0-.05h0l0-.05s0,0,0,0,0,0,0,0h0v0s0,0,0,0,0,0-.05,0h0c.05,0,0,0,0,0h0s0,0,0,0h0c-.05,0,.06-.11,0-.06s0,0,0,0v0s0-.06,0-.1,0,0,0,0,0,0,0,0,0-.06-.06,0,0-.06,0-.06v0h0s0,0,0,0h0s0,0,0-.05a.19.19,0,0,0,0-.12s-.05,0-.05,0h0s.06-.15.06,0v-.32s0,0-.06,0l-.08.13,0,0h0l0,0,0,0h0l-.07.05,0,0,0,0h0s0,0-.07,0a.33.33,0,0,0,0,.14s0,.08,0,.16C53.3,190,53.2,190.07,53.2,190.11Zm.16,2s0,0,0,0l0,0Zm.18.28h0Zm-.07.08Zm0-.08h0Zm0,0Zm1-1.22,0,0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0S54.5,191.14,54.5,191.14Zm.08-.95h0Zm0-.42v0h0Zm-.27,2.28,0,0c-.06,0,.1-.07.06,0S54.37,192,54.34,192.05Zm0-.72,0,0h0l0,0h0Zm0-.19h0Zm0,0h0s0,0,0,0Zm0-.25h0Zm0,0Zm0,.21Zm0,.06s0,0,0,0l0,0Zm0,.11h0Zm0,.12Zm0,.64h0Zm0-.73h0Zm0,.75Zm0,0Zm0-.23h0Zm-.06.25h0Zm0,.2,0,0h0S54.38,192.34,54.37,192.32Zm0-.16s0,0,0,0h0S54.42,192.15,54.41,192.16Zm0-2.18Zm0,2.21h0s0,0,0,0Zm0,0h0Zm0,0h0Zm0,0Zm.09.17h0s0,0,0,.06,0-.05,0-.05,0,0,0,0v0h0v0h0Zm0-.36h0Zm0,0h0Zm0,.19h0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0-.11h0v0Zm0,0Zm0,.12Zm0,0Zm0,0h0Zm0-.16h0Zm0,0h0Zm0,.1h0Zm0-.11h0Zm0,0a0,0,0,0,0,0,0h0l0,0Zm0,0s0,0,0,0h0a0,0,0,0,0,0,0h0Zm0,0h0Zm0-.08s0,0,0,0h0Zm0,0h0v0h0Zm0,0h0s0,0,0,0h0s0,0,0,0S54.45,191.89,54.5,191.87Zm0,0Zm0,.15h0Zm0-2h0l0,0h0Zm0-.42,0,0s0,0,0,0h0v0h0l0,0h0Zm-.06-.05s0,0,0-.05v.05Zm.05,0s0,0,0,0h0S54.45,189.56,54.45,189.57Zm0-.17Zm0-.11s.05,0,0,0Zm-.06-.17c.06,0,.06,0,0,0S54.37,189.12,54.34,189.12Zm0,.22v0l0,0Zm0,1.24Zm0,.47h0Zm0-.15Zm0-.22v0Zm0,.53h0l0,0v0c-.05,0,0,0,0,0s0,0,0,0S54.39,191.23,54.4,191.21Zm-.07-.51h0v.07C54.34,190.68,54.33,190.83,54.33,190.7Zm0,.29h0v0h0l0,0S54.33,191,54.33,191Zm-.11,0v0Zm-.12-.21h0Zm0,.13v0Zm0,.07v0h0Zm-.05-.13h0Zm-.33.43,0,0h0Zm0,0h0Zm-.15.07v0h0Zm0-.09v0h0s0,0,0,0h0S53.54,191.25,53.55,191.24Zm0,.24h0Zm-.11-1.8h0v0Zm0,3s0,0,0,0l-.05,0h0Zm0-1.27h0Zm0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8,191.39h0v0A.1.1,0,0,0,53.8,191.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.79,191.37h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,195.3h0a.11.11,0,0,0,0-.05H47s0,0,0,0h0l0,0C47,195.3,46.94,195.18,47,195.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.19,191.13c.06,0,.06,0,.05.05a.56.56,0,0,1,0,.08s0,0,.06,0,0,0-.07.05c.06,0,0,0,.08,0s0,.05,0,0l-.07,0c.11,0,0,.05.08,0s0,.1,0,.15l-.05,0c.06,0,0,.1.05.09v0s0,0-.06,0h0v.05l0,.07s0,.07,0,.09v.1s0,.05,0,.06v0h0a1.32,1.32,0,0,0,0,.53l-.08.12s0,0,0,0h0v0h0s0,0,0,.07,0,0,0,0a.07.07,0,0,1,0,.05h0c.05,0,0,.06,0,.09l0,0h0s0,0,0,0h0s0,0,0,0h0s0,.05,0,.05h0s0,0,0,0v0s0,0,0,0v0h0v0s0,.08,0,0,0,.06,0,.05h0v0l0,.06c.07-.06,0,0,.06,0h0s0,0,0,0v0a.08.08,0,0,0,0,0h0s0,0,.06,0c-.14.24,0,.37-.07.47l.26-.14,0,0c0-.09.06-.33,0-.33s0,0,.07-.06a1,1,0,0,0,0-.24l0,0h0v0s0,0,0,0h0c.06-.06,0-.06,0-.07v0l0,0h0v-.07h0v0h0v0h0s0,0,0,0l0-.09s0,0,0,0,.06-.08,0,0,0,0,0,0h0l0,0s0,0,0-.06l0-.1h0c.13-.11,0-.12,0-.19s.1-.13.07-.14l-.06,0h0s.06,0,.07,0,.1-.15,0-.08c0,0,0,0,0,0l0,0s0,0-.07,0h0s.07-.08,0,0h0l0,0s0,0,0,0l0,0s0,0,0,0h0l0,0h0v0h0a.06.06,0,0,0,0-.06s0,0,0,0h0l0,0h0a.36.36,0,0,0,0-.11v-.08a.08.08,0,0,0,0-.09.06.06,0,0,0,0,0v-.08h0c0-.07,0-.15,0-.21s0,0,0,0a.31.31,0,0,1,0-.19.68.68,0,0,0,0,.15.82.82,0,0,0,.21.34s.09,0,0,.1,0,0,.05,0c-.06.24,0,.38.12.34l-.09.1s.13,0,0,.06a.61.61,0,0,1,.22.39h0l0,.08s.06-.08.07-.07a.48.48,0,0,0,0,.17s0,.06.09,0-.06.17,0,.1c-.12.17,0,.1,0,0s0,.06-.07.14a.63.63,0,0,1,.19.32h0a.81.81,0,0,1,0,.16l.08,0a.27.27,0,0,0,0,.12l.06-.1h0l.1,0,0,0v-.09a4.34,4.34,0,0,1,.13-.52s0-.16-.07-.13c.07,0,0-.14,0-.16a.09.09,0,0,1,0,.07s0,0,0-.08,0,0,.07,0,.07-.27-.07-.19c.16-.15,0-.09,0-.17s.05,0,0-.1,0-.08,0-.07,0-.16,0-.28-.06.05-.07,0,0-.09,0-.06a.16.16,0,0,0,0-.13s0-.05-.06,0,.06-.18,0-.22a.12.12,0,0,0,0-.11,0,0,0,0,0-.06,0c.08-.16.09-.3,0-.26.08-.1,0-.12,0-.09.09-.15.11-.28,0-.35.15-.13-.15-.16,0-.37-.07,0,0-.08-.07-.05a.09.09,0,0,0,0-.13.32.32,0,0,0,0-.32c.08-.1,0-.09,0-.18s0,.09-.07.09,0-.05,0,0,0,0,0,0,0,0,0,0,0,.11,0,.14-.08.09,0,.07.07-.09.06-.06,0,.06-.09.1a.69.69,0,0,0,0,.32c0,.62-.07,1.21-.08,1.81,0,.21,0,.44,0,.65a.56.56,0,0,1-.05.08h0c.05-.07.07-.08.07-.13s0-.11,0-.18,0-.11-.1-.05.06-.11,0,0,0,0,0,0a.08.08,0,0,1,.06-.09h0v0s0-.05-.07,0,0-.25-.1-.15c.12-.17,0,0,0-.14-.08.09-.08,0-.07,0s0,.07-.06.06.12-.26,0-.16,0,0,0,0,0,0-.1.07l.13-.17c-.06,0-.17,0-.08-.17-.15.06,0-.28-.12-.26s0,.1-.07.08l.06-.1s0,0,0,0,0-.12-.08-.09c.05-.15,0-.25-.07-.2s.05-.22,0-.13a.36.36,0,0,0,0-.33l-.1-.19-.12.28,0,.12a1.36,1.36,0,0,0,0,.17l-.09,0h0v0h0a0,0,0,0,1,0,0,.14.14,0,0,1,0,.06S51.26,191.05,51.19,191.13Zm.32,1h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.69,192h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,187.14h0v0S61.7,187.14,61.69,187.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.22,193.81s0,0,0,0,0,0,0,0,0,0,0-.05,0,.05,0,.12-.07,0,0,0,.06,0,0,0,0,0-.07,0-.07.18-.09.26-.12.11,0,.18,0,0,0,0l0,0c-.06,0-.07.05-.07.11s0,.11,0,.08a.51.51,0,0,1,0,.09c0-.09-.06,0,0,.05,0-.06,0,.08,0,0s0,0,0,0,0,0-.05.05,0-.06,0-.07,0,.13,0,0,0,0,0,0,0-.1,0-.07-.06.11-.08.1,0-.09,0-.15,0-.08-.07,0c.06-.14-.11.13,0-.08-.1.05-.08-.14-.16-.1.07-.16,0-.19,0-.21s-.1,0-.1-.08.06-.22,0-.23a.1.1,0,0,1,0,0v0l0,0s.06-.24-.08-.13h0s.05-.07,0,0,0,0,0,0,0,0-.08,0l0-.06h0s0,0,0,0l0,0c-.13,0,.07-.11,0-.12s0,0-.06,0h0l.05,0s0,0,0,0,0,0,0-.06.08-.08,0-.09.1-.06,0-.06h0a.14.14,0,0,0,.09-.15.81.81,0,0,1,0-.16h-.07s.08,0,.09,0,0-.07,0-.11l0,0,0-.05a.49.49,0,0,0,0-.11l.05,0h0l0,0,0,0s0,0,0,0l0,0-.07,0s0,0,.09,0h0s0,0,0,0l-.06,0c.06,0,0,0,0,0l0,0s0,0,0,0,0,0,0,0l0,0s0-.06,0,0l0,0c.12.14,0,0,0,0s.11.15,0,0c0,.09-.05-.12,0,0,0-.08,0,0,0-.07,0,.11,0,.1,0,.07s0-.09,0-.07,0,.11,0,.07l0-.09v0c0,.08,0,.1,0,.13s0,.12,0-.08c0,0,0,.07,0,0v0a1,1,0,0,1,0-.11c0,.08,0,.1,0-.06,0,.19,0,0,0,.09,0-.12,0-.1,0-.07V192c0,.12,0,.24,0,.09s0,.06,0,0v-.14l0,.2s0-.19,0,0c0-.12,0-.07,0,0h0s0,0,0,0,0,0,0,0h0v0h0l0-.06,0,.06v0h0l0,0s0,0,.08-.08l0,0h0a.09.09,0,0,0,0,0v0h0l0,0h0l0,0,0,0h0l.07,0,0,.15h0v0L61,192l-.07.1h0c0-.06,0,0,0,0v0l0,0s.06-.08,0,0l0-.06-.07.1v0l0,0,0,0h0l0,0,0,0h0s0,0,0,0l0,0h0s0,0,0,0,0,.06,0,.06h0v0l0,.05s.07-.16,0,0c0,0,0-.06,0-.07s0,0,0,0,0,0,0,.06h0v-.07h0s0,0,.08-.09l-.08.1h0c.07-.08.1-.11.06-.05l0,0h0c-.07.08,0,0,0,0h0l-.06.07s0,0,0,.05c.12-.12,0,0,0,.07l.08-.08c-.07.08,0,0,0,0l0,0s0,0,0,0l-.07.07.08-.08c-.14.15,0,.05,0,0s0,0-.08.09c0,0,0,0,0,0l.06-.07c0,.05,0,0,0,0h0c-.09.09-.07.08,0,0s0,0,0,0-.08.08,0,0c-.09.08,0,0,0,0s-.11.1,0,0c-.16.13.15-.11,0,0l.08-.05s0,0,0,0l0,0c-.08.05,0,0,0,0l.06,0s0,0,0,0l0,0,.05,0s0,0,0,0l0,0-.07,0s0,0,.09-.06,0,0,0,0,.07-.08,0,0,0,0,0,0l.07-.06c.1-.1-.07,0,0,0l-.07.06c.07-.07.06-.06,0,0l0,0h0s0,0,0,0l0,0c0,.05-.08.06,0,0s0,0,0,.05c.18-.18,0,0,0,0s.17-.19,0-.06c.09-.09-.1.09,0,0,0,0,0,0,0,0l0,0s0,0,0,0h0c.09-.11,0-.05,0,0v0s.07-.09.05-.07l-.05.05h0l0,0s.08-.12,0,0h0l0,0,0,0s0-.08,0-.07l.07-.06a.46.46,0,0,0-.11-.21s-.06,0-.08-.07a.17.17,0,0,1-.07-.09h0v0c0,.1,0,.1-.07.09s0-.05-.06,0-.11.12-.11.13,0,.06,0-.08c0,.1,0,0,0,.14,0-.06,0,0-.06,0v0s0-.07,0-.07c0,.18-.07,0-.07.2,0,0-.06,0-.11.11h0v0a.2.2,0,0,0,0,.08h0a.35.35,0,0,0,0,.06l0,0a.62.62,0,0,1,0,.1l0,0a0,0,0,0,1,0,0,.21.21,0,0,1,0,.06l0,.05h0a.14.14,0,0,0,0,.09.08.08,0,0,0,0,0c-.06-.06,0,.05-.1,0a.08.08,0,0,1,0,0l-.07,0,0,0s-.07,0,0,.1l0,0s0,.05,0,.08v.09s0,.09-.07.12,0,0,0,0h0s0,0,0,.06,0,.07,0,.06,0,0-.07,0,0,0,.07,0,0,0,0,.05h-.07c.11,0,0,.05.07.06s0,.09,0,.14,0,0,0,0h0s0,0,0,0v0s0,.08.06.07h0c-.07,0-.06,0-.07,0h0s0,0,0,0,.07,0,.05,0h0a.41.41,0,0,0-.05.09c0,.05,0,.08.05.1s.07,0,0,0h0c-.12.1-.11.14,0,.11l-.1,0s.1,0,0,0c.07,0,.1,0,.06.14l.07,0s-.09.12,0,0h0s-.08.06,0,0c-.14.08-.05,0,0,0l-.09.06s0,.08,0,.2c.13,0,0,.08,0,.26.05,0,0,.09.09-.05-.07.09,0,0,0,.05l0-.07s0,0,0,0,0,0-.06.09c.1-.13,0,.12.09-.06h0c-.12.21,0,.07,0,0-.09.13.06,0-.06.14.06-.05,0,.08,0,.09l0-.06h0l0,0v0h0v0h0l0,0v0h0c0,.06,0,.06,0,0s0,0,0,0,0,.14,0,.1h0l0,0c0,.06,0,.05,0,0h0c-.05.12,0,.16,0,.07h0c0,.1,0,.06,0,0s0,0,0,0v0h0c0,.11,0,.05,0,0v0c0,.06,0,.08,0,0l0,0c0,.09,0,0,0,0,0,.17,0,.2,0,.08,0,.13,0,.07,0,0s.07-.1,0,0c0-.11,0,.05.05-.12,0,.06,0,.06,0,0,0,.13,0,.12.07,0,0,.12,0,.05,0,0s0,0,0-.1,0,0,0,0,.06,0,.08-.06,0,0,.06,0a.22.22,0,0,0,0-.11c.07.07.15,0,.11-.14.06.07.05,0,0-.06s.15-.05.11-.17c.07,0,.06,0,.05-.08s0-.12.06-.11,0,0,0-.08,0,0,0-.08.09,0,.09-.13,0,0,.05-.06S61.25,193.87,61.22,193.81Zm-.1-1.78Zm-.17-.1h0l0,0Zm0,0s0,.05,0,0v0Zm0,0h0v0Zm-.15-.18s0,0,0,0a.15.15,0,0,0,0-.06Zm0-.06v0s0,0,0,0Zm0,.25v0h0Zm0,0s0,0,0-.06V192h0v0h0Zm0,0h0a1,1,0,0,0,0-.11ZM60.6,192h0Zm0,0v0a.1.1,0,0,1,0,0Zm0,0v0Zm0,0v0Zm-.11.29h0Zm-.13,0h0Zm0,0h0Zm-.4,1.49h0Zm.19-.19h0Zm.13,1.08v0l0,0v0A.05.05,0,0,0,60.26,194.7Zm0,0h0Zm0,.3h0v0Zm0-.31,0,0s0,0,0,0a.39.39,0,0,1,0-.06s0,0,0,0v0Zm0,.08,0,0h0Zm0,0v0h0S60.35,194.79,60.35,194.8Zm0-.09Zm.27-.08v0h0A.39.39,0,0,1,60.66,194.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,195.21h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,194.8h0v0h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,195.3h0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,195.23c0,.06,0,.08,0,0s0,.06,0,.06h0l0-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,195.35s0,0,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.89,197.36a.28.28,0,0,0,0-.13s0,0,0,0,0,0,0,0h0s0,.06,0,.07h0c0,.08,0,0,0,0s0,0,0,0S52.88,197.34,52.89,197.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,187.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,195.32v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.28,190.87h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,191.18s0,0,0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64,192.44h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.95 193.57 61.95 193.56 61.95 193.56 61.95 193.56 61.95 193.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.87 191.14 62.87 191.15 62.87 191.15 62.87 191.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.95 193.57 61.95 193.57 61.95 193.57 61.95 193.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,193.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.96 193.56 61.95 193.56 61.96 193.56 61.96 193.56 61.96 193.56 61.96 193.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.99 193.52 61.99 193.53 61.99 193.53 61.99 193.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.77,193.56s0,0,0,0l-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.78 193.54 62.78 193.54 62.78 193.54 62.78 193.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.76,193.5s0,0,0,0,0,0,0,0v-.06l-.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.51,187.55v.07c0-.08,0,0,0-.05h0v-.07c0,.05,0,0,0,0,0,.14,0,.11.06,0,0,.11,0,.05,0,0h0s0,0,.06-.06c0,.09.06,0,.06-.08,0,.09.08.08.08-.08,0,.12,0,0,0,0,0,.12.08.11.11,0,0,.11,0,0,.05,0s0-.13.08,0c0-.09,0,0,0-.13,0,0,0,0,0-.06s.1,0,.1-.09c.06.06,0,0,.07-.06s0,0-.06,0,0,0,0,0,0,0,0-.05,0,0,0,0,0,0,0,.09-.05-.06,0,0,0,.07,0,.07,0,0-.06-.08-.06.1-.09.15-.1,0-.09.12c0,0,0,.05,0,.06l0-.09c0-.06-.06,0-.08,0s-.06.1-.09.05a.19.19,0,0,1,0,.11c0-.11,0-.06,0,0,0-.07,0,.07,0,0s0,0,0,0,0,0,0,.05v-.08c0,.08,0,.13,0,.07a.14.14,0,0,0,0,.06c0-.16,0-.16,0-.12s-.05.12-.07.11,0-.08,0-.13,0-.08-.06,0c0-.15-.1.14,0-.08,0,0-.07,0-.08,0l0,0s0,0,0,0h0c.07-.15,0-.18,0-.19l0,0c.07-.08.06-.11,0-.13l0,0c0-.06,0-.1,0-.12s.05-.09,0-.09l0,0h0l0,0s.1-.18-.05-.1c0,0,.08-.06,0,0h0v0h0l.05,0c-.05,0,0,0-.08,0s.07-.1,0-.07h0c.09-.06,0,0,0-.05-.08,0-.06,0,0,0l0,0s0,0,0,0,.15-.1,0-.06,0,0,0,0l-.09,0h0l.13-.07s-.13,0,0-.06c-.13,0,.06-.11,0-.11s-.06,0-.07,0l.07,0s0,0,0,0,0,0,0,0a0,0,0,0,0,0-.09s.11-.06,0-.06c.09,0,.08-.12.09-.16s0-.12,0-.17-.06,0-.07,0l.09,0a.16.16,0,0,1,0-.1l0-.1a.25.25,0,0,0,0-.09h0l0,0a.37.37,0,0,1,.13-.24c.07,0,.12-.08.21-.26,0,.06,0,.09,0,.09h0s0,0,0,0,0,0,.06,0,.08,0,.08,0l0,0s0,0,0,0,0,.12,0,.15,0,.06,0,.1l.26-.14s0,0-.05,0a.89.89,0,0,1,0-.11s0-.08,0-.07l.07-.06a.37.37,0,0,0-.11-.19.47.47,0,0,1-.12-.21l0,.08h0c0,.05,0,0-.08,0a.31.31,0,0,0-.1.13c0-.11,0,0,0-.09,0,.1,0,0,0,.14,0,0,0,0,0,0l0-.15s0,.06,0,.07-.07,0-.08.1c0,0,0,0,0-.09l-.06.1,0,.06,0,.06c0,.06,0,.1-.11.1s0,.08,0,.13h0l0,0h0v0a0,0,0,0,0,0,0,.1.1,0,0,0,0,0h0c-.05,0,0,0-.06,0s0,0,0,.06h0s0,0,0,0v0h0l0,0a.14.14,0,0,0,0,.11h0c-.06,0,0,.05-.1,0a.11.11,0,0,1,0,.13.54.54,0,0,0-.09.15.42.42,0,0,0,0,.32h0s0,0,0,0v0l0,0h0c-.1.11-.1.21,0,.21h0l-.08,0s.1,0,0,.05a.3.3,0,0,1,.08.3s.06,0,.07,0-.06.13,0,.12,0,0,0,0,0,0,0,0h0c-.07.07,0,.05,0,0h0l-.07.07a.16.16,0,0,1,0,.07s0,0,0,0h0a.72.72,0,0,1,0,.21l0,.09c.05,0,0,.08.09,0-.07.08,0,.06,0,.06l0-.06h0s0,0,0,0l-.07.07c.11-.09,0,.13.09,0-.13.19,0,.07,0,.06s.06,0-.07.13c.06,0,0,.09,0,.11s.06-.08.07-.08,0,.06,0,0,0,.11,0,0c-.07.13,0,.13,0,.09s0,.06.06,0c-.05.14,0,.18,0,0,0,.14,0,.07,0,0,0,.16,0,.21,0,.08,0,.13,0,.07,0,0s0-.05,0-.05Zm-.26-1.8v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.95 193.57 61.95 193.56 61.95 193.57 61.95 193.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.79 193.41 62.79 193.42 62.8 193.42 62.79 193.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.79 193.42 62.79 193.42 62.79 193.42 62.79 193.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,195.08c.06,0,.06,0,0,.06a.78.78,0,0,0,0,.07s0,0,.06,0,0,0-.07.06,0,0,.08,0,0,0,0,0l-.07,0c.11,0,0,.05.08,0a.12.12,0,0,0,0,.15l-.05,0c.06,0,0,.1.05.08v0s0,0-.06.06,0,0,.05,0v0a.43.43,0,0,1,0,.07c0,.05,0,.07,0,.09V196s0,0,0,0v0h0v0h0a1.52,1.52,0,0,0,0,.43.57.57,0,0,0,0,.13l-.06.08s0,.05,0,0h0v0h0s0,0,0,.07,0,0,0,0,0,0,0,.06h0s0,.06,0,.08l0,0h0s0,0,0,0h0s0,0,0,0v0s0,0,0,0h0s0,.05,0,0v0s0,0,0,0v0h0v0c0,.06,0,.09,0,.06s0,.05,0,0h0v0l0,.06c.07-.06,0,0,.06,0h0s0,0,0,0v0a0,0,0,0,0,0,0h0s0,.05.05,0c-.13.25.06.38-.06.48l.26-.14s0,0,0,0v0c0,.06.17-.08.17-.21a7.74,7.74,0,0,0-.06-1c0-.05-.07,0-.08,0v0h0s0,0,0,0h0l0,0s0,0,0-.06a.37.37,0,0,0,0-.09h0c.14-.11,0-.12,0-.19s.1-.13.07-.15l-.07.05h0l.07,0s.1-.16,0-.08c0,0,0,0,0,0h0s0,0-.07,0h0c.05,0,.06-.09,0-.05h0s0,0,0,0,0,0,0,0l0,0s0,0,0,0h0l0,0h0v0h0a0,0,0,0,0,0-.05s0,0,0,0h0a.37.37,0,0,0,0-.12v0h0v0a.08.08,0,0,0,0-.09s0,0,0,0v-.08h0c0-.08,0-.15,0-.22s0,0,0,0a.61.61,0,0,1,0-.19.9.9,0,0,0,0,.16.65.65,0,0,0,.21.33s.09,0,0,.11,0,0,.06,0c-.06.24,0,.38.11.35h0A.38.38,0,0,1,45,196s.13,0,0,.07a.61.61,0,0,1,.22.38h0l0,.07,0-.06v0a.57.57,0,0,0,0,.13s0,.05.06,0l0,0s0,0,0,0h0c-.08.13,0,.1,0,0h0s0,.05-.05.11a.64.64,0,0,1,.18.33h0a.86.86,0,0,1,0,.17l.08,0a.27.27,0,0,0,0,.12l.06-.1h0l.1,0,0,0v-.1a2.07,2.07,0,0,1,0-.22h0S46,197,46,197v0l0-.12s0-.16-.07-.13c.07,0,0-.14,0-.17a.09.09,0,0,1,0,.08c0-.05,0-.06,0-.08s0,0,.07,0,.07-.26-.07-.19c.15-.14,0-.09,0-.16s0,0,0-.1,0-.08,0-.08,0-.15,0-.28-.06,0-.07,0,0-.08,0-.05a.17.17,0,0,0,0-.13s0-.06-.06,0,.06-.18,0-.22a.14.14,0,0,0,0-.12s0,0-.06,0c.08-.16.09-.3,0-.27.09-.09.05-.11,0-.09.09-.14.11-.28,0-.34.15-.14-.16-.17,0-.37-.07,0,0-.08-.07,0s0-.11,0-.13a.32.32,0,0,0,0-.32c.08-.11,0-.09,0-.19s0,.09-.07.1,0-.06,0,0,0,0-.05,0,0,0,0,0,0,.12,0,.15-.08.09-.05.06.08-.08.07-.05,0,.06-.09.09v0a.19.19,0,0,0,0,.09,21.93,21.93,0,0,0-.12,2.39s0,0-.07,0h0s.05-.09,0,0v0l0,0h0v0l0,0,0-.07a.13.13,0,0,0,0-.08c0-.1-.07-.19-.1-.29s0,0,0,0v0h0c-.11-.3-.22-.61-.32-.93,0-.08-.09,0-.11.05h0a.36.36,0,0,0,0-.32l-.1-.19-.12.28s0,.08,0,.11,0,.12,0,.17l-.09,0h0v0h0v0h0s0,0,0,0a.08.08,0,0,1,0,.06S44.41,195,44.34,195.08Zm.32,1Zm1.17-.19a.89.89,0,0,1,0,.15v0a2.09,2.09,0,0,1,0-.25A.09.09,0,0,1,45.83,195.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,195.32h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.62,203v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.43,194.83s0,0,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,195.35v0C46.91,195.25,47,195.34,47,195.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.84,193.43v0H62.8S62.84,193.46,62.84,193.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.34,194.06s0,.06.06.05,0,0-.06.06,0,0,.07,0,0,.05,0,.05l-.07,0c.12,0,0,.06.09,0s0,.14,0,.19l-.05,0c.07,0,0,.17.11.1-.11.07,0,0-.11.1.12-.05,0,.07,0,.14s0,.09.06.13.07,0,0,0,0,0,0,0-.08.1-.08.12,0,0,.07,0h0l-.07,0s.1,0,0,0,.06.05.07.08a.07.07,0,0,1,0,.06l0,0h0l0,0s0,0,0,0l0,0h0a.09.09,0,0,0,0,.07s0,0,0,0,0,.1,0,.17h0s0,0,0,.05h0s0,0,0,.05,0,0,0,0l0,0,0,0h0v0l0,0s0,0,0,.06,0,0,0,0l0,0,0,0a1.78,1.78,0,0,1-.1.21c.05,0,0,.07.08,0-.07.05,0,.05,0,.06h0l0,0c.11,0,0,.1.07,0h0c-.12.09,0,0,0,0s0,0,0,0h0s.05,0-.06.08c.05,0,0,.08,0,.11l.07-.05c-.05.05,0,.05,0,0s-.05.1,0,.06c-.09.08-.07.1,0,.09s0,.07,0,0c-.08.11-.07.16,0,.06-.08.1,0,.07,0,0-.09.12-.09.18,0,.12l0,.06,0,.11.25-.17s0-.07,0-.1,0-.06.06-.07,0,0,0-.05h0c0-.05,0-.06,0-.06s.08-.09,0-.11h0c.07-.06,0,0,0-.07l0,0h-.06s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0c.07-.07,0,0-.05,0s0,0,0,0h0s0,0,0,0h0s0,0,0,0v0h0c0-.06.09-.13,0-.08.09-.07-.11,0,0-.06-.06,0,0-.16,0-.18.2-.15,0-.17,0-.25s.1-.14.07-.16l0,0h0l0,0s0-.1,0-.13a0,0,0,0,0,0,0h0s0,0,0,0l.16-.05h0v0c0,.06,0,0,0-.05v.06h0c0-.08,0,.07,0-.16,0,.16,0,0,0,.16,0-.19,0,0,0,0s0-.06,0-.11,0-.11,0,0a.38.38,0,0,0,0-.08c0,.17,0,.15,0,0v.15s0-.16,0,0a.87.87,0,0,0,0-.14v0h0v0l0,0v0s0,0,0,0v0s0,0,0,0h0s0,0,0,0v0h0s0,0,0,.07h0v0c0-.06,0-.11,0,0v0s0,.06,0,.1,0,0,0-.12h0c0,.09,0,0,0,0h0V195s0-.06,0-.07v0s0,.07,0,0h0c0,.12,0,.09,0,0v0h0v0h0v0h0v0h0a.26.26,0,0,1,0,.07c0-.08,0,.06,0,0s0-.1,0-.11h0c0,.09,0,.09,0,0,0,.14,0,.1,0,0s0,0,0,0l0,0s0,0,0,.12l0,0,0,0s0,0,0,0l0,.05h0s0,.05,0,.06v0a.15.15,0,0,0,0,.11.16.16,0,0,1,0,.1v0s.07,0,0,.13,0,0,0,0a.14.14,0,0,1,.08,0l-.06.05s.07,0,0,.11,0,0,.06,0,0,0,0,0a.08.08,0,0,1,0,0,.12.12,0,0,0,0,.12c-.06,0,0,0,0,0h.07c-.07,0,0,0-.07.08s0,0,0,0,0,0,0,0l0,0h0s0,0,0,0,.06,0,0,0,.06,0,.08,0l-.1.09s0,0,0,0,0,0,.05,0,0,0,0,.07,0,.09,0,0l0,.08s.07-.08.08-.06h0s0,.05,0,.06,0,0,0,.07,0,0,0,0,0,.06,0-.07,0,0,0,0,0,0,0,.09,0,0,0,0,0-.1,0-.12v0l.07-.14s0,0,0,0h0l0,0h0l0,0s0,0,0,0,0,0,0,0l0,0h0s0,0,0,0h.05s0,0-.05,0h0s0,0,0,0h0v0h0s0,0,0,0h0c.08,0,0-.05,0-.07s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l0,0c-.06,0,0,0,0,0s0,0-.06,0l.07,0s0,0,0,0,0,0,0,0,0,0-.09,0,.06,0,.06,0l-.09,0h0c.06,0,0,0,0,0s0,0,0,0,0,0,.06,0,0,0-.1,0v0h0s0,0,0,0l0,0h0a.16.16,0,0,0,.06-.05c-.07,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.05l0,0h0s0,0,0,0h0l0,0s0,0,0-.08l-.07,0h0s.06,0,.07-.06-.05,0,0,0,0,0,0,0,0,0-.06,0,0,0,0-.08,0,0-.06,0l.08,0s0,0,0,0,0,0,0,0l0,0h0a.18.18,0,0,1,.09-.08s0,0,0-.05,0,0-.06,0h0c.07,0,.09-.08.06-.07s0,0,.07-.08,0-.06-.05,0c.07,0,0,0,.05-.06l0,0c.06,0,0,0-.05,0s0,0,0,0,0,0,0,0l0,0s0,0,0,0,0,0,.07-.07,0,0-.09.07h0a.22.22,0,0,0,.09-.07l-.06,0,0,0h0s.08-.11,0-.1l0,0s0,0,0,0,0,0,0,0h0l0,0h0s0,0,0,0,0,0,.06,0h0l0,0s-.05,0,0,0,0,0,0,0,0,0,0,0-.05,0-.05,0l0,0,0,0s.08-.06,0,0v0s0,0,0,0,.06,0,.09,0,0,0,0,0,0,0,0,0,0-.1,0-.09h0l.06,0,0,0s0,0,0,0l.05,0-.07,0,.09-.06c0-.05,0-.05,0-.07s.08-.11,0-.06l-.05,0h0l.06,0c.07-.07,0-.06,0-.08a.06.06,0,0,0,0,0h0v0s0,0,0,0h0c.05,0,0,0,0,0l.05,0c-.05,0-.07,0,0,0s0,0,0,0h0c.15-.11,0,0,0-.05s0,0,0,0,.14-.17,0-.12h0l0,0h0s0,0,0,0,0-.06,0-.07l0,0c.15-.12,0-.09,0-.15s.09-.12.06-.12l-.07,0h0l.09-.06s.1-.14,0-.06l0,0h0s0,0-.08,0,.07-.08,0-.05h0c.07,0-.06,0,0,0l-.06,0s0,0,0,0v0l0,0h0c.07-.05.14-.11,0-.05h0l0,0h0l.08-.06s-.13.05,0,0c-.14.06.06-.09,0-.06l0,0h0l0,0s0,0,0,0h0s0,0,0,0h0c.06-.05,0-.06,0,0s.1-.09,0,0c.09-.07.07-.1.07-.13s0,0,0-.08l-.06,0h0l.09-.06c-.12,0,0-.21-.13-.2h0c.08-.07,0-.1.06-.12s-.11,0-.1,0l0,0s0,0,0,0c.14-.12-.06,0,.07-.14l-.1.06,0,0h0l-.13.08,0,0s-.06.09,0,.05l-.07.05s.14,0,0,.14c.12-.07,0,0,0,0s0,0,.06,0,0,0-.06.06,0,0,.07,0,0,0,0,0l-.07.05c.11-.06,0,0,.08,0s0,.09,0,.12l0,0c.07,0,0,.1.08.05h0c-.07.05,0,0-.08.08s-.09-.1-.09-.17.12-.15,0-.07,0,.19,0,.26,0,.51.13.69-.06.08,0,.06,0,.05,0,.09,0,0,0,0,0,0,0,.05h0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0a.14.14,0,0,0,0,.06h0a0,0,0,0,0,0,0s0,0,0,0l0,0h0s0,0,0,0h0s0,0,0,.05,0,0,0,0h0s0,0,0,0,0,0,0,0,0,.09,0,.16,0,0,0,0,0,0,0,0-.06.06,0,0v0h0s0,0,0,0v.07s0,0,0,0v0h0v0h0s0,0,0-.07v.06a.08.08,0,0,1,0,0s0,0,0,.07h0c0-.24,0,0,0,0s0-.26,0,0c0-.14,0,.17,0-.06,0,.12,0,0,0,.09,0-.31,0,0-.06,0s0-.14,0-.09v.11h0c0-.07,0-.09,0-.12s0-.14,0,.1v0s0,0,0,0a.9.9,0,0,0,0,.13c0-.09,0-.11,0,.07,0-.22,0,0,0-.1a.35.35,0,0,1,0,.07v0h0v0s0-.05,0,0,0,0,0,.07h0v-.05h0v-.06a.65.65,0,0,0,0,.11v-.06h0c0,.18,0-.1,0,0v0h0v0h0s0,0,0,0a.22.22,0,0,1,0-.06v.05h0v0l0,0v.09c0-.09,0-.06,0-.05l0,0h0v0s0-.06,0,0a0,0,0,0,0,0,0v0h0s0,0,0-.05,0-.07,0,0a.56.56,0,0,1,0,.07c0-.05,0-.1,0-.07v.09h0s0,0,0,0h0c0-.06,0,0,0-.05s0,.05,0,0v0h0s0,0,0,0h0s0-.06,0,0,0,0,0,0h0c0-.05,0,0,0,0h0s0,0,0,0,0,0,0,0,0-.07,0,.07c0-.06,0,0,0,0s0,0,0,0,0,0,0,0,0-.05,0-.06,0,0,0,.09c0-.08,0,0,0,0v0s0,.05,0,.07,0,0-.05,0h-.06c.14-.08,0,0,.06-.06-.08,0-.06,0,0,0h0l0,0,0,0c.07,0,.14-.11,0-.06s0,0,0,0l0,0h0l.08,0h-.05s0,0,0-.06c-.12,0,0-.09,0-.11s0,0,0-.05,0,0-.06,0a0,0,0,0,0,0,0s0,0,0,0,0,0,0,0,0,0,0,0a.05.05,0,0,0,0,0h0v0h0s0,0,0,0,0,0,0,0,0-.06,0-.06h0s0,0,0-.05h0s0,0,0,0,0,0,0,0h0s0,0,0,0l0,0,0,0,0,0s0,0,0,0h0s0,0,0,0,0,0-.05,0h0c.05,0,0,0,0,0h0s0,0,0,0h0c-.05,0,.06-.12,0-.06s0,0,0,0a0,0,0,0,0,0,0c0-.05,0-.07,0-.1h0l0,0c-.07,0,0-.06-.06,0s0-.06,0-.07v0h0l0,0h0s0,0,0,0,0-.09,0-.11,0,0,0,0h0s0-.15.06,0v-.33s0,0-.07,0l-.07.13,0,0h0l0,0,0,0h0l-.07,0s0,0,0,0l0,0h0l-.07,0a.37.37,0,0,0,0,.14s0,.08-.05.15C46.45,193.94,46.35,194,46.34,194.06Zm.17,2,0,0,0,0Zm.18.28h0Zm-.07.08Zm0-.08Zm0-.06h0Zm1-1.22a.13.13,0,0,0,.06,0s0,0,0,0h0s0,0,0,0,0,0,0,0l0,0s0,0,0,0h0Zm.09-.94Zm0-.42h0ZM47.49,196l0,0c-.06,0,.1-.07.06,0S47.52,196,47.49,196Zm0-.72,0,0h0l0,0h0Zm0-.19h0Zm0,0h0s-.05,0,0,0Zm0-.26h0Zm0,0Zm0,.22Zm0,.06,0,0,0,0Zm0,.1h0Zm0,.12h0Zm0,.65h0Zm0-.73h0Zm0,.74s0,0,0,0h0Zm0,0Zm0-.23Zm0,.24h0Zm0,.2,0,0h0S47.52,196.29,47.52,196.27Zm0-.15s0,0,0,0h0S47.57,196.11,47.56,196.12Zm0-2.19h0Zm0,2.22h0s0,0,0,0Zm0,0h0Zm0,0h0Zm0,0Zm.09.17h0s0,0,0,0,0,0,0,0,0,0,0,0v0h0v0l0,0h0Zm0-.35h0Zm0,0h0Zm0,.19Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0-.11h0Zm0,0h0l0,0h0Zm0,.12h0v0h0Zm0,0h0Zm0,0h0Zm0-.16Zm0,0h0s0,0,0,0Zm0,.1Zm0-.12h0Zm0,0h0l0,0Zm0,0h0l0,0h0v0Zm0,0h0Zm0-.08h0Zm0,0h0Zm0,0h0s0,0,0,0h0l0,0S47.6,195.85,47.65,195.83Zm0,.13h0Zm0-2h0Zm0-.42,0,0a0,0,0,0,0,0,0h0v0h0l0,0v0h0Zm-.06-.06s0,0,0,0,0,0,0,0Zm.05,0s0,0,0,0h0S47.6,193.51,47.6,193.52Zm0-.16h0Zm0-.11s.05,0,0,0Zm-.06-.17c.06,0,.06,0,0,0S47.52,193.07,47.49,193.08Zm0,.22v0l0,0Zm0,1.24Zm0,.47h0Zm0-.16h0Zm0-.22v0Zm0,.53s0,0,0,0,0,0,0,0v0s0,0,0,.05,0-.05,0,0S47.54,195.18,47.55,195.16Zm-.07-.51h0v0s0,0,0,0v.05C47.49,194.64,47.48,194.78,47.48,194.65Zm0,.29h0v0h0s0,0,0,0A.18.18,0,0,1,47.48,194.94Zm-.11,0v0Zm-.12-.21h0v0h0Zm0,.12v0Zm0,.08v0h0Zm-.05-.13h0Zm-.33.42,0,0h0Zm0,0,0,0h0Zm-.15.07h0Zm0-.08v0h0s0,0,0,0h0Zm0,.24Zm-.11-1.8h0Zm0,3s0,0,0,0l-.05,0h0Zm0-1.28h0Zm0,0h0A0,0,0,0,1,46.54,195.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.81,204.56s0-.05,0,0-.05,0-.05,0l.07-.06c.05-.06,0-.09,0-.11s-.06,0,0-.09l-.06.09a.2.2,0,0,0,0-.08s0,0,0,0h0v0h0l0,0s0,0,0,0c.18-.19,0-.05,0-.09s.16-.25,0-.16c.09-.07-.11,0,0-.06-.07,0,0-.15,0-.15.19-.18,0-.15,0-.23s.09-.15.06-.16l-.07,0h0l.09-.07s.09-.19-.06-.09c0,0,0-.05,0,0l0,0s0,0-.08,0,.07-.11,0,0c.13-.12,0,0,.06-.08-.08.06-.07,0,0,0l0,0h0c.07-.06.15-.16,0-.08s0,0,0,0,0,0,0,0h0l.1-.08s-.14.06,0-.06c-.08,0,0,0,0-.05h0l0,0h0l0,0s0,0,0,0,0-.05,0,0,.06-.11,0-.09.1-.1,0-.05c.09-.09.07-.14.06-.17s0-.08,0-.12-.06.06-.07.05l.09-.07c-.12,0,0-.3-.15-.3a.17.17,0,0,0,.06-.16c0-.07-.11,0-.1-.06l.05,0s0,0-.05,0c.13-.13-.07-.08.06-.17l-.26.17,0,0s0,.12,0,.08l-.07,0c0,.07.14.06,0,.2.12-.06,0,0,0,.07s.05,0,.07,0,0,0-.07.06c.06,0,0,0,.08,0s0,.05,0,0l-.07.05c.12-.06,0,.06.09,0s0,.12,0,.17l0,0c.08,0-.05.15.11.07-.11.08,0,0-.11.11.12-.06,0,.05,0,.11a.06.06,0,0,0,0,.09s0,0,0,0,0,0,0,0,0-.08,0,0h0v0c0,.11,0,0,0,.08h0c0-.29,0,0-.06,0s0-.14,0-.09v.1h0v-.12c0,.06,0-.13,0,.1v-.06a.25.25,0,0,0,0,.08c0-.12,0,0,0,.05s0,0,0,0h0v-.05a.06.06,0,0,1,0,0s0-.14,0-.09v.13h0v-.12s0-.13,0,.1v0s0,0,0,0a.35.35,0,0,0,0,.12c0-.06,0-.08,0,0s0,0,0,0h0v.11h0a.43.43,0,0,0,0,0v0s0,0,0,0v0h0v0s0,0,0,0l0,0s0,0,0,0h0s0-.05,0,0h0c0-.08,0,0,0,0l0,.08a.2.2,0,0,1,0,.09.6.6,0,0,0,0-.12c0,.09,0,.08,0,.09h0v-.12h0s0-.05,0-.06a1.27,1.27,0,0,0,0-.14s-.06.06-.07.05l.1-.07c-.06,0-.05-.09-.05-.17s0-.13-.12-.12c.09-.1.05-.13.06-.16s-.11,0-.1,0l0,0s0,0-.06,0c.14-.14-.06-.08.07-.17l-.26.17.05,0s-.06.12,0,.08l-.07.06c0,.06.14,0,0,.2.12-.07,0,0,0,.06s0,0,.07,0,0,0-.07.07c.06,0,0,0,.08,0s0,.05,0,0l-.07.06c.12-.07,0,.05.09,0s0,.11,0,.16l0,0c.07,0-.05.14.11.07-.11.06,0,.05-.11.1s0,0,0,0,0,0,0,0,0,0,0,0,0,.07,0,.1,0,.09.07.12.07,0,0,.05l0,0c-.11.11-.1.17,0,.12l-.1.06s.11,0,0,0c.08,0,.11,0,.09.14a.17.17,0,0,1,.07-.06s-.08.15,0,0-.08.1,0,0c-.13.13,0,.06,0,0l-.09.1s0,.07,0,.2c.1,0,.09,0,0,.13v0l-.05.11c.05,0,0,.08.08,0-.07.06,0,.05,0,.06s0,0,0,0,0,0,0,0l-.08.06c.12-.07,0,.1.09,0-.14.14,0,.05,0,.05s0,0-.08.1c0,0,0,.08,0,.1l.07-.06c0,.05,0,.05,0,0s-.06.09,0,0c-.09.09-.06.1,0,.09s0,0,0,0-.09.12,0,.06c-.09.07,0,.05,0,0s-.08.08-.08.09l.06.19.09-.05a.27.27,0,0,0,.07-.17c.06,0,.08-.06,0-.11v0h0l0,0s0,0,.06-.05,0,0-.06,0h0s0,0,0,0,.08-.1,0-.1,0-.05,0-.06a.15.15,0,0,1-.07,0s0,0,0,0h0c.16-.16,0,0,0-.08s.16-.26,0-.16c.09-.08-.11,0,0-.06-.06,0,0-.1,0-.12v0h0c.18-.23,0-.12,0-.2s.09-.16.05-.16l-.06.06,0,0,.09-.09s.08-.18-.07-.06l0,0s0,0,0,0,0,0-.05,0h0s0-.05,0,0,0,0,0-.08c0,0,0,0,0,0h0a.08.08,0,0,1,0,0c0-.08,0,0,0-.06h0v0h0v0h0v0h0s0,0,0,0h0v0h0v0h0a.18.18,0,0,0,0,.05h0s0,0,0,0h-.07v0h0s0,0,0-.06v.05h0s0,0,0,0h0v0h0v0s0,0,0-.07v.06c0-.18,0-.05,0,0s0-.07,0-.11,0-.11,0,0v-.07c0,.13,0,.14,0,0v0h0v.05s0-.15,0,0l0-.13s0,.08,0,.13,0,.06,0-.13c0,.11,0,0,0,0a.28.28,0,0,0,0-.06s0,0,0,0v0h0v.11c0-.18,0,.08,0-.13,0,.23,0,.06,0,0,0,.17,0-.07,0,.13,0-.08,0,.06,0,0v-.11h0c0,.09,0,.08,0,0,0,.14,0,.1,0,0s0,0,0,0v0c0,.07,0,.05,0-.06h0c0,.12,0,.13,0,0,0,.08,0,.08,0,0s0,.08,0,.06v-.08h0v0h0c0,.09,0,.08,0,0,0,.15,0,.11,0,0s0,0,0,0v0c0,.08,0,.09,0,0h0s0,0,0,0h0c0,.06,0,.07,0,0a.16.16,0,0,1,0,.1l.07-.05s-.09.15,0,0-.09.09,0,0c-.14.1,0,0,0,0a.38.38,0,0,1-.09.08s.05.09,0,.21c.13,0,0,.11,0,.26.05,0,0,.08.08,0-.07.06,0,0,0,.05l0-.05s0,0,0,0,0,0-.08,0c.12-.07-.05.11.09,0-.15.14,0,.06,0,.06s.05,0-.08.1c0,0,0,.07,0,.1l.07-.06c0,.06,0,.05,0,0s0,.1,0,0c-.09.09-.06.1,0,.09s0,.06,0,.05l0,.08,0-.07c0,.12-.06.12,0,0-.07.11,0,.06,0,0-.08.13-.1.12,0,.09-.08.06,0,0,0,0s.07,0,0,.07l0,0s0,0,0,0-.08.06,0,0l0,0h0s0,0-.08.06l0,0,.28-.16s0-.05,0-.07S58.81,204.59,58.81,204.56Zm-1.16-.63Zm0,0,0,0,0,0Zm0-.17h0Zm0-.07h0Zm0-.08h0Zm0,0h0Zm0,0h0Zm0,.44h0Zm.07,1.21h0Zm0-1.28v0h0Zm0,0h0v0h0Zm0,0h0Zm0,0h0Zm0,0h0l0,0Zm.65-.83v0h0Zm0,0h0Zm0,0Zm0,0h0v0h0Zm0,0h0v0h0Zm.09-.12Zm0,0Zm0,.16Zm.1,1.2c0-.07,0,0,0,0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.74,204.28l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.27 208.88 41.27 208.88 41.27 208.88 41.27 208.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.81 210.2 40.81 210.2 40.81 210.2 40.81 210.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,203.84h0v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.92,203.83h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,203.84v0h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,201.32a.34.34,0,0,0,0-.14s0,0,0,0,0,0,0-.05h0l0,.07s0,0,0,0,0,0,0,0,0,0,0,0S46,201.29,46,201.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,203.82v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.72 192.03 60.72 192.03 60.72 192.02 60.72 192.02 60.72 192.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,192.17h0l0,0,0,0h0l0,0,0,0s0,0,0,.07l0-.06h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.87,192.12l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88,192.28h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8,192l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.82,192h0v0h0v0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.71 192 60.71 192 60.71 191.99 60.71 192",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,195.2s0,0,0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,195.46h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,193.8v0s0,0,0,0h0l0,0s0,0,0,0l0-.08-.23.07s0,0,0,.06h0l0,0c-.09-.05,0,.14-.07.09l0,0h0s0,0,0,0h0l0,0h0s0,.05,0,0,0,0,0,0,0,0,0,0l0,0s0,.1,0,0,0,0,0,.07c-.11-.17,0,0,0,.06h0s0,0,0,0-.12-.07-.06,0c0-.09,0,.14,0,0,0,.11-.08.07-.07.16-.12-.16-.07.13-.11.13s-.09,0-.09,0l0,.07a0,0,0,0,0,0,0l0-.09c0,.06-.11,0,0,.14,0,0,0,0,0,0l0,0c0,.06,0,0,0,.11h0s-.07,0,0,.09c-.09-.11,0,0-.06,0s0,.07,0,.07a.09.09,0,0,1,0,.05c0-.06-.12-.11,0,0s0,0,0,0,0,0,0,.06h0l-.08-.09s.07.14,0,.07c.08.12-.07,0,0,.1s0,0,0,.05h0l0,0s0,0,0,0,0,0,0,.07-.07,0,0,0-.09,0,0,0-.08,0-.09,0,0,.1,0,.14,0,0,0,0h0l0-.05a.21.21,0,0,1,0,.15v0l0,0h0v0h0v0l0,0,0,0h0v0s0,0,0,.06l0,0v.18c0-.07-.06,0-.07,0s0,.19,0,.19v-.08c0,.05,0,0,0,.09,0-.2-.07.12-.06-.08l0,.4v-.06s0,.08.06-.06a.4.4,0,0,1,0,.11.38.38,0,0,0,.11-.16s0-.05,0-.05V196h0a.2.2,0,0,0,0-.07s0,0,0,0v0s0,0,.06,0a.18.18,0,0,0,0-.12c0,.07,0-.05,0,.06,0-.08,0,0,0-.11,0,.06,0,0,0,0h0l0,.07c0-.14,0,0,0-.14s.06-.07.08-.14l0,0c0-.11.09,0,0-.19.06.1,0,0,.07.07-.06-.12,0-.07,0-.09s0-.1,0-.16,0-.08,0,0l0,0c.08.07.1,0,0-.09l.05.1s0-.12,0,0a.57.57,0,0,1,0-.12l0,0a.08.08,0,0,1,0-.08l0,0s.1,0,0-.08.07.05,0,0c.09.11,0,0,0,0l.06.07c0-.06,0-.12.1-.11,0-.17,0-.12.12-.12s0,0,0-.09h0c0,.05,0,0,0,0h0a.16.16,0,0,1,0,.06c0-.12,0,0,0-.11h0c.08.11,0,0,0,0,.05.11,0-.07.06.06,0-.07,0,0,0,0a.17.17,0,0,1,0-.07s0,0,0,0,.05,0,0,0h0c0,.05,0,0,0,0s0,0,0-.06h0c.05,0,.07,0,0,0h0c0,.05,0,0,0,0s0,.05.05.05l0,0s0,0,0,0h0s0,0,0,0A.29.29,0,0,0,59.2,193.8Zm-.81,1Zm0,.05Zm.06-.3h0Zm.34-.25Zm.11-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,195.5l0-.05,0,0S57.91,195.47,57.91,195.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88,192.3h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.39 202.87 59.39 202.87 59.39 202.87 59.39 202.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.89,192.2c0,.12,0,0,0,0v.05h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.96 194.83 59.97 194.82 59.96 194.83 59.96 194.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.94,203.58c0-.07,0-.11,0-.1.07-.15,0-.2,0-.19s-.1,0-.11,0,0-.18,0-.15l0,.11,0,0a1.15,1.15,0,0,0,0-.15s0-.19-.1,0c0,0,0-.06,0,0l0-.05c0,.07,0,0-.07.12,0-.1,0-.14-.06,0,.08-.23,0,0,0-.11,0,.12,0,.09,0,0a.3.3,0,0,1,0,.09c0-.12.09-.26,0-.11s0-.05,0,0,0,0-.07.15l.09-.22h0a.86.86,0,0,0,.07-.21s-.06,0-.06,0,.07,0,.08,0a.25.25,0,0,1,0-.08v-.08a.28.28,0,0,0,0-.09s0,0,0-.06-.06-.1-.11-.09h0a.35.35,0,0,0-.1.14c0-.15-.06-.08-.07-.1s0,0-.05.08,0,.11,0,.11v-.08c0,.05,0,0,0,.09,0-.2-.08.13-.08-.07v.41a.25.25,0,0,1,0-.08s.05.06.06-.06v.1s0-.07.06-.11,0,0,0,.05c0-.2,0,0,0,0v0c.06.12,0,.08-.07.12a.25.25,0,0,0,0,.09l0,.21h0a.09.09,0,0,0,.09,0s.07-.07,0,0,0,0,0-.07c-.06.19,0,.22.07.05a.57.57,0,0,1-.06.15s.09-.14,0,0c.1-.08.12-.13.15,0s0-.1,0-.11,0,.18.06,0c0,0,0,.15,0,0-.09.21,0,.07,0,0s0,0-.06.15c0-.05.1,0,.08.11.12-.16.09.05,0,.13h0l.07,0c-.08,0,0,0,0,0l0,0s0,0,0,0H59.7c.06,0,0,0,0,0s0,0,0,0c-.13,0,0,0,0,0s0,.07-.08,0l0,0,0,0s0,0,0,0h0v0h0l0,0h0a.08.08,0,0,0,0,0c0-.06,0,0,0,.05,0-.11,0-.07,0,0s0,0,0,.07c0-.09-.06-.08-.05.07,0-.12,0,0,0,0,0-.13,0-.14-.07,0,0-.23,0,.26-.06,0,0,.11,0,0,0,.13,0-.05,0,0,0,0,0-.12,0-.09-.06,0,0-.11,0-.05,0,0a.28.28,0,0,1,0,.1c0-.05,0,0,0,0s0,0,0,.08v.07s0,0,0-.07c0,.08,0,.12,0,.07s0-.12,0-.11a.54.54,0,0,1,0,.14s.06-.06.09-.09.06.07.06-.08c0,0,0-.06,0-.06v.1c0,.13.08-.17.12-.07s0-.1,0-.11,0,.06,0,0c0,.06,0-.08,0,0s0,0,0,0,0,0,0,0,0,0,0,.06,0-.13,0,0,0,0,0-.09c.07.17.06,0,.06,0v0s0,0,0,0,.06,0,.1-.06.06-.08,0-.1,0,0,0,0,0,0,0,0A.76.76,0,0,1,59.94,203.58Zm-.45-.41h0S59.47,203.22,59.49,203.17Zm0-.39s0,0,0,0h0Zm-.06.37h0Zm0,0Zm0-.25c0-.06,0,0,0-.05h0s0,0,0,.06,0,0,0,0a.41.41,0,0,0,0-.08v0l0-.06c0,.09,0,.07,0,0l0,0h0s0,0,0,.06l0,0a.17.17,0,0,0,0,.1C59.39,202.89,59.4,202.94,59.38,202.93Zm.07-.1v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,175.09c-.07,0,0,0-.07,0l.12-.05c0-.1-.11-.08,0-.21s0,0,0,0v-.08c0-.06,0-.13,0-.12s0,.08-.06.06l0,0,0,0s0,0,0,0,0-.09-.07,0a.13.13,0,0,0,0-.13,0,0,0,0,0-.07,0,.12.12,0,0,0,0-.1s0,0-.07,0,0-.11,0-.13a.17.17,0,0,0-.1,0,.72.72,0,0,0-.28.13s0,.07,0,.09,0-.11,0-.12l-.09.11-.08.09h0a1.16,1.16,0,0,0-.25.29.71.71,0,0,0-.14.33.36.36,0,0,0,0,.09c-.09,0-.14.23-.16.27a.23.23,0,0,0,0,.12.25.25,0,0,0,0,.07l0,.14c0,.09,0,.17,0,.23h.06c-.07,0-.07.15,0,.12h0s0,0,0,0,0,0,0,0,0,.05,0,.07h-.07v0s0,0,0,.07,0,.12,0,0c0,.11-.09.11-.07.19-.14-.09-.08.16-.13.19s-.09,0-.09.06l0,0v0s0,0-.06,0-.11,0,0,.14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.09-.07,0,0,.08c-.08-.08,0,0,0,0s0,.06,0,.06l0,0s-.11-.08-.05,0,0,0,0,0,0,0,.06.07l-.09-.09c0,.05.05.13,0,.08.06.11-.08,0,0,.11s0,0,0,.05l0,0s0,0,0,0,0,0,0,.07-.07,0,0,.06-.08,0,0,0-.08,0-.1.06,0,0,0,.08,0,.06,0,.08l.05,0-.06,0c0,.18-.16.22-.1.46-.07,0-.09.05-.1.07a.42.42,0,0,0-.22,0s0,.09,0,.1h0s0-.11,0-.13a4,4,0,0,0-.41.33,1,1,0,0,0-.27.61c-.06,0-.1.1-.12.18s0,0,0,.05,0,0,0,0,0,0,0,.06h0c.1-.27,0,0-.06,0s0-.3-.07-.12c0-.13-.09.12,0-.07-.09.06-.08-.09-.15,0,0-.14,0-.16,0-.15s-.09.05-.1,0v0h0c0-.06,0-.14,0-.12l0,.1,0,0c0-.08.05-.1.05-.13s0-.18-.12,0c0,0,0-.11,0,0s0,0,0,0a.25.25,0,0,1,0-.09c0,.05,0,0-.07.09,0-.08,0-.13-.07,0,.07-.19,0,0,0-.09,0,.11-.06.07,0,0l0,.05h0c0-.1.06-.19,0-.07s0-.05,0,0,0,.06,0,.06h0l0-.12s-.11.15-.06,0c-.1.17,0-.11-.09,0a.34.34,0,0,1,0,.08h0l0-.08,0,0s0,0,0,0c0-.12,0-.12-.05,0s0-.15,0,0c0-.14,0-.14,0-.15l-.12,0a.26.26,0,0,1,0,.1s0-.11,0-.13-.13-.06-.22-.06h0s-.06,0-.11.08h0s0-.07,0-.07l0,0s0,0,0,0v0a2.11,2.11,0,0,0,0-.26h0a.51.51,0,0,0,0-.13v0h0c0-.05,0-.09,0-.12a.07.07,0,0,0,0-.05.29.29,0,0,0,0-.09.44.44,0,0,0,0-.31h0a.31.31,0,0,0-.19-.09h0l0,0h-.12a.23.23,0,0,0-.11,0,.83.83,0,0,0-.16.12s0-.1,0-.1c.18-.13,0-.11,0-.17s.08-.11.06-.12a.09.09,0,0,0-.06,0h0l.09,0s.08-.13,0-.07.07,0,0,0,0,0,0,0l.06,0s0,0-.07,0,.07-.08,0,0c.12-.08,0,0,.06-.05-.08,0-.06,0,0,0l-.06,0c.07,0,.15-.1.06-.06s0,0,0,0l-.08,0h0l.12-.07s-.11,0,0-.05c-.12.05,0-.08,0-.06l-.06,0,.06,0s0,0,0,0,0,0,0,0,.06-.08,0-.06.09-.08,0,0c.08-.06.07-.09.07-.12a.32.32,0,0,1,0-.09l-.06,0,.08-.06c-.07,0,0-.13,0-.19a.14.14,0,0,0,0-.14c.06.13,0-.06.06,0,0-.08,0-.1,0-.1s0,0,0-.06.11.09.06,0,0,.05,0,0,0,0,0-.09h0l.07.1c0-.09,0-.18.07-.16a.1.1,0,0,1,0-.13s.07-.08,0-.12-.06,0-.06,0l.06,0s0,0,0,0,0-.1,0-.11a.17.17,0,0,0,0-.13s0,0-.06,0a.13.13,0,0,0,0-.09s0,0-.06,0a.28.28,0,0,0,0-.08l0,0s0,0,0,0,0,0,0-.06l0-.06s0,0-.06,0,0-.11,0-.07,0,.11,0,.09,0,0,0-.12a.06.06,0,0,0,0-.06s-.06,0-.08,0,0-.06-.07-.07,0,0,0,.05,0,.07,0,.07,0-.09,0-.1,0-.05,0-.05-.05,0-.08.05l-.06.08a0,0,0,0,1-.06,0,.78.78,0,0,0,0,.09c0-.05,0,0-.06,0s0,0,0,0a1.1,1.1,0,0,0-.4.85.86.86,0,0,0,0,.16v0a.25.25,0,0,0,0,.19.19.19,0,0,0-.07.15.31.31,0,0,0,0,.09v0h0s.07.05.09.07.06,0,.08.05l.07.1a.08.08,0,0,0,.1,0v-.1s0,0,0,0,0,.11,0,.12,0,0,.06,0h0c0,.33,0,.67.08,1a.21.21,0,0,0,0,.06s0,0,0,0h0s0,0,0,0v0h0v0s0,0,0,0h0a1.84,1.84,0,0,0-.22.17h0l0,0,0,.08a.08.08,0,0,0,0,.05l0,0h0a.05.05,0,0,0,0,.05h0s0,0-.05,0-.1.19-.16.31l0,.1a.64.64,0,0,1,0,.07v0h0s0,0,0,0h0v0a.05.05,0,0,0,0,0s-.08.06,0,.08,0,0,0,0,0,.09-.07,0,0,.13,0,.18-.12.29,0,.31c-.13.06,0,.06-.07.13.07,0,0,.08,0,.14l0,0v0a.26.26,0,0,0-.07.1s0,.07,0,0,0,0,0,0,0,0,.06,0h0l-.09.08c0,.06.06.08.08.11s0,.06,0,.15a.06.06,0,0,1,.07,0v0h0s0,0,0,0,0,0,0,.06,0,0,0,0,0,.09,0,0,0,0,0,.06,0,0,0,.06v0s-.17,0-.09.1,0,.12,0,0c0,.11-.07.12-.07.2h0c-.1,0-.07.12-.09.19H97.7s0,0,0,0v0h0s0,0,0,0-.09,0-.06.12,0,0,0,0l0,0a.08.08,0,0,0,0,0h0s0,0,0,0,0,0,0,0-.1.05,0,.14,0,0,0,0h0s0,0-.05,0,0,0,0,.08h0s0,0,0,.08h0l0,0h0l0,0a0,0,0,0,1,0,0h0s-.06,0,0,0h0v0s0,0,0,0l0,0h0l0,0s0,0,0,0h0s0,0,0,.05h0s-.07,0,0,.05h0s0,0,0,0v0h0s0,0,0,0h0s-.07,0-.08.08v0l0,0,0,.08h0v0h0v0h0v0s0,0,0,0,0-.11,0-.13a.58.58,0,0,1-.25-.12h0a.31.31,0,0,0-.25,0,.33.33,0,0,0-.1.06c-.06,0-.13.09-.2.17a.14.14,0,0,0-.11,0,.48.48,0,0,0-.1.09.09.09,0,0,0-.06.06.42.42,0,0,0,0,.1.38.38,0,0,0-.09.15l0,0h0v0a.36.36,0,0,1,0,.09h0a.43.43,0,0,0,0,.07l0,0h0s0,0,0,.05-.06.11,0,.13h0s0,0,0,0h0s0,0,0,0l0,0-.12-.06c.08-.23-.09,0-.1-.1s0-.1,0-.13h0s0,0,0,0l0,.1,0,0c0-.08.05-.1.05-.13s0-.17-.1,0c0,0,0-.11,0,0s0,0,0,0,0,0,0-.1,0,0-.06.08h0c0-.05,0-.08,0,0h0s0,0,0,0h0s0-.06,0,0h0v0a.15.15,0,0,1,0,.06h0a.2.2,0,0,0,0,0l0,0,0,0s0-.09,0,0h0s0,0,0,0l-.08-.06h0l0,0c0-.06,0-.06,0-.06h0l0,0a0,0,0,0,0,0-.06s-.06,0-.08,0h0s0,0,0,0-.07-.06-.11-.1h0a.65.65,0,0,0,0-.21s0,0,0,0,0,0,0,0,0,0,.05,0c0-.2,0-.28-.08-.32.07,0,0-.16,0-.11s0,.15,0,.1,0-.08,0-.17a.31.31,0,0,0-.22-.18.72.72,0,0,0-.29,0h-.11s0,0,0-.05l.09-.07,0,0s0-.1,0-.06l.06-.05s-.14,0,0-.16c-.1.08,0,0,0,0h0c.06-.05,0,0,.06-.05l-.07,0s0,0,0,0v0l0,0h0c0-.05.07-.1,0-.06s-.1,0,0,0c-.06,0,0-.12,0-.12.17-.15,0-.12,0-.19s.09-.12.06-.12,0,0-.06,0h0l.08-.05s.08-.14-.05-.07c0,0,.07,0,0,0l0,0s0,0,.06-.05,0,0-.07,0,.06-.09,0,0c.13-.09,0,0,.06-.06s0,0,0,0v0l0,0h0c.06,0,.13-.09,0,0s0,0,0,0l-.08,0h0l.12-.07s-.12,0,0,0c-.12,0,0-.09,0-.07s-.06,0-.07,0l.07,0h0s0,0,0,0,0-.08,0-.06.1-.09,0,0c.07-.06.06-.1.06-.12a1,1,0,0,0,0-.1h0s0,0,0,0,0,0,0-.09h0v0h0a2.25,2.25,0,0,0,.47-1.47,1,1,0,0,0-.18-.55,0,0,0,0,0,0,0s0,0,0-.05h0l0-.07s0,0,0,0a.1.1,0,0,0,0,0,.49.49,0,0,0-.46,0,2,2,0,0,0-.76,2.15s0,0,0,0h0a.38.38,0,0,0,.09.15.49.49,0,0,0,0,.12c0,.08,0,.12.08,0s0,.05,0,0,0,0,0,.07h.13s0,0,0,.07,0,0,0,0,.05,0,.06,0,0,0-.06,0,0,0,.07,0,0,0,0,0l-.06,0c.1,0,0,0,.08,0s0,.08,0,.12l0,0h0s0,.07,0,.06,0,0,0,0l0,0h0v0l0,0c0,.05,0,.06,0,.08h0v0h0c-.07.07,0,.09,0,.06h0l-.08.05s.09,0,0,0c.07,0,.09,0,.06.11l.05,0h0s-.05.07,0,0v0h0c-.09.07,0,0,0,0h0l-.08.05s0,.07,0,.15c.11,0,0,.08,0,.19s0,.06.07,0c-.06,0,0,0,0,0l0,0s0,0,0,0,0,0-.07,0,0,.07.06,0h0c-.08.07,0,0,0,0v0h0l0,0s0,.06,0,.07l.06,0s0,0,0,0,0,.08,0,0-.06.08,0,.07,0,0,0,0-.07.09,0,.06l0,.05,0,0h0v0h0l0,0c-.08.14-.14.28-.19.39a.7.7,0,0,1-.12.18l0,0,0,0,0,0h0l-.06.11a.3.3,0,0,0,0,.12s0,0,0,0a.14.14,0,0,0,0,.11.21.21,0,0,1,0,.12c0-.06,0-.09,0-.1a1,1,0,0,0,0,.19.11.11,0,0,1,0,.06l0,.09,0,0s0,0,0,0h0c-.16.26-.31.57-.45.83s-.13.23-.19.33l0,.06v0l-.28.41a.75.75,0,0,0-.08.14v-.12h0l0,0,0,0,0,0,0,0s0,0,0,0l-.06,0,0,0s0,0,0-.06,0-.05-.1,0c0-.07,0-.11,0-.06s0,.05,0,.08h0s0,0,0-.1,0,0-.06,0l-.07,0-.15.12c0,.05-.2.08-.19.21s0,0,0,0h0v0c-.07,0-.13.1-.17.2s-.09.19-.14.21,0,.05,0,.06-.11.1-.06.13,0,.09-.07.06,0,0,0,0,0,0-.06.15,0,0,0,0,0,.18-.05.12a.11.11,0,0,1,0,.06.31.31,0,0,0,0,.07c0-.13-.06.15,0-.05,0,.1,0,0-.09.06,0-.28-.08,0-.09,0s0-.14,0-.1a.87.87,0,0,1,0,.1.1.1,0,0,1,0,0,.53.53,0,0,0,0-.14s0-.13-.06.08c0,0,0-.11,0,0s0,0,0,0a.23.23,0,0,1,0-.09c0,.06,0,0,0,.11,0-.07,0-.09,0,0h0s0,.05,0,.05v0h0s0,0,0,0a.59.59,0,0,1,0,.08c0-.11.07-.23,0-.09s0-.05,0,0,0,0,0,.13l.06-.2s-.08.18,0,0c-.08.18,0-.09-.05,0s0,.09,0,.1l0-.1s0,0,0,0,0,0,0,0c0-.12,0-.1,0,0s0-.16,0,0c0-.13,0-.11,0-.11l-.07,0s0,.1,0,.1a1,1,0,0,0,0-.13c-.09.14-.07-.09-.19.1h0l0,0c0-.11,0-.11,0-.11a.38.38,0,0,0,0-.1.32.32,0,0,0,.1-.3,1.05,1.05,0,0,0-.08-.25h0a0,0,0,0,1,0,0,.53.53,0,0,0,0-.19c0-.05-.06-.08-.11-.06a.41.41,0,0,0,0,.1s0,0,0,0,0-.11,0-.14-.11,0-.16,0a.16.16,0,0,0-.11.17s0-.07,0,0,0,0,0,0,0,0,0-.07c0,.09,0,.06,0,.16,0-.05-.13,0-.09.17-.07-.12,0,.06-.07,0,0,.09,0,.12,0,.12h0s0,0,0,0v0c0,.1,0,.19-.08.19a.16.16,0,0,1,0,.14h0c0,.07-.08.14,0,.18s.06,0,.06,0h0l0,0s0,0,0,0,0,.1,0,.11-.06.19,0,.17a.11.11,0,0,0,0,.09s0,.06,0,0a.21.21,0,0,0,.08.29.19.19,0,0,0,.19-.06l0,0h0l0-.06h0v0h0l0-.06v0s.1,0,.15-.07.1-.09.07-.16,0,0,0-.06,0-.06,0,0,0-.05,0-.07,0,0,0,0h0l0,0,0-.07c0,.1,0,0,0,.09,0-.08,0,0,0-.1,0,.08,0,.06,0,0l0,.1c.06-.16,0,0,.06-.11,0,.07,0,0,.08,0l0,.06c.06-.09,0,.1.1-.12,0,.15,0,0,0,.16.06-.17,0,0,0,0s.06,0,.09-.06,0-.09,0,0,0-.05,0-.07c0,.16,0,.16.06,0l0,.14s.06-.14,0,0l0-.07h0s0-.05.07,0a.56.56,0,0,1,0-.1s0,.13,0-.06c0,0,0,.13,0,0,0,.19,0,.06,0,0a.83.83,0,0,1,0,.13s.07-.06.08,0c.07-.18.07-.06.09,0,0-.07,0,.06,0-.12,0,.11,0,0,0,0v-.06s0,0,0,0a.24.24,0,0,1,0,.1c0-.15,0,0,0-.08h0c0,.1,0,.08,0,0a0,0,0,0,1,0,0,2.11,2.11,0,0,1-.1.3c0,.1,0,.18,0,.17s0,.06,0,.08,0,0,0,.06a.83.83,0,0,1,0,.15c0,.05,0,.1,0,.15a0,0,0,0,0,0,0s0,0,0,.06,0,.08.06.07,0,0,0,0a.23.23,0,0,0,0,.18h0v0l0,0a.09.09,0,0,0,.07,0c.09,0,.19,0,.24,0s.15.13.24.06v-.09s0,0,0,0,0,.1,0,.12a.69.69,0,0,1,.17-.05.21.21,0,0,0,.12-.18s0,.07,0,0,0,0,0,0,0,0,0,.07c0-.09.07-.06.07-.17s.06,0,.1,0a.05.05,0,0,0,0,0,0,0,0,0,0,0,0,.17.17,0,0,0,0-.1c.07.13,0-.07.08,0a.12.12,0,0,1,0-.15s0,0,0-.05.13,0,.08,0,0,0,0,0,0,0,0-.11l.09.09c0-.13,0-.23.1-.24a.23.23,0,0,1,0-.2.19.19,0,0,0,.06-.17s-.06,0-.05,0,.06,0,.06,0,0,0,0,0,0-.12,0-.17.08-.25,0-.25,0,0,0-.07,0-.08,0-.09h0a.36.36,0,0,0,0-.2.52.52,0,0,0-.06-.15.83.83,0,0,0-.09-.16h0a.27.27,0,0,0,0-.12c0,.06,0,0,0,.05,0-.07,0,0,0-.1s0,0,0-.05,0,.06,0,.06,0,0,0-.14h0s.06-.05.08-.11l0,0v0a.11.11,0,0,0,0,0l0-.05a0,0,0,0,0,0,0l0-.07a0,0,0,0,1,0,0v0a.35.35,0,0,1,0-.08h0a.24.24,0,0,0,.07-.15l0-.08h0l0,0s.07,0,0-.11h0l0,.06s0-.13,0,0c0-.15,0-.18.1-.25v-.06s0,0,0-.05l0,0s0,0,0,0h0a.11.11,0,0,1,0,.05c0-.08.06-.16.14-.17v0h0a.3.3,0,0,0,0,.2h0v0c.06.07.19.05.3.08a.67.67,0,0,0,.38,0l.1,0,.08,0,0,0s0,0,0,0a.25.25,0,0,0,0-.07s.08,0,.12-.11.07-.11.06,0a3,3,0,0,0,.4-.67l.07-.18v-.07s0,0,0,0,0,.05.06.05v0h0l0,.06h0v0s.05,0,.08,0v0h0v0c0,.08,0,.09,0,0h0l0,.08s.08-.11,0,0l.08-.05.06.05h0l0,0h0l.07.05V183l0,0,0,0v.16c0-.06,0,.07.07-.09,0,.1,0,0,0,0a.1.1,0,0,1,0-.06h0s0,0,0,0l0,.09c.09-.14,0,.1.09-.09-.09.21,0,.07,0,0-.07.13,0,0,0,.13,0-.06,0,.07,0,.07l0-.1c0,.08,0,.07,0,0s0,.09,0,0c0,.12,0,.11,0,.07h0s0,0,0,0h0s.05.1.05.16,0,.15,0,.23a.35.35,0,0,0,0,.2v0s0,0,0,0,0,.06,0,.07h0s0,0,0,.05a1.2,1.2,0,0,1,.11.23c0,.08.07.13.12.13,0,.16,0,.22.12.23h.23s0,0,.05,0l0,0a.09.09,0,0,0,.13,0,.26.26,0,0,0,0-.09l0-.05c0,.08,0,.11,0,.12s.11-.05.18-.09a.22.22,0,0,0,.11-.21s0,.05,0,0,0,0,0,0,0,0,0,.05c0-.1.06-.08.05-.18s.15-.11.11-.22c.08.08,0-.08.07,0a.11.11,0,0,1,0-.14s0,0,0-.05.15,0,.09-.07,0,0,0,0,0,0,0-.09l.1.06c0-.06,0-.11,0-.15h0c0-.05,0-.07.07-.09a.24.24,0,0,1,0-.2.21.21,0,0,0,.05-.18s-.06,0-.06,0,.06,0,.06,0,0,0,0,0,0-.13,0-.16.07-.23,0-.23.1-.16,0-.15a.3.3,0,0,0,0-.16v0a.56.56,0,0,0,0-.2h0a4.32,4.32,0,0,0,.38-.67c.18-.35.41-.73.59-1.11h0a.24.24,0,0,1-.06.18c.11,0,0,.07,0,.12s0,.08.06.06,0,0,0,.08,0,0,.07,0,0,.08,0,.05l-.05.08c.05,0,.05,0,.05,0s0,0,0,0a.06.06,0,0,0,0,.07.13.13,0,0,0,.08,0,.41.41,0,0,0,0,.07s0,0,.07,0,0,0,.08-.1c0,.15,0,0,0,.16.07-.17.07,0,.12,0s.1-.08.14-.14,0-.11,0,0,0,0,0-.07c0,.12.09.07.1-.08,0,.05,0,.08,0,.11s0-.15,0,0c.06-.16,0-.19.14-.25l0-.06s.1,0,0-.1.06.06,0,0c.07.11,0,0,0,0s0,0,0,.07a.29.29,0,0,1,.14-.22.22.22,0,0,1,0-.17,1.86,1.86,0,0,0,.12-.18s.05-.07-.06,0c.06,0,0-.06,0-.07a.11.11,0,0,1,0,0s0,0,0,0l.07,0c-.1,0,.05-.11-.08,0,.14-.11,0,0,0,0s0-.05.08-.1c0,0,0-.08,0-.12l-.06.06c0-.06,0-.06,0,0s0-.1,0-.05,0-.11,0-.09,0-.06,0,0,0-.13,0-.1l-.05,0v0a.86.86,0,0,0,0-.15s0-.07.07-.11a.15.15,0,0,1,0-.13s0,0,0,.09l0-.07,0,0s0,0,0,0h0a2.56,2.56,0,0,0,.72.45c.28.13.57.58.92.58,0,0,0,0,0,0s0,.24,0,.34a.29.29,0,0,0,.06.21c-.06.15,0,.26.08.3l0,0,0,.22.09-.21a.34.34,0,0,1,.15,0,.2.2,0,0,0,.21,0h0v.05l0,0h0V181a.14.14,0,0,0,0,.06.09.09,0,0,0,0,.09l0,0v.13c0,.05,0,.08,0,.08v0l0,0h0l0,0,0,0c0,.25,0,.51,0,.78v0h0v.24h0s0,.06,0,.1l0,0h0s0,0,0,0h0s0,.05,0,.05h0s0,0,0,.05h0l-.08.09s0,.05-.07.06h-.07c0,.08,0,.1,0,.1s0,0-.06,0a.3.3,0,0,0,0,.14s0,.06,0,0c0,.07,0,0,0,.1s0,0,0,.08,0-.06,0,0,0,0,0,.15,0,0-.06.1a.84.84,0,0,0,0,.17s0,0,0,0-.11.15,0,.25c-.08,0,0,0-.1,0s0,.11-.06.2a.37.37,0,0,0,0,.23v0s.06,0,0,.06h0c-.1.12-.09.22,0,.18l-.08.07s.1,0,0,0c.09.06.11,0,.12.17h0a1.24,1.24,0,0,1,0,.27c0,.08,0,.16.08.18s0,.22.08.23.17,0,.23-.09h0s.08,0,.11,0a.11.11,0,0,0,.11-.05v-.06s0,0,0,0,.09-.05.14-.09a.18.18,0,0,0,.08-.09s0,0,0-.08c0,.11.07.09.09,0,0,.09,0,0,0,0s0-.11.06,0c0-.08,0,0,0-.09s0,0,0-.05.05,0,.06-.05,0,0,0,0,0,0,0-.07h0s0,0,0,0a.36.36,0,0,1,0-.07c0,.07,0,0,0,0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.05,0-.1,0,0,0,0,0-.07c.1.13,0,0,0-.06s.15,0,.07-.07-.06-.08,0,0a.21.21,0,0,1,0-.08s0,0,.08,0,0,.05,0,.06,0,.11.11-.1c-.06.15,0,0,0,.16.08-.16,0,0,0,0s.06,0,.09,0,.06-.09,0,0a.67.67,0,0,0,0-.07c0,.16,0,.17.05,0l-.05.12s.07-.12,0,0c.07-.08.09-.11.11,0a.34.34,0,0,1,0-.1s0,.15,0,0c0,0,0,.13,0,0-.06.19,0,.07,0,0l0,.13s.07,0,.07.07c.1-.16.07,0,.08.1,0-.06,0,.06.06-.11,0,.1,0,0,0,0a.28.28,0,0,1,0-.06s0,0,0,0a.56.56,0,0,0,0,.1c.05-.16,0,.08.06-.11,0,.21,0,.06,0,0,0,.15,0,0,0,.13,0-.07,0,.06,0,0s0-.1,0-.1a.16.16,0,0,0,0,0h0s0,0,0,0c-.09.05-.09.07-.07.09h0v0h0l0,0s0,0,0,0a1.83,1.83,0,0,1,0,.21c0,.07,0,.11.06,0-.06.12.11-.08,0,.09.06,0,.08,0,.11.06s0,.05.09,0c0,.13,0,.16.07.14s.11-.07.15-.09h0l.07.05s0,0,.08,0a.31.31,0,0,1,0-.09.1.1,0,0,0,0,0c0,.08,0,.1,0,.12s.07,0,.11-.06.07-.07.06-.16,0,.06,0,0,0,0,0,0,0,0,0,.05,0-.05,0-.14.11,0,.06-.15c.08.1,0-.05.06,0s0-.09,0-.1,0,0,0,0,.13,0,.06,0,0,0,0,0,0,0-.06-.08l.1.07c0-.08,0-.15,0-.15a.06.06,0,0,1,0-.09h0l0-.07a.09.09,0,0,0,0-.07s-.06,0-.06,0l.06,0s0,0,0,0,0-.09,0-.1,0-.17,0-.14.08-.16,0-.08a.21.21,0,0,0,0-.24.31.31,0,0,0-.17-.07s0,.1,0,.1,0-.11,0-.13l-.1,0h-.15s0,0,0,0a.06.06,0,0,0-.06,0v0h0a0,0,0,0,0,0,0l0,0,0,0a.06.06,0,0,0,0,.07.14.14,0,0,0,0,.07h0l0-.08v0c0,.07,0,0,0,0s0,0,0-.06,0,0,0,0,0,0,0-.06,0,0,0-.06,0,0,0,.1,0-.07,0,0,0,.07,0,.08,0,0,0-.09-.05,0-.08.09l0,.06a.11.11,0,0,1,0,.06s0,0-.07.08,0,.06,0,.1,0,0,0,0l0,0a.17.17,0,0,0-.06.06s0,.06,0,.1a.19.19,0,0,1,0,.08s0,0,0,.06h0s0,0,0,0,0-.26,0-.06c0-.13-.06.14,0-.06,0,.09,0,0-.09,0,.07-.28-.06,0-.07-.07s0-.15,0-.11l0,.1,0,0,0-.13s0,0,0,0h0s0,0-.06.09,0-.11,0,0,0,0,0,0a.35.35,0,0,1,0-.1c0,.06,0,0-.06.1,0-.08,0-.11,0,0,.08-.19,0,0,0-.1,0,.12,0,.09,0,.06l0,.08c0-.11.07-.23,0-.1h0a1.12,1.12,0,0,1,0,.13l.07-.19s-.09.16,0,0c-.09.18,0-.1-.06,0s0,.09,0,.1l0-.1s0,0,0,0,0,0,0,0c0-.11,0-.1,0,0s0-.15,0,0c0-.13,0-.11,0-.12s0,0-.07,0a.34.34,0,0,1,0,.1s0-.11,0-.13-.06,0-.07,0,.07,0,0-.07h0s.1-.09,0-.09.07,0,0,0,0,0,0,0a.08.08,0,0,1,.06,0s0,0-.06,0,.07,0,0,0c.12,0,0,0,.06,0s0,0,0,0h-.05c.07,0,.14-.05.05,0s0,0,0,0h-.06l.1,0s-.11,0,0,0h0s0,0,0-.05h0s0,0,0,0h0s0,0,0,0h0s.06,0,0-.05v0s0,0,0,0l0,0a.08.08,0,0,0,0-.08.65.65,0,0,0,0-.32v0a.47.47,0,0,0-.11-.16s0,.1,0,.09,0-.1,0-.13a.72.72,0,0,1-.28-.13h0l0,0h-.08a.16.16,0,0,0-.09,0l-.06,0s0-.06,0-.09l0-.46s0,0,0,0v0h0c0-.07,0-.14,0-.21s0-.16,0-.24.08-.14.06-.17-.05,0-.06.05,0,0,0,0h0c.05,0,.06,0,.07,0s.09-.18,0-.11.06-.06,0,0l0,0a.1.1,0,0,1,.06-.05s0,0-.07,0,.06-.1,0-.07h0c.08-.06,0,0,0-.05l0,0v0h0c.05,0,.07-.07,0,0s0,0,0,0h0v0l.05,0h-.06v0l0,0c-.12,0,.05-.12,0-.11l0,0h0l0,0h0v0h0v0s0-.07,0-.07h0s.07-.09,0-.06a.16.16,0,0,0,.06-.16.36.36,0,0,0,0-.11l0,0a.21.21,0,0,0,.07-.2h0s0,0,0,0h0v0s0,0,0,0h0v0s.06,0,0-.06v-.05l0,.07s0,0,0,0,0-.07,0,0,0-.06,0-.07,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.08,0,0,0,0,0-.06c.11.13,0,0,0,0s.14,0,.06-.05,0-.09,0,0c0-.08,0-.07,0-.13s.08,0,.07,0,0-.08,0-.09.09,0,.08,0h-.06s0,0,0,0l.07,0s.1-.06,0-.09.07,0,0,0h0s0,0-.06,0,.07,0,0,0c.12,0,0,0,.06,0s0,0,0,0h0c.07,0,.14,0,.06,0h0s-.1,0,0,0c-.1,0,.06-.05,0-.06h-.06l.06,0h0s0,0,0,0,.06,0,0,0h0v0s0,0,0,0,.06-.07.06-.08h0s0,0,0,0l0,0c0-.06,0-.08,0-.08s.06-.09,0-.06-.06.09-.06.07,0,0,.08-.1a.17.17,0,0,0,0-.13h0a.14.14,0,0,0,0-.09s0,0,0,0,0,0,0-.08,0,0,0,0l0,0c0-.09,0,0,0-.11s0-.09.07-.16,0,0,0,0,.08-.07,0-.19c.07.07,0,0,.08,0-.06-.1,0-.08,0-.11s0-.12,0-.17h0s0-.07,0,0l0,0c.09,0,.11,0,.06-.1l0,.06s0-.1,0,0c0-.12,0-.16,0-.21s0,0,0-.05.09,0,0-.08.07,0,0,0,0,0,0,0l.06.06a.12.12,0,0,1,.1-.14c0-.16,0-.14.14-.16s0,0,0-.09,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.06,0,0-.11c.09.09,0,0,0,0s0-.08.06,0c0-.06,0,0,.05,0s0,0,0-.05,0,0,0,0,0,0,0-.05.06,0,0,0,0,0,0-.06.08,0,0-.06h0l0,0h0a.43.43,0,0,0,0,.05l.1-.06.09,0a.25.25,0,0,0,.15-.12c0,.08.09,0,.15,0l.09-.12c0-.05,0-.1.07-.14v0l0-.05h0s0,0,0,0h.06s0,0,0,0,.11,0,.14-.13l0-.06a0,0,0,0,0,0,0c0,.06,0,.09,0,.08a.86.86,0,0,1,.13-.17c0-.07.08-.15,0-.21s.07,0,0,0,0,0,0,0,0-.05.06,0,0-.1,0-.15.12-.2,0-.22c.13,0,0-.05.07-.08s-.05,0,0-.07v0l0,0s0,0,0,0,.15-.12.07-.11S105.07,175.07,105,175.09Zm-15.7,11h0s-.06.08,0,.13-.05.06-.08.12l0,.09s0,0-.05.09c0-.13,0-.11,0-.06s0,0,0,0l0,.05c0-.06,0-.08,0-.09s0,0-.07,0,0-.06,0,0,.09-.08.09-.12v0a.24.24,0,0,0,0-.08c.06,0,0,0,0-.09s0-.12.06-.1,0,0,0-.09,0,0,0-.07.07,0,.06.08.05-.06.05,0a.25.25,0,0,0,0,.07h.06c-.06,0,0,0-.06,0s0,0,.06,0S89.29,186,89.33,186.05Zm.27-.33a.56.56,0,0,1-.09.17h0c0-.09,0-.18-.09-.19a.18.18,0,0,0,0-.18l-.07,0s0,0,0,0v0s0,0,0,0l0,0a.15.15,0,0,1,0-.09.08.08,0,0,0,.07,0s0,0,0-.13,0,.11,0,0c0,.19,0,.05,0,0s0,0,0,.13.12,0,.12.09h0a.25.25,0,0,1,0,.12A.18.18,0,0,1,89.6,185.72Zm1.9-.65h0s0,0,.06,0,.06.07.11.09,0,.05,0,.07v.06a.33.33,0,0,0-.11.15.55.55,0,0,0,0,.13c0,.07,0,.12-.09.12s0,.06,0,.08h0l0,0s0,.1,0,.1,0,.05,0,0,0,0,0,.08,0,0,0,.06,0-.06,0-.06,0,0,0,.13h0l0,.07a.67.67,0,0,0,0,.24l0,0c0,.11-.1.15,0,.25-.08,0,0,0-.09,0s0,.11,0,.17c.07-.25.1-.54.16-.77A8.52,8.52,0,0,1,91.5,185.07Zm-.2,1.52,0-.15h-.06s.06,0,.08,0a.29.29,0,0,1,0-.18.56.56,0,0,0,.13-.36h0v0h0a4.1,4.1,0,0,0-.1.48l0,0a.38.38,0,0,1-.08.18l0,0v0Zm-.44.74c-.09.06-.15,0-.18-.06l0-.14c0-.06,0-.11,0-.17.08-.29.16-.58.27-.88s.27-.65.4-1v0A7.1,7.1,0,0,0,91,186a2.22,2.22,0,0,0-.15,1.07s0,0,.06,0a.36.36,0,0,0,0-.09v0l0-.05,0,.13s0,.08,0,.06,0,0,0,0a.23.23,0,0,0-.06.11.17.17,0,0,0,0,.13c0,.05.08,0,.12-.07l0,.11A.18.18,0,0,1,90.86,187.33Zm.73-.28a.33.33,0,0,1-.17.16.33.33,0,0,1,0,.1h-.09s0,.05,0,.13,0-.1-.06,0c0-.18,0,0,0,0s0,0,0-.12a.28.28,0,0,1-.17.07h0v0h0s0-.07,0,0l0-.08,0-.06a.45.45,0,0,0,0-.08.34.34,0,0,1,.09-.13s0,0,0-.05.11,0,0-.11.07,0,0,0c.08.09,0,0,0,0s0,0,.06.06a.25.25,0,0,1,0-.12h0a0,0,0,0,1,0,0h0a0,0,0,0,0,0,.08h0c-.08,0-.08.06-.06.11l0,0-.07.08.22.06s.05-.08,0-.11.11,0,.06-.12c.06.06,0,0,0,0a.06.06,0,0,0,.09,0A.82.82,0,0,1,91.59,187.05Zm.42-1.29h0s0,.06,0,.09,0,.27,0,.42,0,.13,0,.1,0,0,0,0a.37.37,0,0,0-.16.37.35.35,0,0,1-.05-.08s0,.17,0,.07l0,0a.11.11,0,0,0,0-.08s0,0,0-.05,0-.11,0-.07,0,0,0-.08,0,0,0-.06.09,0,.08-.1,0,0,0-.06,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.08,0,0,0,0a.09.09,0,0,1,0-.05l-.13.06a3.87,3.87,0,0,1,.14-.71l0,.24.12-.43c0,.05,0,.07.12,0-.09.1,0,.09-.07.17C92,185.54,92,185.65,92,185.76Zm1.32-2.32a.16.16,0,0,0,0-.11s0-.07-.07-.08,0,0,0-.11h0a.05.05,0,0,0,.06,0v0a.27.27,0,0,0,0,.09l0,.09Zm.16-.43a.13.13,0,0,0,0,.06.83.83,0,0,1,0-.12h0l0,0Zm.05-.8a1.7,1.7,0,0,0-.06.31h0v0s0,0,0,.07h0s0,0,0,0h0a1,1,0,0,1,.12-.48l0-.08A.88.88,0,0,1,93.54,182.21Zm.61-.65,0,0s0,0,0,0a1.08,1.08,0,0,0-.07.18,1,1,0,0,1-.08.27.24.24,0,0,1-.08.09.15.15,0,0,0,0-.07h0v0h0v-.11s-.06.06-.06,0,.07,0,.08-.06,0-.05,0-.08l0,0,0-.06.06-.09v0h0v0h0s0,0,0,0l0,0h0l0,0Zm-.36-.26s0,0,0,0,0,0,0,0h0c0-.06.11-.16,0-.1.08-.06-.1,0,0-.05-.07,0,0-.14,0-.14.13-.12,0-.13,0-.17s0,0,0,0,.09-.12.06-.13l-.06,0h0l.08,0s.07-.14,0-.09h0s0,0,0,0h0l0,0s0,0-.07,0,.07-.1,0-.05c.12-.08,0,0,.06,0-.08,0-.06,0,0,0h0s0,0,0,0,.08-.07,0,0,0,0,0,0h-.05l.09-.05s-.11,0,0,0c-.07,0,0,0,0-.06v0s0,0,0,0l0,0h0l0,0s0,0,0,0,0,0,0,0,.06-.08,0-.1v0h0v0a.12.12,0,0,0,0-.1.54.54,0,0,1,0-.1l0,0h0l.05,0s0-.05,0-.08a.11.11,0,0,0,.08,0,.38.38,0,0,0,.09-.09l.06-.09s0,.11,0,.11c-.17.13,0,.12,0,.18s-.09.12-.07.13l.07,0h0s-.07,0-.08,0h0V180s-.07.13,0,0-.06.07,0,0,0,0,0,0,0,0-.06.06,0,0,.08,0-.07.09,0,0h0c-.12.1,0,0-.05.06.07,0,.06,0,0,0a.09.09,0,0,1,0,0h0c-.07.05-.14.13,0,.06s0,0,0,0,0,0,.07,0h0l-.1.08s.11,0,0,0c.12-.06,0,.09,0,.06l.06,0-.06.05h0s0,0,0,0-.06.08,0,.06-.09.09,0,0c-.08.07-.07.1-.06.13a.32.32,0,0,0,0,.09h0l0,0c.05,0,0,.07,0,.13v0h0v0s0,0,0,.05l0,0h0s0,0,0,0h0s0,.05,0,0S94,181,94,181s0,0,0,0h0c0,.05-.06.08,0,.05h0c-.06,0,0,0,0,0l0,0,0,0h0l0,0h0l0,0a.2.2,0,0,0-.09.12h0l0,0S93.82,181.29,93.79,181.3Zm.06-2.38-.06.08c0-.08,0-.15.07-.22s0,0,0,0,0,.05,0,.08Zm-.06.17c-.07,0,.08.07,0,0a.22.22,0,0,1,0,.08l0,0h0l.06-.17S93.78,179.08,93.79,179.09Zm-.06.32a.13.13,0,0,0,0-.13l.11,0,0,.05,0,.06s0,.06-.08.06h0Zm.42-.6-.05,0,0,0h0s0,0,0,0,.07-.08,0-.07,0,0,0,0,0,0,0,0v0a0,0,0,0,0,0,0,.08.08,0,0,0,0,0h0s0,0,0,0h0v0s0,0,0,0h0A.09.09,0,0,0,94.15,178.81Zm.18-1.34a1.27,1.27,0,0,1,0,.27h0l0,0a1.47,1.47,0,0,1-.36.75l.36-1.06Zm-1,1a.74.74,0,0,1-.07-.36,1.43,1.43,0,0,1,.5-.73,5.61,5.61,0,0,0-.34.92,2.88,2.88,0,0,0-.13.74.25.25,0,0,1,0-.07C93.32,178.83,93.35,178.65,93.37,178.51Zm.07,1.06c-.08,0-.13,0-.15-.09a.28.28,0,0,0,.22,0A.13.13,0,0,1,93.44,179.57Zm.19-.44h0v0l0,.1a.28.28,0,0,1-.13,0v0l.06-.19s0,0,0,0c0-.23.11-.45.17-.68,0-.08,0-.13,0-.13.07-.23.15-.47.24-.69a.15.15,0,0,0,0-.11.29.29,0,0,1,.31,0c-.07.18-.13.37-.2.54A11.58,11.58,0,0,0,93.63,179.13Zm.23,3.75v0h0a.08.08,0,0,0,0,0s0,0,0,0-.08,0-.09.13-.08.17,0,.17l0,.05,0,0s0-.09,0-.12v-.06s0,0,0-.05a1,1,0,0,1,.11-.25s0,0,0,0a.32.32,0,0,0,.06-.08.29.29,0,0,0,0,.09h.06l0,.05A0,0,0,0,0,93.86,182.88Zm0-.25v0s0-.07,0-.08.09,0,0-.07c.1,0,.05,0,0,0s0,0,.08,0a.8.8,0,0,1,0-.15c0-.06,0-.11.07-.16.06.1-.09.13,0,.18-.12,0-.06,0,0,.08v0h0c-.07-.05,0,.16-.09.07A.13.13,0,0,1,93.89,182.63Zm.55-.44a.65.65,0,0,1,0,.13c0,.05,0,.09,0,.14a.53.53,0,0,0,0,.11l0,.13a.8.8,0,0,0,0,.15c-.06,0-.07.16-.09.06a.17.17,0,0,1,0,.09.13.13,0,0,0,0,.1s0,0-.06,0l-.07.11v0l0,0s0,0,0,0v0c.06,0,.06,0,0-.08s.16-.1.14-.23.05-.05.05-.12,0-.13.07-.14,0,0,0-.1,0,0,0-.1.1-.12.1-.21,0,0,.05-.12,0,0-.06,0,0,0,0,0,0,0,0,0l0-.08a1.21,1.21,0,0,0,0-.18v0l0,0h0l0,0a.22.22,0,0,1,0,.08h0s0,0,0,0h0V182h0l0,0s0,0,0,0h0l-.05.08a.1.1,0,0,0,.07,0A.08.08,0,0,1,94.44,182.19Zm1.51,1.6a.36.36,0,0,0,0,.09h0l0,0s0,0-.05,0,0-.08,0-.08,0-.07,0-.09Zm.93-1.56s0,0,.07-.07l0,.07v0h0s0,0,0,.07,0,0,0,0l0,0Zm.07.11a.24.24,0,0,1,0,.08l0-.1,0,0s0,0,0,0S97,182.32,97,182.34Zm-.3.51a0,0,0,0,1,0,0l0-.08h0s0,.12,0,.12Zm-.34-.6h0a.35.35,0,0,1,0-.06l0,0c0-.07,0,0,0-.08s0,0,0,0a.58.58,0,0,0-.11.2h0a.1.1,0,0,0,0-.05h0Zm0,1.38c0,.05-.07.12-.12.25a.12.12,0,0,1,0,.08l0,0a.24.24,0,0,1,0-.16l0,0a.08.08,0,0,0,0,0h0l0,0h0a.3.3,0,0,0,.07-.1l0-.05,0,0a.45.45,0,0,0,0-.23l.07,0c0-.06,0-.17,0-.1s0-.09,0-.11l0,0a1,1,0,0,0,0-.18.43.43,0,0,0,0-.11s.06,0,.08-.07l0-.05s0,0,0,0,.08,0,.06-.11,0,0,0,0,0,.15,0,.24a1.32,1.32,0,0,0-.08.19.4.4,0,0,1,0,.11v0a.13.13,0,0,0,0,.06l0,0s0,0,0,.07h0a1.18,1.18,0,0,1-.07.2Zm.86-.39s0,0,0,0a.37.37,0,0,0-.13.21v0a.34.34,0,0,0,0,.14s0,0-.06-.05,0,.16,0,.07a1,1,0,0,1-.09.28.51.51,0,0,1-.16.21.45.45,0,0,1,0,.08l-.09,0s0,.06,0,.13,0-.09-.07,0c0-.18,0,0,0,0s0,0,0-.11a.19.19,0,0,1-.16.06l0,0s0,0,0-.07,0,0,0-.05,0,.11,0,.11a.46.46,0,0,1,.07-.07l.09-.07a.19.19,0,0,0,.07-.2s.06,0,0,0,0,0,0,0,.05,0,.05,0,0-.08,0-.15l.1,0,0-.22h0v0h0s0,0,0,0l0-.05.09,0c0-.05,0,0,0-.1s0,0,0,0h0l0,.05c-.06-.1.06,0,0-.11.1.07,0,0,0,0s0-.07.07,0c0-.06,0,0,0,0a.14.14,0,0,0,0,0s0,0,0,0,.06,0,0-.05.06,0,0,0,0,0,0-.06.08,0,0-.08,0,0,0,0h.06c0,.06,0,.12,0,.18S97.24,183.25,97.17,183.24Zm.06-.65s0,0,0,0h0s0,0,0,0a.06.06,0,0,0-.05,0c0-.05,0-.1.08-.1s0,0,0,0h0s0,0,.05,0Zm1.18-4s0,0,0,.08,0,.08,0,.06,0,.05,0,.07a.43.43,0,0,1,0,0s0,0,0,0-.08.12-.07.21,0,0,0,0,0-.17.08-.29,0,0,0,0l.09-.17a.14.14,0,0,0,0-.06s0,0,0,0C98.28,178.61,98.38,178.54,98.41,178.59Zm.53-.75a.72.72,0,0,1,.19-.13.35.35,0,0,1,0,.06.12.12,0,0,1,.08,0l.06,0h0l0,.08s0,0,0,.05a.45.45,0,0,0-.11,0h0a.8.8,0,0,0-.22.2h0v0l0,0h0s0,0,0,0h0l0,0s0,0,0-.06l0,0v0s0-.05,0,0h0s0,0,0,0h0v0Zm0,1.32v0L99,179s0,.05,0,.05v0a2.33,2.33,0,0,0,.07-.25A.2.2,0,0,0,99,179c0,.08,0,.1,0,.12s0,.09,0,.14,0,0,0,.06l0,0h0s0-.07,0-.07h0S98.89,179.18,98.9,179.16Zm.13-3.74a1.75,1.75,0,0,1-.12.32h0v0l0,0h0l0,.05a.29.29,0,0,0,0-.09l.15-.5v0s0,.05,0,.06v.06S99,175.41,99,175.42Zm-.56.55h0a.27.27,0,0,1,0-.27h0a1.22,1.22,0,0,1,.1-.24.31.31,0,0,0,0-.1h0a.3.3,0,0,1,.15-.21A3.85,3.85,0,0,0,98.47,176Zm.15.05h0v0l.07-.11,0,0a.27.27,0,0,1-.07.08s0,.06,0,.07h0v0a.5.5,0,0,0,0-.13v0c0-.11,0-.22.08-.33s.09-.27.13-.41a.1.1,0,0,1,.09.06.25.25,0,0,1,0,.07h0c-.05.16-.11.31-.17.47a1.79,1.79,0,0,0-.09.3Zm.78,3.8c-.08.05.09,0,0,.05a.06.06,0,0,1,0,.08s0,.05,0,.07-.09,0-.09.08,0,.09,0,.11h-.06s0,0,0,0l0,.06v0l0-.08s0,0,0,.05,0,0,0,0a.14.14,0,0,0,0,.07s0-.06,0,0v0s0,0,0-.06,0,0,0,.1,0,0,0,.09c0-.15,0,.05,0-.06,0,.1,0,.09,0,.08a.17.17,0,0,1,0,.07c0-.09,0-.18,0-.06s0-.05,0,0,0,0,0,.13l0-.17c0,.05,0,.18,0,.05,0,.1,0,.09,0,.07s0,0,0,0,0,.08,0,.09v-.09s0,.05,0,.05,0,0,0,.06c0-.1,0-.07,0,0s0-.15,0,0c0-.12,0-.1,0-.1s-.06,0-.07,0,0,.09,0,.09l.06-.13s-.07,0-.08,0h0c0-.05,0-.08-.11-.11a.22.22,0,0,0,.06-.1.07.07,0,0,1,0-.05s0,0,0-.06,0,0,0-.06l.12,0a.3.3,0,0,0,.22,0,.34.34,0,0,1,0-.11s0,0,.08,0l.06,0-.08.05s0,0,0,.06c.11-.05,0,0,0,.07s0,0,.07,0c-.06,0,0,0,0,0l0,0,0,0-.06,0c.1,0-.05.05.07,0-.13.09,0,0,0,0l-.08.05c.05,0,0,0,0,0l.07,0h0s0,0,0,0-.06,0,0,0,0,0,0,0-.08.06,0,0c-.08,0,0,0,0,0s-.1.07,0,0c-.14.08.13-.06,0,0l.07,0s0,0,0,0-.07.05,0,0,0,0,0,0l.06,0h0l0,0,0,0s0,0,0,0l0,0-.07,0,.09-.05s0,0,0,0,.07-.06,0,0,0,0,0,0l.06,0c.09-.07-.07,0,0,0l-.06,0c.06,0,0,0,0,0l0,0s0,0,0,0,0,0,0,0l0,0s-.07,0,0,0l0,0c.17-.1,0,0,0,0s.16-.12,0-.05c.08,0-.1,0,0,0-.06,0,0,0,0,0,.17-.11,0,0,0-.06s.09-.07.06-.06l-.06,0h0l.08-.05s.09-.07,0,0,.06,0,0,0h0l.07,0c-.05,0,0,0-.07,0s.06-.05,0,0h0c.11-.07,0,0,0,0l0,0h0s.07,0,0,0h0l0,0,0,0h0l0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0,.07,0,0-.1.07,0,.07,0,0-.06,0-.06,0-.05.08,0l0-.06h0v0h0l0,0h0l0,0s0,0,0,.06,0,0,0,0h0c0,.07,0,0,0,0s0,0,0,.05.07,0,0,0,0,0,.06,0c-.16.18,0,0,0,.08a.49.49,0,0,1-.06.13S99.34,179.85,99.4,179.82Zm2.11.71s0-.05-.05-.09a.66.66,0,0,1,0-.15v.08l0,0s0,0,0,.06,0,0,.06,0h0Zm.14.06.06-.05,0,0,0,0h.06A.14.14,0,0,1,101.65,180.59Zm2.6,4c0-.05.17-.15,0-.14.08,0-.08,0,0,0,0,0,0-.13,0-.16l0,0,0,0s0,0,.1-.06c-.08.13,0,.05-.07.15,0-.06.07,0,.06,0a.6.6,0,0,1,0,.12.08.08,0,0,0,0,.07.19.19,0,0,1,0,.08s0,.07,0,0,0,0,0,0h0c-.09,0-.09.1,0,.2l-.06-.05s0,.1,0,0c0,.16,0,.22-.12.28s0,.07,0,.08h0s0,0,0,.11,0-.09,0,0a.54.54,0,0,0,0-.08h0s0,0,0-.09,0,0,0,0,0,0,0-.06v0h0v0h0s0,0,0,0v0h0s.07-.08,0-.05l0,0,.06,0c.1-.07,0-.08,0-.13h-.06c.06,0,.06-.06,0,0s0,0,0,0,0,0,0,0,0,0,0,0h0s-.06,0,0,0,0,0,0,0C104.4,184.58,104.24,184.59,104.25,184.56Zm-.09-.28h0c0-.06,0-.06,0-.06s0,0,0,0h0v0s0,0,0,0,0,.07-.08.12A.08.08,0,0,1,104.16,184.28Zm-.31-.13c.05,0,.07,0,.08,0a.1.1,0,0,0,0,0h0l-.08.1h0v0s0,0,0-.08S103.85,184.21,103.85,184.15Zm-.09.35a.07.07,0,0,1,0,.05h0l0,0s0-.09,0,0h0v0h0c0-.05,0,0,0,0h0C103.73,184.54,103.76,184.53,103.76,184.5Zm-.13.57s0,0,0-.06,0-.07,0-.09l-.06,0,0,0h0a0,0,0,0,0,0,0s0,0,0,0a.08.08,0,0,1,0,0h0s0,0,0,.08c0-.1,0,0,0-.1h0s0,0,0,0h0s0,.05,0,0h0l-.06,0c.1,0,0,.05.06,0s0,.08,0,.14l0,.11,0,0a.19.19,0,0,0,.06-.07s0,0,0,0a.64.64,0,0,1,0-.09s0,0,0,0,0-.05,0-.08h0c.08,0,0,0,.09,0s0-.07,0-.1h0c-.07.05-.08.09,0,.06s0,0,0,0-.11.09,0,.09,0,0,0,0,.06,0,0,.07,0,0,.07,0,0,.05,0,0-.06.14,0,.11a.41.41,0,0,0,0,.07l0,0H104l0,0c-.06.09-.1.1-.13.06a.53.53,0,0,1,0-.17c0,.05,0-.08-.08.08,0-.1,0,0,0-.05a.14.14,0,0,1,0,.07s0,0,0,0,0-.05,0-.09,0,0,0,0,0,0,0,0c.11-.19,0-.06,0-.06S103.64,185.07,103.63,185.07Zm-1.77-1.7,0-.07s0,0,0,0v0s0,.05,0,.06h0l0,0h-.08Zm-.43.46s0,.08,0,.08,0,.07-.06.06,0,0,0,0v0l0-.14,0,0S101.41,183.82,101.43,183.83Zm-.18.73s-.06,0,0-.06,0,0,0,0l0-.05s0,.06,0,.08Zm.06-.4c0,.05,0,.07,0,.1s-.09.08-.07.14h0s0,0-.06,0l0,0h0s0,0,0-.06.07-.09,0-.11.1,0,0-.06a.11.11,0,0,0,.08-.07S101.35,184.18,101.31,184.16Zm.08,1.16v0s0,0,.06.09A.07.07,0,0,1,101.39,185.32Zm.88-2.15c0,.07,0,.06.06,0l0,.1c.09-.15.06,0,.13-.08,0,.05.06.07.12.09l-.08.1,0,0s0,.1,0,0a.55.55,0,0,0-.06.08s.14-.08.06.07c.1-.12,0,0,0,0s0,0,.06,0,0,0,0,.07l.06-.06s0,0,0,0l-.06.06c.1-.09,0,0,.08,0s0,0,0,.06h0s0,0,0,0,0,0,0,0h0s0,0,0,0h0l0,.05v0l0,.07a.34.34,0,0,0,0,.14v0s0,0,0,0v0c0-.05.08-.07,0-.16.08,0,.06,0,.07,0s-.07,0-.06-.07l0,0s0,0,0,0c.11,0,0-.06.07,0l-.18-.05h0s0,0,0,0h-.05l0-.09h0s0,0-.06,0l.08,0s0,0,0,0,0-.06,0-.11.06-.05.08-.06-.08-.06-.07-.07h0s0,0,0,0c.13-.07,0,0,.07-.08l-.11,0s0-.06,0-.09S102.25,183.22,102.27,183.17Zm0,.7a.1.1,0,0,0,.07,0c.07,0,0,0,0,0l0,0c-.06,0,0,0,0,0s0,0,0,0,0,0,0,0h0c.08,0,0,0,.06,0s0,0,0,.07h0s-.06,0,.06.08c-.08,0,0,0-.09,0s0,0,0,0,0,0,0,0h0s0,0-.06,0,.06,0,0,0h0s0,0,0,0h0a0,0,0,0,0,0,0s0,0,0,0h0a.13.13,0,0,0,0-.06s0,0,0,0h0v0s0,0,0,0,0,0,0,0S102.33,183.88,102.25,183.87Zm-.07.57c.08,0,.09,0,.08-.05l0,0s-.08,0,0,0-.07,0,0,0c-.1,0,0,0,0,0l-.07,0s0,0,0,0h0a.11.11,0,0,1,0,0c.09,0,0,.06-.07.12s0,0,.07,0c-.06,0,0,0,0,0h0s0,0,0,0,.16-.09,0-.08c.08,0-.09,0,0,0C102.15,184.5,102.23,184.46,102.18,184.44Zm-.12-.4s0,0,0,0v0h0l0,0v0s0,0,0,0h.06s-.09.06,0,0-.08,0,0,0c-.12,0,0,0,0,0l-.08,0s0,.06,0,.1c.1,0,0,.08-.06.13s0,0,.06,0c-.06,0,0,0,0,0s0,0,0,0,0,0,0,0,0,0-.06,0-.06,0,.06,0c-.13,0,0,0,0,0s0,0-.07,0,0,0,0,.05H102s0,0,0,0,0,0,0,0-.07,0,0,0,0,0,0,0-.08.06,0,0c-.08,0,0,0,0,0s-.1.07,0,.06c-.14.06.13,0,0,.07.06,0,0,0,.07,0s0,0,0,0-.06.06,0,.06,0,0,0,0l.06,0s0,0,0,0,0,0,0,0h0l-.06.05a.14.14,0,0,1,0,.06v0h-.07l0,0s0,0,0,0,0,.12,0,0,0,0,0,.08h0c0-.13,0-.12,0-.09v.05s0,0,0,0h0l0,0s0-.06,0-.1,0,0,0,0c0-.13-.08.14,0-.06,0,0-.06,0-.08,0s0,0-.06,0c0-.15,0-.16,0-.15s-.09,0-.09,0,0-.17,0-.16l0,.08s0,0,0,0l0,0h0l.05-.08s0,0,0-.08,0,0,0,0h0l0,0c.08,0,0-.14.08-.1a.08.08,0,0,1,0-.08.15.15,0,0,0,0-.1h-.06s0,0,0,0a.08.08,0,0,0,0-.13.1.1,0,0,0,.07-.14.08.08,0,0,0,0-.13c.09-.06.12-.14,0-.19.08,0,.06-.05,0-.07s.13-.09.11-.21.05,0,.05,0v0l0,0s0,0,0,.06c.09,0,0,0,0,0s0,0,0,0h-.06l.06,0s0,0,0,0h-.06c.1,0,0,0,.07,0s0,.05,0,.08h0s-.06,0,.07.06h-.1c.1,0,0,0,0,.05s0,0,0,.07.06,0,0,0h0c-.1,0-.1.05,0,.05h-.08s.08,0,0,0,.08,0,0,.07h.06s-.09.05,0,0-.08,0,0,0c-.11,0,0,0,0,0h-.07s0,.05,0,.08c.1,0,0,0-.06.1s0,0,.07,0c-.07,0,0,0,0,0l0,0s0,0,0,0h-.06c.1,0-.05,0,.07,0-.13,0,0,0,0,0s0,0-.07,0,0,0,0,0h.06s0,0,0,0-.06,0,0,0-.06,0,0,0,0,0,0,0-.07,0,0,0,0,0,0,0-.1,0,0,0c-.13,0,.13,0,0,0,0,0,0,0,.06,0s0,0,0,0-.07,0,0,0,0,0,0,0a.11.11,0,0,1,.06,0h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0,.08,0,0,0h0c.1,0,0,0,0-.06h-.06c.06,0,.06,0,0,0s0,0,0,0,0,0,0,0,0,0,0,0h0s-.06,0,0,0,0,0,0,0c.16,0,0,0,0,0s.16-.07.05-.06c.08,0-.09,0,0,0-.05,0,0-.06,0-.07.17-.05,0-.07,0-.09s.09,0,.07-.06h0s.09,0,0,0,.07,0,0,0h0s0,0-.06,0,.06,0,0,0c.12,0,0,0,.06,0-.07,0-.06,0,0,0h0c.07,0,.14,0,.06,0h-.08l.12,0s-.11,0,0,0c-.11,0,.06,0,0,0h0s0,0,0,0,.06,0,0,0,.1,0,0,0c.08,0,.07,0,.07-.05s0,0,0,0h0A2.44,2.44,0,0,0,102.06,184Zm0-3.84.06-.06,0,0-.07,0h0a.34.34,0,0,0,0-.11s0,0,.07-.06C102,180.17,102.08,180.09,102,180.2Zm.1-1h0s0,0,0,.09h0s0,0,0,0a.1.1,0,0,1,0-.06h.06S102.12,179.28,102.11,179.24Zm.13.6-.09,0,0,0s0,0,0-.07a.08.08,0,0,0,0-.07.06.06,0,0,1,0,0v0h0s.05-.05,0-.07a0,0,0,0,1,0,0h0v0h0s0,0,0,0h0s-.1.07,0,.09-.07,0,0,0,0,0,0,0a.07.07,0,0,1-.06,0s0,0,.06,0-.07,0,0,0h0c-.09,0,0,0,0,0l0,0h0s-.07,0,0,0,0,0,0,0h0l0,0Zm.09-1c0,.08-.06.06,0,.14s-.05,0-.07,0,0,0,0,0,0-.09-.08-.06h0a.24.24,0,0,0,0-.07l0-.08,0-.05s.09-.1.08,0c0-.09,0,0,.06-.07a.14.14,0,0,1,0,.07s0,0,0,0l0,.05h0s0,0,0,0h0a.56.56,0,0,1,0,.07l0,0a.06.06,0,0,1,0,0C102.36,178.89,102.33,178.94,102.33,178.86Zm1.29-2.08s0,0,0,0,0,0,0,0,0,0,0,0,0,.08,0,0,0,0,0,.06c-.11-.11,0,0,0,.07s-.16,0-.09.09c0-.06,0,.11,0,0,0,.11-.08.09-.07.18-.13-.11-.07.14-.11.16s-.09,0-.09,0l0,.05v0c0-.05,0-.06-.06-.07s-.1,0,0,.14,0,0,0,0h0s0,0,0,0,0,0,0,.08-.07,0,0,.09c-.08-.1,0,0,0,0s0,.07,0,.06l0,.05c0-.05-.11-.09,0,0s0,0,0,0,0,0,0,.08l-.08-.1c0,.05,0,.13,0,.07.05.11-.06,0,0,.09h0s0,0,0,.05l0,0s0,0,0,0,0,0,0,.07-.06,0,0,.06-.08,0,0,0-.08,0-.09.05,0,.1,0,.14,0,0,0,0,0,0-.06-.05a.23.23,0,0,1-.06.18l0,.05s0,0-.07,0,0-.12,0-.07,0,.11,0,.1,0,0,0-.14l0,0h0v-.06a0,0,0,0,0,0,0,.14.14,0,0,0,0-.09s0,0,.05,0,0,0,0-.07,0,0,0-.05a.14.14,0,0,0,0,0c-.06-.09,0,0,0-.11s.06-.1.07-.18l0,0a.07.07,0,0,1,0-.05v0h0s0-.05,0-.11,0,0,.08,0c-.06-.1,0-.08,0-.12s0-.12,0-.18,0-.08,0,0,0,0,0,0,.11,0,.06-.12l0,.06s0-.1,0,0c0-.13,0-.16.06-.22s0,0,0-.05.1,0,0-.08.07,0,0,0c.08.09,0,0,0,0s0,0,0,0a.17.17,0,0,1,.12-.16c0-.16,0-.15.14-.18s0,0,0-.09,0,0,0,0l0,0s0,0,0,0l0,.05c-.05-.1.06,0,0-.11l0,0h0c-.07.12,0,.14,0,.15s.09,0,.11,0a.48.48,0,0,1,.07.16Zm.57-.38h-.09l-.09,0s0,0,0,0,0,0,0,.1,0-.05,0,0a0,0,0,0,0,0,0c.06,0,0,0,0,0s0,0-.05,0,0,0,0,0,0,0,0,0l0,0s0,0,0,.06,0,0,0,0l0,0s0,0-.06,0,0,.07,0,.11-.07,0,0-.08c-.06.05,0-.08,0-.09l0,.09c0-.08,0-.07,0,0s0-.11,0-.06h0s0,0,0,0v0s0,0,0,0h0s0,0,0,0v0c.06,0,.08,0,0-.08s0,0,0,0,.08,0,0-.05l0,0,0,0s0,0,0,0h0l0,.06-.12.12.14,0s0,0,0,0h0s0,0,0,0l.26-.08s0,0,0-.09,0,.06,0,.05,0,0,0-.06,0,0,0,0,0,0,0-.05h0l0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0-.07,0,0,0,0,0,0,0-.08,0,0,0,0,0,0,0-.09,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.06,0,0,0,0,0,0,0l0,0s0,0,0,0,0,0,0,0l0,0A.19.19,0,0,1,104.19,176.4Zm-.2-.61c.07,0-.07-.06,0,0,0-.06,0-.08,0-.13s.08,0,.08,0l0,0v0h0l-.07,0s0,0,0,0c-.06,0,0,0,0,0h0l0,0,0,0h0s0,0,0,0h0a0,0,0,0,1,0,0h0c-.08,0,0,0,0,0s0,0-.07,0,0,0,0,0,0,0,0,0S104.09,175.84,104,175.79Zm.31.11h-.06c.09,0-.06,0,.06,0-.13,0,0,0,0,0s0,0-.08,0,0,0,0,0,0,0,0-.06h0s0,0,0,0h0s.06,0,0-.05,0,0,0,0h.05c-.06,0,0,0,0,0h0S104.32,175.9,104.3,175.9Zm-.07,0a.08.08,0,0,1,0,0h0l0,0s0,0,0,0h0s0,0,0,0h.06C104.37,175.8,104.3,175.82,104.23,175.87Zm.11-.16v0l0,0s0-.08,0-.1.09,0,.07,0l0,0s0,0,0,0l.07,0h0l.05,0s-.08,0,0,0-.07,0,0,0c-.1,0,0,0,0,0l-.07,0A0,0,0,0,1,104.34,175.71Zm0-.42h0s0,0,0-.05.07,0,0,0h0a.07.07,0,0,0,0,.06h0s-.06,0,.07.06c-.09,0,0,0-.1,0,.1,0,0,0,0,0s0,0,0,0c-.1-.05.06,0,0-.06s0,0,0,0h0Zm.08.55s0,0,.06,0c-.06,0,0,0,0,0h0c.09,0,0,0,.06,0-.12,0,0,0,0,0s0,0-.08,0,0,0,0,0h0s.16-.07,0-.06c.08,0-.08,0,0,0,0,0,0-.06,0-.07s.08,0,.07-.05,0,0,0,0h0s0,0,0,0h0l0,0C104.59,175.78,104.52,175.8,104.45,175.84Zm.11-.2s0,0,0,.06l0,0s.06,0,0,0h0s0,0,.06,0l-.06,0s.07,0,0,0c.11,0,0,0,.06,0-.07,0,0,0,0,0h0c.06,0,.13,0,.06,0h0l-.08,0,.11,0s-.09,0,0,0c-.1,0,.06,0,0-.05h0s0,0,0,0,0,0,0,0,.06,0,0,0,.09,0,0,0a.1.1,0,0,0,.07,0v0s0,0,0,0h0c-.09,0-.09,0,0,.06h-.08s.08,0,0,0,.07.05,0,.1h0s-.08,0,0,0-.08,0,0,0c-.11,0,0,0,0,0Zm.09-.54s0,0,0,.07h0c.06,0,0,0,.08.06-.09,0,0,0-.1,0s.08-.09,0-.15a.06.06,0,0,0,0,0C104.67,175.08,104.57,175.12,104.65,175.1Zm0,.79,0,0a0,0,0,0,0,0,0h.07l0,0S104.68,175.81,104.7,175.89Zm0-.16,0,0s0-.05,0-.06.09,0,.07-.05h0s0,0,0,0,0,0,0,0Zm.09-.61s.08.06,0,.06v.06a.49.49,0,0,1,0,.17.37.37,0,0,1,0,.09.59.59,0,0,0,0,.08l-.06,0s.07,0,0,0c.12,0,0,0,.06,0-.07,0-.05,0,0,0h0c.06,0,.14,0,.06,0h0s-.1,0,0,0c-.1,0,.06,0,0-.05h0s0,0,0,0,.06,0,0,0,.09,0,0,0c.08,0,.07,0,.07-.07s0-.05,0-.07h-.06l.08,0s0-.06,0-.1,0-.08-.07-.07c.08-.06,0-.08.06-.09s-.09,0-.08,0l0,0,0,0c.12-.08,0,0,.06-.09l-.21.1h0s-.06.06,0,0a.11.11,0,0,1-.06,0s0,0,0,0h-.09a.1.1,0,0,0,0-.13c.08,0,.06-.07.08-.08s-.09,0-.08,0l0,0h0c.12-.08,0,0,.06-.09l-.18.08h-.07l0,.06h0s0,0,0,0v0h0v0h0s0,0,0,0h0s0,0,0,0,0,0,0,0h-.06c.09,0,0,0,.06.05s0,0,0,.08h0c0,.05,0,0,0,.11-.08-.05,0,0-.08,0s0,.05,0,.06,0,0,0,0v0a.19.19,0,0,0,0,.07s0,0,0,0l0,0c-.09,0-.1,0,0,.07l-.07,0s.07,0,0,0l0,0s0,0,0,.06a0,0,0,0,1,0,0l0-.06s0,0,0,.07l.06,0s-.09,0,0,0-.07,0,0,0c-.1,0,0,0,0,0l-.07,0s0,.07,0,.09,0-.08,0-.1.09-.05.07-.07h-.06s0,0,0,0,.07,0,.08,0h0s0,0,0,0,.06,0,0,0h0a.06.06,0,0,1,0,0s0,0,0,0,.07,0,0,0c.1,0,0,0,0,0s0,0,0,0l0,0c.05,0,.12,0,.05,0s0,0,0,0,0,0-.07,0l.1,0s-.08-.06,0,0c-.09-.06.06,0,0-.06s0,0,0,0l0,0s0,0,0,0,0,0,0,0,.06,0,0,0,.09,0,0,0,.07,0,.08,0V175l0,0s.06,0,.07,0a.09.09,0,0,1,0-.09h-.07a.08.08,0,0,1-.07-.07s0,.06,0,.1h0c0,.05-.07,0,0,.11-.08,0,0,0-.08,0s0,.05,0,.07,0,.07,0,.1,0,0,0,0l0,0c-.09,0-.1,0,0,.07l-.06,0s.06.05,0,0,.06.09,0,.13l0,0s0,0,0,0h.06s-.08,0,0,0c-.11,0,0,0,0,0H104s0,.07,0,.09,0,.08-.07.1h0s0,0,0,.07,0-.09,0-.05,0,.09,0,.08,0,0,0-.1,0,0-.07.08a.08.08,0,0,0,0,0s0-.05,0-.1v0a.22.22,0,0,1,0-.08h0v0s0,0,0-.06h0l0,0,0,0v0a.21.21,0,0,0,.07-.15h0v0s0,0,.06-.08h0a.25.25,0,0,0,0-.1s0,.06,0,.05,0-.05,0-.18a.1.1,0,0,0,.07,0h0v0h0l.07-.08,0,0,.06.06s0,0,0,0,0,0,0,0l0,0h.05s.06,0,.12-.13c0,.16,0,0,0,.16,0-.08.07-.09.09-.06s0,.08.05.11.12.07.17.12.08,0,0,.08,0,0,.05,0c-.08.17-.08.23,0,.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.82 180.51 93.82 180.51 93.82 180.51 93.82 180.51 93.82 180.51 93.82 180.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.15,166.07a5.53,5.53,0,0,0-4.36,1.17,4.46,4.46,0,0,0-1.4,1.53,4.69,4.69,0,0,0-.49,1.72l-.06-.18a2.51,2.51,0,0,0-.16-.46s-.1-.23-.16-.25-.14.08-.12.15l0,.12V170a.85.85,0,0,0,0,.17c0,.07,0,.14,0,.2s.07.27.11.4.18.54.29.81.27.25.37.09a3.94,3.94,0,0,1,.61-.73,3.57,3.57,0,0,1,.37-.31.81.81,0,0,0,.18-.19l.12-.21c0-.07,0-.24-.07-.24a.78.78,0,0,0-.3,0,.61.61,0,0,0-.27.15,2.92,2.92,0,0,0-.38.32c-.08.07-.13.17-.2.24,0-.19,0-.39.09-.58a3.91,3.91,0,0,1,.34-1.05A4.14,4.14,0,0,1,89,167.62a5.7,5.7,0,0,1,4.11-1.33C93.23,166.31,93.25,166.09,93.15,166.07Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.42,159.87c-.14.24-.26.49-.39.73l-.19.37c-.12.3-.29.17-.5-.37,0-.14-.18-.5-.29-.29a7.54,7.54,0,0,1-1.17,1.82c0-.06,0-.13,0-.2a3.1,3.1,0,0,0,.6-.71.91.91,0,0,0-.16-1.11.11.11,0,0,0-.17,0,2.64,2.64,0,0,0-.55,1.65c-.32.34-.66.65-.84.82l-.42-.53c-.06-.09-.15-.11-.21,0a4.33,4.33,0,0,1-.81,1,1,1,0,0,0-.24-.43.11.11,0,0,0-.18,0,2.31,2.31,0,0,1-.71.95c0-.24-.07-.49-.11-.73s-.13-.23-.21-.1l-1.08,1.6a1.41,1.41,0,0,1,.07-.41c0-.12-.12-.38-.2-.19a5.39,5.39,0,0,1-1.08,1.56c-.18.17-.52.52-.8.49-.44-.06-.56-.48-.55-.87,0,0,0,0,0-.06a3.77,3.77,0,0,0,1-.67,2.46,2.46,0,0,0,.74-1.14c0-.34-.18-.53-.51-.49s-.75.56-.93.93a6.11,6.11,0,0,0-.42,1.16,3.11,3.11,0,0,1-.41.2c-.11,0-.08.3,0,.26s.21-.1.32-.15a1,1,0,0,0,.44,1c.79.42,1.63-.7,2.09-1.51,0,.08,0,.16,0,.24s.13.23.21.1l1.11-1.63c0,.22.07.44.1.66,0,.06.08.22.17.15a2.66,2.66,0,0,0,.83-1l.09.24c0,.07.06.36.19.25a4.52,4.52,0,0,0,1-1.14c.13.18.26.36.4.53s.13.11.2,0l.76-.8a2.66,2.66,0,0,0,.07.39c0,.09.15.25.25.16a5,5,0,0,0,1.13-1.45.58.58,0,0,0,.49.45.53.53,0,0,0,.5-.26,4.39,4.39,0,0,0,.4-.67,4.48,4.48,0,0,0,.06.64c0,.14.16.13.18,0a10,10,0,0,0,.07-1.34C105.75,160,105.55,159.65,105.42,159.87Zm-9.91,4c.11-.26.45-1,.83-1,.14-.08.2,0,.19.18a.23.23,0,0,1,0,.35,1.88,1.88,0,0,1-.29.39,3.5,3.5,0,0,1-1,.76C95.34,164.34,95.44,164.1,95.51,163.92Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,165.29c-.07-.56-.15-1.13-.22-1.69,0-.13-.29-.52-.4-.23-.18.5-.22,1.22-.63,1.61a.84.84,0,0,1-.64.26.67.67,0,0,1-.17-.06,1.91,1.91,0,0,0,.33-1.18c0-.12-.17-.44-.32-.28a1.82,1.82,0,0,0-.52,1.35.48.48,0,0,1-.3,0c-.13,0-.12-.07-.25,0-.37.07-.57,1.25-1,.64a.13.13,0,0,0-.22,0l-.43.65-.18.28c-.19.29-.37.2-.52-.28,0-.08-.13-.25-.21-.13a18.35,18.35,0,0,1-1.63,2,2.35,2.35,0,0,1,0-1.12c0-.06,0-.34-.16-.2l-1,1.2c-.22.27-1,1.43-1.39.89-.11-.15-.21.12-.13.23.32.42.77.16,1.06-.16.47-.53.92-1.08,1.38-1.63a2.81,2.81,0,0,0,.12,1.15c0,.08.11.17.18.09a15.94,15.94,0,0,0,1.63-1.94c0,.25.16.47.42.51.47.08.85-.68,1.08-1.07a.65.65,0,0,0,.62.11c.36-.14.34-.71.75-.68.15,0,.21.1.37,0s.08-.05.12-.08a.88.88,0,0,0,.43.22c.83.17,1.18-.52,1.42-1.21,0,.22,0,.44.08.66a6.79,6.79,0,0,0,.29,1.63c0,.13.21.17.24,0A4.17,4.17,0,0,0,105.45,165.29Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,193.69l-.1.1v-.08l-.13.2L71,194a4.15,4.15,0,0,1-.43.3,4.79,4.79,0,0,1-.45.25,3,3,0,0,0-.44.23c-.06,0-.08.21,0,.21a1.53,1.53,0,0,0,.46-.14,3.65,3.65,0,0,0,.41-.18,4.94,4.94,0,0,0-1.72,3.05,4.25,4.25,0,0,0,.16,1.94c.15.42.45,1,1,1a.13.13,0,0,0,0-.22c-1-.54-1-2-.74-2.92a4.59,4.59,0,0,1,1.32-2.22,2.61,2.61,0,0,0,0,.4.61.61,0,0,1,0,.14.65.65,0,0,0,.14.29.17.17,0,0,0,.22.05c.13-.13.1-.25.1-.41a2.18,2.18,0,0,1,0-.25,2.35,2.35,0,0,1,.09-.53,2.41,2.41,0,0,1,.21-.5,1.38,1.38,0,0,1,.14-.24l.09-.13a.33.33,0,0,0,.06-.27C71.63,193.76,71.5,193.55,71.38,193.69Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,194.49,81.2,194a.13.13,0,0,0-.2,0l-.4.55a.93.93,0,0,0-.3-.29c-.09-.06-.18-.05-.22.06l-.21.63v-.06a1.49,1.49,0,0,0,0-.21c0-.11-.19-.47-.3-.24l0,0h0c-.2.56-.44,1.84-1.33,1.6a7.16,7.16,0,0,0,.38-.8c.32-.79-.54-1-.93-.37a1.25,1.25,0,0,0,0,1.27c-.16.21-.32.33-.42.15s-.25-.16-.28,0a1.82,1.82,0,0,1-.23.6,2.47,2.47,0,0,1-.29-.47c-.06-.14-.25-.17-.27,0a2.28,2.28,0,0,1-.37,1l0-.09c0-.18-.21-.42-.28-.15a1.82,1.82,0,0,1-.44.82l-.07-.46c0-.06,0-.12,0-.17s-.12-.31-.21-.15a.93.93,0,0,0-.11.77s0,.06,0,.08a2,2,0,0,1-.19.42c-.14.35-.26.27-.35-.24,0-.13-.1-.43-.19-.23A4.07,4.07,0,0,1,72.71,200c-.33.22-.5.17-.59,0a4.44,4.44,0,0,0,.59-2.1c0-.05-.07-.2-.14-.14a1.69,1.69,0,0,0-.69,1.12,3.14,3.14,0,0,0,0,1.23,4.36,4.36,0,0,1-.6.76c-.07.06,0,.28,0,.2a5,5,0,0,0,.65-.74s0,0,0,.06c.53.68,1.42-.59,1.89-1.43a.34.34,0,0,0,.45.29c.3-.07.48-.4.59-.78a1,1,0,0,0,.09.13.1.1,0,0,0,.16,0,2.22,2.22,0,0,0,.49-.7c0,.06,0,.11.07.17a.12.12,0,0,0,.2,0,2.64,2.64,0,0,0,.5-1,3.54,3.54,0,0,0,.34.45.12.12,0,0,0,.19,0,2.23,2.23,0,0,0,.29-.65c.26.2.54,0,.78-.32a1,1,0,0,0,.43.13,1.38,1.38,0,0,0,1.29-1.07l.09.1c.08.06.17,0,.2-.05.11-.26.21-.52.31-.79l.14.17c0,.11.19.27.3.12s.29-.41.44-.62l.44.36C81.84,195.05,81.9,194.62,81.75,194.49Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36,197a1.1,1.1,0,0,0-.3.51c-.08.17-.16.35-.25.52l-.27.53a2.52,2.52,0,0,1-.24.42.64.64,0,0,1-.38.27c-.16,0-.22-.18-.24-.31a2.35,2.35,0,0,1-.05-.65,3.84,3.84,0,0,0,.18-.35,1.4,1.4,0,0,0,.11-.5s0-.15-.09-.1a1,1,0,0,0-.2.25s-.09,0-.11.08a.69.69,0,0,0,0,.13c0,.09-.09.18-.14.26-.14.26-.29.52-.45.76a11.18,11.18,0,0,1-1.1,1.37c-.08.08,0,.37.11.26a7.46,7.46,0,0,0,1.21-1.36c.11-.16.21-.32.31-.49v.16c0,.26.07.62.31.77s.59-.11.74-.32a5.43,5.43,0,0,0,.51-.91l.27-.58a1.67,1.67,0,0,0,.19-.61C80.46,197,80.43,196.93,80.36,197Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,192.59a5.4,5.4,0,0,0-.58.59,2.44,2.44,0,0,1-.37.35l-.1.07a.25.25,0,0,1-.38-.08.68.68,0,0,1,0-.15c0-.11-.16-.3-.24-.18h0s0,0,0,0h0a7.05,7.05,0,0,1-.69,1.23,1.2,1.2,0,0,1-.37.28,3,3,0,0,0,0-1.3c0-.11-.23-.37-.37-.2a1.92,1.92,0,0,0-.23,1.79.36.36,0,0,1,0,.09c-.1.17-.15.27-.36.24s-.2-.11-.22-.33a2.27,2.27,0,0,1,.14-1,.14.14,0,0,1,0-.06c.05-.2-.3-.57-.4-.3l0,.06h0a6.58,6.58,0,0,1-.46,1.26,5.14,5.14,0,0,1-.29.51.7.7,0,0,1-.15.25c-.14.09-.26,0-.22-.18s-.15-.41-.3-.24a1.5,1.5,0,0,0-.29.73,1.33,1.33,0,0,1-.16.59c-.06.08-.5.32-.5.07s-.24-.35-.28-.11a1.7,1.7,0,0,1-.37,1c-.2.2-.85.31-.88-.13,0-.19-.22-.18-.21,0a.7.7,0,0,0,.91.62,1.22,1.22,0,0,0,.75-1,.53.53,0,0,0,.53.1c.41-.16.45-.63.55-1a.47.47,0,0,0,.06.09.41.41,0,0,0,.59,0,3.06,3.06,0,0,0,.62-.95c.09.35.33.72.74.66s.56-.38.71-.7h0c.73.06,1.2-.7,1.38-1.4a.54.54,0,0,0,.28.11.79.79,0,0,0,.53-.24,5.22,5.22,0,0,0,.85-.91C89.07,192.77,89,192.46,88.84,192.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,192c-.17,0-.11.39.08.39S90.76,192,90.57,192Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.66,205.13c-.46-.6-1.36-1.14-2.09-.67-.09.06-.06.28.06.25a1.63,1.63,0,0,1,1.87.86,3.29,3.29,0,0,1-.54,2.66,8.61,8.61,0,0,1-3.38,3.18,3.39,3.39,0,0,1-2.3.45A1.64,1.64,0,0,1,39,210.27a5.3,5.3,0,0,1,1.66-3.84,7.49,7.49,0,0,1,3.78-2.12c.19,0,.1-.43-.1-.41a7.15,7.15,0,0,0-4.5,2.36,5.13,5.13,0,0,0-1.37,4.56,2.53,2.53,0,0,0,1.76,1.67,3.78,3.78,0,0,0,2.61-.38,8.68,8.68,0,0,0,4-3.94A2.83,2.83,0,0,0,46.66,205.13Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.48,217a3.62,3.62,0,0,1-.73,0,2.21,2.21,0,0,1-.62-.13,1.27,1.27,0,0,1-.76-.64,2.4,2.4,0,0,1-.23-1.18c0-.13,0-.37,0-.61l0,0a2.17,2.17,0,0,0,.69.32,1.39,1.39,0,0,0,.8.09c.15-.06.13-.31,0-.38a1.89,1.89,0,0,0-.33-.13l-.3-.06a2.51,2.51,0,0,1-.6-.21.91.91,0,0,1-.54-.8.34.34,0,0,0-.21-.31c-.13,0-.19.08-.2.19s0,.05,0,.07a1.69,1.69,0,0,1-.38,1,2.56,2.56,0,0,0-.56,1.1c0,.09.1.3.2.18a6.3,6.3,0,0,0,.37-.53l.29-.4a3.66,3.66,0,0,0,0,.88,2.59,2.59,0,0,0,.62,1.35,2.36,2.36,0,0,0,1.16.68,2.25,2.25,0,0,0,.69.08,1.94,1.94,0,0,0,.34,0c.11,0,.2-.08.31-.1S45.68,217,45.48,217Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,208.7c-.31.29-.94,1-1.37.47a.15.15,0,0,0-.28.06c-.14.62-.85.83-1.28,1.21-.23.19-1,1.5-1.36.86a.17.17,0,0,0-.25-.09c-.36.22-.39.57-.59.91s-.21.36-.44.26-.08-.07-.19-.22a1.82,1.82,0,0,0-.15-.27.14.14,0,0,0-.11,0h-.07a.15.15,0,0,0-.1.13,4.72,4.72,0,0,1-.6,1.55,2.72,2.72,0,0,1-.25-.76c0-.11-.13-.24-.21-.1a18.92,18.92,0,0,1-1.32,2,1.31,1.31,0,0,1-.09-1c0-.13-.13-.49-.25-.29-.22.39-.38.81-.61,1.21a3.11,3.11,0,0,1-1,1.22c-.45.21-.55-.15-.56-.56a4.62,4.62,0,0,0,1-2.33c0-.1-.1-.39-.24-.27a3.29,3.29,0,0,0-1.07,1.85,3.79,3.79,0,0,0-.07.71,4.34,4.34,0,0,1-.51.54c-.09.08,0,.36.1.26a4.35,4.35,0,0,0,.44-.41,1.13,1.13,0,0,0,.23.61c.68.82,1.67-.82,2.17-1.87a1.85,1.85,0,0,0,.29.72c0,.06.12.12.17,0a21.46,21.46,0,0,0,1.3-2,3.44,3.44,0,0,0,.3.81c0,.06.12.12.17.05a4.8,4.8,0,0,0,.68-1.38,1,1,0,0,0,0-.27.46.46,0,0,0,0,.1.56.56,0,0,0,.14.3c.68.73,1.1-.58,1.44-1,.4.45,1,0,1.35-.44.46-.61,1.38-.89,1.7-1.59a.8.8,0,0,0,.66.12c.48-.11.67-.5.86-.92C58.21,208.82,58.13,208.59,58,208.7Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,208.18c-.29,0-.12.54.14.54S60.29,208.18,60,208.18Z",
    style: {
      fill: "#7AC1FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.05,271.69c.55.22.67,1.28.7,3.37,0,1.59.31,4.36-1.56,4.87s-4.58.17-5.73-1.35c-1.45-1.9-2.41-3.56-4.48-5.88-1.79-2-3.74-3.9-4.42-6.69-.61-2.51,0-3.58,1.69-4.27,2.37-.95,6,2.4,7.81,3C218.63,265.18,222.51,271.47,223.05,271.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91,286s.68,2.25,1,4.22c.28,1.56.67,4.17.1,5.32s-2.71,1.87-6,1.77c-2.13-.07-5.48,1.3-7.79,2.52s-7.27,1.67-9.75,1.32c-2.92-.41-5.91-2.17-6.36-3.39s.21-2.47,7.18-5.26c.06,0,9.66-2.91,13.08-6.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.54,235.68c-1-8.42-1.55-13-1.55-13s0-11.94.68-22.88c.74-11.82,1.43-17.9-.9-35,0,0-36.22-3.25-37.21,10.41s-.67,49.37-.35,55.38,1.08,14.39,1.9,25.57c1,13.38,2.55,31.93,2.55,31.93,4.31,2.46,12.1.92,12.1.92s2.51-33,2.39-40a59.54,59.54,0,0,0-2.29-15.19s1-11.25,1.83-21,1.65-14.49,1.89-18.75l.83-.39s.46,16.93.77,23,1.15,11.8,2.63,23c1.29,9.71,3.82,31.61,3.82,31.61,3.57,4.63,9.75,1.53,9.75,1.53S226.53,244.11,225.54,235.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.58,194.06s9.36-4.36,14.09-8.37c0,0-4.44,6-10.15,8.53,0,0-2.48,21-2.46,20.55L207.37,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.09 116.11 201.5 128.62 213.32 128.03 212 113.43 200.09 116.11",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.77,120.9c4.4-.2,6.63.46,8.61,4.25s2.75,15.13,3.43,21,.86,10-1.54,10.56-11.77.86-11.77.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.19,127.39c-.63-3.51-5.23-7.18-9.54-6.48-1,.16-2,.32-2.93.49-.52,2.11-6.28,3.42-11.79,2.12-1.66.44-7.13,1.46-8.51,1.92-4,1.32-5.59,5.21-6.21,18.13,0,0-1.94,57.79-2.1,63.61,9.78,4.13,20.49,4.26,26.19,3.15,11.86-2.31,16.56-7.15,16.56-7.15l-1.51-41.34S226.64,135.3,225.19,127.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.56,120.24l.09.79a17.58,17.58,0,0,0,7.25,0c3.84-.86,4.61-1.94,4.61-1.94l-.08-.9s1-.35,1.46,1.12.56,1.79.56,1.79.44,2.69-4.07,4.06a13.94,13.94,0,0,1-11.24-1.23l-1.77.38s1.53-3.53,2-4.25a1.19,1.19,0,0,1,1.11-.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.5 106.83 141.07 119.05 152.71 150.88 174.57 138.63 164.5 106.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.42 109.94 143.77 120.2 154.07 147.56 172.41 137.28 163.42 109.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.27,112.89l-.38-1c-.21-.54-1.84-.22-3.65.72l-3.46,1.78c-1.81.94-3.1,2.13-2.89,2.67l.38,1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,109c-.13-.34-.84-.28-1.59.12l-1.35.73s-.84-2.1-3.95-.64-2.41,3.89-2.41,3.89l-1.44.79c-.79.44-1.36,1.07-1.26,1.41l.18.62,12.06-6.3Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,109c-.13-.34-.84-.28-1.59.12l-1.35.73s-.84-2.1-3.95-.64-2.41,3.89-2.41,3.89l-1.44.79c-.79.44-1.36,1.07-1.26,1.41l.18.62,12.06-6.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,110.41c-1.12.55-1.56.82-1.24,1.65s.71,1.62.71,1.62l-5.33,2.8s-.45-1.21-.64-1.67-.59-.69-1.44-.24l-.31-.34,8.41-4.29Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,110.41c-1.12.55-1.56.82-1.24,1.65s.71,1.62.71,1.62l-5.33,2.8s-.45-1.21-.64-1.67-.59-.69-1.44-.24l-.31-.34,8.41-4.29Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,112.94l-.38-1c-.21-.54-1.84-.22-3.65.72L152,114.47c-1.81.94-3.1,2.13-2.89,2.67l.38,1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.42,125.44c-5.41.47-7.71,1.46-11.77,8.78-4.41,7.94-12.88,22.32-14,24.14-1.49,2.52-1.78,6.37-.49,8.69,1.21,2.16,5,3.15,9.36-1.74,5.15-5.82,14.74-20,14.74-20S198.45,134.53,192.42,125.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,168.71c-4.14-.5-13.82-13.64-16.58-17.93a30.65,30.65,0,0,0-8.38-8.85c-4.39-3.24-3.75-8.22-1.84-12.78.66-1.59,2.91-.56,2.91-.56l.79,2.17,1.38,3.75c.93.86,1.45,1.14,1.52.89.11-.49-.69-2.5-.67-4.61,0-2.53,1.8-.86,2.33,0a32.59,32.59,0,0,1,1.87,4.18c.88,2.27.52,4.56,1.59,6.1s15.52,15.38,15.52,15.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46,125.16c-3.27-.08-7.21.44-10.26,4.4s-15.26,25.51-15.26,25.51l-6.85-6.14a12,12,0,0,0-5.26,7.45,74.18,74.18,0,0,0,6.2,8.41c2.89,3.18,6.12,5.38,8.77,4.41s5.35-3.08,11-11,11.92-17.31,11.92-17.31S197.7,131.73,193.46,125.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.77,100.8s-3,4.48-2.61,4.91,2.5.84,2.5.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.15,103.68a3.52,3.52,0,1,1,3.52-3.52A3.52,3.52,0,0,1,193.15,103.68Zm0-6.25a2.73,2.73,0,1,0,2.73,2.73A2.73,2.73,0,0,0,193.15,97.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62,86.3c-5.46,2.11-7.35,6-7.91,15.48-.59,9.91.42,13,1.72,14.36.88.9,5.76,1.06,8.23.38,3.08-.85,10-3.32,13.31-8.3,3.84-5.86,3.48-16-.63-19.25A15.85,15.85,0,0,0,199.62,86.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,116.8l-.28-1.82a11.8,11.8,0,0,1-6.12,1.38C194.91,116.92,197.88,117.08,200.17,116.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 99.43 200.58 100.8 200.15 101.55 189.97 100.22 189.97 99.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.25,93.48a1.26,1.26,0,0,0-.15.38c-.53,2.1.4,3.82,1.82,5.25.6.6.33,1.37.6,2.07.08.19,1.23,1.46,1.28,1.28,0,0,.94-3.66,4-3.2s3.53,4.42,1.57,6.83-3.76,1.49-3.78,1.48c.18.09.24,1.26.3,1.48a10.81,10.81,0,0,0,.79,2,9.49,9.49,0,0,0,2.8,3.27,6.82,6.82,0,0,0,5.6,1.56,6.18,6.18,0,0,0,1.31-.46c3.32-1.57,5.22-5.83,6.12-9.19,1-3.82,1.44-6.81.56-10.67a12.29,12.29,0,0,0-2.95-5.64c-1.6-1.7-1.83-2.09-3.59-2.17.83.73,1.53,1.62,0,2.87a11.62,11.62,0,0,1-5.3,2.68,23.62,23.62,0,0,1-10,0,1.09,1.09,0,0,0-.92.06A.53.53,0,0,0,196.25,93.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.74,104.55l.11-4.15a2.08,2.08,0,0,0-.11,4.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelves--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelving--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "410.23 275.43 410.23 283.89 449.12 261.44 449.12 252.98 410.23 275.43",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.23 275.43 410.23 283.89 449.12 261.44 449.12 252.98 410.23 275.43",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.23 283.89 405.63 281.24 405.63 272.78 410.23 275.43 410.23 283.89",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.23 283.89 405.63 281.24 405.63 272.78 410.23 275.43 410.23 283.89",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.85 249.24 364.85 257.7 403.74 235.24 403.74 226.78 364.85 249.24",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.85 249.24 364.85 257.7 403.74 235.24 403.74 226.78 364.85 249.24",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.85 257.7 360.26 255.04 360.26 246.58 364.85 249.24 364.85 257.7",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.85 257.7 360.26 255.04 360.26 246.58 364.85 249.24 364.85 257.7",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.49 86.64 418.6 109.09 418.6 281.24 457.49 258.79 457.49 86.64",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.49 86.64 418.6 109.09 418.6 281.24 457.49 258.79 457.49 86.64",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.6 109.09 353.78 71.67 353.78 243.82 418.6 281.24 418.6 109.09",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.6 109.09 353.78 71.67 353.78 243.82 418.6 281.24 418.6 109.09",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.78 71.67 392.67 49.21 457.49 86.64 418.6 109.09 353.78 71.67",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.78 71.67 392.67 49.21 457.49 86.64 418.6 109.09 353.78 71.67",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 187.68 412.12 217.62 412.11 270.01 360.26 240.07 360.26 187.68",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 187.68 412.12 217.62 412.11 270.01 360.26 240.07 360.26 187.68",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.57 202.3 386.8 203 386.8 255.4 385.58 254.69 385.57 202.3",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91,227.81v7.49l.65.38a.74.74,0,0,0,1.11-.64v-5.4a1.41,1.41,0,0,0-.71-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.47,222.37v7.49l-.66-.38a3,3,0,0,1-1.11-1.92v-5.4c0-.5.27-.65.71-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.11 112.83 360.26 82.89 360.26 127.8 412.11 157.73 412.11 112.83",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 127.8 399.15 105.35 360.26 82.89 360.26 127.8",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.11 165.23 360.26 135.29 360.26 180.19 412.11 210.12 412.11 165.23",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 180.19 399.15 157.74 360.26 135.29 360.26 180.19",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tubes--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "370.06 184.04 366.12 181.77 385.26 170.72 389.19 173 370.06 184.04",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.64,164.28h0l.25-.15v.43a.74.74,0,0,1-.14.44l-.11.13V167a1.78,1.78,0,0,0-.33-.25,3.09,3.09,0,0,0-2.81,0,1.7,1.7,0,0,0-.35.27v-.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,164.6a3.09,3.09,0,0,0-2.81,0,1.13,1.13,0,0,0-.54.58c-.13-.36.05-.75.54-1a3.09,3.09,0,0,1,2.81,0c.49.29.68.68.55,1A1.2,1.2,0,0,0,376.81,164.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,162a3.11,3.11,0,0,0-2.82,0,1.18,1.18,0,0,0-.54.58c-.13-.36.05-.75.54-1a3.11,3.11,0,0,1,2.82,0c.49.29.67.68.54,1A1.23,1.23,0,0,0,381.32,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,159.4a3.11,3.11,0,0,0-2.82,0,1.2,1.2,0,0,0-.54.59c-.13-.37.05-.76.54-1.05a3.18,3.18,0,0,1,2.82,0c.49.29.67.68.54,1.05A1.11,1.11,0,0,0,385.82,159.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,167.2a3.09,3.09,0,0,0-2.81,0,1.1,1.1,0,0,0-.54.58c-.13-.36.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.67.68.54,1A1.1,1.1,0,0,0,372.31,167.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,158.94a3.11,3.11,0,0,0-2.82,0,1.81,1.81,0,0,0-.33.26v-.71l2.59-1.5.9.53v1.69A1.62,1.62,0,0,0,385.82,158.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,159.09h0l0,0h0l.25-.14v.43a.72.72,0,0,1-.15.43.64.64,0,0,1-.1.13h0v1.89a1.9,1.9,0,0,0-.34-.26,3.11,3.11,0,0,0-2.82,0,1.9,1.9,0,0,0-.34.26v-.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.09,161.71h0l.31-.18V162a.75.75,0,0,1-.15.44l-.1.12h0v1.88a1.6,1.6,0,0,0-.34-.26,3.09,3.09,0,0,0-2.81,0,1.35,1.35,0,0,0-.34.27v-.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.19,160.26v0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.18,160.28l-.08.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.16,159.92v-.71c.41.44.29,1-.34,1.36a3.11,3.11,0,0,1-2.82,0c-.64-.37-.75-.93-.33-1.37v.72Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,175a3.09,3.09,0,0,0-2.81,0,1.06,1.06,0,0,0-.54.58c-.13-.37.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.68.67.55,1A1.13,1.13,0,0,0,376.81,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,172.4a3.11,3.11,0,0,0-2.82,0,1.14,1.14,0,0,0-.54.58c-.13-.37.05-.76.54-1a3.11,3.11,0,0,1,2.82,0c.49.28.67.68.54,1A1.18,1.18,0,0,0,381.32,172.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,169.8a3.11,3.11,0,0,0-2.82,0,1.18,1.18,0,0,0-.54.58c-.13-.36.05-.76.54-1a3.11,3.11,0,0,1,2.82,0c.49.28.67.68.54,1A1.1,1.1,0,0,0,385.82,169.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,177.59a3.16,3.16,0,0,0-2.81,0,1.11,1.11,0,0,0-.54.59c-.13-.37.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.67.67.54,1A1.11,1.11,0,0,0,372.31,177.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,169.34a3.11,3.11,0,0,0-2.82,0,1.78,1.78,0,0,0-.33.25v-.71l2.59-1.49.9.52v1.7A1.35,1.35,0,0,0,385.82,169.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,171.94a3.11,3.11,0,0,0-2.82,0,1.9,1.9,0,0,0-.34.26v-.72l3.5-2v2.73A1.9,1.9,0,0,0,381.32,171.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,174.54a3.09,3.09,0,0,0-2.81,0,1.6,1.6,0,0,0-.34.26v-.71l3.49-2v2.72A1.3,1.3,0,0,0,376.81,174.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,177.14a3.09,3.09,0,0,0-2.81,0,1.41,1.41,0,0,0-.35.27v-.72l3.49-2v2.72A1.43,1.43,0,0,0,372.31,177.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.67,157a.85.85,0,0,1,.51-.71,2.69,2.69,0,0,1,2.47,0,.85.85,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67,157a.85.85,0,0,1,.51-.71,2.69,2.69,0,0,1,2.47,0,.85.85,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,173c0,.17-.1.26-.22.18a.6.6,0,0,1-.22-.47V156.45a1.21,1.21,0,0,1,.28-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.68,173.44h0a.17.17,0,0,1-.12-.16v-17.2l.25-.07v17.34A.09.09,0,0,1,383.68,173.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,157.92a1.08,1.08,0,0,1-.44-.4V157a.68.68,0,0,1,0-.19,1.47,1.47,0,0,1,.41-.35,2.93,2.93,0,0,1,2.46-.08v-.14h0l.06,0a1.13,1.13,0,0,1,.35.29.76.76,0,0,1,.13.23.63.63,0,0,1,0,.19v.68h0v2h0v12.88h0a1.74,1.74,0,0,1-3.34.7,1.59,1.59,0,0,0,1.84.66h0a1,1,0,0,0,.71-.95V158.08A2.92,2.92,0,0,1,383.11,157.92Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,174.27h0a1.52,1.52,0,0,0,1.28-1.61V156.39l0,0a.87.87,0,0,1,.19.25h0s0,0,0,.05v0a.31.31,0,0,1,0,.13v.76h0v2h0v12.88h0A1.75,1.75,0,0,1,384.59,174.27Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.42,155.89a1,1,0,0,1,.58-.81,3.14,3.14,0,0,1,2.83,0,1,1,0,0,1,.58.81h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.58-.82h0v-.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.42,155.89a1,1,0,0,1,.58-.81,3.14,3.14,0,0,1,2.83,0,1,1,0,0,1,.58.81h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.58-.82h0v-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,157.49a3.46,3.46,0,0,0,2.26.16c.62-.26.93-.53.93-1.12v-1.3a.89.89,0,0,1,.35.66h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,156.71a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.14,3.14,0,0,1,2.83,0A.86.86,0,0,1,385.83,156.71Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,156.71a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.14,3.14,0,0,1,2.83,0A.86.86,0,0,1,385.83,156.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.29,155.22c.63.17.84.64.56,1a1.72,1.72,0,0,1-1.74.55c-.94-.12-1.13-.62-1.13-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.44,156.49a2.31,2.31,0,0,1-2.05,0,.63.63,0,0,1,0-1.19,2.25,2.25,0,0,1,2.05,0A.63.63,0,0,1,385.44,156.49Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.44,156.49a2.31,2.31,0,0,1-2.05,0,.63.63,0,0,1,0-1.19,2.25,2.25,0,0,1,2.05,0A.63.63,0,0,1,385.44,156.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.44,156.33a.36.36,0,0,1,.12.08l-.12.08a2.31,2.31,0,0,1-2.05,0l-.13-.08a.57.57,0,0,1,.13-.08A2.25,2.25,0,0,1,385.44,156.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.16,159.55a.88.88,0,0,1,.51-.71,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.16,159.55a.88.88,0,0,1,.51-.71,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.83,175.61c0,.18-.1.26-.22.18a.61.61,0,0,1-.21-.47V159.05a1.59,1.59,0,0,1,.27-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.17,176.05h0a.17.17,0,0,1-.12-.16v-17.2l.25-.07V176A.1.1,0,0,1,379.17,176.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,160.53a1.26,1.26,0,0,1-.44-.41v-.57a.57.57,0,0,1,0-.18,1.34,1.34,0,0,1,.41-.36,3,3,0,0,1,2.46-.08v-.13h0l.06,0a1.15,1.15,0,0,1,.35.29.59.59,0,0,1,.13.23.63.63,0,0,1,0,.19v.69h0v2h0v12.87h0a1.74,1.74,0,0,1-3.34.7,1.61,1.61,0,0,0,1.84.66h0a1,1,0,0,0,.71-1V160.68A3,3,0,0,1,378.6,160.53Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09,176.87h0a1.51,1.51,0,0,0,1.27-1.61V159l0,0a.92.92,0,0,1,.2.25h0l0,0v0a.93.93,0,0,1,0,.13v.77h0v2h0v12.87h0A1.74,1.74,0,0,1,380.09,176.87Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.91,158.49a1,1,0,0,1,.59-.81,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.59.81h0v.87h0a1,1,0,0,1-.59.81,3.11,3.11,0,0,1-2.82,0,1,1,0,0,1-.59-.81h0v-.87Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.91,158.49a1,1,0,0,1,.59-.81,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.59.81h0v.87h0a1,1,0,0,1-.59.81,3.11,3.11,0,0,1-2.82,0,1,1,0,0,1-.59-.81h0v-.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.36,160.09a3.42,3.42,0,0,0,2.27.16c.61-.26.92-.52.92-1.12v-1.29a.84.84,0,0,1,.36.65h0v.87h0a1,1,0,0,1-.59.81,3.11,3.11,0,0,1-2.82,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,159.31a3.11,3.11,0,0,1-2.82,0,.86.86,0,0,1,0-1.63,3.11,3.11,0,0,1,2.82,0A.86.86,0,0,1,381.32,159.31Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,159.31a3.11,3.11,0,0,1-2.82,0,.86.86,0,0,1,0-1.63,3.11,3.11,0,0,1,2.82,0A.86.86,0,0,1,381.32,159.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.78,157.82c.63.17.84.64.56,1a1.71,1.71,0,0,1-1.73.55c-.94-.13-1.14-.63-1.14-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,159.09a2.27,2.27,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,380.94,159.09Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,159.09a2.27,2.27,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,380.94,159.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,158.93l.12.08-.12.08a2.27,2.27,0,0,1-2.06,0l-.12-.08a.5.5,0,0,1,.12-.08A2.27,2.27,0,0,1,380.94,158.93Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.66,162.16a.88.88,0,0,1,.51-.72,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.72v15.58h0a1.75,1.75,0,0,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,162.16a.88.88,0,0,1,.51-.72,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.72v15.58h0a1.75,1.75,0,0,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.33,178.22c0,.17-.11.25-.23.17a.61.61,0,0,1-.21-.46V161.65a2.27,2.27,0,0,1,.28-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,178.65h0a.2.2,0,0,1-.12-.17v-17.2l.25-.07v17.34A.09.09,0,0,1,374.66,178.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,163.13a1.29,1.29,0,0,1-.43-.4v-.57a.58.58,0,0,1,0-.19,1.16,1.16,0,0,1,.4-.35,2.9,2.9,0,0,1,2.46-.08v-.14h0l.07,0a1.5,1.5,0,0,1,.35.29.89.89,0,0,1,.13.23.69.69,0,0,1,0,.2v.68h0v2h0v12.88h0a1.75,1.75,0,0,1-3.35.7,1.61,1.61,0,0,0,1.85.66h0a1,1,0,0,0,.7-1V163.29A2.92,2.92,0,0,1,374.09,163.13Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.58,179.47h0a1.5,1.5,0,0,0,1.27-1.61V161.6l0,0a.84.84,0,0,1,.19.24v0s0,0,0,.05v0a.5.5,0,0,1,0,.13h0a.15.15,0,0,1,0,.07v.68h0v2h0v12.88h0A1.75,1.75,0,0,1,375.58,179.47Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.4,161.1a1,1,0,0,1,.59-.82,3.13,3.13,0,0,1,2.83,0,1,1,0,0,1,.58.82h0V162h0a1,1,0,0,1-.58.82,3.13,3.13,0,0,1-2.83,0,1,1,0,0,1-.59-.82h0v-.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.4,161.1a1,1,0,0,1,.59-.82,3.13,3.13,0,0,1,2.83,0,1,1,0,0,1,.58.82h0V162h0a1,1,0,0,1-.58.82,3.13,3.13,0,0,1-2.83,0,1,1,0,0,1-.59-.82h0v-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.86,162.69a3.4,3.4,0,0,0,2.26.16c.62-.26.92-.52.92-1.12v-1.29a.87.87,0,0,1,.36.66h0V162h0a1,1,0,0,1-.58.82,3.13,3.13,0,0,1-2.83,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.82,161.91a3.13,3.13,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.13,3.13,0,0,1,2.83,0A.86.86,0,0,1,376.82,161.91Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.82,161.91a3.13,3.13,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.13,3.13,0,0,1,2.83,0A.86.86,0,0,1,376.82,161.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28,160.43c.63.16.83.64.56,1a1.74,1.74,0,0,1-1.74.55c-.94-.12-1.13-.63-1.13-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,161.69a2.27,2.27,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.33,2.33,0,0,1,2.06,0A.63.63,0,0,1,376.43,161.69Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,161.69a2.27,2.27,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.33,2.33,0,0,1,2.06,0A.63.63,0,0,1,376.43,161.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,161.53l.12.08a.5.5,0,0,1-.12.08,2.27,2.27,0,0,1-2.06,0l-.12-.08.12-.08A2.27,2.27,0,0,1,376.43,161.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.15,164.76a.85.85,0,0,1,.51-.71,2.69,2.69,0,0,1,2.47,0,.85.85,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,164.76a.85.85,0,0,1,.51-.71,2.69,2.69,0,0,1,2.47,0,.85.85,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,180.82c0,.17-.1.26-.22.18a.6.6,0,0,1-.22-.47V164.26a1.21,1.21,0,0,1,.28-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16,181.25h0a.17.17,0,0,1-.12-.16v-17.2l.25-.07v17.34A.09.09,0,0,1,370.16,181.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,165.73a1.08,1.08,0,0,1-.44-.4v-.57a.68.68,0,0,1,0-.19,1.47,1.47,0,0,1,.41-.35,2.93,2.93,0,0,1,2.46-.08V164h0l.06,0a1,1,0,0,1,.35.29.76.76,0,0,1,.13.23.63.63,0,0,1,0,.19v.68h0v2h0v12.88h0a1.74,1.74,0,0,1-3.34.7,1.59,1.59,0,0,0,1.84.66h0a1,1,0,0,0,.71-.95V165.89A2.92,2.92,0,0,1,369.59,165.73Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.07,182.08h0a1.52,1.52,0,0,0,1.28-1.62V164.2l0,0a1,1,0,0,1,.19.24v0l0,.05v0a.65.65,0,0,1,0,.13h0v.75h0v2h0v12.88h0A1.76,1.76,0,0,1,371.07,182.08Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.9,163.7a1,1,0,0,1,.58-.81,3.07,3.07,0,0,1,2.83,0,1,1,0,0,1,.58.81h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.58-.82h0v-.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.9,163.7a1,1,0,0,1,.58-.81,3.07,3.07,0,0,1,2.83,0,1,1,0,0,1,.58.81h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.58-.82h0v-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,165.3a3.46,3.46,0,0,0,2.26.16c.62-.26.93-.53.93-1.12V163a.89.89,0,0,1,.35.66h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,164.52a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.07,3.07,0,0,1,2.83,0A.86.86,0,0,1,372.31,164.52Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,164.52a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.07,3.07,0,0,1,2.83,0A.86.86,0,0,1,372.31,164.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,163c.63.16.84.64.56,1a1.72,1.72,0,0,1-1.74.55c-.93-.12-1.13-.63-1.13-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,164.3a2.33,2.33,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,371.93,164.3Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,164.3a2.33,2.33,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,371.93,164.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,164.14l.12.08-.12.08a2.33,2.33,0,0,1-2.06,0l-.12-.08a.36.36,0,0,1,.12-.08A2.27,2.27,0,0,1,371.93,164.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "370.06 170.32 389.19 159.27 389.19 159.73 370.06 170.77 366.12 168.5 366.12 168.04 370.06 170.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.06 170.77 370.06 170.32 389.19 159.27 389.19 159.73 370.06 170.77",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,168l3.94,2.28,19.13-11-3-1.75h0v1.69c.41.44.29,1-.34,1.36a3.09,3.09,0,0,1-2.81,0c-.65-.37-.76-.93-.34-1.37v-.71l-.76.44v.43a.72.72,0,0,1-.15.43.64.64,0,0,1-.1.13v1.89c.41.43.29,1-.34,1.36a3.11,3.11,0,0,1-2.82,0c-.64-.37-.75-.93-.34-1.37v-.71l-.76.44V162a.75.75,0,0,1-.15.44l-.1.12v1.88c.42.44.31,1-.33,1.37a3.18,3.18,0,0,1-2.82,0c-.64-.37-.75-.93-.34-1.36v-.72l-.77.44v.43a.74.74,0,0,1-.14.44l-.11.13V167c.42.44.32,1-.33,1.38a3.16,3.16,0,0,1-2.81,0c-.64-.37-.75-.92-.35-1.36v-.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.06 180.71 389.19 169.66 389.19 170.12 370.06 181.17 366.12 178.9 366.12 178.44 370.06 180.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.19 169.66 370.06 180.71 370.06 181.17 389.19 170.12 389.19 169.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.16,170.31v-.7c.41.43.29,1-.34,1.35a3.11,3.11,0,0,1-2.82,0c-.64-.37-.75-.93-.33-1.37v.72Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,176.69v.72c-.4.43-.29,1,.35,1.35a3.09,3.09,0,0,0,2.81,0c.65-.37.75-.94.33-1.37v-2.72l1-.58v.71c-.41.44-.3,1,.34,1.36a3.09,3.09,0,0,0,2.81,0c.65-.37.76-.93.34-1.37v-2.72l1-.59v.72c-.41.44-.3,1,.34,1.36a3.11,3.11,0,0,0,2.82,0c.64-.37.75-.92.34-1.36v-2.73l1-.59v.71c-.42.44-.31,1,.33,1.37a3.11,3.11,0,0,0,2.82,0c.63-.36.75-.92.34-1.35v-1.7h0l3,1.75-19.13,11.05-3.94-2.27Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tubes--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.17,168.57h0l.25-.15v.44a.75.75,0,0,1-.15.43.64.64,0,0,1-.1.13v1.86a2.36,2.36,0,0,0-.33-.25,3.16,3.16,0,0,0-2.81,0,1.48,1.48,0,0,0-.35.28v-.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.34,168.89a3.09,3.09,0,0,0-2.81,0,1.11,1.11,0,0,0-.54.59c-.13-.37.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.67.67.54,1A1.11,1.11,0,0,0,385.34,168.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,166.29a3.16,3.16,0,0,0-2.81,0,1.11,1.11,0,0,0-.54.59c-.13-.37.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.67.67.55,1A1.18,1.18,0,0,0,389.84,166.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,163.7a3.09,3.09,0,0,0-2.81,0,1.06,1.06,0,0,0-.54.58c-.13-.37.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.5.28.68.67.55,1A1.13,1.13,0,0,0,394.34,163.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,171.49a3.11,3.11,0,0,0-2.82,0,1.2,1.2,0,0,0-.54.59c-.13-.37,0-.76.54-1.05a3.18,3.18,0,0,1,2.82,0c.49.29.67.68.54,1.05A1.11,1.11,0,0,0,380.84,171.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.35,163.24a3.11,3.11,0,0,0-2.82,0,1.43,1.43,0,0,0-.33.25v-.71l2.58-1.49.91.52v1.69A1.6,1.6,0,0,0,394.35,163.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,163.39h0l0,0h0l.25-.15v.43a.74.74,0,0,1-.14.44l-.11.12h0v1.89a1.33,1.33,0,0,0-.34-.26,3.09,3.09,0,0,0-2.81,0,1.14,1.14,0,0,0-.34.26v-.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.62,166h0l.31-.18v.43a.75.75,0,0,1-.15.44l-.11.13h0v1.87a1.31,1.31,0,0,0-.33-.26,3.16,3.16,0,0,0-2.81,0,2.13,2.13,0,0,0-.35.27V168Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.72,164.56h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.71,164.57l-.09.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,164.21v-.71c.41.44.29,1-.34,1.36a3.11,3.11,0,0,1-2.82,0c-.64-.37-.75-.93-.33-1.37v.72Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.34,179.29a3.09,3.09,0,0,0-2.81,0,1.1,1.1,0,0,0-.54.58c-.13-.36.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.67.68.54,1A1.1,1.1,0,0,0,385.34,179.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,176.69a3.09,3.09,0,0,0-2.81,0,1.1,1.1,0,0,0-.54.58c-.13-.36.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.49.28.67.68.55,1A1.16,1.16,0,0,0,389.84,176.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,174.09a3.09,3.09,0,0,0-2.81,0,1.13,1.13,0,0,0-.54.58c-.13-.36.05-.76.54-1a3.09,3.09,0,0,1,2.81,0c.5.28.68.68.55,1A1.2,1.2,0,0,0,394.34,174.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,181.89a3.11,3.11,0,0,0-2.82,0,1.18,1.18,0,0,0-.54.58c-.13-.37,0-.76.54-1a3.11,3.11,0,0,1,2.82,0c.49.28.67.68.54,1A1.1,1.1,0,0,0,380.84,181.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.35,173.63a3.11,3.11,0,0,0-2.82,0,1.81,1.81,0,0,0-.33.26v-.72l2.58-1.49.91.53v1.69A1.35,1.35,0,0,0,394.35,173.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,176.23a3.09,3.09,0,0,0-2.81,0,1.6,1.6,0,0,0-.34.26v-.71l3.49-2v2.73A1.6,1.6,0,0,0,389.84,176.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.34,178.83a3.09,3.09,0,0,0-2.81,0,1.41,1.41,0,0,0-.35.27v-.72l3.49-2v2.73A1.12,1.12,0,0,0,385.34,178.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,181.43a3.09,3.09,0,0,0-2.81,0,1.25,1.25,0,0,0-.35.27V181l3.49-2v2.71A1.78,1.78,0,0,0,380.84,181.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.2,161.24a.88.88,0,0,1,.51-.71,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2,161.24a.88.88,0,0,1,.51-.71,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.87,177.3c0,.18-.11.26-.23.18a.61.61,0,0,1-.21-.47V160.74a2.27,2.27,0,0,1,.28-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,177.74h0a.19.19,0,0,1-.12-.16v-17.2l.25-.07v17.34A.1.1,0,0,1,392.2,177.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,162.22a1.22,1.22,0,0,1-.43-.41v-.57a.57.57,0,0,1,0-.18,1.29,1.29,0,0,1,.4-.36,3,3,0,0,1,2.46-.08v-.13h0l.07,0a1.46,1.46,0,0,1,.35.29.76.76,0,0,1,.13.23.63.63,0,0,1,0,.19v.69h0v2h0v12.87h0a1.75,1.75,0,0,1-3.35.7,1.64,1.64,0,0,0,1.85.66h0a1,1,0,0,0,.7-1V162.37A3,3,0,0,1,391.63,162.22Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,178.56h0a1.5,1.5,0,0,0,1.27-1.61V160.68l0,0a.76.76,0,0,1,.2.25h0s0,0,0,0v0l0,.13v0a.13.13,0,0,1,0,.06v.69h0v2h0v12.87h0A1.75,1.75,0,0,1,393.12,178.56Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.94,160.18a1,1,0,0,1,.59-.81,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.59.81h0v.87h0a1,1,0,0,1-.59.81,3.11,3.11,0,0,1-2.82,0,1,1,0,0,1-.59-.81h0v-.87Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.94,160.18a1,1,0,0,1,.59-.81,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.59.81h0v.87h0a1,1,0,0,1-.59.81,3.11,3.11,0,0,1-2.82,0,1,1,0,0,1-.59-.81h0v-.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,161.78a3.4,3.4,0,0,0,2.26.16c.62-.26.92-.52.92-1.12v-1.29a.84.84,0,0,1,.36.65h0v.87h0a1,1,0,0,1-.59.81,3.11,3.11,0,0,1-2.82,0A.57.57,0,0,1,391.4,161.78Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.35,161a3.11,3.11,0,0,1-2.82,0,.86.86,0,0,1,0-1.63,3.11,3.11,0,0,1,2.82,0A.86.86,0,0,1,394.35,161Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.35,161a3.11,3.11,0,0,1-2.82,0,.86.86,0,0,1,0-1.63,3.11,3.11,0,0,1,2.82,0A.86.86,0,0,1,394.35,161Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82,159.51c.63.17.83.64.56,1a1.74,1.74,0,0,1-1.74.55c-.94-.13-1.13-.63-1.13-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,160.78a2.27,2.27,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,394,160.78Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,160.78a2.27,2.27,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,394,160.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,160.62a.5.5,0,0,1,.12.08l-.12.08a2.27,2.27,0,0,1-2.06,0l-.12-.08.12-.08A2.27,2.27,0,0,1,394,160.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.69,163.85a.88.88,0,0,1,.51-.72,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.72v15.58h0a1.75,1.75,0,0,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.69,163.85a.88.88,0,0,1,.51-.72,2.75,2.75,0,0,1,2.47,0,.88.88,0,0,1,.51.72v15.58h0a1.75,1.75,0,0,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,179.91c0,.17-.1.25-.22.17a.58.58,0,0,1-.22-.46V163.34a2.27,2.27,0,0,1,.28-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.7,180.34h0a.18.18,0,0,1-.12-.17V163l.25-.07v17.34A.1.1,0,0,1,387.7,180.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.13,164.82a1.24,1.24,0,0,1-.44-.4v-.57a.58.58,0,0,1,0-.19,1.2,1.2,0,0,1,.41-.35,2.9,2.9,0,0,1,2.46-.08v-.14h0l.06,0a1.32,1.32,0,0,1,.35.29.89.89,0,0,1,.13.23.69.69,0,0,1,0,.2v.68h0v2h0v12.88h0a1.74,1.74,0,0,1-3.34.7,1.59,1.59,0,0,0,1.84.66h0a1,1,0,0,0,.71-1V165A2.92,2.92,0,0,1,387.13,164.82Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.61,181.16h0a1.51,1.51,0,0,0,1.28-1.61V163.29l0,0a.84.84,0,0,1,.19.24v0a.08.08,0,0,1,0,.05v0a.28.28,0,0,1,0,.13h0v.75h0v2h0v12.88h0A1.75,1.75,0,0,1,388.61,181.16Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,162.79A1,1,0,0,1,387,162a3.14,3.14,0,0,1,2.83,0,1,1,0,0,1,.58.82h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.58-.82h0v-.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,162.79A1,1,0,0,1,387,162a3.14,3.14,0,0,1,2.83,0,1,1,0,0,1,.58.82h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.58-.82h0v-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,164.38a3.4,3.4,0,0,0,2.26.16c.62-.26.93-.52.93-1.12v-1.29a.89.89,0,0,1,.35.66h0v.86h0a1,1,0,0,1-.58.82,3.14,3.14,0,0,1-2.83,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.85,163.6a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.14,3.14,0,0,1,2.83,0A.86.86,0,0,1,389.85,163.6Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.85,163.6a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.14,3.14,0,0,1,2.83,0A.86.86,0,0,1,389.85,163.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.31,162.12c.63.16.84.64.56,1a1.74,1.74,0,0,1-1.74.55c-.93-.12-1.13-.63-1.13-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.44,
    cy: 162.79,
    rx: 1.46,
    ry: 0.84,
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.44,
    cy: 162.79,
    rx: 1.46,
    ry: 0.84,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,163.22l.13.08a.57.57,0,0,1-.13.08,2.25,2.25,0,0,1-2,0,.36.36,0,0,1-.12-.08.62.62,0,0,1,.12-.08A2.25,2.25,0,0,1,389.46,163.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.18,166.45a.85.85,0,0,1,.51-.71,2.69,2.69,0,0,1,2.47,0,.85.85,0,0,1,.51.71V182h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.18,166.45a.85.85,0,0,1,.51-.71,2.69,2.69,0,0,1,2.47,0,.85.85,0,0,1,.51.71V182h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.85,182.51c0,.17-.1.26-.22.18a.63.63,0,0,1-.21-.47V166a1,1,0,0,1,.27-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19,182.94h0a.17.17,0,0,1-.12-.16v-17.2l.25-.07v17.34A.09.09,0,0,1,383.19,182.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,167.42a1.15,1.15,0,0,1-.44-.4v-.57a.68.68,0,0,1,0-.19,1.47,1.47,0,0,1,.41-.35,2.93,2.93,0,0,1,2.46-.08v-.14h0l.06,0a1,1,0,0,1,.35.29.59.59,0,0,1,.13.23.63.63,0,0,1,0,.19v.68h0v2h0V182h0a1.74,1.74,0,0,1-3.34.7,1.6,1.6,0,0,0,1.84.66h0a1,1,0,0,0,.71-.95V167.58A2.92,2.92,0,0,1,382.62,167.42Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,183.77h0a1.52,1.52,0,0,0,1.27-1.62V165.89l0,0a1.06,1.06,0,0,1,.2.24v0l0,.05v0l0,.13h0v.75h0v2h0V182h0A1.75,1.75,0,0,1,384.11,183.77Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,165.39a1,1,0,0,1,.59-.82,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.59.82h0v.86h0a1,1,0,0,1-.59.82,3.11,3.11,0,0,1-2.82,0,1,1,0,0,1-.59-.82h0v-.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,165.39a1,1,0,0,1,.59-.82,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.59.82h0v.86h0a1,1,0,0,1-.59.82,3.11,3.11,0,0,1-2.82,0,1,1,0,0,1-.59-.82h0v-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,167a3.52,3.52,0,0,0,2.26.16c.61-.26.92-.53.92-1.12v-1.3a.87.87,0,0,1,.36.66h0v.86h0a1,1,0,0,1-.59.82,3.11,3.11,0,0,1-2.82,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.93,
    cy: 165.39,
    rx: 2,
    ry: 1.15,
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.93,
    cy: 165.39,
    rx: 2,
    ry: 1.15,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,164.72c.63.16.84.64.56,1a1.69,1.69,0,0,1-1.73.55c-.94-.12-1.14-.63-1.14-.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,166a2.33,2.33,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,385,166Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,166a2.33,2.33,0,0,1-2.06,0,.63.63,0,0,1,0-1.19,2.27,2.27,0,0,1,2.06,0A.63.63,0,0,1,385,166Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,165.83l.12.08L385,166a2.27,2.27,0,0,1-2.06,0l-.12-.07.12-.08A2.27,2.27,0,0,1,385,165.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.68,169.05a.87.87,0,0,1,.51-.71,2.75,2.75,0,0,1,2.47,0,.87.87,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,169.05a.87.87,0,0,1,.51-.71,2.75,2.75,0,0,1,2.47,0,.87.87,0,0,1,.51.71v15.58h0a1.75,1.75,0,1,1-3.49,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,185.11c0,.18-.11.26-.23.18a.63.63,0,0,1-.21-.47V168.55a1.57,1.57,0,0,1,.28-.21l.16-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68,185.55h0a.19.19,0,0,1-.12-.16v-17.2l.26-.07v17.34A.1.1,0,0,1,378.68,185.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.11,170a1.22,1.22,0,0,1-.43-.41v-.57a.57.57,0,0,1,0-.18,1.29,1.29,0,0,1,.4-.36,3,3,0,0,1,2.46-.08v-.13h0l.07,0a1.29,1.29,0,0,1,.35.29.76.76,0,0,1,.13.23.63.63,0,0,1,0,.19v.68h0v2h0v12.87h0a1.74,1.74,0,0,1-3.34.7,1.6,1.6,0,0,0,1.84.65h0a1,1,0,0,0,.7-1V170.18A3,3,0,0,1,378.11,170Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.6,186.37h0a1.5,1.5,0,0,0,1.27-1.61V168.49l0,0a.87.87,0,0,1,.19.25h0s0,0,0,0v0a.35.35,0,0,1,0,.13v0a.13.13,0,0,1,0,.06v.68h0v2h0v12.87h0A1.75,1.75,0,0,1,379.6,186.37Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.42,168a1,1,0,0,1,.59-.81,3.14,3.14,0,0,1,2.83,0,1,1,0,0,1,.58.81h0v.87h0a1,1,0,0,1-.58.81,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.59-.81h0V168Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.42,168a1,1,0,0,1,.59-.81,3.14,3.14,0,0,1,2.83,0,1,1,0,0,1,.58.81h0v.87h0a1,1,0,0,1-.58.81,3.14,3.14,0,0,1-2.83,0,1,1,0,0,1-.59-.81h0V168Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.88,169.59a3.46,3.46,0,0,0,2.26.16c.62-.26.92-.52.92-1.12v-1.29a.84.84,0,0,1,.36.65h0v.87h0a1,1,0,0,1-.58.81,3.14,3.14,0,0,1-2.83,0A.57.57,0,0,1,377.88,169.59Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,168.81a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.14,3.14,0,0,1,2.83,0A.86.86,0,0,1,380.84,168.81Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,168.81a3.14,3.14,0,0,1-2.83,0,.86.86,0,0,1,0-1.63,3.14,3.14,0,0,1,2.83,0A.86.86,0,0,1,380.84,168.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.3,167.32c.63.17.83.64.56,1a1.71,1.71,0,0,1-1.74.54c-.94-.12-1.13-.62-1.13-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.42,
    cy: 167.99,
    rx: 1.46,
    ry: 0.84,
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.42,
    cy: 167.99,
    rx: 1.46,
    ry: 0.84,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.45,168.43a.36.36,0,0,1,.12.08.62.62,0,0,1-.12.08,2.27,2.27,0,0,1-2.06,0l-.12-.08.12-.08A2.27,2.27,0,0,1,380.45,168.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "378.59 174.61 397.72 163.56 397.72 164.02 378.59 175.07 374.65 172.79 374.65 172.33 378.59 174.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.59 175.07 378.59 174.61 397.72 163.56 397.72 164.02 378.59 175.07",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.65,172.33l3.94,2.28,19.13-11.05-3-1.75h0v1.69c.41.44.29,1-.34,1.36a3.11,3.11,0,0,1-2.82,0c-.64-.37-.75-.93-.33-1.37v-.71l-.77.44v.43a.74.74,0,0,1-.14.44l-.11.12v1.89c.41.43.3,1-.34,1.36a3.09,3.09,0,0,1-2.81,0c-.64-.37-.75-.93-.34-1.36v-.72l-.76.44v.43a.75.75,0,0,1-.15.44l-.11.13v1.87c.42.44.31,1-.33,1.37a3.09,3.09,0,0,1-2.81,0c-.64-.37-.75-.92-.35-1.36V168l-.76.44v.44a.75.75,0,0,1-.15.43.64.64,0,0,1-.1.13v1.86c.42.44.31,1-.33,1.38a3.09,3.09,0,0,1-2.81,0c-.64-.37-.76-.92-.36-1.35v-.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.59 185 397.72 173.96 397.72 174.41 378.59 185.46 374.65 183.19 374.65 182.73 378.59 185",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.72 173.96 378.59 185 378.59 185.46 397.72 174.41 397.72 173.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,174.61v-.71c.41.43.29,1-.34,1.36a3.18,3.18,0,0,1-2.82,0c-.64-.38-.75-.94-.33-1.37v.72Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,181v.72c-.41.44-.29,1,.35,1.35a3.09,3.09,0,0,0,2.81,0c.64-.37.75-.93.33-1.37V179l1-.59v.72c-.4.43-.29,1,.35,1.35a3.09,3.09,0,0,0,2.81,0c.64-.37.75-.93.33-1.36v-2.73l1-.58v.71c-.41.44-.3,1,.34,1.37a3.16,3.16,0,0,0,2.81,0c.64-.37.75-.93.34-1.37v-2.73l1-.59v.72c-.42.43-.31,1,.33,1.37a3.18,3.18,0,0,0,2.82,0c.63-.37.75-.93.34-1.36v-1.69h0l3,1.75-19.13,11-3.94-2.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.59 188.51 374.65 186.23 393.78 175.19 397.72 177.46 378.59 188.51",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M400.67,182.72c-2.4,1.39-2.4,3.63,0,5a9.6,9.6,0,0,0,8.7,0c2.4-1.39,2.4-3.63,0-5A9.6,9.6,0,0,0,400.67,182.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402,183.45a6.72,6.72,0,0,1,6.08,0c1.68,1,1.68,2.55,0,3.52a6.72,6.72,0,0,1-6.08,0C400.31,186,400.31,184.42,402,183.45Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M402,183.45a6.72,6.72,0,0,1,6.08,0c1.68,1,1.68,2.55,0,3.52a6.72,6.72,0,0,1-6.08,0C400.31,186,400.31,184.42,402,183.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M406.92,174.19v-6h-3.76v6a6.63,6.63,0,1,0,3.76,0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.92,174.19v-6h-3.76v6a6.63,6.63,0,1,0,3.76,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "406.55 174.21 406.68 168.64 406.4 168.72 406.4 174.21 406.55 174.21",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.92,169.31s-.38.34-1.88.34-1.88-.33-1.88-.33v-1.16h3.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.92,168.41a4.11,4.11,0,0,1-1.88.34,4.21,4.21,0,0,1-1.88-.33v-.26h3.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.67,166.93a5,5,0,0,0-3.28,0c-.9.37-.9,1,0,1.34a5,5,0,0,0,3.28,0C407.59,167.9,407.59,167.3,406.67,166.93Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.67,166.93a5,5,0,0,0-3.28,0c-.9.37-.9,1,0,1.34a5,5,0,0,0,3.28,0C407.59,167.9,407.59,167.3,406.67,166.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.73,167.63c.16.13.7.4,2.06.25,1.2-.14,1-.75.07-.82A4.67,4.67,0,0,0,403.73,167.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,167.12a4.47,4.47,0,0,0-2.12,0c-.58.16-.58.44,0,.6a4.47,4.47,0,0,0,2.12,0C406.69,167.56,406.69,167.28,406.09,167.12Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,167.12a4.47,4.47,0,0,0-2.12,0c-.58.16-.58.44,0,.6a4.47,4.47,0,0,0,2.12,0C406.69,167.56,406.69,167.28,406.09,167.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.67,168.27a1.28,1.28,0,0,0,.6-.42c-.8.63-2.76.54-3.58.27s-.84-.83-.52-1.08c-.67.37-.6.89.22,1.23A5,5,0,0,0,406.67,168.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,167.12a3.72,3.72,0,0,0-1-.13v.86a3.72,3.72,0,0,0,1-.13C406.69,167.56,406.69,167.28,406.09,167.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.67,166.93a5.11,5.11,0,0,0-2.65-.18,5.82,5.82,0,0,1,2.62.26c.76.39.72.74.52,1C407.54,167.63,407.37,167.22,406.67,166.93Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06,185.92a6.69,6.69,0,0,1-6,0c-1.1-.63-1.47-1.52-1.13-2.33a2.5,2.5,0,0,1,1.13-1.16,6.69,6.69,0,0,1,6,0,2.55,2.55,0,0,1,1.13,1.16C409.53,184.4,409.15,185.29,408.06,185.92Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.06,185.92a6.69,6.69,0,0,1-6,0c-1.1-.63-1.47-1.52-1.13-2.33a2.5,2.5,0,0,1,1.13-1.16,6.69,6.69,0,0,1,6,0,2.55,2.55,0,0,1,1.13,1.16C409.53,184.4,409.15,185.29,408.06,185.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405,175v-6.48a5,5,0,0,1-1.27-.16v6.08a6.14,6.14,0,0,0-4.93,5.94,6,6,0,0,0,6.24,6.3A6.14,6.14,0,0,1,405,175Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M389.69,188.77c-3.06,1.77-3.06,4.64,0,6.41a12.29,12.29,0,0,0,11.11,0c3.06-1.77,3.06-4.64,0-6.41A12.29,12.29,0,0,0,389.69,188.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.38,189.7a8.64,8.64,0,0,1,7.77,0c2.14,1.24,2.14,3.25,0,4.49a8.58,8.58,0,0,1-7.77,0C389.24,193,389.24,190.94,391.38,189.7Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M391.38,189.7a8.64,8.64,0,0,1,7.77,0c2.14,1.24,2.14,3.25,0,4.49a8.58,8.58,0,0,1-7.77,0C389.24,193,389.24,190.94,391.38,189.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,177.89v-7.71h-4.79v7.7a8.47,8.47,0,1,0,4.79,0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.66,177.89v-7.71h-4.79v7.7a8.47,8.47,0,1,0,4.79,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "397.2 177.91 397.35 170.8 397.01 170.9 397.01 177.91 397.2 177.91",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,171.66s-.48.43-2.39.43-2.4-.42-2.4-.42v-1.48h4.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,170.51a5.23,5.23,0,0,1-2.39.43,5.36,5.36,0,0,1-2.4-.42v-.33h4.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,168.62a6.37,6.37,0,0,0-4.18,0c-1.14.47-1.14,1.24,0,1.71a6.37,6.37,0,0,0,4.18,0C398.52,169.86,398.52,169.09,397.34,168.62Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.34,168.62a6.37,6.37,0,0,0-4.18,0c-1.14.47-1.14,1.24,0,1.71a6.37,6.37,0,0,0,4.18,0C398.52,169.86,398.52,169.09,397.34,168.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.6,169.52c.2.16.89.51,2.62.31,1.54-.18,1.33-1,.09-1A5.92,5.92,0,0,0,393.6,169.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,168.86a5.65,5.65,0,0,0-2.71,0c-.74.21-.74.56,0,.77a5.65,5.65,0,0,0,2.71,0C397.37,169.42,397.37,169.07,396.61,168.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,168.86a5.65,5.65,0,0,0-2.71,0c-.74.21-.74.56,0,.77a5.65,5.65,0,0,0,2.71,0C397.37,169.42,397.37,169.07,396.61,168.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,170.33a1.7,1.7,0,0,0,.78-.53c-1,.8-3.53.69-4.58.33s-1.07-1-.66-1.37c-.85.47-.76,1.14.28,1.57A6.37,6.37,0,0,0,397.34,170.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,168.86a5,5,0,0,0-1.34-.16v1.09a5,5,0,0,0,1.34-.16C397.37,169.42,397.37,169.07,396.61,168.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,168.62a6.44,6.44,0,0,0-3.37-.23,7.51,7.51,0,0,1,3.34.33c1,.5.92.94.67,1.23C398.45,169.51,398.24,169,397.34,168.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,192.85a8.52,8.52,0,0,1-7.71,0c-1.4-.81-1.88-1.94-1.44-3a3.27,3.27,0,0,1,1.44-1.48,8.52,8.52,0,0,1,7.71,0,3.27,3.27,0,0,1,1.44,1.48C401,190.91,400.52,192,399.12,192.85Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.12,192.85a8.52,8.52,0,0,1-7.71,0c-1.4-.81-1.88-1.94-1.44-3a3.27,3.27,0,0,1,1.44-1.48,8.52,8.52,0,0,1,7.71,0,3.27,3.27,0,0,1,1.44,1.48C401,190.91,400.52,192,399.12,192.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.21,179v-8.27a5.77,5.77,0,0,1-1.61-.2v7.76a7.83,7.83,0,0,0-6.3,7.58c0,4.16,2.69,8,8,8A7.85,7.85,0,0,1,395.21,179Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15,195.16a16.37,16.37,0,0,0-9.08,1.1c-3.55,1.74-3.55,4.57,0,6.32a16.46,16.46,0,0,0,9.08,1.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15,190l-.63-.91v-6.88h-4v6.87L402.06,197a1.92,1.92,0,0,0-.35,1.06v0h0a.49.49,0,0,0,0,.12,2.64,2.64,0,0,0,0,.28,4.12,4.12,0,0,0,2.25,2.78,12.19,12.19,0,0,0,8.16,1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15,190l-.63-.91v-6.88h-4v6.87L402.06,197a1.92,1.92,0,0,0-.35,1.06v0h0a.49.49,0,0,0,0,.12,2.64,2.64,0,0,0,0,.28,4.12,4.12,0,0,0,2.25,2.78,12.19,12.19,0,0,0,8.16,1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "412.15 190.68 411.24 189.26 411.26 182.73 410.97 182.82 410.97 189.34 412.15 191.02 412.15 190.68",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.52,183.46s-.41.36-2,.36-2-.36-2-.36v-1.24h4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.52,182.49a5.85,5.85,0,0,1-4,0v-.27h4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.15,194.89l-.28-.07a12.91,12.91,0,0,0-7.58.87c-2.81,1.44-2.81,3.77,0,5.2a13,13,0,0,0,7.86.82Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.15,194.89l-.28-.07a12.91,12.91,0,0,0-7.58.87c-2.81,1.44-2.81,3.77,0,5.2a13,13,0,0,0,7.86.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,180.9a5.37,5.37,0,0,0-3.54,0c-1,.39-1,1,0,1.43a5.37,5.37,0,0,0,3.54,0C412.25,181.94,412.25,181.29,411.26,180.9Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.26,180.9a5.37,5.37,0,0,0-3.54,0c-1,.39-1,1,0,1.43a5.37,5.37,0,0,0,3.54,0C412.25,181.94,412.25,181.29,411.26,180.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,181.65a3.15,3.15,0,0,0,2.21.26c1.3-.15,1.12-.8.08-.88A5.07,5.07,0,0,0,408.1,181.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.64,181.09a4.92,4.92,0,0,0-2.29,0c-.62.18-.62.48,0,.66a4.92,4.92,0,0,0,2.29,0C411.28,181.57,411.28,181.27,410.64,181.09Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.64,181.09a4.92,4.92,0,0,0-2.29,0c-.62.18-.62.48,0,.66a4.92,4.92,0,0,0,2.29,0C411.28,181.57,411.28,181.27,410.64,181.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,182.33a1.37,1.37,0,0,0,.65-.45c-.86.68-3,.59-3.86.29s-.9-.89-.56-1.16c-.72.4-.64,1,.23,1.32A5.37,5.37,0,0,0,411.26,182.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.64,181.09a4.41,4.41,0,0,0-1.14-.13v.92a4.41,4.41,0,0,0,1.14-.13C411.28,181.57,411.28,181.27,410.64,181.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,180.9a5.44,5.44,0,0,0-2.85-.2,6.35,6.35,0,0,1,2.82.28c.82.42.78.79.56,1C412.19,181.65,412,181.2,411.26,180.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.78,189.77v-7.18a4.66,4.66,0,0,1-.89-.19v6.94l-5.47,8a2,2,0,0,0,.19,1.9,4.71,4.71,0,0,0,1.57,1.5,8.72,8.72,0,0,0,3.26,1.17s-2.25-1.17-2.69-2.06a2.92,2.92,0,0,1,.44-2.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M370,124.28c-4.3,2.11-4.3,5.52,0,7.63a19.87,19.87,0,0,0,15.54,0c4.29-2.11,4.29-5.52,0-7.63A19.87,19.87,0,0,0,370,124.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.15,126.49a2.35,2.35,0,0,0-.42-1.28l-6.56-9.59V107.3h-4.88v8.31l-6.56,9.59a2.28,2.28,0,0,0-.42,1.28.13.13,0,0,0,0,.06h0a.76.76,0,0,0,0,.15,2,2,0,0,0,0,.34,5,5,0,0,0,2.72,3.36,14.74,14.74,0,0,0,13.32,0c1.85-1.07,2.76-2.47,2.75-3.87C387.14,126.52,387.15,126.5,387.15,126.49Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.15,126.49a2.35,2.35,0,0,0-.42-1.28l-6.56-9.59V107.3h-4.88v8.31l-6.56,9.59a2.28,2.28,0,0,0-.42,1.28.13.13,0,0,0,0,.06h0a.76.76,0,0,0,0,.15,2,2,0,0,0,0,.34,5,5,0,0,0,2.72,3.36,14.74,14.74,0,0,0,13.32,0c1.85-1.07,2.76-2.47,2.75-3.87C387.14,126.52,387.15,126.5,387.15,126.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "379.51 108.03 379.86 107.92 379.83 115.82 383.9 122.18 379.51 115.92 379.51 108.03",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,108.8s-.49.45-2.44.45-2.44-.44-2.44-.44v-1.5h4.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,107.63a5.3,5.3,0,0,1-2.44.44,5.4,5.4,0,0,1-2.44-.43v-.33h4.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,122.54a15.51,15.51,0,0,0-9.16,1c-3.4,1.74-3.4,4.55,0,6.29a15.73,15.73,0,0,0,12.51,0c3.52-1.74,3.52-4.55,0-6.29a12.89,12.89,0,0,0-3.35-1",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.59,122.54a15.51,15.51,0,0,0-9.16,1c-3.4,1.74-3.4,4.55,0,6.29a15.73,15.73,0,0,0,12.51,0c3.52-1.74,3.52-4.55,0-6.29a12.89,12.89,0,0,0-3.35-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,105.71a6.51,6.51,0,0,0-4.27,0c-1.16.48-1.16,1.26,0,1.74a6.51,6.51,0,0,0,4.27,0C381.05,107,381.05,106.19,379.85,105.71Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.85,105.71a6.51,6.51,0,0,0-4.27,0c-1.16.48-1.16,1.26,0,1.74a6.51,6.51,0,0,0,4.27,0C381.05,107,381.05,106.19,379.85,105.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376,106.62c.21.16.91.52,2.68.32,1.56-.18,1.35-1,.09-1.07A6,6,0,0,0,376,106.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,105.94a6.17,6.17,0,0,0-2.77,0c-.75.22-.75.58,0,.8a6.17,6.17,0,0,0,2.77,0C379.88,106.52,379.88,106.16,379.1,105.94Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,105.94a6.17,6.17,0,0,0-2.77,0c-.75.22-.75.58,0,.8a6.17,6.17,0,0,0,2.77,0C379.88,106.52,379.88,106.16,379.1,105.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,107.45a1.76,1.76,0,0,0,.79-.55c-1.05.82-3.6.71-4.67.35s-1.09-1.07-.67-1.41c-.87.48-.78,1.17.28,1.61A6.51,6.51,0,0,0,379.85,107.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,105.94a5.66,5.66,0,0,0-1.37-.16v1.12a5.66,5.66,0,0,0,1.37-.16C379.88,106.52,379.88,106.16,379.1,105.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,105.71a6.61,6.61,0,0,0-3.44-.24,7.52,7.52,0,0,1,3.4.34c1,.5.95,1,.68,1.26C381,106.62,380.77,106.07,379.85,105.71Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.85,116.44v-8.68a5.07,5.07,0,0,1-1.07-.24v8.4l-6.62,9.66a2.47,2.47,0,0,0,.24,2.3,5.48,5.48,0,0,0,1.89,1.81,10.59,10.59,0,0,0,3.94,1.42s-2.71-1.42-3.25-2.49a3.58,3.58,0,0,1,.53-3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M386.43,118.3c-2.5,1.45-2.5,3.78,0,5.23a10,10,0,0,0,9.05,0c2.49-1.45,2.49-3.78,0-5.23A10,10,0,0,0,386.43,118.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.81,119.07a7,7,0,0,1,6.32,0c1.75,1,1.75,2.64,0,3.65a7,7,0,0,1-6.32,0C386.06,121.71,386.06,120.08,387.81,119.07Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M387.81,119.07a7,7,0,0,1,6.32,0c1.75,1,1.75,2.64,0,3.65a7,7,0,0,1-6.32,0C386.06,121.71,386.06,120.08,387.81,119.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,109.44v-6.28H389v6.27a6.9,6.9,0,1,0,3.9,0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.92,109.44v-6.28H389v6.27a6.9,6.9,0,1,0,3.9,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 109.46 392.67 103.66 392.39 103.75 392.39 109.46 392.54 109.46",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,104.37s-.39.35-1.95.35-2-.35-2-.35v-1.2h3.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,103.43a4.27,4.27,0,0,1-1.95.35,4.38,4.38,0,0,1-2-.34v-.27h3.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66,101.89a5.24,5.24,0,0,0-3.41,0c-.92.39-.92,1,0,1.39a5.12,5.12,0,0,0,3.41,0C393.62,102.9,393.62,102.28,392.66,101.89Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.66,101.89a5.24,5.24,0,0,0-3.41,0c-.92.39-.92,1,0,1.39a5.12,5.12,0,0,0,3.41,0C393.62,102.9,393.62,102.28,392.66,101.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,102.62a3,3,0,0,0,2.14.25c1.25-.14,1.08-.77.07-.84A4.78,4.78,0,0,0,389.61,102.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.07,102.08a4.85,4.85,0,0,0-2.21,0c-.6.18-.6.46,0,.64a4.85,4.85,0,0,0,2.21,0C392.69,102.54,392.69,102.26,392.07,102.08Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.07,102.08a4.85,4.85,0,0,0-2.21,0c-.6.18-.6.46,0,.64a4.85,4.85,0,0,0,2.21,0C392.69,102.54,392.69,102.26,392.07,102.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66,103.28a1.28,1.28,0,0,0,.63-.43c-.83.65-2.87.56-3.72.27s-.88-.85-.54-1.12c-.69.39-.62.93.22,1.28A5.12,5.12,0,0,0,392.66,103.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.07,102.08A4.55,4.55,0,0,0,391,102v.9a4.52,4.52,0,0,0,1.1-.14C392.69,102.54,392.69,102.26,392.07,102.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66,101.89a5.38,5.38,0,0,0-2.75-.19,6.31,6.31,0,0,1,2.72.27c.8.41.76.77.55,1C393.57,102.62,393.4,102.19,392.66,101.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.11,121.63a7,7,0,0,1-6.28,0c-1.14-.66-1.53-1.58-1.17-2.42a2.63,2.63,0,0,1,1.17-1.21,7,7,0,0,1,6.28,0,2.63,2.63,0,0,1,1.17,1.21C395.64,120.05,395.25,121,394.11,121.63Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.11,121.63a7,7,0,0,1-6.28,0c-1.14-.66-1.53-1.58-1.17-2.42a2.63,2.63,0,0,1,1.17-1.21,7,7,0,0,1,6.28,0,2.63,2.63,0,0,1,1.17,1.21C395.64,120.05,395.25,121,394.11,121.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,110.31v-6.74a4.91,4.91,0,0,1-1.32-.17v6.33a6.36,6.36,0,0,0-5.13,6.17,6.22,6.22,0,0,0,6.49,6.55A6.39,6.39,0,0,1,390.93,110.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Jar--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M412.11,129.74a12.88,12.88,0,0,0-10.57.44c-3.19,1.84-3.19,4.82,0,6.66a12.92,12.92,0,0,0,10.57.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.11,115.08a4.64,4.64,0,0,0-.55-.26,1.72,1.72,0,0,1-1.1-1.59v-1l-6.33-.91v1.94a1.71,1.71,0,0,1-1.1,1.59,8.51,8.51,0,0,0-1,.48,3.72,3.72,0,0,0-2.18,3V133a3.71,3.71,0,0,0,2.18,3,11.73,11.73,0,0,0,10.09.22Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,115.08a4.64,4.64,0,0,0-.55-.26,1.72,1.72,0,0,1-1.1-1.59v-1l-6.33-.91v1.94a1.71,1.71,0,0,1-1.1,1.59,8.51,8.51,0,0,0-1,.48,3.72,3.72,0,0,0-2.18,3V133a3.71,3.71,0,0,0,2.18,3,11.73,11.73,0,0,0,10.09.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,115.08a4.64,4.64,0,0,0-.55-.26,1.72,1.72,0,0,1-1.1-1.59v-1l-6.33-.91v1.94a1.71,1.71,0,0,1-1.1,1.59,8.51,8.51,0,0,0-1,.48,3.72,3.72,0,0,0-2.18,3V133a3.71,3.71,0,0,0,2.18,3,11.73,11.73,0,0,0,10.09.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,130.25a10.74,10.74,0,0,0-9.63,0c-2.66,1.53-2.66,4,0,5.52a10.77,10.77,0,0,0,9.63,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,114.21a3.69,3.69,0,0,0-1-.88,8.27,8.27,0,0,0-5.07-.81v-1.23h-1.87v1.94a1.72,1.72,0,0,1-1.1,1.59,8.51,8.51,0,0,0-1,.48l0,0a3.69,3.69,0,0,0-2.15,3V133a3.71,3.71,0,0,0,2.18,3,11.69,11.69,0,0,0,7.75,1c-6.06.41-7.53-2.16-7.53-4V118.8a2.14,2.14,0,0,1,.56-1.66,3.93,3.93,0,0,0,.74.54,8.33,8.33,0,0,0,7.53,0,3.69,3.69,0,0,0,1-.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,112.67a6.93,6.93,0,0,1-1.32-.47c-2.05-1.19-5.09-1.58-7.18-.42l-.08,0a2.89,2.89,0,0,0-1.51,1.82,1.47,1.47,0,0,0,0,.36v.57a2,2,0,0,0,.39,1.16,3.66,3.66,0,0,0,1.16,1,8.35,8.35,0,0,0,7.54,0,3.84,3.84,0,0,0,1-.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.74,117.07v-2c0-.77.19.28-1.17.28-1.17,0-2.22-2.72-3-3.61l-.08,0a2.89,2.89,0,0,0-1.51,1.82,1.47,1.47,0,0,0,0,.36v.57a2,2,0,0,0,.39,1.16,3.66,3.66,0,0,0,1.16,1,8.35,8.35,0,0,0,7.54,0C409.6,117.32,407.74,117.81,407.74,117.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,112.7s-.82-.35-1.28-.61a7.81,7.81,0,0,0-7.29-.26c-2.08,1.2-2.08,3.14,0,4.34a8.33,8.33,0,0,0,7.53,0,3.84,3.84,0,0,0,1-.87Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,112.68v1.92a3.82,3.82,0,0,1-1,.86,7.48,7.48,0,0,1-3.33.88,7.86,7.86,0,0,1-4.2-.89,3.6,3.6,0,0,1-1.17-1,2.21,2.21,0,0,1-.35-.79,1.55,1.55,0,0,1,0-.37v-1.12c0-.1,0-.2,0-.3a2.86,2.86,0,0,1,1.54-1.88l.28-.15a6.84,6.84,0,0,1,2-.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,112.68v.75a3.69,3.69,0,0,1-1,.87,8.26,8.26,0,0,1-7.53,0,2.64,2.64,0,0,1-1.56-2.14c0-.1,0-.2,0-.3a2.81,2.81,0,0,1,1.54-1.9,1.47,1.47,0,0,1,.22-.1l.06,0,.09,0a6.64,6.64,0,0,1,1.89-.6l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.37,114.43a3.56,3.56,0,0,0,1.16,1,8,8,0,0,0,4.21.89h0c0-.39.23-.69-1.17-1-1.15-.23-2.86-.71-3.66-2a2.68,2.68,0,0,1,.91-3.59c-.1,0-.19.1-.29.15a2.64,2.64,0,0,0-1.55,2.17v1.13a1.47,1.47,0,0,0,0,.36A2,2,0,0,0,402.37,114.43Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M402,136.85c3.19,1.84,3.19,4.82,0,6.65a12.71,12.71,0,0,1-11.52,0c-3.18-1.83-3.18-4.81,0-6.65A12.71,12.71,0,0,1,402,136.85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.54,122a10.49,10.49,0,0,0-1-.49,1.71,1.71,0,0,1-1.1-1.58V118H393.1v1.94a1.72,1.72,0,0,1-1.1,1.58,8.61,8.61,0,0,0-1,.49,3.7,3.7,0,0,0-2.19,3v14.61a3.71,3.71,0,0,0,2.19,3.05,11.67,11.67,0,0,0,10.55,0,3.72,3.72,0,0,0,2.18-3.05V125A3.71,3.71,0,0,0,401.54,122Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.54,122a10.49,10.49,0,0,0-1-.49,1.71,1.71,0,0,1-1.1-1.58V118H393.1v1.94a1.72,1.72,0,0,1-1.1,1.58,8.61,8.61,0,0,0-1,.49,3.7,3.7,0,0,0-2.19,3v14.61a3.71,3.71,0,0,0,2.19,3.05,11.67,11.67,0,0,0,10.55,0,3.72,3.72,0,0,0,2.18-3.05V125A3.71,3.71,0,0,0,401.54,122Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.54,122a10.49,10.49,0,0,0-1-.49,1.71,1.71,0,0,1-1.1-1.58V118H393.1v1.94a1.72,1.72,0,0,1-1.1,1.58,8.61,8.61,0,0,0-1,.49,3.7,3.7,0,0,0-2.19,3v14.61a3.71,3.71,0,0,0,2.19,3.05,11.67,11.67,0,0,0,10.55,0,3.72,3.72,0,0,0,2.18-3.05V125A3.71,3.71,0,0,0,401.54,122Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,142.44c-2.66-1.53-2.66-4,0-5.52a10.78,10.78,0,0,1,9.65,0c2.66,1.52,2.66,4,0,5.52A10.78,10.78,0,0,1,391.44,142.44Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,120a8.13,8.13,0,0,0-5.07-.81V118H393.1v1.93a1.72,1.72,0,0,1-1.1,1.59,8.61,8.61,0,0,0-1,.49l0,0a3.69,3.69,0,0,0-2.15,3v14.62a3.71,3.71,0,0,0,2.19,3.05,11.65,11.65,0,0,0,7.74,1c-6.06.42-7.52-2.15-7.52-4V125.46a2.16,2.16,0,0,1,.55-1.65,3.9,3.9,0,0,0,.74.53,8.33,8.33,0,0,0,7.53,0C402.11,123.14,402.11,121.2,400,120Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.54,122a10.49,10.49,0,0,0-1-.49,1.71,1.71,0,0,1-1.1-1.58V118h-.7v2.59a1.9,1.9,0,0,0,1.12,1.49c.59.33,2.48,1.15,2.94,2s.3,2.56.3,4.58V139a4.68,4.68,0,0,1-3,4.35,9.27,9.27,0,0,0,1.43-.64,3.66,3.66,0,0,0,2.18-3.06V125A3.71,3.71,0,0,0,401.54,122Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.59,120.68v.55a2.61,2.61,0,0,1-1.56,2.18,8.33,8.33,0,0,1-7.53,0,3.61,3.61,0,0,1-1.17-1,2,2,0,0,1-.39-1.15v-.57a1.47,1.47,0,0,1,0-.36,2.86,2.86,0,0,1,1.52-1.82.2.2,0,0,1,.08,0,8.34,8.34,0,0,1,7.45,0,2.87,2.87,0,0,1,1.52,1.81A1.64,1.64,0,0,1,401.59,120.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,123.74v-2c0-.78.2.27-1.16.27-1.18,0-2.23-2.72-3-3.6a.2.2,0,0,0-.08,0,2.86,2.86,0,0,0-1.52,1.82,1.47,1.47,0,0,0,0,.36v.57a2,2,0,0,0,.39,1.15,3.61,3.61,0,0,0,1.17,1,8.33,8.33,0,0,0,7.53,0C398.56,124,396.7,124.48,396.7,123.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,122.84c-2.08-1.2-2.08-3.15,0-4.35a8.33,8.33,0,0,1,7.53,0c2.08,1.2,2.08,3.15,0,4.35A8.33,8.33,0,0,1,392.5,122.84Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.59,118.83v1.1a1.5,1.5,0,0,1,0,.37,2.86,2.86,0,0,1-1.52,1.82,7.35,7.35,0,0,1-3.33.88,7.76,7.76,0,0,1-4.2-.89,3.6,3.6,0,0,1-1.17-1,2.13,2.13,0,0,1-.35-.79,1.47,1.47,0,0,1,0-.36v-1.13a2.65,2.65,0,0,1,1.56-2.18l.28-.15a8.41,8.41,0,0,1,7.25.15A2.63,2.63,0,0,1,401.59,118.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,121c-2.08-1.2-2.08-3.15,0-4.35a8.33,8.33,0,0,1,7.53,0c2.08,1.2,2.08,3.15,0,4.35A8.33,8.33,0,0,1,392.5,121Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.33,121.1a3.6,3.6,0,0,0,1.17,1,7.76,7.76,0,0,0,4.2.89h0c0-.38.23-.68-1.16-1-1.16-.22-2.87-.7-3.67-2a2.7,2.7,0,0,1,.91-3.59l-.28.15a2.65,2.65,0,0,0-1.56,2.18V120a1.47,1.47,0,0,0,0,.36A2.13,2.13,0,0,0,391.33,121.1Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-shelf--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.51,126.24v-2.89h0a1,1,0,0,1,.58-.78l17.48-10a3,3,0,0,1,2.68,0l50.24,28.83a1,1,0,0,1,.58.77h0V145h0a1,1,0,0,1-.58.77l-17.47,10a3,3,0,0,1-2.69,0L275.09,127a1,1,0,0,1-.58-.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,142.92,328,153a3,3,0,0,1-2.69,0l-50.24-28.83a.82.82,0,0,1,0-1.55l17.48-10a3,3,0,0,1,2.68,0l50.24,28.83C346.23,141.8,346.23,142.49,345.49,142.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.67,153.27v2.89a2.77,2.77,0,0,0,1.34-.32l17.48-10a1,1,0,0,0,.58-.77h0v-2.89h0a.72.72,0,0,0-.11-.33c.2.38.05.8-.47,1.1L328,153A2.63,2.63,0,0,1,326.67,153.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "297.16 84.75 281.4 93.84 281.4 123.81 297.16 114.71 297.16 84.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,94.34l15.25-8.75a6.36,6.36,0,0,0,3.48,1.91l-15.11,8.71A15.3,15.3,0,0,1,281.91,94.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,96.16a3.28,3.28,0,0,1-2.93,0l-2.56-1.47a.89.89,0,0,1,0-1.69l15-8.62.64.37-14.78,8.53c-.49.28-.49.73,0,1l2.39,1.35a1.93,1.93,0,0,0,1.75,0l14.78-8.52.72.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,87.54v30l-15,8.62a3.22,3.22,0,0,1-2.93,0l-2.57-1.47a1,1,0,0,1-.6-.84v-30a1,1,0,0,0,.6.84l2.57,1.48a3.28,3.28,0,0,0,2.93,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.53,96.51a3.07,3.07,0,0,1-1.47-.35l-2.57-1.48a1,1,0,0,1-.6-.84v30a1,1,0,0,0,.6.84l2.57,1.47a3,3,0,0,0,1.47.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.82 91.1 288.07 100.2 292.96 131.07 308.71 121.98 303.82 91.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.69,100.63,304,91.88A8.34,8.34,0,0,0,308,93.46l-15.11,8.71A19.87,19.87,0,0,1,288.69,100.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,102.05a4.11,4.11,0,0,1-3.18.14l-3-1.22c-.94-.39-1.05-1.08-.24-1.54l15-8.63.74.3-14.77,8.54c-.49.28-.42.69.14.92l2.79,1.12a2.4,2.4,0,0,0,1.9-.08l14.78-8.52.84.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,93.42l4.89,30.88-15,8.62a4.11,4.11,0,0,1-3.18.14l-3-1.22c-.47-.19-.73-.46-.78-.74l-4.89-30.87c.05.28.31.54.78.74l3,1.22a4.07,4.07,0,0,0,3.18-.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.93,102.44a3.8,3.8,0,0,1-1.64-.25l-3-1.22c-.47-.2-.73-.46-.78-.74l4.89,30.87c.05.28.31.55.78.74l3,1.22a3.83,3.83,0,0,0,1.64.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.8 141.53 325.99 149.97 301.53 135.93 316.34 127.49 340.8 141.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,149.32l14.29-8.19a5.9,5.9,0,0,1,.07-3.71L326,145.53A14.21,14.21,0,0,0,325.82,149.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.72,144.38a3,3,0,0,0-1.37,2.36v2.76c0,.87.61,1.22,1.37.79l14.08-8.08v-.69l-13.89,7.92c-.45.27-.82.05-.82-.47v-2.56a1.79,1.79,0,0,1,.83-1.41l13.87-7.93v-.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,136.3l-24.46-14-14.08,8.08a3,3,0,0,0-1.37,2.36v2.76a.94.94,0,0,0,.4.88l24.46,14a1,1,0,0,1-.4-.88v-2.76a3,3,0,0,1,1.37-2.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,145.39a2.77,2.77,0,0,0-.4,1.35v2.76a1,1,0,0,0,.4.88l-24.46-14a.94.94,0,0,1-.4-.88V132.7a2.76,2.76,0,0,1,.4-1.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.8 134.6 325.99 143.04 301.53 129 316.34 120.56 340.8 134.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,142.4l14.29-8.2a5.87,5.87,0,0,1,.07-3.7L326,138.61A14.13,14.13,0,0,0,325.82,142.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.72,137.45a3,3,0,0,0-1.37,2.36v2.76c0,.87.61,1.22,1.37.79l14.08-8.08v-.68l-13.89,7.92c-.45.26-.82,0-.82-.48v-2.55a1.81,1.81,0,0,1,.82-1.42l13.88-7.92v-.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,129.37l-24.46-14-14.08,8.08a3,3,0,0,0-1.37,2.36v2.76a1,1,0,0,0,.4.89l24.46,14a.94.94,0,0,1-.4-.88v-2.76a3,3,0,0,1,1.37-2.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,138.47a2.73,2.73,0,0,0-.4,1.34v2.76a.94.94,0,0,0,.4.88l-24.46-14a1,1,0,0,1-.4-.89v-2.76a2.76,2.76,0,0,1,.4-1.34Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-shelf--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.51,77.67V74.78h0a1,1,0,0,1,.58-.77l17.48-10a3,3,0,0,1,2.68,0l50.24,28.83a1,1,0,0,1,.58.77h0v2.89h0a1,1,0,0,1-.58.77l-17.47,10a3,3,0,0,1-2.69,0L275.09,78.44a1,1,0,0,1-.58-.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,94.35l-17.47,10a3,3,0,0,1-2.69,0L275.09,75.55c-.74-.43-.74-1.12,0-1.54l17.48-10a3,3,0,0,1,2.68,0l50.24,28.83C346.23,93.23,346.23,93.92,345.49,94.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.67,104.7v2.89a2.77,2.77,0,0,0,1.34-.32l17.48-10a1,1,0,0,0,.58-.78h0V93.58h0a.72.72,0,0,0-.11-.33c.2.38.05.81-.47,1.1l-17.48,10A2.63,2.63,0,0,1,326.67,104.7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "324.39 82.82 309.59 91.26 285.13 77.22 299.93 68.78 324.39 82.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,90.62l14.28-8.2a6,6,0,0,1,.08-3.7l-14.19,8.11A14.13,14.13,0,0,0,309.42,90.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.32,85.67A3,3,0,0,0,308.94,88V90.8c0,.87.62,1.22,1.38.78l14.07-8.07v-.69L310.5,90.74c-.45.26-.82.05-.82-.47V87.71a1.83,1.83,0,0,1,.83-1.42l13.87-7.92v-.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39,77.6l-24.46-14-14.07,8.08A3,3,0,0,0,284.48,74v2.76a1,1,0,0,0,.41.88l24.46,14a1,1,0,0,1-.41-.88V88a3,3,0,0,1,1.37-2.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,86.69a2.76,2.76,0,0,0-.4,1.34V90.8a1,1,0,0,0,.41.88l-24.46-14a1,1,0,0,1-.41-.88V74a2.78,2.78,0,0,1,.41-1.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.39 75.89 309.59 84.33 285.13 70.3 299.93 61.85 324.39 75.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,83.69,323.7,75.5a5.91,5.91,0,0,1,.08-3.71L309.59,79.9A13.62,13.62,0,0,0,309.42,83.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31,78.75a3,3,0,0,0-1.37,2.36v2.76c0,.87.62,1.22,1.37.79l14.08-8.08v-.69L310.5,83.81c-.45.26-.82,0-.82-.47V80.78a1.79,1.79,0,0,1,.83-1.41l13.87-7.93v-.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39,70.67l-24.46-14-14.08,8.08a3,3,0,0,0-1.37,2.36v2.76a1,1,0,0,0,.4.88l24.47,14a1,1,0,0,1-.41-.88V81.11a3.05,3.05,0,0,1,1.37-2.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,79.76a2.77,2.77,0,0,0-.4,1.35v2.76a1,1,0,0,0,.41.88l-24.47-14a1,1,0,0,1-.4-.88V67.07a2.84,2.84,0,0,1,.4-1.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.67 56.43 314.92 65.53 314.92 95.5 330.67 86.4 330.67 56.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.43,66l15.24-8.75a6.38,6.38,0,0,0,3.49,1.9L319,67.9A15.18,15.18,0,0,1,315.43,66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,67.84a3.22,3.22,0,0,1-2.93,0L315,66.37a.88.88,0,0,1,0-1.68l15-8.62.64.36L315.89,65a.53.53,0,0,0,0,1l2.39,1.36a2,2,0,0,0,1.76,0l14.77-8.52.72.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.53,59.22v30l-15,8.62a3.28,3.28,0,0,1-2.93,0L315,96.34a1.05,1.05,0,0,1-.61-.85v-30a1,1,0,0,0,.61.84l2.57,1.48a3.28,3.28,0,0,0,2.93,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,68.19a3,3,0,0,1-1.46-.34L315,66.37a1,1,0,0,1-.61-.84v30a1.05,1.05,0,0,0,.61.85l2.57,1.47a3,3,0,0,0,1.46.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.11 60.13 321.36 69.23 321.36 99.19 337.11 90.1 337.11 60.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.87,69.73,337.11,61a6.44,6.44,0,0,0,3.49,1.9l-15.12,8.71A15,15,0,0,1,321.87,69.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,71.54a3.22,3.22,0,0,1-2.93,0l-2.57-1.47c-.81-.47-.81-1.22,0-1.68l15-8.62.64.36-14.78,8.53c-.48.28-.48.73,0,1L324.72,71a2,2,0,0,0,1.76,0l14.77-8.51.72.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,62.92v30l-15,8.63a3.28,3.28,0,0,1-2.93,0L321.45,100a1,1,0,0,1-.61-.84v-30a1,1,0,0,0,.61.84L324,71.54a3.22,3.22,0,0,0,2.93,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.48,71.89a2.9,2.9,0,0,1-1.46-.35l-2.57-1.47a1,1,0,0,1-.61-.84v30a1,1,0,0,0,.61.84l2.57,1.48a3,3,0,0,0,1.46.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.1,380.25h-8.22l1.31,8h0a1.47,1.47,0,0,0,.79,1,4.41,4.41,0,0,0,4,0,1.48,1.48,0,0,0,.8-1h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.26,357.07H363l1.32,8h0a1.48,1.48,0,0,0,.8,1,4.41,4.41,0,0,0,4,0,1.47,1.47,0,0,0,.79-1h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.44,408.81h8.21l-1.31,8h0a1.48,1.48,0,0,1-.8,1,4.41,4.41,0,0,1-4,0,1.48,1.48,0,0,1-.8-1h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.27,385.63h8.22l-1.31,8h0a1.51,1.51,0,0,1-.8,1,4.41,4.41,0,0,1-4,0,1.48,1.48,0,0,1-.8-1h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.53 256.41 326.99 306.36 326.99 387.39 240.53 337.44 240.53 256.41",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.25 308.14 58.25 389.17 104.59 415.93 104.59 334.89 58.25 308.14",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.99 306.36 373.38 279.6 373.38 360.63 326.99 387.39 326.99 306.36",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.59 415.93 240.53 337.44 240.53 256.41 104.59 334.89 104.59 415.93",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.09 393.7 144.71 392.76 144.71 311.73 143.09 312.66 143.09 393.7",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.32 360.63 201.94 359.7 201.94 278.67 200.32 279.6 200.32 360.63",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.59 362.88 282.98 361.95 282.98 280.92 284.59 281.85 284.59 362.88",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.08,309.09v1.67a1.82,1.82,0,0,0,.82,1.42l50.87,29.38a1.84,1.84,0,0,0,1.65,0L239.72,264a1.82,1.82,0,0,1,1.64,0l84.86,49a1.76,1.76,0,0,0,1.64,0l50.88-29.37a1.81,1.81,0,0,0,.83-1.42v-1.67a1.81,1.81,0,0,0-.83-1.42L241.37,199.8a1.84,1.84,0,0,0-1.65,0L52.9,307.66A1.83,1.83,0,0,0,52.08,309.09Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.08,309.09v1.67a1.82,1.82,0,0,0,.82,1.42l50.87,29.38a1.84,1.84,0,0,0,1.65,0L239.72,264a1.82,1.82,0,0,1,1.64,0l84.86,49a1.76,1.76,0,0,0,1.64,0l50.88-29.37a1.81,1.81,0,0,0,.83-1.42v-1.67a1.81,1.81,0,0,0-.83-1.42L241.37,199.8a1.84,1.84,0,0,0-1.65,0L52.9,307.66A1.83,1.83,0,0,0,52.08,309.09Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.6,338.18v3.58a1.66,1.66,0,0,1-.82-.2L52.9,312.18a1.8,1.8,0,0,1-.82-1.42v-1.67a1.85,1.85,0,0,1,.67-1.32c-.3.27-.25.62.15.84L103.78,338A1.63,1.63,0,0,0,104.6,338.18Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,309.64v3.57a1.65,1.65,0,0,1-.83-.2l-84.85-49a1.58,1.58,0,0,0-.82-.2v-3.56a1.68,1.68,0,0,1,.82.19l84.85,49A1.65,1.65,0,0,0,327,309.64Z",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,308.61,103.77,338a1.84,1.84,0,0,0,1.65,0l134.3-77.54a1.82,1.82,0,0,1,1.64,0l84.86,49a1.82,1.82,0,0,0,1.64,0l50.88-29.37c.46-.27.46-.69,0-.95L241.37,199.8a1.84,1.84,0,0,0-1.65,0L52.9,307.66C52.44,307.93,52.44,308.35,52.9,308.61Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,308.61,103.77,338a1.84,1.84,0,0,0,1.65,0l134.3-77.54a1.82,1.82,0,0,1,1.64,0l84.86,49a1.82,1.82,0,0,0,1.64,0l50.88-29.37c.46-.27.46-.69,0-.95L241.37,199.8a1.84,1.84,0,0,0-1.65,0L52.9,307.66C52.44,307.93,52.44,308.35,52.9,308.61Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.9,341.25c0,.56,1.67.05,3.73-1.14l4.91-2.82c2-1.19,3.72-2.61,3.72-3.17v-1l-12.36,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.77,284.18c0,.55,1.66,0,3.72-1.15l4.91-2.82c2.06-1.19,3.72-2.61,3.72-3.17v-1l-12.35,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34,313c0,.56,1.66,0,3.72-1.14L175,309c2.05-1.19,3.72-2.62,3.72-3.17v-1L166.34,312Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34,348.32c0,.56,1.66.05,3.72-1.14l4.91-2.82c2.05-1.19,3.72-2.61,3.72-3.17v-1l-12.35,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.29,286c0,.56-1.67.05-3.73-1.14l-4.9-2.83c-2.06-1.18-3.73-2.61-3.73-3.17v-1L268.29,285Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,310.93c0,.56-1.67.05-3.72-1.14L302.91,307c-2.06-1.19-3.73-2.62-3.73-3.17v-1l12.36,7.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,345.71c0,.56-1.67.05-3.72-1.14l-4.91-2.82c-2.06-1.19-3.73-2.62-3.73-3.17v-1l12.36,7.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.13 322.41 143.9 355.65 143.9 357.43 201.13 324.19 201.13 322.41",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.74 321.52 326.99 346.49 326.99 348.27 283.74 323.3 283.74 321.52",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M335.45,273.56l22,12.68c.31.19.31.48,0,.66l-26.81,15.43a1.19,1.19,0,0,1-1.13,0l-22-12.68a.35.35,0,0,1,0-.66l26.81-15.43A1.25,1.25,0,0,1,335.45,273.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.42,274.68l18.87,9.94.38.61v.49a.72.72,0,0,1-.38.61l-24.87,14.36a1.4,1.4,0,0,1-1.3,0L310.67,290v-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,300.36a1.36,1.36,0,0,0,.65-.16l24.87-14.36a.73.73,0,0,0,.38-.61.71.71,0,0,0-.38-.61l-18-10.42-26.58,15.34,18.45,10.66A1.36,1.36,0,0,0,329.77,300.36Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.25,272.76l17.83,10.3.18.25v1.92h0a.31.31,0,0,1-.18.25l-24.87,14.36a1,1,0,0,1-.88,0l-17.84-10.3v-1.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,287.63l.22.13,2.91,1.67.54.32,14.17,8.18a1,1,0,0,0,.88,0l24.87-14.36c.25-.14.25-.37,0-.51l-.24-.14-17.59-10.16L311.71,287.5l0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,298V300a.9.9,0,0,0,.44-.11l24.87-14.36a.31.31,0,0,0,.18-.25v-1.92a.32.32,0,0,1-.18.26l-24.87,14.36A.89.89,0,0,1,329.77,298Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,287.38l3.21,1.85.5.29,14.13,8.15a1,1,0,0,0,.88,0l22.27-12.86.56-.32a5.47,5.47,0,0,0,1.8-1.57l.05-.07a.29.29,0,0,0,.05-.13.4.4,0,0,0-.31-.45,8.54,8.54,0,0,1-1.68-.7h0l-15.68-9.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,287.15a.25.25,0,0,1,0,.48.91.91,0,0,1-.82,0,.25.25,0,0,1,0-.48A.91.91,0,0,1,314.81,287.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,286.89a1.9,1.9,0,0,0,0,.41l.29-.16a2.29,2.29,0,0,1,0-.25,1.11,1.11,0,0,1,.42-1,.52.52,0,0,1,.3-.08,1.09,1.09,0,0,1,.51.15,3.07,3.07,0,0,1,1.24,1.79,1.06,1.06,0,0,0,.31,0,3.51,3.51,0,0,0-1.4-2,1.1,1.1,0,0,0-1.11-.08A1.41,1.41,0,0,0,311.58,286.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.64,287.46a.64.64,0,0,0,0,.07l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,285.71a.26.26,0,0,1,0,.48.93.93,0,0,1-.83,0,.25.25,0,0,1,0-.48A.93.93,0,0,1,317.31,285.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.08,285.45a2.73,2.73,0,0,0,0,.41l.29-.16a2.29,2.29,0,0,1,0-.25,1.13,1.13,0,0,1,.42-1,.61.61,0,0,1,.3-.08,1.06,1.06,0,0,1,.51.15,3.16,3.16,0,0,1,1.25,1.79,1,1,0,0,0,.3,0,3.42,3.42,0,0,0-1.4-2,1.1,1.1,0,0,0-1.11-.08A1.43,1.43,0,0,0,314.08,285.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.8,284.27a.25.25,0,0,1,0,.48.93.93,0,0,1-.83,0,.25.25,0,0,1,0-.48A.93.93,0,0,1,319.8,284.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,284a3,3,0,0,0,0,.42l.29-.17a2.09,2.09,0,0,1,0-.25,1.11,1.11,0,0,1,.42-1,.6.6,0,0,1,.29-.08,1.06,1.06,0,0,1,.51.15,3.2,3.2,0,0,1,1.25,1.79,1,1,0,0,0,.3,0,3.42,3.42,0,0,0-1.4-2,1.09,1.09,0,0,0-1.11-.08A1.43,1.43,0,0,0,316.57,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.29,282.83c.23.14.23.35,0,.48a.87.87,0,0,1-.83,0c-.22-.13-.22-.34,0-.48A.93.93,0,0,1,322.29,282.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,282.57a3,3,0,0,0,0,.42l.29-.17a2.09,2.09,0,0,1,0-.25,1.12,1.12,0,0,1,.42-1,.61.61,0,0,1,.3-.08,1,1,0,0,1,.5.16,3.09,3.09,0,0,1,1.25,1.78.8.8,0,0,0,.31,0,3.51,3.51,0,0,0-1.4-2,1.11,1.11,0,0,0-1.12-.08A1.43,1.43,0,0,0,319.06,282.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,281.39c.23.14.23.35,0,.48a.85.85,0,0,1-.82,0c-.23-.13-.23-.34,0-.48A.91.91,0,0,1,324.78,281.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.55,281.13a3,3,0,0,0,0,.42l.3-.17a1,1,0,0,1,0-.25,1.12,1.12,0,0,1,.42-1,.61.61,0,0,1,.3-.08,1.11,1.11,0,0,1,.51.16,3.08,3.08,0,0,1,1.24,1.78.8.8,0,0,0,.31,0,3.51,3.51,0,0,0-1.4-2,1.1,1.1,0,0,0-1.11-.08A1.41,1.41,0,0,0,321.55,281.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.28,280a.25.25,0,0,1,0,.47.87.87,0,0,1-.83,0c-.23-.13-.23-.34,0-.48A.9.9,0,0,1,327.28,280Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.05,279.69a3,3,0,0,0,0,.42l.29-.17a2,2,0,0,1,0-.25,1.15,1.15,0,0,1,.42-1,.61.61,0,0,1,.3-.08,1.08,1.08,0,0,1,.51.16,3.14,3.14,0,0,1,1.25,1.78.61.61,0,0,0,.3,0,3.42,3.42,0,0,0-1.4-2,1.1,1.1,0,0,0-1.11-.08A1.44,1.44,0,0,0,324.05,279.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,278.52c.23.13.23.34,0,.48a.93.93,0,0,1-.83,0c-.23-.14-.23-.35,0-.48A.87.87,0,0,1,329.77,278.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.54,278.26a2.93,2.93,0,0,0,0,.41l.29-.17a1.93,1.93,0,0,1,0-.24,1.13,1.13,0,0,1,.42-1,.6.6,0,0,1,.29-.08,1.08,1.08,0,0,1,.51.16,3.14,3.14,0,0,1,1.25,1.78.75.75,0,0,0,.3,0,3.45,3.45,0,0,0-1.4-2,1.07,1.07,0,0,0-1.11-.07A1.43,1.43,0,0,0,326.54,278.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.26,277.08c.23.13.23.34,0,.48a.91.91,0,0,1-.82,0c-.23-.14-.23-.35,0-.48A.85.85,0,0,1,332.26,277.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,276.82a2.93,2.93,0,0,0,0,.41l.29-.17a1.93,1.93,0,0,1,0-.24,1.14,1.14,0,0,1,.42-1,.61.61,0,0,1,.3-.08,1.08,1.08,0,0,1,.5.16,3.09,3.09,0,0,1,1.25,1.78.8.8,0,0,0,.31,0,3.54,3.54,0,0,0-1.4-2,1.09,1.09,0,0,0-1.12-.07A1.43,1.43,0,0,0,329,276.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.75,275.64c.23.13.23.34,0,.48a.91.91,0,0,1-.82,0c-.23-.14-.23-.35,0-.48A.91.91,0,0,1,334.75,275.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.52,275.38a2.93,2.93,0,0,0,0,.41l.3-.17a1,1,0,0,1,0-.24,1.14,1.14,0,0,1,.42-1,.6.6,0,0,1,.3-.07,1.09,1.09,0,0,1,.51.15,3.08,3.08,0,0,1,1.24,1.78.8.8,0,0,0,.31,0,3.54,3.54,0,0,0-1.4-2,1.09,1.09,0,0,0-1.11-.07A1.41,1.41,0,0,0,331.52,275.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.25,274.2a.26.26,0,0,1,0,.48.93.93,0,0,1-.83,0,.25.25,0,0,1,0-.48A.93.93,0,0,1,337.25,274.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,273.94a2.93,2.93,0,0,0,0,.41l.29-.17a1.94,1.94,0,0,1,0-.24,1.17,1.17,0,0,1,.42-1,.6.6,0,0,1,.3-.07,1.06,1.06,0,0,1,.51.15,3.13,3.13,0,0,1,1.25,1.79,1,1,0,0,0,.3,0,3.39,3.39,0,0,0-1.4-2,1.07,1.07,0,0,0-1.11-.08A1.43,1.43,0,0,0,334,273.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.26,295.11a.33.33,0,0,1-.14,0l-13.72-7.92a.29.29,0,0,1-.1-.39.28.28,0,0,1,.38-.1l13.72,7.92a.28.28,0,0,1,.1.39A.27.27,0,0,1,332.26,295.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.92,294.15a.43.43,0,0,1-.14,0l-13.72-7.92a.29.29,0,0,1-.1-.39.28.28,0,0,1,.38-.1l13.72,7.92a.29.29,0,0,1,.11.39A.29.29,0,0,1,333.92,294.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.58,293.19a.27.27,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1,.28-.49l13.73,7.92a.29.29,0,0,1,.1.39A.29.29,0,0,1,335.58,293.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.25,292.23a.23.23,0,0,1-.14,0l-13.72-7.92a.29.29,0,0,1-.11-.39.3.3,0,0,1,.39-.1l13.72,7.92a.29.29,0,0,1,.1.39A.28.28,0,0,1,337.25,292.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.91,291.27a.23.23,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1-.11-.38.29.29,0,0,1,.39-.11l13.72,7.92a.29.29,0,0,1,.1.39A.27.27,0,0,1,338.91,291.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.57,290.31a.23.23,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1,.28-.49l13.72,7.92a.29.29,0,0,1,.1.39A.27.27,0,0,1,340.57,290.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,289.35a.25.25,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1-.1-.38.28.28,0,0,1,.38-.11l13.72,7.93a.28.28,0,0,1,.11.38A.3.3,0,0,1,342.23,289.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,288.39a.27.27,0,0,1-.14,0L330,280.43a.28.28,0,0,1-.1-.38.28.28,0,0,1,.38-.11L344,287.87a.28.28,0,0,1,.11.38A.29.29,0,0,1,343.89,288.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.56,287.43a.28.28,0,0,1-.15,0l-13.72-7.92a.28.28,0,0,1-.1-.38A.29.29,0,0,1,332,279l13.72,7.93a.28.28,0,0,1,.1.38A.28.28,0,0,1,345.56,287.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.22,286.47a.23.23,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1-.11-.38.29.29,0,0,1,.39-.11L347.36,286a.28.28,0,0,1,.1.38A.28.28,0,0,1,347.22,286.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.88,285.51a.23.23,0,0,1-.14,0L335,277.55a.28.28,0,1,1,.28-.48L349,285a.28.28,0,0,1,.1.38A.27.27,0,0,1,348.88,285.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,284.55a.25.25,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1-.1-.38.27.27,0,0,1,.38-.1L350.68,284a.28.28,0,0,1-.14.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.2,283.59a.27.27,0,0,1-.14,0l-13.72-7.92a.28.28,0,0,1,.28-.48l13.72,7.92a.28.28,0,0,1,.11.38A.3.3,0,0,1,352.2,283.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.57,296.07a.43.43,0,0,1-.14,0l-14.51-8.4a.27.27,0,0,1-.1-.38.28.28,0,0,1,.38-.1l14.51,8.39a.29.29,0,0,1,.11.39A.31.31,0,0,1,330.57,296.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M323.65,285.9a2.1,2.1,0,0,0,.7-.72.59.59,0,0,1,.31-.08c.4.06.06.21,0,.37a.06.06,0,0,0,.08.08c.28,0,.95-.21.77.25a.06.06,0,0,0,0,.08c.08,0,.47.08.42.17a.07.07,0,0,0,.06.09,8.81,8.81,0,0,1,.89,0,1.62,1.62,0,0,1,.4.05c.09.11,0,.33-.09.41a.06.06,0,0,0,0,.1c.16.07.27.16.17.32a.07.07,0,0,0,0,.1c.38.1,1.06-.21,1.17.24.06.28,0,.35.37.32.06,0,.11-.13,0-.13-.37,0-.1-.42-.31-.56s-.71.13-.94,0,0-.16-.09-.33-.13,0-.15-.06-.06-.06-.07-.06a.16.16,0,0,0,0-.1c0-.08.05-.07.06-.11.09-.43-.59-.33-.87-.35a4.16,4.16,0,0,1-.5,0s0-.1,0-.12-.4-.15-.4-.17.09-.15,0-.24-.58-.1-.75-.09h-.14s.11,0,.12-.12,0-.09,0-.17-.14-.13-.26-.14a.67.67,0,0,0-.36.06.66.66,0,0,0,.06-.38c-.1-.42-.57-.11-.82,0-.05,0-.07.14,0,.12a1.88,1.88,0,0,1,.53-.16c.23,0,.06.37-.07.58l-.27.14a1.16,1.16,0,0,0-.56.36C323.12,286,323.39,286,323.65,285.9Zm.15-.44.21-.11a1,1,0,0,1-.35.37s-.3.11-.22,0A.93.93,0,0,1,323.8,285.46Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M329.56,289.21a.06.06,0,0,0,.05.06c.32.1.62-.28.74-.66.11,0,.37-.05.42.13,0,0-.07.17-.07.2s0,.06.06.06.74-.21.65.1c0,0,0,.06,0,.07s.46-.07.51.16-.2.2-.08.35.26,0,.36,0,.13-.09.2-.06,0,.07,0,.1,0,.09.08.11.11,0,.17,0,.07-.06.11-.06a.51.51,0,0,1,.22.06s.32.14.29.09-.15.23-.05.36.57,0,.71,0,.11-.14,0-.14a3,3,0,0,1-.33,0c-.29-.12-.21-.2-.16-.35s0-.09,0-.08-.33-.18-.47-.18-.21.09-.24.09c-.22,0-.11-.07-.12-.22a.05.05,0,0,0-.08-.05c-.13,0-.46.31-.47,0,0-.05.14-.13.15-.2s-.05-.18-.18-.21a.66.66,0,0,0-.28,0c-.36.05-.06,0-.18-.1a.34.34,0,0,0-.33-.1c-.06,0-.18,0-.23,0s-.07,0-.07-.13.07-.15,0-.25-.16-.16-.32-.12a1.11,1.11,0,0,0-.31.1c0-.26-.05-.48-.29-.47-.07,0-.13.13-.05.14s.18.24.13.44C329.88,288.7,329.59,289,329.56,289.21Zm.32-.24a.81.81,0,0,1,.23-.22l0,.09C330,288.89,329.82,289.16,329.88,289Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53,290.82a2.14,2.14,0,0,0,.7-.73.68.68,0,0,1,.31-.07c.4.05.06.21,0,.36s0,.1.08.09c.28-.05.95-.21.77.24,0,0,0,.08,0,.08s.47.08.43.18,0,.08.06.08a8.88,8.88,0,0,1,.89,0,1.68,1.68,0,0,1,.4.05c.09.1-.06.33-.1.4a.07.07,0,0,0,0,.1c.15.07.27.16.17.32s0,.09,0,.1c.38.11,1.06-.2,1.16.25.07.28,0,.34.37.31.07,0,.11-.12,0-.12-.36,0-.09-.42-.3-.56s-.71.13-.94,0,0-.16-.09-.32-.13,0-.16-.06-.05-.06-.06-.06,0,0,0-.1.05-.07.06-.12c.08-.42-.6-.32-.87-.34-.1,0-.45,0-.5,0s0-.11,0-.12-.4-.15-.41-.17.09-.16.05-.24-.59-.1-.76-.1h-.13a.13.13,0,0,0,.12-.12c0-.05,0-.08,0-.16s-.14-.14-.25-.15a.77.77,0,0,0-.36.07.59.59,0,0,0,.05-.38c-.1-.42-.56-.12-.81,0-.06,0-.07.14,0,.12s.4-.19.53-.16.06.37-.07.57-.19.11-.27.14a1.18,1.18,0,0,0-.56.36C325,290.86,325.26,291,325.53,290.82Zm.15-.44.21-.11a1.06,1.06,0,0,1-.36.37s-.29.11-.21,0A.76.76,0,0,1,325.68,290.38Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M320.36,287.75a.07.07,0,0,0,0,.06c.33.1.63-.28.74-.66.12,0,.38,0,.42.13,0,0-.06.17-.07.2a.06.06,0,0,0,.06.06c.18,0,.74-.21.65.1,0,0,0,.06,0,.07s.47-.07.52.16-.2.2-.08.35.25,0,.36,0,.13-.09.2-.07,0,.08,0,.11.05.09.09.11.11,0,.16,0,.08-.06.12-.06a.55.55,0,0,1,.22.06s.31.14.28.09-.14.23,0,.36.57,0,.7,0,.12-.14,0-.14l-.33,0c-.29-.12-.21-.2-.16-.35s0-.09-.06-.08-.32-.18-.47-.18-.2.09-.23.09c-.23,0-.12-.07-.12-.22a.06.06,0,0,0-.08,0c-.13,0-.47.31-.47,0,0-.05.14-.13.15-.2s-.05-.18-.18-.21a.66.66,0,0,0-.28,0c-.36,0-.06,0-.18-.1s-.14-.11-.34-.1a1.64,1.64,0,0,1-.22,0c-.2-.05-.07,0-.08-.13s.07-.15,0-.25-.15-.16-.32-.13l-.3.11c0-.26-.05-.48-.3-.47-.06,0-.13.12,0,.14s.18.24.13.44C320.67,287.24,320.38,287.5,320.36,287.75Zm.31-.24a1,1,0,0,1,.23-.22.39.39,0,0,1,0,.09C320.83,287.43,320.61,287.7,320.67,287.51Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M333.79,280.3a2.24,2.24,0,0,0,.7-.73.68.68,0,0,1,.31-.07c.4.06.06.21,0,.36s0,.1.07.09c.28,0,1-.21.78.24,0,0,0,.08,0,.08s.47.08.43.18a.06.06,0,0,0,.06.08,8.62,8.62,0,0,1,.88,0,1.7,1.7,0,0,1,.41.05c.09.1-.06.33-.1.4a.07.07,0,0,0,0,.1c.15.07.27.16.17.32s0,.09,0,.1c.39.11,1.07-.2,1.17.25.07.28,0,.35.37.32.06,0,.11-.13,0-.13-.36,0-.1-.42-.3-.56s-.71.13-.94,0,0-.15-.09-.32-.13,0-.16-.06-.05-.06-.06-.06l0-.1c0-.08,0-.07.05-.12.09-.42-.59-.32-.86-.34a4.15,4.15,0,0,1-.5,0s0-.11,0-.12-.4-.15-.41-.17.09-.15.05-.24-.59-.1-.76-.1h-.13a.14.14,0,0,0,.12-.12c0-.05,0-.08,0-.16s-.14-.14-.25-.15a.77.77,0,0,0-.36.07.66.66,0,0,0,.05-.38c-.1-.42-.56-.12-.81,0-.06,0-.07.14,0,.12s.4-.19.53-.16.05.37-.07.58l-.27.13a1.18,1.18,0,0,0-.56.36C333.25,280.34,333.52,280.44,333.79,280.3Zm.15-.44.2-.11a1,1,0,0,1-.35.37s-.29.11-.21,0A.72.72,0,0,1,333.94,279.86Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M339.7,283.61a.08.08,0,0,0,0,.06c.33.1.63-.28.74-.66.12,0,.38-.05.42.13,0,0-.07.17-.07.2a.06.06,0,0,0,.06.06c.18,0,.74-.21.65.1a.06.06,0,0,0,0,.07c.15.1.47-.07.52.16s-.2.2-.08.35.25,0,.36,0,.13-.09.2-.07,0,.08,0,.11.05.08.09.11.1,0,.16,0,.08-.06.12-.06a.55.55,0,0,1,.22.06s.31.14.28.08-.14.24,0,.37.57,0,.7,0,.12-.14,0-.14a3,3,0,0,1-.33,0c-.28-.12-.21-.21-.15-.35s0-.09-.06-.08-.32-.18-.47-.18-.2.09-.23.09c-.23,0-.12-.07-.12-.23s-.05-.06-.08-.05-.47.32-.48,0c0,0,.14-.12.15-.19s0-.18-.17-.21-.19,0-.29,0c-.35.06-.05,0-.17-.09s-.14-.11-.34-.1a2,2,0,0,1-.22,0c-.2-.05-.07,0-.08-.13s.07-.15,0-.25-.16-.16-.32-.13l-.31.11c0-.26,0-.48-.29-.47-.07,0-.13.12,0,.13s.18.25.13.44C340,283.1,339.72,283.36,339.7,283.61Zm.31-.24a.81.81,0,0,1,.23-.22.29.29,0,0,1,0,.08C340.17,283.29,340,283.56,340,283.37Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M335.66,285.21a2.21,2.21,0,0,0,.71-.72.52.52,0,0,1,.3-.07c.41.05.07.21,0,.36a.08.08,0,0,0,.08.09c.28-.05,1-.22.77.24a.07.07,0,0,0,0,.08c.09,0,.47.08.43.18a.06.06,0,0,0,.05.08,8.75,8.75,0,0,1,.89,0,2.48,2.48,0,0,1,.41,0c.08.11-.06.34-.1.41a.07.07,0,0,0,0,.1c.15.07.26.16.16.32s0,.09,0,.1c.38.11,1.06-.21,1.17.25.07.28,0,.34.37.31.06,0,.11-.12,0-.12-.37,0-.1-.42-.31-.57s-.71.13-.93,0,0-.16-.1-.32-.13,0-.15-.07-.05-.06-.06-.05,0-.05,0-.11,0-.06.05-.11c.09-.42-.59-.32-.86-.34a3.91,3.91,0,0,1-.5,0s0-.1,0-.12l-.4-.16s.09-.16,0-.25-.58-.1-.75-.09h-.13s.11,0,.11-.12a.27.27,0,0,0,0-.16c0-.14-.14-.14-.26-.15a.82.82,0,0,0-.36.07.62.62,0,0,0,.06-.39c-.1-.41-.57-.11-.81,0-.06,0-.08.14,0,.11s.4-.18.54-.15.05.37-.08.57l-.27.14a1.23,1.23,0,0,0-.56.36C335.13,285.26,335.4,285.35,335.66,285.21Zm.15-.44a1.08,1.08,0,0,0,.21-.11,1,1,0,0,1-.35.38s-.3.1-.21,0A.83.83,0,0,1,335.81,284.77Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5,282.15s0,.05,0,.06c.32.1.62-.28.74-.66.12,0,.37-.05.42.13a1.5,1.5,0,0,0-.07.2s0,.06.06.06c.18,0,.74-.21.65.1a.06.06,0,0,0,0,.07c.15.1.47-.07.51.16s-.2.2-.08.35.26,0,.36,0,.13-.09.21-.07,0,.08,0,.11,0,.08.08.11.11,0,.17,0,.07-.06.11-.07a.71.71,0,0,1,.22.07s.32.14.29.08-.14.24-.05.37.58,0,.71,0,.11-.14,0-.14l-.33,0c-.29-.12-.21-.21-.16-.35s0-.09,0-.08-.32-.18-.47-.18a1.85,1.85,0,0,0-.23.09c-.23,0-.12-.07-.13-.23s0-.06-.08-.05-.46.32-.47,0c0,0,.14-.13.15-.19s-.05-.18-.18-.21-.19,0-.28,0c-.36.06-.06,0-.18-.09s-.13-.11-.33-.1a2,2,0,0,1-.23,0c-.19-.05-.06,0-.07-.13s.07-.15,0-.25-.16-.16-.32-.13a2,2,0,0,0-.31.11c0-.26,0-.48-.29-.47-.07,0-.13.12,0,.13s.18.24.13.44C330.81,281.64,330.52,281.9,330.5,282.15Zm.31-.24a.81.81,0,0,1,.23-.22l0,.08C331,281.83,330.75,282.1,330.81,281.91Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M334.62,288.6a2.05,2.05,0,0,0,.7-.73.68.68,0,0,1,.31-.07c.4.06.06.21,0,.36s0,.1.08.09c.28,0,.95-.21.77.24,0,0,0,.08,0,.08s.47.08.42.18,0,.09.06.08a8.81,8.81,0,0,1,.89,0,1.62,1.62,0,0,1,.4,0c.09.1-.05.33-.09.4a.06.06,0,0,0,0,.1c.16.07.27.16.17.32a.07.07,0,0,0,0,.1c.38.11,1.06-.2,1.17.25.06.28,0,.34.37.32.06,0,.11-.13,0-.13-.37,0-.1-.42-.31-.56s-.71.13-.94,0,0-.15-.09-.32-.13,0-.15-.06-.06-.06-.07-.06a.16.16,0,0,0,0-.1c0-.08,0-.07.06-.12.09-.42-.59-.32-.87-.34a4.16,4.16,0,0,1-.5,0s0-.11,0-.12-.4-.15-.4-.17.09-.15,0-.24-.58-.1-.75-.1h-.14a.13.13,0,0,0,.12-.12c0-.05,0-.08,0-.16s-.14-.14-.26-.15a.8.8,0,0,0-.36.07.67.67,0,0,0,.06-.38c-.1-.42-.57-.12-.82,0,0,0-.07.14,0,.12s.4-.19.53-.16.06.37-.07.58l-.27.13a1.23,1.23,0,0,0-.56.36C334.09,288.64,334.36,288.74,334.62,288.6Zm.15-.44.21-.11a1,1,0,0,1-.35.37s-.3.11-.22,0A.76.76,0,0,1,334.77,288.16Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M330.33,285.84a.07.07,0,0,0,0,.06c.33.1.63-.28.74-.66.12,0,.38-.05.42.13l-.07.2a.06.06,0,0,0,.06.06c.18,0,.74-.21.65.1,0,0,0,.06,0,.07s.47-.07.52.16-.2.2-.08.35.25,0,.36,0,.13-.09.2-.07,0,.08,0,.11,0,.09.09.11.11,0,.16,0,.08-.06.12-.06a.55.55,0,0,1,.22.06s.31.14.28.09-.14.23,0,.36.57,0,.7,0,.12-.14,0-.14l-.33,0c-.29-.12-.21-.2-.16-.35s0-.09-.06-.08-.32-.18-.47-.18-.2.09-.23.09c-.23,0-.12-.07-.12-.22a.06.06,0,0,0-.08-.05c-.13,0-.47.31-.47,0,0-.05.14-.13.15-.2s0-.18-.18-.21a.66.66,0,0,0-.28,0c-.36.05-.06,0-.18-.1s-.14-.11-.34-.1-.17,0-.22,0-.07,0-.08-.13.07-.15,0-.25-.15-.16-.32-.13l-.3.11c0-.26-.05-.48-.3-.47-.06,0-.13.12,0,.14s.18.24.13.44C330.65,285.33,330.35,285.59,330.33,285.84Zm.32-.24c0-.05.12-.14.22-.22a.39.39,0,0,1,0,.09S330.58,285.79,330.65,285.6Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M327.15,282.67a.89.89,0,0,1,0,.4.07.07,0,0,0,.06.07c.18,0,.74-.21.65.1a.07.07,0,0,0,0,.07c.15.1.47-.07.52.15s-.2.2-.08.35.25,0,.36,0,.13-.1.2-.07,0,.07,0,.1.05.09.09.11.1,0,.16,0,.08-.06.11-.06a.77.77,0,0,1,.23.06s.31.14.28.09-.14.23-.05.36.58,0,.71,0,.12-.14,0-.14l-.34.05c-.28-.13-.21-.21-.15-.36a.06.06,0,0,0-.06-.08c-.19,0-.32-.18-.47-.17s-.2.08-.23.08c-.23,0-.12-.07-.12-.22a.07.07,0,0,0-.08-.05c-.13.05-.47.31-.48,0,0,0,.14-.13.15-.2s0-.18-.18-.21a.68.68,0,0,0-.28,0c-.36.06,0,0-.17-.1s-.14-.11-.34-.1-.18,0-.23,0-.06,0-.07-.12.07-.16,0-.25-.26-.27-.31-.07a.17.17,0,0,0,0,.07Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microscope--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M302.13,288.33l-22-12.69a.34.34,0,0,1,0-.65l34.42-19.88a1.27,1.27,0,0,1,1.14,0l22,12.69a.35.35,0,0,1,0,.66l-34.42,19.87A1.27,1.27,0,0,1,302.13,288.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.26,266.36v2.06L303.19,285.2v-2.06a5,5,0,0,1,2.54-3.52l24-13.85a2.22,2.22,0,0,1,2-.34A1,1,0,0,1,332.26,266.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.19,255.86l0,0h0a2.16,2.16,0,0,0-2.07.32l-24,13.85a4.94,4.94,0,0,0-2.53,3.52v2.06l16.64,9.61v-2.06a5,5,0,0,1,2.54-3.52l24-13.85a2.22,2.22,0,0,1,2-.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.41,267.47a13.32,13.32,0,0,1,7.38-1.47l10.07-5.81,7.76,4.48-10.07,5.81c.33,1.52-.52,3.1-2.54,4.27a13.94,13.94,0,0,1-12.61,0C292.92,272.74,292.92,269.48,296.41,267.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.48,260.16v3.43L317.54,267v-3.43a6.59,6.59,0,0,1,3-5.15,2.05,2.05,0,0,1,2.12-.19A2.08,2.08,0,0,1,323.48,260.16Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.48,260.16v3.43L317.54,267v-3.43a6.59,6.59,0,0,1,3-5.15,2.05,2.05,0,0,1,2.12-.19A2.08,2.08,0,0,1,323.48,260.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.52,254.14l0,0a2.1,2.1,0,0,0-2.09.21,6.6,6.6,0,0,0-3,5.15v3.44l7.14,4.11v-3.43a6.59,6.59,0,0,1,3-5.15,2.13,2.13,0,0,1,2-.24Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.52,254.14l0,0a2.1,2.1,0,0,0-2.09.21,6.6,6.6,0,0,0-3,5.15v3.44l7.14,4.11v-3.43a6.59,6.59,0,0,1,3-5.15,2.13,2.13,0,0,1,2-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,261.46c.44-.26.79,0,.79.46a1.74,1.74,0,0,1-.79,1.37c-.44.25-.8,0-.8-.46A1.75,1.75,0,0,1,320.51,261.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,230l1.81-3s-4.24-2.42-5.53-3.2l-2.15,3c2.89,2.69,5.62,9.2,4.41,16.62-.7,4.26-2.2,7.5-4.93,11.79l5.53,3.19A30.19,30.19,0,0,0,325,247C326.6,241.75,325.34,232.77,320.17,230Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,230c1.91,1.14,6,6.48,4.66,15.78-.62,4.27-3.13,8.15-5.52,12.57a3,3,0,0,1,.44-.29,2,2,0,0,1,2.12-.2l.76.44a1.28,1.28,0,0,1,.46.43,31,31,0,0,0,5.62-15.19c.67-9.69-3.81-14.82-6.73-16.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,226.93a10.32,10.32,0,0,0-4.91-1.37l-.56,3.25a5.82,5.82,0,0,1,3.66,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.04 267.23 308.04 264.49 300.28 260.01 300.28 262.75 308.04 267.23",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.04 267.23 308.04 264.49 300.28 260.01 300.28 262.75 308.04 267.23",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.04 267.23 321.62 259.39 321.62 256.65 308.04 264.49 308.04 267.23",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.04 267.23 321.62 259.39 321.62 256.65 308.04 264.49 308.04 267.23",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.28 260.01 313.86 252.17 321.62 256.65 308.04 264.49 300.28 260.01",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8,265.61v-2.52c0-1.32.86-2.64,2.61-3.64a13.92,13.92,0,0,1,12.6,0c1.74,1,2.61,2.32,2.61,3.64h0v2.52h0c0,1.33-.85,2.67-2.61,3.69a13.94,13.94,0,0,1-12.61,0c-1.76-1-2.62-2.36-2.6-3.69Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8,265.61v-2.52c0-1.32.86-2.64,2.61-3.64a13.92,13.92,0,0,1,12.6,0c1.74,1,2.61,2.32,2.61,3.64h0v2.52h0c0,1.33-.85,2.67-2.61,3.69a13.94,13.94,0,0,1-12.61,0c-1.76-1-2.62-2.36-2.6-3.69Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,259.45a13.92,13.92,0,0,0-12.6,0c-3.49,2-3.49,5.27,0,7.28a13.94,13.94,0,0,0,12.61,0C312.49,264.72,312.49,261.46,309,259.45Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,263v-1.89a3.31,3.31,0,0,1,2-2.73,10.47,10.47,0,0,1,9.46,0,3.33,3.33,0,0,1,1.95,2.73h0V263h0a3.3,3.3,0,0,1-1.95,2.77,10.44,10.44,0,0,1-9.46,0,3.3,3.3,0,0,1-2-2.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.71,
    cy: 261.06,
    rx: 6.68,
    ry: 3.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.17,258.49a9.87,9.87,0,0,0-8.92,0c-2.46,1.42-2.46,3.72,0,5.14a9.81,9.81,0,0,0,8.92,0C309.63,262.21,309.63,259.91,307.17,258.49Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,260.23a9.87,9.87,0,0,1,8.92,0,3.83,3.83,0,0,1,1.66,1.7,3.74,3.74,0,0,1-1.66,1.7,9.81,9.81,0,0,1-8.92,0,3.69,3.69,0,0,1-1.66-1.7A3.78,3.78,0,0,1,298.25,260.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.84,261.28a2.5,2.5,0,0,0-2.26,0,.69.69,0,0,0,0,1.31,2.5,2.5,0,0,0,2.26,0A.69.69,0,0,0,303.84,261.28Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,262.61a.73.73,0,0,0-.7,0,.21.21,0,0,0,0,.4.78.78,0,0,0,.7,0C301.17,262.9,301.17,262.72,301,262.61Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.61,261.62c0,.17.25.31.55.31s.55-.14.55-.31-.25-.31-.55-.31S301.61,261.45,301.61,261.62Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.33,262.71c0,.05.08.1.17.1s.17-.05.17-.1-.07-.1-.17-.1S300.33,262.66,300.33,262.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,247.52v-7H295v7h0a1.22,1.22,0,0,0,.72,1,3.8,3.8,0,0,0,3.43,0A1.2,1.2,0,0,0,299.8,247.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,246.08a1.23,1.23,0,0,0,.72,1,3.8,3.8,0,0,0,3.43,0,1.22,1.22,0,0,0,.7-1v1.46a1.2,1.2,0,0,1-.7,1,3.8,3.8,0,0,1-3.43,0,1.22,1.22,0,0,1-.72-1h0v-1.45Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,246.08a1.23,1.23,0,0,0,.72,1,3.8,3.8,0,0,0,3.43,0,1.22,1.22,0,0,0,.7-1v1.46a1.2,1.2,0,0,1-.7,1,3.8,3.8,0,0,1-3.43,0,1.22,1.22,0,0,1-.72-1h0v-1.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,247.52v-7h4.85v7h0a1.21,1.21,0,0,1-.71,1,3.8,3.8,0,0,1-3.43,0A1.22,1.22,0,0,1,305.6,247.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,246.08a1.22,1.22,0,0,1-.71,1,3.8,3.8,0,0,1-3.43,0,1.23,1.23,0,0,1-.71-1v1.46a1.22,1.22,0,0,0,.71,1,3.8,3.8,0,0,0,3.43,0,1.21,1.21,0,0,0,.71-1h0v-1.45Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,246.08a1.22,1.22,0,0,1-.71,1,3.8,3.8,0,0,1-3.43,0,1.23,1.23,0,0,1-.71-1v1.46a1.22,1.22,0,0,0,.71,1,3.8,3.8,0,0,0,3.43,0,1.21,1.21,0,0,0,.71-1h0v-1.45Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.13,250.59v-7l-4.85,0v7h0a1.22,1.22,0,0,0,.72,1,3.8,3.8,0,0,0,3.43,0A1.17,1.17,0,0,0,305.13,250.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.28,249.15a1.22,1.22,0,0,0,.72,1,3.8,3.8,0,0,0,3.43,0,1.2,1.2,0,0,0,.7-1v1.45a1.17,1.17,0,0,1-.7,1,3.8,3.8,0,0,1-3.43,0,1.22,1.22,0,0,1-.72-1h0v-1.45Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,234.48a3.54,3.54,0,0,1,1.6-2.78,10.51,10.51,0,0,0,1.71-1.69l2.32-2.82a11,11,0,0,1,11.6-3.64,8.83,8.83,0,0,1,1.93.82c1.71,1,2.48,2.3,2.31,3.59l0,8.09c.1,1.24-.67,2.5-2.31,3.46L308,242.75a12.43,12.43,0,0,1-11.24,0c-1.55-.89-2.33-2.05-2.33-3.22S294.47,235.65,294.47,234.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.86 237.15 311.92 238.27 311.92 237.15 313.86 236.03 313.86 237.15",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34,234.89a11,11,0,0,1-11.61,3.64,9.26,9.26,0,0,1-1.93-.82c-2.85-1.63-3.09-4.21-.73-6a10.51,10.51,0,0,0,1.71-1.69l2.32-2.82a11,11,0,0,1,11.6-3.64,8.83,8.83,0,0,1,1.93.82c2.85,1.63,3.1,4.21.73,6a10.4,10.4,0,0,0-1.7,1.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.8,241.81a12.4,12.4,0,0,0,11.24,0l5.61-3.24a4,4,0,0,0,2.32-3.25v1c0,1.18-.77,2.35-2.32,3.26L308,242.75a12.43,12.43,0,0,1-11.24,0c-1.55-.89-2.33-2.05-2.33-3.22v-1C294.47,239.75,295.25,240.92,296.8,241.81Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,227.6v-5.51l-15.9,0v5.51h0c0,1.18.78,2.35,2.34,3.24a12.41,12.41,0,0,0,11.23,0C315.2,230,316,228.78,316,227.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.07,222.14l15.9,0s0,0,0,1.23a4,4,0,0,1-2.32,3.25,12.4,12.4,0,0,1-11.24,0,4,4,0,0,1-2.34-3.23C300.08,222.19,300.07,222.14,300.07,222.14Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,218.89a12.43,12.43,0,0,1,11.24,0c3.11,1.79,3.12,4.69,0,6.49a12.43,12.43,0,0,1-11.24,0C299.3,223.6,299.29,220.69,302.39,218.89Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,218.89a12.43,12.43,0,0,1,11.24,0c3.11,1.79,3.12,4.69,0,6.49a12.43,12.43,0,0,1-11.24,0C299.3,223.6,299.29,220.69,302.39,218.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.46,221.65v-9.87l-6.87,0v9.87h0a1.7,1.7,0,0,0,1,1.4,5.37,5.37,0,0,0,4.86,0A1.71,1.71,0,0,0,311.46,221.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59,211.8l6.87,0v1.45a1.71,1.71,0,0,1-1,1.4,5.37,5.37,0,0,1-4.86,0,1.73,1.73,0,0,1-1-1.4Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.59,210.4a5.37,5.37,0,0,1,4.86,0c1.34.77,1.35,2,0,2.81a5.4,5.4,0,0,1-4.86,0C304.26,212.43,304.25,211.17,305.59,210.4Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.59,210.4a5.37,5.37,0,0,1,4.86,0c1.34.77,1.35,2,0,2.81a5.4,5.4,0,0,1-4.86,0C304.26,212.43,304.25,211.17,305.59,210.4Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,210.79a3.86,3.86,0,0,1,3.5,0,1.06,1.06,0,0,1,0,2,3.83,3.83,0,0,1-3.49,0A1.06,1.06,0,0,1,306.27,210.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.77,212.2a2,2,0,0,1,.39.3,1.8,1.8,0,0,1-.39.29,3.83,3.83,0,0,1-3.49,0,1.8,1.8,0,0,1-.39-.29,1.68,1.68,0,0,1,.38-.3A3.89,3.89,0,0,1,309.77,212.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.8,212.34c0,.13.1.27.28.31s.36,0,.39-.16-.1-.28-.28-.32A.31.31,0,0,0,308.8,212.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.37,212.19a.13.13,0,0,0,.1.16.13.13,0,0,0,.16-.1.14.14,0,0,0-.11-.16A.12.12,0,0,0,308.37,212.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,223.51a1.79,1.79,0,0,0-1.88.16,4.45,4.45,0,0,0-1.12.94c-.09.09-.16.19-.24.28s0,0,0,0a6.26,6.26,0,0,0-1,1.83,4.64,4.64,0,0,0-.25,1.44,1.87,1.87,0,0,0,.73,1.67l.87.5a1.32,1.32,0,0,1-.35-.32,2.23,2.23,0,0,1-.38-1.35,5.76,5.76,0,0,1,2.61-4.51,2.17,2.17,0,0,1,1.36-.34,1.24,1.24,0,0,1,.5.17h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,223.51a1.79,1.79,0,0,0-1.88.16,4.45,4.45,0,0,0-1.12.94c-.09.09-.16.19-.24.28s0,0,0,0a6.26,6.26,0,0,0-1,1.83,4.64,4.64,0,0,0-.25,1.44,1.87,1.87,0,0,0,.73,1.67l.87.5a1.32,1.32,0,0,1-.35-.32,2.23,2.23,0,0,1-.38-1.35,5.76,5.76,0,0,1,2.61-4.51,2.17,2.17,0,0,1,1.36-.34,1.24,1.24,0,0,1,.5.17h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,224a1.24,1.24,0,0,0-.5-.17,2.17,2.17,0,0,0-1.36.34,5.76,5.76,0,0,0-2.61,4.51,2.23,2.23,0,0,0,.38,1.35,1.32,1.32,0,0,0,.35.32l0,0a1.33,1.33,0,0,0,.72.17,2.41,2.41,0,0,0,1.12-.35,5.75,5.75,0,0,0,2.6-4.52A1.84,1.84,0,0,0,318.77,224Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,224a1.24,1.24,0,0,0-.5-.17,2.17,2.17,0,0,0-1.36.34,5.76,5.76,0,0,0-2.61,4.51,2.23,2.23,0,0,0,.38,1.35,1.32,1.32,0,0,0,.35.32l0,0a1.33,1.33,0,0,0,.72.17,2.41,2.41,0,0,0,1.12-.35,5.75,5.75,0,0,0,2.6-4.52A1.84,1.84,0,0,0,318.77,224Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.91,226c.58-.34,1-.07,1,.6a2.32,2.32,0,0,1-1,1.82c-.58.34-1.05.06-1.05-.61A2.3,2.3,0,0,1,316.91,226Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tubes--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "189.51 244.14 211.32 231.55 206.83 228.95 185.02 241.54 189.51 244.14",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.45,221.32h0l.29-.17v.5a.88.88,0,0,1-.17.49l-.12.15v2.12a1.63,1.63,0,0,0-.38-.28,3.54,3.54,0,0,0-3.2,0,1.46,1.46,0,0,0-.4.31v-.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,221.69a3.54,3.54,0,0,0-3.2,0,1.29,1.29,0,0,0-.62.66c-.15-.41.06-.86.62-1.19a3.54,3.54,0,0,1,3.2,0c.56.33.77.78.62,1.19A1.29,1.29,0,0,0,197.2,221.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,218.72a3.54,3.54,0,0,0-3.2,0,1.35,1.35,0,0,0-.62.67c-.15-.42.06-.87.62-1.19a3.54,3.54,0,0,1,3.2,0c.56.32.77.77.62,1.19A1.3,1.3,0,0,0,202.33,218.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.47,215.76a3.56,3.56,0,0,0-3.21,0,1.31,1.31,0,0,0-.62.67c-.14-.42.06-.87.62-1.19a3.56,3.56,0,0,1,3.21,0c.56.32.76.77.62,1.19A1.31,1.31,0,0,0,207.47,215.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,224.65a3.56,3.56,0,0,0-3.21,0,1.31,1.31,0,0,0-.61.66c-.15-.41.05-.86.61-1.18a3.56,3.56,0,0,1,3.21,0c.56.32.77.77.62,1.18A1.33,1.33,0,0,0,192.07,224.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.47,215.24a3.56,3.56,0,0,0-3.21,0,2,2,0,0,0-.38.29v-.81l3-1.7,1,.59v1.93A1.81,1.81,0,0,0,207.47,215.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.68,215.41h0l0,0h0l.29-.17v.49a.88.88,0,0,1-.17.5.75.75,0,0,1-.12.14h0v2.15a1.68,1.68,0,0,0-.38-.3,3.56,3.56,0,0,0-3.21,0,1.54,1.54,0,0,0-.39.3v-.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.52,218.39h0l.35-.2v.49a.82.82,0,0,1-.16.49l-.13.15h0v2.14a1.48,1.48,0,0,0-.38-.3,3.54,3.54,0,0,0-3.2,0,2.22,2.22,0,0,0-.4.31v-.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9,216.75h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.88,216.76l-.1.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.86,216.35v-.81c.46.5.33,1.13-.39,1.55a3.56,3.56,0,0,1-3.21,0c-.73-.42-.86-1.06-.38-1.56v.82Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,233.54a3.48,3.48,0,0,0-3.2,0,1.25,1.25,0,0,0-.62.66c-.15-.42.06-.86.62-1.19a3.54,3.54,0,0,1,3.2,0c.56.33.77.78.62,1.19A1.25,1.25,0,0,0,197.2,233.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,230.57a3.54,3.54,0,0,0-3.2,0,1.31,1.31,0,0,0-.62.67c-.15-.42.06-.87.62-1.19a3.54,3.54,0,0,1,3.2,0c.56.32.77.77.62,1.19A1.27,1.27,0,0,0,202.33,230.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.47,227.61a3.56,3.56,0,0,0-3.21,0,1.31,1.31,0,0,0-.62.67c-.14-.42.06-.87.62-1.19a3.56,3.56,0,0,1,3.21,0c.56.32.76.77.62,1.19A1.31,1.31,0,0,0,207.47,227.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,236.5a3.56,3.56,0,0,0-3.21,0,1.31,1.31,0,0,0-.61.66c-.15-.41.05-.86.61-1.18a3.5,3.5,0,0,1,3.21,0c.56.32.77.77.62,1.18A1.33,1.33,0,0,0,192.07,236.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.47,227.09a3.56,3.56,0,0,0-3.21,0,1.65,1.65,0,0,0-.38.29v-.81l3-1.7,1,.59v1.93A1.54,1.54,0,0,0,207.47,227.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,230.05a3.56,3.56,0,0,0-3.21,0,1.54,1.54,0,0,0-.39.3v-.82l4-2.3v3.12A1.68,1.68,0,0,0,202.34,230.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,233a3.54,3.54,0,0,0-3.2,0,1.84,1.84,0,0,0-.4.31v-.82l4-2.3v3.11A1.48,1.48,0,0,0,197.2,233Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,236a3.48,3.48,0,0,0-3.2,0,1.29,1.29,0,0,0-.4.31v-.83l4-2.29v3.09A1.63,1.63,0,0,0,192.07,236Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.88,213a1,1,0,0,1,.58-.81,3.09,3.09,0,0,1,2.81,0,1,1,0,0,1,.59.81v17.76h0a2,2,0,1,1-4,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,213a1,1,0,0,1,.58-.81,3.09,3.09,0,0,1,2.81,0,1,1,0,0,1,.59.81v17.76h0a2,2,0,1,1-4,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,216.31a.7.7,0,0,1,.41-.57,2.2,2.2,0,0,1,2,0,.7.7,0,0,1,.41.57v14.34h0a1.4,1.4,0,1,1-2.79,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.87,232.05a1.39,1.39,0,0,1-1.39-1.32,1,1,0,0,0,1.9-.27h0v-14.9a1.76,1.76,0,0,1,.47.18.7.7,0,0,1,.41.57v14.34h0A1.4,1.4,0,0,1,205.87,232.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,216.31c0,.44.63.8,1.4.8s1.39-.36,1.39-.8-.62-.8-1.39-.8S204.47,215.87,204.47,216.31Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,216.31c0,.44.63.8,1.4.8s1.39-.36,1.39-.8-.62-.8-1.39-.8S204.47,215.87,204.47,216.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,216.31a.71.71,0,0,1,.41-.57.61.61,0,0,0,.28,1,1.94,1.94,0,0,0,2.05-.27,1.48,1.48,0,0,1-1.34.59C205.1,217.11,204.47,216.75,204.47,216.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.64,231.27c0,.2-.12.3-.25.21a.73.73,0,0,1-.25-.54V212.4a1.34,1.34,0,0,1,.32-.24l.18-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,231.77h0a.2.2,0,0,1-.13-.18V212l.28-.08v19.77A.1.1,0,0,1,205,231.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,214.08a1.33,1.33,0,0,1-.5-.46V213a.76.76,0,0,1,0-.21,1.48,1.48,0,0,1,.47-.41,3.34,3.34,0,0,1,2.8-.09v-.15h0l.07,0a1.34,1.34,0,0,1,.4.32.91.91,0,0,1,.15.27.78.78,0,0,1,0,.22v.78h0v2.3h0v14.68h0a2,2,0,0,1-3.81.8,1.84,1.84,0,0,0,2.1.75h0a1.13,1.13,0,0,0,.8-1.09V214.25A3.33,3.33,0,0,1,204.38,214.08Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,232.7h0a1.71,1.71,0,0,0,1.45-1.83V212.33l0,0a1.13,1.13,0,0,1,.22.28v0a.14.14,0,0,1,0,.06v0a.83.83,0,0,1,0,.15h0s0,.05,0,.08v.78h0v2.3h0v14.68h0A2,2,0,0,1,206.07,232.7Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.59,211.76a1.13,1.13,0,0,1,.67-.93,3.58,3.58,0,0,1,3.22,0,1.15,1.15,0,0,1,.67.93h0v1h0a1.13,1.13,0,0,1-.67.93,3.52,3.52,0,0,1-3.22,0,1.11,1.11,0,0,1-.67-.93h0v-1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.59,211.76a1.13,1.13,0,0,1,.67-.93,3.58,3.58,0,0,1,3.22,0,1.15,1.15,0,0,1,.67.93h0v1h0a1.13,1.13,0,0,1-.67.93,3.52,3.52,0,0,1-3.22,0,1.11,1.11,0,0,1-.67-.93h0v-1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.11,213.58a3.9,3.9,0,0,0,2.58.18c.7-.29,1.05-.6,1.05-1.27V211a1,1,0,0,1,.41.75h0v1h0a1.13,1.13,0,0,1-.67.93,3.52,3.52,0,0,1-3.22,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.87,
    cy: 211.76,
    rx: 2.28,
    ry: 1.32,
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.87,
    cy: 211.76,
    rx: 2.28,
    ry: 1.32,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,211c.72.19,1,.74.64,1.16a2,2,0,0,1-2,.63c-1.07-.14-1.29-.72-1.29-.86Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,212.44a2.63,2.63,0,0,1-2.35,0,.72.72,0,0,1,0-1.36,2.63,2.63,0,0,1,2.35,0A.72.72,0,0,1,207,212.44Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,212.44a2.63,2.63,0,0,1-2.35,0,.72.72,0,0,1,0-1.36,2.63,2.63,0,0,1,2.35,0A.72.72,0,0,1,207,212.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,212.26a.67.67,0,0,1,.14.09l-.14.09a2.63,2.63,0,0,1-2.35,0l-.13-.09a.6.6,0,0,1,.13-.09A2.56,2.56,0,0,1,207,212.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.74,215.93a1,1,0,0,1,.58-.81,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.58.81v17.76h0a2,2,0,0,1-4,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,215.93a1,1,0,0,1,.58-.81,3.11,3.11,0,0,1,2.82,0,1,1,0,0,1,.58.81v17.76h0a2,2,0,0,1-4,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,219.28a.67.67,0,0,1,.41-.57,2.14,2.14,0,0,1,2,0,.67.67,0,0,1,.4.57v14.34h0a1.39,1.39,0,1,1-2.78,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.73,235a1.4,1.4,0,0,1-1.39-1.33,1,1,0,0,0,1.91-.26h0v-14.9a1.76,1.76,0,0,1,.47.18.67.67,0,0,1,.4.57v14.34h0A1.4,1.4,0,0,1,200.73,235Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,219.28c0,.44.62.8,1.39.8s1.39-.36,1.39-.8-.62-.81-1.39-.81S199.34,218.83,199.34,219.28Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,219.28c0,.44.62.8,1.39.8s1.39-.36,1.39-.8-.62-.81-1.39-.81S199.34,218.83,199.34,219.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,219.28a.69.69,0,0,1,.4-.57.61.61,0,0,0,.29,1,1.94,1.94,0,0,0,2-.27,1.48,1.48,0,0,1-1.34.59C200,220.08,199.34,219.72,199.34,219.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.51,234.24c0,.2-.12.29-.26.2a.68.68,0,0,1-.24-.53V215.36a2.09,2.09,0,0,1,.31-.24l.19-.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.89,234.73h0a.2.2,0,0,1-.14-.18V214.94l.29-.08v19.76A.11.11,0,0,1,199.89,234.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.24,217a1.32,1.32,0,0,1-.5-.46v-.65a.52.52,0,0,1,0-.21,1.43,1.43,0,0,1,.46-.4,3.34,3.34,0,0,1,2.8-.09v-.16l0,0,.07,0a1.5,1.5,0,0,1,.4.33,1,1,0,0,1,.14.27.52.52,0,0,1,0,.21v.78h0V219h0v14.68h0a2,2,0,0,1-1.43,1.91,2,2,0,0,1-2.38-1.11,1.84,1.84,0,0,0,2.1.75h0a1.12,1.12,0,0,0,.81-1.08V217.22A3.31,3.31,0,0,1,199.24,217Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.93,235.67h0a1.72,1.72,0,0,0,1.45-1.83V215.3l0,0a.94.94,0,0,1,.22.28h0l0,.06v0a.58.58,0,0,1,0,.14v.87h0V219h0v14.68h0A2,2,0,0,1,200.93,235.67Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.45,214.73a1.13,1.13,0,0,1,.67-.93,3.52,3.52,0,0,1,3.22,0,1.11,1.11,0,0,1,.67.93h0v1h0a1.13,1.13,0,0,1-.67.93,3.58,3.58,0,0,1-3.22,0,1.15,1.15,0,0,1-.67-.93h0v-1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.45,214.73a1.13,1.13,0,0,1,.67-.93,3.52,3.52,0,0,1,3.22,0,1.11,1.11,0,0,1,.67.93h0v1h0a1.13,1.13,0,0,1-.67.93,3.58,3.58,0,0,1-3.22,0,1.15,1.15,0,0,1-.67-.93h0v-1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,216.55a4,4,0,0,0,2.58.18c.7-.3,1-.6,1-1.28V214a1,1,0,0,1,.41.75h0v1h0a1.13,1.13,0,0,1-.67.93,3.58,3.58,0,0,1-3.22,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,215.66a3.58,3.58,0,0,1-3.22,0,1,1,0,0,1,0-1.86,3.52,3.52,0,0,1,3.22,0A1,1,0,0,1,202.34,215.66Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,215.66a3.58,3.58,0,0,1-3.22,0,1,1,0,0,1,0-1.86,3.52,3.52,0,0,1,3.22,0A1,1,0,0,1,202.34,215.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,214c.72.19,1,.73.64,1.16a2,2,0,0,1-2,.62c-1.07-.14-1.29-.71-1.29-.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,215.41a2.61,2.61,0,0,1-2.34,0,.72.72,0,0,1,0-1.36,2.61,2.61,0,0,1,2.34,0A.72.72,0,0,1,201.9,215.41Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,215.41a2.61,2.61,0,0,1-2.34,0,.72.72,0,0,1,0-1.36,2.61,2.61,0,0,1,2.34,0A.72.72,0,0,1,201.9,215.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,215.22l.14.09a.71.71,0,0,1-.14.1,2.61,2.61,0,0,1-2.34,0,.71.71,0,0,1-.14-.1l.14-.09A2.61,2.61,0,0,1,201.9,215.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.61,218.9a1,1,0,0,1,.58-.81,3.09,3.09,0,0,1,2.81,0,1,1,0,0,1,.58.81v17.76h0a2,2,0,1,1-4,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,218.9a1,1,0,0,1,.58-.81,3.09,3.09,0,0,1,2.81,0,1,1,0,0,1,.58.81v17.76h0a2,2,0,1,1-4,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,222.24a.71.71,0,0,1,.41-.57,2.2,2.2,0,0,1,2,0,.71.71,0,0,1,.41.57v14.35h0a1.4,1.4,0,0,1-2.79,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,238a1.39,1.39,0,0,1-1.39-1.32,1,1,0,0,0,1.91-.27h0V221.5a1.75,1.75,0,0,1,.47.17.71.71,0,0,1,.41.57v14.35h0A1.4,1.4,0,0,1,195.59,238Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,222.24c0,.45.63.81,1.39.81s1.4-.36,1.4-.81-.63-.8-1.4-.8S194.2,221.8,194.2,222.24Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,222.24c0,.45.63.81,1.39.81s1.4-.36,1.4-.81-.63-.8-1.4-.8S194.2,221.8,194.2,222.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,222.24a.69.69,0,0,1,.41-.56.61.61,0,0,0,.28,1,2,2,0,0,0,2.05-.27,1.49,1.49,0,0,1-1.35.59C194.83,223.05,194.2,222.69,194.2,222.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,237.21c0,.19-.12.29-.26.2a.7.7,0,0,1-.24-.53V218.33a1.34,1.34,0,0,1,.32-.24l.18-.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75,237.7h0a.22.22,0,0,1-.14-.19v-19.6l.29-.08v19.76A.11.11,0,0,1,194.75,237.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.1,220a1.29,1.29,0,0,1-.49-.46v-.65a.76.76,0,0,1,0-.21,1.41,1.41,0,0,1,.46-.4,3.32,3.32,0,0,1,2.81-.09V218h0l.07,0a1.5,1.5,0,0,1,.4.33.76.76,0,0,1,.15.26.83.83,0,0,1,0,.22v.78h0V222h0v14.68h0a2,2,0,0,1-3.81.8,1.83,1.83,0,0,0,2.1.75h0a1.13,1.13,0,0,0,.81-1.09V220.19A3.36,3.36,0,0,1,194.1,220Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,238.64h0a1.72,1.72,0,0,0,1.45-1.84V218.26l0,0a1.18,1.18,0,0,1,.23.28h0l0,.06v0a.83.83,0,0,1,0,.15v.87h0V222h0v14.68h0A2,2,0,0,1,195.8,238.64Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,217.69a1.14,1.14,0,0,1,.66-.93,3.6,3.6,0,0,1,3.23,0,1.14,1.14,0,0,1,.66.93h0v1h0a1.13,1.13,0,0,1-.66.93,3.6,3.6,0,0,1-3.23,0,1.13,1.13,0,0,1-.66-.93h0v-1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,217.69a1.14,1.14,0,0,1,.66-.93,3.6,3.6,0,0,1,3.23,0,1.14,1.14,0,0,1,.66.93h0v1h0a1.13,1.13,0,0,1-.66.93,3.6,3.6,0,0,1-3.23,0,1.13,1.13,0,0,1-.66-.93h0v-1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.84,219.51a3.87,3.87,0,0,0,2.57.19c.71-.3,1.06-.6,1.06-1.28V217a1,1,0,0,1,.4.74h0v1h0a1.13,1.13,0,0,1-.66.93,3.6,3.6,0,0,1-3.23,0A.71.71,0,0,1,193.84,219.51Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.21,218.62a3.54,3.54,0,0,1-3.23,0,1,1,0,0,1,0-1.86,3.6,3.6,0,0,1,3.23,0A1,1,0,0,1,197.21,218.62Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.21,218.62a3.54,3.54,0,0,1-3.23,0,1,1,0,0,1,0-1.86,3.6,3.6,0,0,1,3.23,0A1,1,0,0,1,197.21,218.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.59,216.93c.72.19.95.73.64,1.15a1.94,1.94,0,0,1-2,.63c-1.07-.14-1.29-.71-1.29-.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.77,218.37a2.56,2.56,0,0,1-2.35,0,.71.71,0,0,1,0-1.35,2.56,2.56,0,0,1,2.35,0A.71.71,0,0,1,196.77,218.37Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.77,218.37a2.56,2.56,0,0,1-2.35,0,.71.71,0,0,1,0-1.35,2.56,2.56,0,0,1,2.35,0A.71.71,0,0,1,196.77,218.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.77,218.19l.14.09-.14.09a2.56,2.56,0,0,1-2.35,0l-.14-.09.14-.09A2.63,2.63,0,0,1,196.77,218.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--test-tube--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.47,221.87a1,1,0,0,1,.58-.81,3.09,3.09,0,0,1,2.81,0,1,1,0,0,1,.59.81v17.76h0a2,2,0,1,1-4,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,221.87a1,1,0,0,1,.58-.81,3.09,3.09,0,0,1,2.81,0,1,1,0,0,1,.59.81v17.76h0a2,2,0,1,1-4,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.07,225.21a.69.69,0,0,1,.4-.57,2.2,2.2,0,0,1,2,0,.68.68,0,0,1,.41.57v14.35h0a1.39,1.39,0,1,1-2.78,0h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,241a1.39,1.39,0,0,1-1.39-1.32,1,1,0,0,0,1.9-.27h0v-14.9a1.64,1.64,0,0,1,.47.18.68.68,0,0,1,.41.57v14.35h0A1.39,1.39,0,0,1,190.46,241Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.07,225.21c0,.44.62.8,1.39.8s1.39-.36,1.39-.8-.62-.8-1.39-.8S189.07,224.77,189.07,225.21Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.07,225.21c0,.44.62.8,1.39.8s1.39-.36,1.39-.8-.62-.8-1.39-.8S189.07,224.77,189.07,225.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.07,225.21a.7.7,0,0,1,.4-.57.61.61,0,0,0,.29,1.05,1.91,1.91,0,0,0,2-.27,1.48,1.48,0,0,1-1.34.59C189.69,226,189.07,225.65,189.07,225.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,240.17c0,.2-.11.3-.25.21a.7.7,0,0,1-.24-.54V221.3a1.11,1.11,0,0,1,.31-.24l.18-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.62,240.67h0a.19.19,0,0,1-.14-.18V220.87l.28-.07v19.76A.1.1,0,0,1,189.62,240.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,223a1.33,1.33,0,0,1-.5-.46v-.65a.76.76,0,0,1,0-.21,1.48,1.48,0,0,1,.47-.41,3.34,3.34,0,0,1,2.8-.09V221h0l.07,0a1.22,1.22,0,0,1,.4.33.76.76,0,0,1,.15.26.57.57,0,0,1,0,.22v.78h0V225h0v14.68h0a2,2,0,0,1-3.81.8,1.84,1.84,0,0,0,2.1.75h0a1.13,1.13,0,0,0,.8-1.09V223.16A3.38,3.38,0,0,1,189,223Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,241.61h0a1.73,1.73,0,0,0,1.45-1.84V221.23l0,0a1.35,1.35,0,0,1,.22.28v0l0,.06v0a.83.83,0,0,1,0,.15h0a.22.22,0,0,1,0,.08v.78h0V225h0v14.68h0A2,2,0,0,1,190.66,241.61Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,220.66a1.14,1.14,0,0,1,.67-.93,3.58,3.58,0,0,1,3.22,0,1.16,1.16,0,0,1,.67.93h0v1h0a1.16,1.16,0,0,1-.67.93,3.58,3.58,0,0,1-3.22,0,1.14,1.14,0,0,1-.67-.93h0v-1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,220.66a1.14,1.14,0,0,1,.67-.93,3.58,3.58,0,0,1,3.22,0,1.16,1.16,0,0,1,.67.93h0v1h0a1.16,1.16,0,0,1-.67.93,3.58,3.58,0,0,1-3.22,0,1.14,1.14,0,0,1-.67-.93h0v-1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,222.48a3.9,3.9,0,0,0,2.58.18c.7-.29,1.05-.59,1.05-1.27v-1.48a1,1,0,0,1,.41.75h0v1h0a1.16,1.16,0,0,1-.67.93,3.58,3.58,0,0,1-3.22,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,221.59a3.52,3.52,0,0,1-3.22,0,1,1,0,0,1,0-1.86,3.58,3.58,0,0,1,3.22,0A1,1,0,0,1,192.07,221.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,221.59a3.52,3.52,0,0,1-3.22,0,1,1,0,0,1,0-1.86,3.58,3.58,0,0,1,3.22,0A1,1,0,0,1,192.07,221.59Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.45,219.9c.72.18,1,.73.64,1.15a1.94,1.94,0,0,1-2,.63c-1.07-.14-1.3-.72-1.3-.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.63,221.34a2.63,2.63,0,0,1-2.35,0,.72.72,0,0,1,0-1.36,2.63,2.63,0,0,1,2.35,0A.72.72,0,0,1,191.63,221.34Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.63,221.34a2.63,2.63,0,0,1-2.35,0,.72.72,0,0,1,0-1.36,2.63,2.63,0,0,1,2.35,0A.72.72,0,0,1,191.63,221.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.63,221.16l.14.09-.14.09a2.63,2.63,0,0,1-2.35,0l-.13-.09.13-.09A2.56,2.56,0,0,1,191.63,221.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "189.51 228.2 211.32 215.61 211.32 216.13 189.51 228.72 185.02 226.13 185.02 225.61 189.51 228.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.51 228.72 189.51 228.2 211.32 215.61 211.32 216.13 189.51 228.72",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,225.61l4.49,2.59,21.81-12.59-3.46-2h0v1.94c.46.49.33,1.12-.39,1.54a3.56,3.56,0,0,1-3.21,0c-.73-.42-.86-1.06-.38-1.56v-.81l-.87.5v.49a.88.88,0,0,1-.17.5.75.75,0,0,1-.12.14v2.15c.47.5.34,1.13-.38,1.55a3.56,3.56,0,0,1-3.21,0c-.73-.42-.86-1.05-.39-1.55v-.82l-.87.51v.49a.82.82,0,0,1-.16.49l-.13.15v2.14c.48.49.36,1.13-.38,1.56a3.54,3.54,0,0,1-3.2,0c-.73-.42-.86-1.05-.4-1.55v-.82l-.86.5v.5a.88.88,0,0,1-.17.49l-.12.15v2.12c.48.5.36,1.14-.38,1.57a3.54,3.54,0,0,1-3.2,0c-.73-.42-.86-1-.4-1.54v-.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.51 240.05 211.32 227.46 211.32 227.98 189.51 240.57 185.02 237.98 185.02 237.46 189.51 240.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.32 227.46 189.51 240.05 189.51 240.57 211.32 227.98 211.32 227.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.86,228.2v-.81c.46.5.33,1.13-.39,1.55a3.56,3.56,0,0,1-3.21,0c-.73-.42-.86-1.06-.38-1.56v.82Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,235.46v.83c-.46.49-.33,1.12.4,1.54a3.54,3.54,0,0,0,3.2,0c.74-.43.86-1.07.38-1.57v-3.09l1.15-.67v.82c-.46.49-.33,1.13.4,1.54a3.48,3.48,0,0,0,3.2,0c.74-.42.86-1.06.38-1.55V230.2l1.16-.67v.82c-.47.5-.34,1.13.39,1.55a3.56,3.56,0,0,0,3.21,0c.72-.42.85-1.05.38-1.55v-3.12l1.16-.66v.81c-.48.5-.35,1.14.38,1.56a3.56,3.56,0,0,0,3.21,0c.72-.42.85-1.05.39-1.55v-1.93h0l3.46,2-21.81,12.59L185,237.46Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Distiller--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M275.47,250a15.19,15.19,0,0,0,13.77,0c3.8-2.19,3.8-5.75,0-7.94a15.19,15.19,0,0,0-13.77,0C271.67,244.28,271.67,247.84,275.47,250Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M261.74,247,242.3,235.72c-.24-.13-.24-.36,0-.5l15.38-8.88a1,1,0,0,1,.87,0L278,237.57a.26.26,0,0,1,0,.5L262.61,247A1,1,0,0,1,261.74,247Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M238.28,233l-19.45-11.23a.26.26,0,0,1,0-.5l15.38-8.88a1,1,0,0,1,.87,0l19.44,11.23a.26.26,0,0,1,0,.5L239.14,233A.93.93,0,0,1,238.28,233Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--distiller--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "238.71 211.63 238.71 231.61 237.8 231.09 237.29 210.81 238.71 211.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.71 211.63 238.71 231.61 239.61 231.09 240.13 210.81 238.71 211.63",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.97 201.38 220.97 221.36 220.06 220.84 219.55 200.56 220.97 201.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.97 201.38 220.97 221.36 221.87 220.84 222.39 200.56 220.97 201.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.59 203.74 252.59 223.72 251.68 223.2 251.17 202.91 252.59 203.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.59 203.74 252.59 223.72 253.49 223.2 254.01 202.91 252.59 203.74",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.52,200.58l-19.44-11.22a1,1,0,0,0-.87,0l-15.38,8.88a1,1,0,0,0-.43.75v.53a1,1,0,0,0,.43.75l19.45,11.23a.93.93,0,0,0,.86,0l15.38-8.88a1,1,0,0,0,.44-.75v-.54A1,1,0,0,0,254.52,200.58Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.52,200.58l-19.44-11.22a1,1,0,0,0-.87,0l-15.38,8.88a1,1,0,0,0-.43.75v.53a1,1,0,0,0,.43.75l19.45,11.23a.93.93,0,0,0,.86,0l15.38-8.88a1,1,0,0,0,.44-.75v-.54A1,1,0,0,0,254.52,200.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,210l-19.45-11.22a.26.26,0,0,1,0-.5l15.38-8.88a1,1,0,0,1,.87,0l19.44,11.22a.26.26,0,0,1,0,.5L239.14,210A.93.93,0,0,1,238.28,210Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,210l-19.45-11.22a.26.26,0,0,1,0-.5l15.38-8.88a1,1,0,0,1,.87,0l19.44,11.22a.26.26,0,0,1,0,.5L239.14,210A.93.93,0,0,1,238.28,210Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.41,198.06a2.23,2.23,0,0,0-.43-1.3L238.32,187v-8.46l-5,0V187l-6.66,9.75a2.29,2.29,0,0,0-.42,1.3v.06h0v.15a2.07,2.07,0,0,0,0,.35,5.09,5.09,0,0,0,2.77,3.42,15,15,0,0,0,13.54,0c1.88-1.09,2.81-2.51,2.8-3.93Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41,198.06a2.23,2.23,0,0,0-.43-1.3L238.32,187v-8.46l-5,0V187l-6.66,9.75a2.29,2.29,0,0,0-.42,1.3v.06h0v.15a2.07,2.07,0,0,0,0,.35,5.09,5.09,0,0,0,2.77,3.42,15,15,0,0,0,13.54,0c1.88-1.09,2.81-2.51,2.8-3.93Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,197.59l-1.73-2.53-2.47-3.66h-8.44l-2.47,3.67-1.74,2.53a1.31,1.31,0,0,0-.08.43,1.18,1.18,0,0,0,0,.37v0a4.37,4.37,0,0,0,2.44,2.73,14.17,14.17,0,0,0,12,0,4.36,4.36,0,0,0,2.43-2.72h0a1.83,1.83,0,0,0,0-.4h0A1.51,1.51,0,0,0,244.26,197.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,197.59l-1.73-2.53-2.47-3.66h-8.44l-2.47,3.67-1.74,2.53a1.31,1.31,0,0,0-.08.43,1.18,1.18,0,0,0,0,.37v0a4.37,4.37,0,0,0,2.44,2.73,14.17,14.17,0,0,0,12,0,4.36,4.36,0,0,0,2.43-2.72h0a1.83,1.83,0,0,0,0-.4h0A1.51,1.51,0,0,0,244.26,197.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.65 179.31 238 179.19 237.97 187.22 242.11 193.69 237.65 187.32 237.65 179.31",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.32,180.09s-.5.45-2.48.45-2.48-.44-2.48-.44v-1.53l5,0Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.32,179.33a5.39,5.39,0,0,1-2.48.45,5.5,5.5,0,0,1-2.48-.44v-.77l5,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.25,190.18a9.3,9.3,0,0,0-4.52.42c-1.68.69-1.68,1.82,0,2.51a9.36,9.36,0,0,0,6.18,0c1.73-.69,1.73-1.82,0-2.51a6.84,6.84,0,0,0-1.66-.42",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.25,190.18a9.3,9.3,0,0,0-4.52.42c-1.68.69-1.68,1.82,0,2.51a9.36,9.36,0,0,0,6.18,0c1.73-.69,1.73-1.82,0-2.51a6.84,6.84,0,0,0-1.66-.42",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,176.94a6.59,6.59,0,0,0-4.34,0c-1.18.49-1.18,1.28,0,1.77a6.59,6.59,0,0,0,4.34,0C239.21,178.22,239.21,177.43,238,176.94Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,176.94a6.59,6.59,0,0,0-4.34,0c-1.18.49-1.18,1.28,0,1.77a6.59,6.59,0,0,0,4.34,0C239.21,178.22,239.21,177.43,238,176.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.11,177.87c.21.16.92.53,2.72.32,1.59-.18,1.37-1,.1-1.08A6.21,6.21,0,0,0,234.11,177.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,177.18a6.06,6.06,0,0,0-2.81,0c-.76.22-.76.58,0,.81a6.06,6.06,0,0,0,2.81,0C238,177.76,238,177.4,237.23,177.18Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,177.18a6.06,6.06,0,0,0-2.81,0c-.76.22-.76.58,0,.81a6.06,6.06,0,0,0,2.81,0C238,177.76,238,177.4,237.23,177.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.45,192.85c-2.13,1-5.54.42-6.48-.48s.38-1.84,1.39-2.19a6.37,6.37,0,0,0-1.63.42c-1.68.69-1.68,1.82,0,2.51a9.36,9.36,0,0,0,6.18,0A4.54,4.54,0,0,0,239.45,192.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,178.71a1.69,1.69,0,0,0,.8-.55c-1.06.83-3.65.71-4.73.35s-1.12-1.09-.69-1.43c-.88.49-.79,1.18.28,1.63A6.59,6.59,0,0,0,238,178.71Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,177.18a5.81,5.81,0,0,0-1.39-.17v1.14a5.36,5.36,0,0,0,1.39-.16C238,177.76,238,177.4,237.23,177.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,176.94a6.82,6.82,0,0,0-3.5-.24A7.83,7.83,0,0,1,238,177c1,.52.95,1,.69,1.28C239.14,177.86,238.93,177.31,238,176.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,187.85V179a5.13,5.13,0,0,1-1.09-.23v8.53l-6.73,9.82a2.52,2.52,0,0,0,.24,2.34,5.79,5.79,0,0,0,1.93,1.84,10.54,10.54,0,0,0,4,1.44s-2.76-1.44-3.31-2.53a3.67,3.67,0,0,1,.55-3.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "262.18 240.47 262.18 245.16 259.59 243.67 258.11 238.12 262.18 240.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.18 240.47 262.18 245.16 264.76 243.67 266.24 238.12 262.18 240.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.11 231.77 247.11 236.46 244.53 234.97 243.05 229.43 247.11 231.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.11 231.77 247.11 236.46 249.7 234.97 251.18 229.43 247.11 231.77",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.96 233.66 273.96 238.35 271.38 236.86 269.9 231.32 273.96 233.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.96 233.66 273.96 238.35 276.55 236.86 278.02 231.32 273.96 233.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,230.84l-19.44-11.23a1,1,0,0,0-.87,0l-15.38,8.88a1,1,0,0,0-.43.75v.54a1,1,0,0,0,.43.75l19.44,11.22a1,1,0,0,0,.87,0L278,232.87a1,1,0,0,0,.43-.75v-.53A1,1,0,0,0,278,230.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,240.22,242.3,229c-.24-.13-.24-.36,0-.5l15.38-8.88a1,1,0,0,1,.87,0L278,230.84a.26.26,0,0,1,0,.5l-15.38,8.88A1,1,0,0,1,261.74,240.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,152.21l9.87,5.69.65-1.13-9.87-5.69h0a.33.33,0,0,0-.33,0,1,1,0,0,0-.46.8A.31.31,0,0,0,257.71,152.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.36,157.07a1,1,0,0,1-.46.8c-.25.15-.46,0-.46-.27a1,1,0,0,1,.46-.8C268.16,156.65,268.36,156.77,268.36,157.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,234.11V154.49h-1.31v79.63h0a.33.33,0,0,0,.2.26,1,1,0,0,0,.92,0A.31.31,0,0,0,268.5,234.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,154.23a1,1,0,0,1,.93,0,.28.28,0,0,1,0,.54,1,1,0,0,1-.92,0C267.13,154.61,267.13,154.37,267.38,154.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.9,166.71l9.87,5.69.65-1.14-9.87-5.69h0a.34.34,0,0,0-.33,0,1,1,0,0,0-.46.8A.31.31,0,0,0,267.9,166.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.55,171.56a1,1,0,0,1-.46.8c-.25.15-.46,0-.46-.26a1,1,0,0,1,.46-.8C278.35,171.15,278.55,171.27,278.55,171.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.11,245.14h0v-16.4H273.88v16.4h0c0,1.28.84,2.56,2.52,3.53a13.49,13.49,0,0,0,12.19,0C290.28,247.7,291.12,246.42,291.11,245.14Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.11,245.14h0v-16.4H273.88v16.4h0c0,1.28.84,2.56,2.52,3.53a13.49,13.49,0,0,0,12.19,0C290.28,247.7,291.12,246.42,291.11,245.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,236v9.08h0a3.73,3.73,0,0,0,2.19,3.06,11.69,11.69,0,0,0,10.59,0,3.74,3.74,0,0,0,2.2-3.06V236Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.2,239.08c-2.92-1.68-2.92-4.42,0-6.11a11.69,11.69,0,0,1,10.59,0c2.93,1.69,2.93,4.43,0,6.11A11.69,11.69,0,0,1,277.2,239.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.7 230.33 290.7 245.27 290.29 246.2 290.29 230.79 290.7 230.33",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.64,230.65v14.09c0,1.69,2.29,4.62,7.85,4.72a13.72,13.72,0,0,1-4-1.52,4,4,0,0,1-2-3.45V231.6Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,226.3a6.36,6.36,0,0,0-2.14-1.88,15,15,0,0,0-13.56,0,6.36,6.36,0,0,0-2.14,1.88h-.67v1.95h0c0,1.45.89,2.9,2.8,4a15,15,0,0,0,13.56,0c1.91-1.1,2.84-2.55,2.8-4h0V226.3Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.42,226.3a6.36,6.36,0,0,0-2.14-1.88,15,15,0,0,0-13.56,0,6.36,6.36,0,0,0-2.14,1.88h-.67v1.95h0c0,1.45.89,2.9,2.8,4a15,15,0,0,0,13.56,0c1.91-1.1,2.84-2.55,2.8-4h0V226.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.28,232.25c.25-.15.49-.3.71-.46a19.48,19.48,0,0,1-6,1.67,14.9,14.9,0,0,1-8.64-2.2,4.84,4.84,0,0,1-2.13-3.53V226.3h-.32v1.95h0c0,1.45.89,2.9,2.8,4A15,15,0,0,0,289.28,232.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.5,
    cy: 226.3,
    rx: 9.59,
    ry: 5.54,
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.5,
    cy: 226.3,
    rx: 9.59,
    ry: 5.54,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.41,229.82c-3.37-1.95-3.37-5.09,0-7a13.47,13.47,0,0,1,12.18,0c3.37,1.95,3.37,5.1,0,7A13.47,13.47,0,0,1,276.41,229.82Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.41,229.82c-3.37-1.95-3.37-5.09,0-7a13.47,13.47,0,0,1,12.18,0c3.37,1.95,3.37,5.1,0,7A13.47,13.47,0,0,1,276.41,229.82Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.56,223.89A13.56,13.56,0,0,0,276.4,225a5.06,5.06,0,0,0-2.29,2.4c-.65-1.61.12-3.38,2.29-4.63-1.08.71-1.34,2-.56,1.84S280.65,222.17,285.56,223.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.59,225a13.41,13.41,0,0,0-12.18,0,5,5,0,0,0-2.3,2.4,5.08,5.08,0,0,0,2.3,2.4,13.47,13.47,0,0,0,12.18,0,5.08,5.08,0,0,0,2.3-2.4A5,5,0,0,0,288.59,225Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,227.42a2.3,2.3,0,0,1-.15.32,5.37,5.37,0,0,0-2.14-2.05,13.43,13.43,0,0,0-12.19,0,5.37,5.37,0,0,0-2.14,2.05,2.3,2.3,0,0,1-.15-.32,5.06,5.06,0,0,1,2.29-2.4,13.49,13.49,0,0,1,12.19,0A5.06,5.06,0,0,1,290.88,227.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.59,229.82a11.78,11.78,0,0,1-5.19,1.51,14,14,0,0,1-5.4-.66,8.92,8.92,0,0,1-2.42-1.28,4.57,4.57,0,0,1-1.64-2.18,3.22,3.22,0,0,1-.09-1.38,3.36,3.36,0,0,1,.51-1.27,5.76,5.76,0,0,1,2.05-1.78,5.52,5.52,0,0,0-1.94,1.84,3.3,3.3,0,0,0-.48,1.24,3.18,3.18,0,0,0,.11,1.3,4.31,4.31,0,0,0,1.61,2.06,8.79,8.79,0,0,0,2.38,1.22,13.78,13.78,0,0,0,5.3.72A12.72,12.72,0,0,0,288.59,229.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,198l-19.44-11.23a1,1,0,0,0-.87,0l-15.38,8.88a1,1,0,0,0-.43.75v.54a1,1,0,0,0,.43.75l19.44,11.22a1,1,0,0,0,.87,0L278,200a1,1,0,0,0,.43-.75v-.53A.93.93,0,0,0,278,198Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,207.38,242.3,196.15a.26.26,0,0,1,0-.5l15.38-8.88a1,1,0,0,1,.87,0L278,198c.24.13.24.36,0,.5l-15.38,8.88A1,1,0,0,1,261.74,207.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M252.93,193.06c-3.51,2-3.51,5.31,0,7.34a14.07,14.07,0,0,0,12.7,0c3.51-2,3.51-5.31,0-7.34A14.07,14.07,0,0,0,252.93,193.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.84,194.13a9.85,9.85,0,0,1,8.88,0c2.46,1.42,2.46,3.72,0,5.13a9.79,9.79,0,0,1-8.88,0C252.38,197.85,252.38,195.55,254.84,194.13Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.84,194.13a9.85,9.85,0,0,1,8.88,0c2.46,1.42,2.46,3.72,0,5.13a9.79,9.79,0,0,1-8.88,0C252.38,197.85,252.38,195.55,254.84,194.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262,180.57V171.8h-5.48v8.76a9.68,9.68,0,1,0,5.48,0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,180.57V171.8h-5.48v8.76a9.68,9.68,0,1,0,5.48,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.49 180.65 261.67 172.5 261.27 172.63 261.27 180.65 261.49 180.65",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,173.49s-.55.5-2.74.5-2.74-.49-2.74-.49v-1.69H262Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,172.58a5.92,5.92,0,0,1-2.74.5,6,6,0,0,1-2.74-.49v-.78H262Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,170a7.28,7.28,0,0,0-4.79,0c-1.31.54-1.31,1.41,0,1.95a7.28,7.28,0,0,0,4.79,0C263,171.43,263,170.56,261.66,170Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,170a7.28,7.28,0,0,0-4.79,0c-1.31.54-1.31,1.41,0,1.95a7.28,7.28,0,0,0,4.79,0C263,171.43,263,170.56,261.66,170Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.37,171c.24.18,1,.58,3,.35,1.75-.2,1.51-1.08.1-1.19A6.84,6.84,0,0,0,257.37,171Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.82,170.28a6.76,6.76,0,0,0-3.1,0c-.85.25-.85.65,0,.89a6.5,6.5,0,0,0,3.1,0C261.69,170.93,261.69,170.53,260.82,170.28Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.82,170.28a6.76,6.76,0,0,0-3.1,0c-.85.25-.85.65,0,.89a6.5,6.5,0,0,0,3.1,0C261.69,170.93,261.69,170.53,260.82,170.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,172a1.92,1.92,0,0,0,.88-.61c-1.17.92-4,.79-5.23.38s-1.23-1.2-.76-1.57c-1,.54-.87,1.31.32,1.8A7.28,7.28,0,0,0,261.66,172Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.82,170.28a6,6,0,0,0-1.54-.18v1.25a6,6,0,0,0,1.54-.18C261.69,170.93,261.69,170.53,260.82,170.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,170a7.35,7.35,0,0,0-3.86-.27,8.51,8.51,0,0,1,3.82.38c1.11.57,1.05,1.07.76,1.41C262.93,171,262.69,170.43,261.66,170Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,189.86a8.55,8.55,0,1,1-16.4-3.39,4.85,4.85,0,0,1,2.14-2.19,12.63,12.63,0,0,1,11.42,0,4.9,4.9,0,0,1,2.14,2.19A8.49,8.49,0,0,1,267.83,189.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,189.86a8.55,8.55,0,1,1-16.4-3.39,4.85,4.85,0,0,1,2.14-2.19,12.63,12.63,0,0,1,11.42,0,4.9,4.9,0,0,1,2.14,2.19A8.49,8.49,0,0,1,267.83,189.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,189.86a8.5,8.5,0,0,0-.69-3.35c-.67,1.15-2.66,4.64-2.66,4.64,0,3.11-2.24,7.25-5.2,7.25A8.54,8.54,0,0,0,267.83,189.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,190.88a12.63,12.63,0,0,1-11.42,0c-2.07-1.2-2.78-2.88-2.14-4.41a4.85,4.85,0,0,1,2.14-2.19,12.63,12.63,0,0,1,11.42,0,4.9,4.9,0,0,1,2.14,2.19C267.77,188,267.06,189.68,265,190.88Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,189.42c-2-2.06-.42-5,1-5.66a7.81,7.81,0,0,0-1.09.52,4.85,4.85,0,0,0-2.14,2.19c-.64,1.53.07,3.21,2.14,4.41a12.83,12.83,0,0,0,9.85.7C259.91,192.11,255.67,191.46,253.67,189.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.22,181.83v-9.46a6.7,6.7,0,0,1-1.85-.23V181a9,9,0,0,0-7.21,8.67c0,4.76,3.08,9.2,9.12,9.2A9,9,0,0,1,259.22,181.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263,164.62l-7.26-4.19a1,1,0,0,0-.86,0l-3.2,1.85a1,1,0,0,0-.43.75v1.85a1,1,0,0,0,.43.75l3.93,2.26a3,3,0,0,1,1.5,2.6v.24c0,.16.21.32.64.44a6.5,6.5,0,0,0,3.1,0c.44-.12.66-.29.65-.45v-.15A3,3,0,0,1,263,168h0a1,1,0,0,0,.43-.75v-1.85A1,1,0,0,0,263,164.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,162.83l7.09,4.09a.91.91,0,0,0,.85,0l3.12-1.8c.23-.13.23-.35,0-.49l-7.09-4.09a.91.91,0,0,0-.85,0l-3.12,1.8A.26.26,0,0,0,251.78,162.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,201.82V154.49h-1.31v47.33h0a.33.33,0,0,0,.2.27,1,1,0,0,0,.92,0A.33.33,0,0,0,268.5,201.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.41,227.21l-.29.74a.67.67,0,0,1-1.26,0l-.29-.74a6.49,6.49,0,0,1-.45-2.38V221h2.74v3.81A6.7,6.7,0,0,1,283.41,227.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,227.33a4.68,4.68,0,0,0,.12-1.48V221h-.24v4.88A4.11,4.11,0,0,0,282.61,227.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.51,221H283v6h0a4.76,4.76,0,0,0,.5-2.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,221v.74a1.49,1.49,0,0,1-.87,1.22,4.7,4.7,0,0,1-4.23,0,2,2,0,0,1-.65-.57,1.15,1.15,0,0,1-.22-.65V221a.75.75,0,0,1,0-.2,1.6,1.6,0,0,1,.84-1l.05,0a4.69,4.69,0,0,1,4.18,0,1.62,1.62,0,0,1,.85,1A1.49,1.49,0,0,1,285.47,221Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.73,222.75v-1.1c0-.44.11-1.1-.65-1.1a2.1,2.1,0,0,1-1.66-.77l-.05,0a1.6,1.6,0,0,0-.84,1,.75.75,0,0,0,0,.2v.75a1.15,1.15,0,0,0,.22.65,2,2,0,0,0,.65.57,4.7,4.7,0,0,0,4.23,0C283.77,223.32,282.73,223.16,282.73,222.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38,222.24a1.28,1.28,0,0,1,0-2.43,4.62,4.62,0,0,1,4.22,0,1.28,1.28,0,0,1,0,2.43A4.68,4.68,0,0,1,280.38,222.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,218.75v1.86a1.49,1.49,0,0,1,0,.21,1.62,1.62,0,0,1-.85,1,4.09,4.09,0,0,1-1.87.49,4.48,4.48,0,0,1-2.36-.49,2,2,0,0,1-.65-.57,1,1,0,0,1-.19-.45.64.64,0,0,1,0-.2v-1.88a1.49,1.49,0,0,1,.87-1.22l.16-.08a4.72,4.72,0,0,1,4.07.08A1.49,1.49,0,0,1,285.47,218.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.72,221.27a2,2,0,0,0,.65.57,4.48,4.48,0,0,0,2.36.49v-.68c0-.44.13-1-.65-1.1a3.07,3.07,0,0,1-2.06-1.1,1.51,1.51,0,0,1,.51-2l-.16.08a1.49,1.49,0,0,0-.87,1.22v1.88a.64.64,0,0,0,0,.2A1,1,0,0,0,279.72,221.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.63,161.36v0a2.61,2.61,0,0,0,1,2.1l9.6,5.55c1.34.77,2.43,3.07,2.43,5.13v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v0a2.61,2.61,0,0,0,1,2.1l9.6,5.55c1.34.77,2.43,3.07,2.43,5.13v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v0a2.61,2.61,0,0,0,1,2.1l9.6,5.55c1.34.77,2.43,3.07,2.43,5.13v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v.05a2.64,2.64,0,0,0,1,2.11l9.6,5.54c1.34.77,2.43,3.07,2.43,5.13v0c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v.05a2.64,2.64,0,0,0,1,2.11l9.6,5.54c1.34.77,2.43,3.07,2.43,5.13s-1.09,3.1-2.43,2.33l-5-2.91c-.55-.31-1,.12-1,1v1.58a.36.36,0,0,1-.21.29,1.12,1.12,0,0,1-1,0,.36.36,0,0,1-.21-.29v-2.4c0-2.06,1.09-3.11,2.43-2.34l5,2.91c.55.32,1-.11,1-1a2.61,2.61,0,0,0-1-2.1l-9.6-5.54c-1.33-.78-2.42-3.08-2.42-5.14v0c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-.95v-.06a2.61,2.61,0,0,0-1-2.1l-9.6-5.55c-1.33-.77-2.42-3.07-2.42-5.13v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-.95v-.06a2.61,2.61,0,0,0-1-2.1l-9.6-5.55c-1.33-.77-2.42-3.07-2.42-5.13v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-.95V184a2.61,2.61,0,0,0-1-2.1l-9.6-5.55c-1.33-.77-2.42-3.07-2.42-5.13v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-1v0a2.61,2.61,0,0,0-1-2.1l-9.6-5.55c-1.33-.77-2.42-3.07-2.42-5.13v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-1v-.05a2.61,2.61,0,0,0-1-2.1l-28.05-16.21c-.55-.31-1,.12-1,1v19.15a.35.35,0,0,1-.2.29,1.12,1.12,0,0,1-1,0,.36.36,0,0,1-.21-.29v-20c0-2.06,1.08-3.11,2.42-2.34l28.05,16.21c1.34.77,2.43,3.07,2.43,5.13v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54C279.07,160.08,278.63,160.51,278.63,161.36Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.46,161V161a3,3,0,0,0,.32,1.31,2.22,2.22,0,0,0,.84,1.2l9.6,5.55a4.75,4.75,0,0,1,1.77,2.21,7.27,7.27,0,0,1,.49,2.51v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v0a3,3,0,0,0,.32,1.31,2.22,2.22,0,0,0,.84,1.2l9.6,5.55A4.75,4.75,0,0,1,291,181.9a7.27,7.27,0,0,1,.49,2.51v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v0a3,3,0,0,0,.32,1.31,2.22,2.22,0,0,0,.84,1.2l9.6,5.55a4.75,4.75,0,0,1,1.77,2.21,7.27,7.27,0,0,1,.49,2.51v.05c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v0a3,3,0,0,0,.32,1.31,2.29,2.29,0,0,0,.84,1.21l9.6,5.54a4.75,4.75,0,0,1,1.77,2.21,7.27,7.27,0,0,1,.49,2.51v.05c0,2.06-1.09,3.11-2.43,2.33l-9.6-5.54c-.55-.32-1,.11-1,1v.05a3,3,0,0,0,.32,1.31,2.29,2.29,0,0,0,.84,1.21l9.6,5.54a4.75,4.75,0,0,1,1.77,2.21,7.27,7.27,0,0,1,.49,2.51c0,2.06-1.09,3.1-2.43,2.33l-5-2.91c-.55-.31-1,.12-1,1v2.25l0,0a1.12,1.12,0,0,1-1,0,.36.36,0,0,1-.21-.29v-2.4c0-2.06,1.09-3.11,2.43-2.34l5,2.91c.55.32,1-.11,1-1a3,3,0,0,0-.33-1.31,2.13,2.13,0,0,0-.84-1.2l-9.6-5.54a4.92,4.92,0,0,1-1.77-2.21,7.32,7.32,0,0,1-.48-2.52v0c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-.95v-.06a3,3,0,0,0-.33-1.31,2.13,2.13,0,0,0-.84-1.2l-9.6-5.54a4.92,4.92,0,0,1-1.77-2.21,7.32,7.32,0,0,1-.48-2.52v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-.95v-.06a3,3,0,0,0-.33-1.31,2.13,2.13,0,0,0-.84-1.2l-9.6-5.54a4.92,4.92,0,0,1-1.77-2.21,7.32,7.32,0,0,1-.48-2.52v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-.95V184a3,3,0,0,0-.33-1.31,2.13,2.13,0,0,0-.84-1.2l-9.6-5.55a4.81,4.81,0,0,1-1.77-2.21,7.22,7.22,0,0,1-.48-2.51v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-1v0a3,3,0,0,0-.33-1.31,2.13,2.13,0,0,0-.84-1.2l-9.6-5.55a4.81,4.81,0,0,1-1.77-2.21,7.22,7.22,0,0,1-.48-2.51v-.05c0-2.06,1.09-3.1,2.42-2.33l9.6,5.54c.55.32,1-.11,1-1v-.05a3,3,0,0,0-.33-1.31,2.13,2.13,0,0,0-.84-1.2L261,144c-.55-.31-1,.12-1,1V164.8l0,0a1.12,1.12,0,0,1-1,0,.36.36,0,0,1-.21-.29v-20c0-2.06,1.08-3.11,2.42-2.34l28.05,16.21a4.75,4.75,0,0,1,1.77,2.21,7.23,7.23,0,0,1,.49,2.51v0c0,2.06-1.09,3.1-2.43,2.33l-9.6-5.54C278.9,159.67,278.46,160.1,278.46,161Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,160.63a4.91,4.91,0,0,0-1.76-2.21l-28.06-16.2c-1.33-.78-2.42.27-2.42,2.33v3.59a26.88,26.88,0,0,1,.3-4.72,1.36,1.36,0,0,1,2.08-.9l28.36,16.38a5.88,5.88,0,0,1,1.79,2.67A6.37,6.37,0,0,0,291,160.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,161.08v0a3.9,3.9,0,0,0,1.47,3.12l9.6,5.54a5.13,5.13,0,0,1,1.95,4.12V174c0,1.66-.87,2.5-1.95,1.88l-9.6-5.54c-.81-.47-1.47.16-1.47,1.41v0a3.9,3.9,0,0,0,1.47,3.12l9.6,5.54a5.13,5.13,0,0,1,1.95,4.12v.06c0,1.65-.87,2.49-1.95,1.87l-9.6-5.54c-.81-.47-1.47.16-1.47,1.41v0a3.9,3.9,0,0,0,1.47,3.12l9.6,5.54a5.13,5.13,0,0,1,1.95,4.12v.06c0,1.65-.87,2.49-1.95,1.87l-9.6-5.54c-.81-.47-1.47.16-1.47,1.41V193a3.9,3.9,0,0,0,1.47,3.12l9.6,5.54a5.13,5.13,0,0,1,1.95,4.12v.06c0,1.65-.87,2.49-1.95,1.87l-9.6-5.54c-.81-.47-1.47.16-1.47,1.41v.05a3.9,3.9,0,0,0,1.47,3.12l9.6,5.54a5.13,5.13,0,0,1,1.95,4.12c0,1.66-.87,2.5-1.95,1.88l-5-2.91c-.82-.47-1.48.17-1.48,1.42v2.23a1.24,1.24,0,0,1-.47,0v-2.51c0-1.65.87-2.49,1.95-1.87l5,2.9c.81.47,1.47-.16,1.47-1.41a3.9,3.9,0,0,0-1.47-3.12l-9.6-5.54a5.16,5.16,0,0,1-1.95-4.12v0c0-1.66.88-2.5,1.95-1.88l9.6,5.55c.81.46,1.47-.17,1.47-1.42v-.05a3.9,3.9,0,0,0-1.47-3.12l-9.6-5.54a5.16,5.16,0,0,1-1.95-4.12v-.05c0-1.66.88-2.5,1.95-1.88l9.6,5.55c.81.46,1.47-.17,1.47-1.42v0a3.9,3.9,0,0,0-1.47-3.12l-9.6-5.54a5.16,5.16,0,0,1-1.95-4.12v-.05c0-1.66.88-2.5,1.95-1.88l9.6,5.55c.81.46,1.47-.17,1.47-1.42v0a3.9,3.9,0,0,0-1.47-3.12l-9.6-5.54a5.16,5.16,0,0,1-1.95-4.12v-.05c0-1.66.88-2.5,1.95-1.88l9.6,5.55c.81.46,1.47-.17,1.47-1.42v-.05a3.9,3.9,0,0,0-1.47-3.12l-9.6-5.54a5.16,5.16,0,0,1-1.95-4.12v-.05c0-1.66.88-2.5,1.95-1.88l9.6,5.54c.81.47,1.47-.16,1.47-1.41V163a3.9,3.9,0,0,0-1.47-3.12l-28.05-16.2c-.81-.47-1.47.16-1.47,1.41v19.81a1,1,0,0,1-.48,0V144.83c0-1.66.88-2.5,1.95-1.88l28.05,16.21a5.13,5.13,0,0,1,1.95,4.12v.05c0,1.66-.87,2.5-1.95,1.88l-9.6-5.54C278.81,159.2,278.15,159.83,278.15,161.08Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.21,230a.72.72,0,0,1-.72.72.73.73,0,0,1-.73-.72c0-.4.42-.78.73-1.46C282.8,229.23,283.21,229.62,283.21,230Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.58,232.08c-2.24-1.3-2.24-3.4,0-4.69a8.94,8.94,0,0,1,8.12,0c2.24,1.29,2.24,3.39,0,4.69A9,9,0,0,1,254.58,232.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,229.35h-1.23a2.3,2.3,0,0,0-1.1-1.2,6.23,6.23,0,0,0-5.64,0,2.3,2.3,0,0,0-1.1,1.2h-1.23l1.75,1.63h0a3.36,3.36,0,0,0,.58.43,6.23,6.23,0,0,0,5.64,0A2.93,2.93,0,0,0,262,231h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,229.35h-1.23a2.3,2.3,0,0,0-1.1-1.2,6.23,6.23,0,0,0-5.64,0,2.3,2.3,0,0,0-1.1,1.2h-1.23l1.75,1.63h0a3.36,3.36,0,0,0,.58.43,6.23,6.23,0,0,0,5.64,0A2.93,2.93,0,0,0,262,231h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,225.59h0L262.05,224h-6.81l-1.75,1.63h0c-1.49,1.36-1.22,3.18.83,4.37a9.53,9.53,0,0,0,8.61,0C265,228.77,265.27,227,263.77,225.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,225.59h0L262.05,224h-6.81l-1.75,1.63h0c-1.49,1.36-1.22,3.18.83,4.37a9.53,9.53,0,0,0,8.61,0C265,228.77,265.27,227,263.77,225.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,230.55c-3.4.67-6.53-.74-7.32-1.56-1.34-1.37-.8-2.59,1-4l-.28-.7-1.43,1.33h0c-1.49,1.36-1.22,3.18.83,4.37A9.63,9.63,0,0,0,261.51,230.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35,224.32a2.77,2.77,0,0,0-.89-.78,6.23,6.23,0,0,0-5.64,0,2.67,2.67,0,0,0-.89.78h-.28v.82h0a2,2,0,0,0,1.17,1.66,6.23,6.23,0,0,0,5.64,0,2,2,0,0,0,1.16-1.66h0v-.82Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35,224.32a2.77,2.77,0,0,0-.89-.78,6.23,6.23,0,0,0-5.64,0,2.67,2.67,0,0,0-.89.78h-.28v.82h0a2,2,0,0,0,1.17,1.66,6.23,6.23,0,0,0,5.64,0,2,2,0,0,0,1.16-1.66h0v-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,226.8l.29-.19a8,8,0,0,1-2.49.69,6.14,6.14,0,0,1-3.59-.91,2,2,0,0,1-.89-1.47v-.6h-.13v.82h0a2,2,0,0,0,1.17,1.66A6.23,6.23,0,0,0,261.46,226.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,226c-1.56-.9-1.56-2.35,0-3.25a6.23,6.23,0,0,1,5.64,0c1.56.9,1.56,2.35,0,3.25A6.23,6.23,0,0,1,255.82,226Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,226c-1.56-.9-1.56-2.35,0-3.25a6.23,6.23,0,0,1,5.64,0c1.56.9,1.56,2.35,0,3.25A6.23,6.23,0,0,1,255.82,226Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,225.54a1.28,1.28,0,0,1,0-2.43,4.64,4.64,0,0,1,4.2,0,1.28,1.28,0,0,1,0,2.43A4.7,4.7,0,0,1,256.54,225.54Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,225.54a1.28,1.28,0,0,1,0-2.43,4.64,4.64,0,0,1,4.2,0,1.28,1.28,0,0,1,0,2.43A4.64,4.64,0,0,1,256.54,225.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,223.49a4.68,4.68,0,0,0-3.15.39,1.77,1.77,0,0,0-.79.83c-.22-.56,0-1.16.79-1.6-.37.25-.46.69-.19.64A4.7,4.7,0,0,1,259.69,223.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.74,223.88a4.64,4.64,0,0,0-4.2,0,.83.83,0,0,0,0,1.66,4.64,4.64,0,0,0,4.2,0,.83.83,0,0,0,0-1.66Z",
    style: {
      fill: "#7AC1FB",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,224.71l0,.11a2,2,0,0,0-.74-.71,4.64,4.64,0,0,0-4.2,0,1.88,1.88,0,0,0-.74.71.54.54,0,0,1-.05-.11,1.77,1.77,0,0,1,.79-.83,4.64,4.64,0,0,1,4.2,0A1.82,1.82,0,0,1,261.53,224.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.74,225.54a4.17,4.17,0,0,1-1.79.52,4.91,4.91,0,0,1-1.86-.23,2.14,2.14,0,0,1-1.4-1.19,1.38,1.38,0,0,1,.85-1.53,1.37,1.37,0,0,0-.79,1.51,2.08,2.08,0,0,0,1.37,1.13A4.72,4.72,0,0,0,259,226,4.52,4.52,0,0,0,260.74,225.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flame--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.61,222.23c1.31-.09,2.28-1.55,1.35-3.6s-1.49-3.15-1.15-5.22a12.62,12.62,0,0,0-1.54,3.07,11.57,11.57,0,0,0-.71,3C256.42,221.31,257.36,222.23,258.61,222.23Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,222.23c1.31-.09,2.28-1.55,1.35-3.6s-1.49-3.15-1.15-5.22a12.62,12.62,0,0,0-1.54,3.07,11.57,11.57,0,0,0-.71,3C256.42,221.31,257.36,222.23,258.61,222.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58,222.11a1.67,1.67,0,0,0,1.07-1,2.77,2.77,0,0,0-.15-2.33l-.15-.32a11.44,11.44,0,0,1-1.08-3.13c-.17.37-.35.79-.52,1.27a10.6,10.6,0,0,0-.68,2.82,2.58,2.58,0,0,0,.4,1.89A2,2,0,0,0,258.58,222.11Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,222a1.32,1.32,0,0,0,.51-1.38c-.13-.66-.76-1.54-.76-1.84a5.45,5.45,0,0,0-.61,1.74A1.38,1.38,0,0,0,258.65,222Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,222a1.32,1.32,0,0,0,.51-1.38c-.13-.66-.76-1.54-.76-1.84a5.45,5.45,0,0,0-.61,1.74A1.38,1.38,0,0,0,258.65,222Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,225.06a.4.4,0,0,1-.07-.33l.06-.27c0-.18,0-.36.07-.55a3.74,3.74,0,0,0,0-.58c0-.2,0-.39-.06-.59a12.24,12.24,0,0,1-.1-1.23,5.59,5.59,0,0,1,.14-1.23h0a6.85,6.85,0,0,0,.06,1.2c.06.39.17.78.26,1.18l.12.61a4.32,4.32,0,0,1,.07.64,2.36,2.36,0,0,1-.07.65,1.7,1.7,0,0,1-.1.32.37.37,0,0,1-.29.24Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.8,173.17l-.29.74a.68.68,0,0,1-1.26,0l-.29-.74a6.49,6.49,0,0,1-.45-2.38V167h2.74v3.81A6.49,6.49,0,0,1,236.8,173.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,173.29a4.68,4.68,0,0,0,.12-1.48V167h-.25v4.88A4,4,0,0,0,236,173.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.9,167h-.5v6h0a4.76,4.76,0,0,0,.5-2.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.86,167v.74A1.47,1.47,0,0,1,238,169a4.68,4.68,0,0,1-4.22,0,2.09,2.09,0,0,1-.66-.57,1.17,1.17,0,0,1-.21-.65V167a.71.71,0,0,1,0-.2,1.62,1.62,0,0,1,.85-1l0,0a4.69,4.69,0,0,1,4.18,0,1.62,1.62,0,0,1,.85,1A.75.75,0,0,1,238.86,167Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,168.7v-1.09c0-.44.11-1.1-.65-1.1a2.1,2.1,0,0,1-1.66-.77l0,0a1.62,1.62,0,0,0-.85,1,.71.71,0,0,0,0,.2v.75a1.17,1.17,0,0,0,.21.65,2.09,2.09,0,0,0,.66.57,4.68,4.68,0,0,0,4.22,0C237.17,169.28,236.12,169.12,236.12,168.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,168.2a1.29,1.29,0,0,1,0-2.44,4.68,4.68,0,0,1,4.22,0,1.29,1.29,0,0,1,0,2.44A4.68,4.68,0,0,1,233.77,168.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.86,164.71v1.86a.75.75,0,0,1,0,.21,1.62,1.62,0,0,1-.85,1,4.18,4.18,0,0,1-1.87.49,4.33,4.33,0,0,1-2.35-.5,2,2,0,0,1-.66-.56,1.24,1.24,0,0,1-.19-.45.65.65,0,0,1,0-.2V164.7a1.49,1.49,0,0,1,.87-1.22.8.8,0,0,1,.16-.08,4.7,4.7,0,0,1,4.06.08A1.47,1.47,0,0,1,238.86,164.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,167.23a2,2,0,0,0,.66.56,4.33,4.33,0,0,0,2.35.5v-.68c0-.44.13-1-.65-1.1a3,3,0,0,1-2.05-1.1,1.5,1.5,0,0,1,.51-2,.8.8,0,0,0-.16.08,1.49,1.49,0,0,0-.87,1.22v1.88a.65.65,0,0,0,0,.2A1.24,1.24,0,0,0,233.11,167.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72,162.88v.1a.36.36,0,0,1-.2.26,1.1,1.1,0,0,1-1,0,.42.42,0,0,1-.19-.21.31.31,0,0,1,0-.1c-.07-4.85-2.64-10.21-5.78-12l-7.08-4.08c-3.19-1.84-5.79.65-5.79,5.56v12.49a.35.35,0,0,1-.21.29,1.12,1.12,0,0,1-1,0,.35.35,0,0,1-.21-.29V151.57c0-6.12,3.24-9.24,7.22-6.94l7.08,4.08C253.28,150.87,256.37,157.06,256.72,162.88Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5,163.25a1.09,1.09,0,0,1-1,0,.42.42,0,0,1-.19-.21.34.34,0,0,0,0-.1c-.07-4.85-2.64-10.21-5.78-12l-.24-.14-6.84-3.94-.24-.14c-3.19-1.84-5.78.66-5.78,5.57v12.92a1.11,1.11,0,0,1-1,0,.35.35,0,0,1-.21-.29V151.57c0-6.12,3.24-9.24,7.22-6.94l6.84,3.94c3.72,2.15,6.8,8.28,7.18,14.08C256.49,162.85,256.5,163.05,256.5,163.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.46,144.63c-3.07-1.77-5.7-.32-6.74,3.26a5.52,5.52,0,0,1,3.18-3.39,4.54,4.54,0,0,1,3,.15l7.11,3.76Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,162.82a2.21,2.21,0,0,1-.31-1.13c-.52-4.82-3.09-9.74-6.17-11.51l-7.08-4.08c-3.45-2-6.26.7-6.26,6v13.14a1,1,0,0,1-.48,0V151.84c0-5.71,3-8.62,6.74-6.48l7.08,4.08c3.34,1.93,6.12,7.3,6.65,12.52C256.24,162.51,256.16,162.9,256,162.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M211.69,269.67,192.9,258.82c-.27-.15-.27-.4,0-.56l29.43-17a1.1,1.1,0,0,1,1,0l18.78,10.85c.27.16.27.41,0,.56l-29.42,17A1.1,1.1,0,0,1,211.69,269.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-4"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "196.08 257.89 212.26 267.11 238.98 251.78 222.81 242.78 196.08 257.89"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,266.41l-15.6-9a6.47,6.47,0,0,0-.08-4l15.5,8.86A15.71,15.71,0,0,1,212.44,266.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.26,262.27l-15.5-8.86a8.55,8.55,0,0,1,.28,1.33l15.39,8.88A8,8,0,0,0,212.26,262.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.46,261a3.31,3.31,0,0,1,1.5,2.59v3c0,.95-.67,1.34-1.5.86l-15.37-8.82v-.75l15.17,8.65c.5.29.9,0,.9-.52v-2.79a2,2,0,0,0-.9-1.55L196.09,253v-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.09,252.18l26.72-15.11,15.37,8.6a3.29,3.29,0,0,1,1.5,2.58v3a1.05,1.05,0,0,1-.44,1l-26.72,15.34a1.07,1.07,0,0,0,.44-1v-3a3.29,3.29,0,0,0-1.5-2.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.52,262.12a3,3,0,0,1,.44,1.46v3a1.07,1.07,0,0,1-.44,1l26.72-15.34a1.05,1.05,0,0,0,.44-1v-3a3.08,3.08,0,0,0-.44-1.47Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.9 249.2 213.32 258.64 238.09 244.42 221.67 235.21 196.9 249.2",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.9 249.2 213.32 258.64 238.09 244.42 221.67 235.21 196.9 249.2",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.49,258,197.6,248.8a5.3,5.3,0,0,0-.08-3.53l15.8,9.1A11.8,11.8,0,0,1,213.49,258Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,254.37l-15.8-9.1a7.53,7.53,0,0,1,.28,1.33l15.68,9.05A6.84,6.84,0,0,0,213.32,254.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,253.2a3,3,0,0,1,1.39,2.39v2.58c0,.88-.62,1.24-1.39.8L196.9,249.9v-.7l15.49,8.91c.46.27.83.05.83-.48v-2.37a1.83,1.83,0,0,0-.84-1.43l-15.47-8.92v-.78Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,253.2a3,3,0,0,1,1.39,2.39v2.58c0,.88-.62,1.24-1.39.8L196.9,249.9v-.7l15.49,8.91c.46.27.83.05.83-.48v-2.37a1.83,1.83,0,0,0-.84-1.43l-15.47-8.92v-.78Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,244.13l24.77-14.22L237.35,239a3.06,3.06,0,0,1,1.39,2.4V244a1,1,0,0,1-.4.9l-24.78,14.21a.94.94,0,0,0,.41-.89v-2.58a3,3,0,0,0-1.39-2.39Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,244.13l24.77-14.22L237.35,239a3.06,3.06,0,0,1,1.39,2.4V244a1,1,0,0,1-.4.9l-24.78,14.21a.94.94,0,0,0,.41-.89v-2.58a3,3,0,0,0-1.39-2.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,254.23a2.8,2.8,0,0,1,.4,1.36v2.58a.94.94,0,0,1-.41.89l24.78-14.21a1,1,0,0,0,.4-.9v-2.57a2.8,2.8,0,0,0-.4-1.36Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,254.23a2.8,2.8,0,0,1,.4,1.36v2.58a.94.94,0,0,1-.41.89l24.78-14.21a1,1,0,0,0,.4-.9v-2.57a2.8,2.8,0,0,0-.4-1.36Z",
    style: {
      opacity: 0.35000000000000003
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M63.69,309.41c.27.73,1,1.18,2.35,1.36l18.5-10.84,2.4-2.43a.19.19,0,0,0-.19-.31l-4.43,1.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,297l4-.78a.12.12,0,0,1,.11.2l-2.67,3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.55,296.43a.12.12,0,0,0-.11-.2l-.77.15h0A.69.69,0,0,1,86,297v.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18,307.89l.32-.18.39-.23,14-8a1.83,1.83,0,0,0-.11-1.3A1.85,1.85,0,0,0,82.5,297l-14,8-.75.43C68.27,305.2,69.67,307.63,69.18,307.89Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.41,307.19l.72-.41c.21-.12.09-.64-.16-1.18-.33-.72-1-1.41-1.26-1.26l-.53.3-.19.12c.29-.15.93.54,1.26,1.26.24.52.36,1,.18,1.16h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,307.09c.49-.27-.92-2.7-1.42-2.44l-.72.41c.5-.26,1.91,2.18,1.42,2.44Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18,307.89l.71-.41c.49-.25-.86-2.61-1.37-2.46l0,0-.72.41C68.27,305.2,69.67,307.63,69.18,307.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.57,296.3l-.13-.07-2.86,1.57-14.79,8.48s-.05,0-.07,0c.42.65.74,1.48.46,1.62l.32-.18.39-.23,14-8h0l2.67-3A.11.11,0,0,0,86.57,296.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.16,309.62l3-1.73c.21-.11.09-.63-.15-1.16-.33-.72-1-1.42-1.26-1.28h0l-3,1.74c-.6.34,0,1.65.62,2.24A.73.73,0,0,0,66.16,309.62Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.34,308.68a2.2,2.2,0,0,0-1.23-1.49.51.51,0,0,0-.46.06c-.45.42.08,1.62.71,2.18a.75.75,0,0,0,.78.2C66.37,309.49,66.46,309.14,66.34,308.68Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.2,271.27l-22.68-13.09a1.31,1.31,0,0,0-1.3,0L120.87,280.9a.28.28,0,0,0,0,.5l22.89,13.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,268.52V269a2.1,2.1,0,0,1-1,1.81L144.81,292a2.06,2.06,0,0,1-1,.28,2.1,2.1,0,0,1-1.06-.28l-20-11.5a2.1,2.1,0,0,1-1-1.81V278h0a.27.27,0,0,0,.13.23l22,12.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,268.51,160.78,256a1.22,1.22,0,0,0-1.25,0l-37.7,21.77a.27.27,0,0,0,0,.48l21.93,12.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.56 289.04 131.84 282.28 166.12 262.49 177.9 269.22 143.56 289.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.9 269.22 177.45 269.48 166.12 263.01 132.29 282.54 131.84 282.28 166.12 262.49 177.9 269.22",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.9 269.22 177.45 269.48 166.12 263.01 132.29 282.54 131.84 282.28 166.12 262.49 177.9 269.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.8 270.24 138.02 270.36 143.76 273.68 153.98 267.78 154.19 267.66 148.23 264.21 137.8 270.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.02 270.36 143.76 273.68 153.98 267.78 148.23 264.46 138.02 270.36",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,290.89v1.39a2.07,2.07,0,0,0,1.05-.28l36.65-21.16a2.1,2.1,0,0,0,1-1.82v-.51Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,290.89v1.39a2.07,2.07,0,0,0,1.05-.28l36.65-21.16a2.1,2.1,0,0,0,1-1.82v-.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35,291.2a2.51,2.51,0,0,0,2.14-.17L183,270a2.45,2.45,0,0,0,1.2-1.73l4-23.83a2.73,2.73,0,0,0,0-.41,2.47,2.47,0,0,0-.73-1.76l-37.93,21.9a1.83,1.83,0,0,0-.89,1.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,290.89l.25.14.34.17,4.32-25.79a1.83,1.83,0,0,1,.89-1.28l37.93-21.9a2.46,2.46,0,0,0-.51-.39l-38,21.94a1.86,1.86,0,0,0-.89,1.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,264.61l-.59-.34a1.8,1.8,0,0,0-.35.8l-4.33,25.82.25.14.34.17,4.32-25.79A1.87,1.87,0,0,1,149,264.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,268.59a5.44,5.44,0,0,1,2.47-3.17c1.18-.68,2-.36,1.81.7a5.39,5.39,0,0,1-2.46,3.17C166.6,270,165.78,269.66,166,268.59Z",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M94,302.35,72,315a.35.35,0,0,0,0,.66l26.8,15.43a1.27,1.27,0,0,0,1.14,0l22-12.69a.34.34,0,0,0,0-.65L95.11,302.35A1.27,1.27,0,0,0,94,302.35Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,303.48l-18.87,9.93-.39.61v.5a.72.72,0,0,0,.39.61L99,329.48a1.25,1.25,0,0,0,.65.16,1.19,1.19,0,0,0,.64-.16l18.45-10.65v-.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,329.15A1.25,1.25,0,0,1,99,329L74.14,314.63a.7.7,0,0,1-.39-.61.72.72,0,0,1,.39-.61l18-10.41,26.57,15.34L100.3,329A1.19,1.19,0,0,1,99.66,329.15Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,301.56,74.35,311.85l-.19.26V314h0a.3.3,0,0,0,.19.26l24.86,14.36a1,1,0,0,0,.89,0l17.84-10.3v-1.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,316.43l-.23.13-2.9,1.67-.54.32-14.17,8.17a.92.92,0,0,1-.88,0L74.34,312.37a.28.28,0,0,1,0-.52l.24-.13,17.6-10.16,25.54,14.74,0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,326.83v1.91a.89.89,0,0,1-.44-.1L74.34,314.28a.31.31,0,0,1-.18-.26v-1.91a.33.33,0,0,0,.18.26l24.88,14.35A.8.8,0,0,0,99.66,326.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,316.17,114.72,318l-.5.29-14.12,8.15a1,1,0,0,1-.88,0L76.94,313.61l-.56-.32a5.57,5.57,0,0,1-1.8-1.57.43.43,0,0,0,0-.07.38.38,0,0,1-.06-.13.39.39,0,0,1,.31-.45,8.07,8.07,0,0,0,1.68-.7h0l15.68-9.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,316a.25.25,0,0,0,0,.48.93.93,0,0,0,.83,0,.25.25,0,0,0,0-.48A.93.93,0,0,0,114.61,316Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.27,314.4a1.07,1.07,0,0,0-1.11.08,3.39,3.39,0,0,0-1.4,2,.75.75,0,0,0,.3,0,3.14,3.14,0,0,1,1.25-1.78,1.06,1.06,0,0,1,.51-.15.6.6,0,0,1,.3.07,1.17,1.17,0,0,1,.42,1,1.94,1.94,0,0,1,0,.24l.29.17a2.93,2.93,0,0,0,0-.41A1.43,1.43,0,0,0,117.27,314.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.78,316.26s0,.05,0,.07l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,314.51a.25.25,0,0,0,0,.48.93.93,0,0,0,.83,0,.25.25,0,0,0,0-.48A.93.93,0,0,0,112.12,314.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,313a1.09,1.09,0,0,0-1.12.08,3.42,3.42,0,0,0-1.39,2,1,1,0,0,0,.3,0,3.13,3.13,0,0,1,1.25-1.79,1.06,1.06,0,0,1,.51-.15.59.59,0,0,1,.29.07,1.14,1.14,0,0,1,.42,1,1.93,1.93,0,0,1,0,.24l.29.17a2.93,2.93,0,0,0,0-.41A1.43,1.43,0,0,0,114.78,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,313.07a.25.25,0,0,0,0,.48.91.91,0,0,0,.82,0,.25.25,0,0,0,0-.48A.91.91,0,0,0,109.63,313.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28,311.52a1.1,1.1,0,0,0-1.11.08,3.48,3.48,0,0,0-1.4,2,1.06,1.06,0,0,0,.31,0,3,3,0,0,1,1.25-1.79,1.05,1.05,0,0,1,.5-.15.6.6,0,0,1,.3.07,1.14,1.14,0,0,1,.42,1,1.93,1.93,0,0,1,0,.24l.29.17a2.93,2.93,0,0,0,0-.41A1.41,1.41,0,0,0,112.28,311.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13,311.63a.26.26,0,0,0,0,.48.93.93,0,0,0,.83,0,.25.25,0,0,0,0-.48A.93.93,0,0,0,107.13,311.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79,310.08a1.1,1.1,0,0,0-1.11.08,3.51,3.51,0,0,0-1.4,2,1,1,0,0,0,.31,0,3.07,3.07,0,0,1,1.24-1.79,1.06,1.06,0,0,1,.51-.15.61.61,0,0,1,.3.08,1.13,1.13,0,0,1,.42,1,2.29,2.29,0,0,1,0,.25l.29.16a2.83,2.83,0,0,0,0-.41A1.4,1.4,0,0,0,109.79,310.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,310.19a.26.26,0,0,0,0,.48.93.93,0,0,0,.83,0,.25.25,0,0,0,0-.48A.93.93,0,0,0,104.64,310.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3,308.64a1.09,1.09,0,0,0-1.11.08,3.42,3.42,0,0,0-1.4,2,1,1,0,0,0,.3,0,3.2,3.2,0,0,1,1.25-1.79,1.06,1.06,0,0,1,.51-.15.61.61,0,0,1,.3.08,1.13,1.13,0,0,1,.42,1,2.11,2.11,0,0,1,0,.25l.29.16a2.73,2.73,0,0,0,0-.41A1.43,1.43,0,0,0,107.3,308.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.15,308.75c-.23.14-.23.35,0,.48a.93.93,0,0,0,.83,0c.23-.13.23-.34,0-.48A.93.93,0,0,0,102.15,308.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81,307.2a1.11,1.11,0,0,0-1.12.08,3.46,3.46,0,0,0-1.39,2,.75.75,0,0,0,.3,0,3.14,3.14,0,0,1,1.25-1.78,1,1,0,0,1,.5-.16.61.61,0,0,1,.3.08,1.12,1.12,0,0,1,.42,1,2.09,2.09,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.43,1.43,0,0,0,104.81,307.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,307.31c-.23.14-.23.35,0,.48a.85.85,0,0,0,.82,0c.23-.13.23-.34,0-.48A.91.91,0,0,0,99.66,307.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.31,305.76a1.1,1.1,0,0,0-1.11.08,3.51,3.51,0,0,0-1.4,2,.8.8,0,0,0,.31,0,3,3,0,0,1,1.25-1.78,1,1,0,0,1,.5-.16.61.61,0,0,1,.3.08,1.12,1.12,0,0,1,.42,1,2,2,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.41,1.41,0,0,0,102.31,305.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.16,305.87c-.22.14-.22.35,0,.48a.87.87,0,0,0,.83,0c.23-.13.23-.34,0-.48A.93.93,0,0,0,97.16,305.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,304.32a1.1,1.1,0,0,0-1.11.08,3.51,3.51,0,0,0-1.4,2,.75.75,0,0,0,.3,0,3.14,3.14,0,0,1,1.25-1.78,1.08,1.08,0,0,1,.51-.16.61.61,0,0,1,.3.08,1.15,1.15,0,0,1,.42,1,2,2,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.42,1.42,0,0,0,99.82,304.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,304.44c-.23.13-.23.34,0,.47a.87.87,0,0,0,.83,0c.23-.13.23-.34,0-.47A.87.87,0,0,0,94.67,304.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.33,302.88a1.09,1.09,0,0,0-1.11.08,3.42,3.42,0,0,0-1.4,2,.75.75,0,0,0,.3,0,3.14,3.14,0,0,1,1.25-1.78,1.08,1.08,0,0,1,.51-.16.61.61,0,0,1,.3.08,1.15,1.15,0,0,1,.42,1,1.94,1.94,0,0,1,0,.24l.29.17a2.93,2.93,0,0,0,0-.41A1.46,1.46,0,0,0,97.33,302.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,303c-.23.13-.23.34,0,.48a.93.93,0,0,0,.83,0c.23-.14.23-.35,0-.48A.87.87,0,0,0,92.18,303Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.84,301.45a1.09,1.09,0,0,0-1.12.07,3.48,3.48,0,0,0-1.39,2,.75.75,0,0,0,.3,0,3.14,3.14,0,0,1,1.25-1.78,1.08,1.08,0,0,1,.5-.16.61.61,0,0,1,.3.08,1.14,1.14,0,0,1,.42,1,1.93,1.93,0,0,1,0,.24l.29.17a2.93,2.93,0,0,0,0-.41A1.43,1.43,0,0,0,94.84,301.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.16,323.9a.28.28,0,0,1-.14-.52l13.72-7.92a.29.29,0,0,1,.39.1.28.28,0,0,1-.1.38l-13.72,7.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,322.94a.28.28,0,0,1-.14-.52l13.72-7.92a.29.29,0,0,1,.39.1.28.28,0,0,1-.1.38l-13.73,7.93A.32.32,0,0,1,95.5,322.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,322a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.38l13.72-7.92a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.38L94,322A.32.32,0,0,1,93.84,322Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,321a.28.28,0,0,1-.14-.53l13.72-7.92a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39L92.32,321A.33.33,0,0,1,92.18,321Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.52,320.07a.32.32,0,0,1-.25-.14.29.29,0,0,1,.11-.39l13.72-7.92a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39L90.66,320A.37.37,0,0,1,90.52,320.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.86,319.11a.29.29,0,0,1-.25-.14.29.29,0,0,1,.11-.39l13.72-7.92a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39L89,319.07A.43.43,0,0,1,88.86,319.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.19,318.15A.28.28,0,0,1,87,318a.29.29,0,0,1,.1-.39l13.72-7.92a.28.28,0,0,1,.29.49l-13.73,7.92A.33.33,0,0,1,87.19,318.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.53,317.19a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l13.72-7.92a.29.29,0,0,1,.39.1.29.29,0,0,1-.11.39l-13.72,7.92A.23.23,0,0,1,85.53,317.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87,316.23a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l13.72-7.92a.28.28,0,0,1,.38.1.28.28,0,0,1-.1.39L84,316.19A.23.23,0,0,1,83.87,316.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21,315.27a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l13.72-7.92a.28.28,0,0,1,.28.49l-13.72,7.92A.23.23,0,0,1,82.21,315.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,314.31a.3.3,0,0,1-.25-.14.28.28,0,0,1,.11-.38l13.72-7.93a.28.28,0,0,1,.38.11.28.28,0,0,1-.1.38l-13.72,7.92A.27.27,0,0,1,80.55,314.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,313.35a.28.28,0,0,1-.24-.14.27.27,0,0,1,.1-.38l13.73-7.93a.28.28,0,0,1,.38.11.28.28,0,0,1-.1.38L79,313.31A.28.28,0,0,1,78.88,313.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.22,312.39a.28.28,0,0,1-.24-.14.28.28,0,0,1,.1-.38l13.72-7.93a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-13.72,7.92A.23.23,0,0,1,77.22,312.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.85,324.86a.28.28,0,0,1-.14-.52l14.51-8.4a.29.29,0,0,1,.39.11.28.28,0,0,1-.1.38L99,324.83A.32.32,0,0,1,98.85,324.86Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.11,314.43a1.23,1.23,0,0,0-.56-.36,2.28,2.28,0,0,1-.28-.13c-.12-.21-.29-.54-.07-.58s.39.11.54.16.06-.1,0-.12c-.24-.1-.71-.4-.81,0a.6.6,0,0,0,.06.38.82.82,0,0,0-.36-.07c-.12,0-.22,0-.26.15s0,.11,0,.16a.13.13,0,0,0,.11.12h-.13c-.17,0-.64-.12-.75.1s0,.21,0,.24-.35.13-.4.17,0,.11,0,.12a4.15,4.15,0,0,1-.5,0c-.27,0-1-.08-.86.34,0,.05,0,0,0,.12l0,.1s0,0-.06.06-.12,0-.15.06.07.22-.1.32-.7-.14-.94,0,.07.55-.3.56c-.08,0,0,.12,0,.13.34,0,.3,0,.37-.32.11-.45.79-.14,1.17-.25,0,0,.05-.06,0-.1s0-.25.17-.32a.07.07,0,0,0,0-.1c0-.07-.19-.3-.1-.4a1.7,1.7,0,0,1,.41-.05,8.75,8.75,0,0,1,.89,0s.07,0,.05-.08.34-.16.43-.18,0-.05,0-.08c-.19-.45.49-.28.77-.24,0,0,.09,0,.08-.09s-.39-.3,0-.36a.68.68,0,0,1,.31.07,2.16,2.16,0,0,0,.71.73C106,314.84,106.31,314.74,106.11,314.43Zm-.13.09c.09.11-.18,0-.21,0a1,1,0,0,1-.35-.37l.21.11A.74.74,0,0,1,106,314.52Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M99.24,317.32c0-.19,0-.41.13-.44s0-.13,0-.13c-.25,0-.33.21-.29.47a2,2,0,0,0-.31-.11c-.16,0-.27,0-.32.13s0,.16,0,.25.12.08-.07.13a2,2,0,0,1-.23,0c-.2,0-.21,0-.33.1s.18.15-.18.09c-.09,0-.19-.06-.28,0s-.2.06-.18.21.15.15.15.19c0,.32-.34,0-.47,0s-.08,0-.08,0,.1.21-.13.23c0,0-.18-.09-.23-.09s-.28.19-.47.18-.07,0-.06.08.13.23-.15.35a3,3,0,0,1-.33,0c-.08,0,0,.13,0,.14s.58.2.71,0-.1-.28-.05-.37c0,.06.25-.07.28-.08a.6.6,0,0,1,.23-.06s.07.06.11.06.12,0,.17,0,.06-.1.08-.11-.07-.07,0-.11.14,0,.2.07.27.12.37,0-.1-.25-.08-.35.36-.06.51-.16a.06.06,0,0,0,0-.07c-.09-.31.47-.06.65-.1,0,0,.07,0,.06-.06s-.07-.19-.07-.2c0-.18.3-.16.42-.13.11.38.41.76.74.66a.08.08,0,0,0,0-.06C99.84,317.76,99.55,317.5,99.24,317.32Zm.12.31,0-.08a.81.81,0,0,1,.23.22C99.61,318,99.39,317.69,99.36,317.63Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M104.23,319.35a1.23,1.23,0,0,0-.56-.36l-.27-.14c-.13-.2-.3-.53-.07-.57s.39.11.53.15.06-.09,0-.11c-.25-.1-.72-.4-.82,0a.69.69,0,0,0,.06.39.8.8,0,0,0-.36-.07c-.12,0-.21,0-.26.15a.27.27,0,0,0,0,.16.15.15,0,0,0,.12.12h-.13c-.18,0-.65-.12-.76.09s.06.22,0,.25l-.4.16s0,.11,0,.12a4,4,0,0,1-.5,0c-.28,0-1-.08-.87.34,0,0,.05,0,.06.11a.23.23,0,0,0,0,.11s0,0-.07.05-.12,0-.15.07.07.22-.09.32-.71-.15-.94,0,.06.56-.31.57c-.08,0,0,.12,0,.12.34,0,.31,0,.37-.31.11-.46.79-.14,1.17-.25,0,0,0-.07,0-.1s0-.25.17-.32a.06.06,0,0,0,0-.1c0-.07-.18-.3-.09-.41a2.35,2.35,0,0,1,.4,0,8.81,8.81,0,0,1,.89,0,.07.07,0,0,0,.06-.08c0-.1.34-.16.42-.18a.06.06,0,0,0,0-.08c-.18-.46.49-.29.77-.24a.07.07,0,0,0,.08-.09c0-.15-.38-.31,0-.36a.57.57,0,0,1,.31.07,2.1,2.1,0,0,0,.7.72C104.16,319.75,104.43,319.66,104.23,319.35Zm-.12.08c.08.11-.18,0-.22,0a1,1,0,0,1-.35-.38l.21.11A.93.93,0,0,1,104.11,319.43Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.45,315.86c0-.2-.06-.41.12-.44s0-.13,0-.13c-.24,0-.32.21-.29.47a1.67,1.67,0,0,0-.31-.11c-.16,0-.26,0-.32.13s0,.16,0,.25.13.08-.07.13a2,2,0,0,1-.23,0,.34.34,0,0,0-.33.1c-.12.1.18.15-.18.09a.65.65,0,0,0-.28,0c-.13,0-.2.06-.18.21s.15.15.15.19c0,.32-.34.05-.47,0s-.08,0-.08.05.1.21-.12.23c0,0-.19-.09-.24-.09s-.28.19-.47.18-.07,0-.05.08.13.23-.16.35l-.33,0c-.08,0,0,.13,0,.14s.58.2.71,0-.09-.28,0-.37.26-.07.29-.08a.71.71,0,0,1,.22-.07s.07.07.11.07.12,0,.17,0,.06-.1.08-.11-.06-.07,0-.11.13.05.2.07.27.11.36,0-.1-.25-.08-.35.37-.06.51-.16,0,0,0-.07c-.09-.31.48-.07.65-.1s.07,0,.06-.06a1.5,1.5,0,0,0-.07-.2c0-.18.31-.16.42-.13.12.38.42.76.74.66a.07.07,0,0,0,0-.06C109,316.3,108.75,316,108.45,315.86Zm.11.31,0-.09a1,1,0,0,1,.23.23C108.81,316.5,108.6,316.23,108.56,316.17Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M96,308.83a1.23,1.23,0,0,0-.56-.36l-.27-.14c-.13-.2-.3-.53-.07-.57s.39.11.53.15.06-.09,0-.11c-.25-.1-.72-.4-.82,0a.67.67,0,0,0,.06.38.8.8,0,0,0-.36-.07c-.12,0-.21,0-.25.15s0,.11,0,.16a.13.13,0,0,0,.12.12h-.13c-.18,0-.65-.12-.76.09s.06.22,0,.25-.34.13-.4.17,0,.11,0,.11a4,4,0,0,1-.5,0c-.28,0-1-.08-.87.34,0,.05,0,0,.06.11a.23.23,0,0,0,0,.11s0,0-.07.05-.12,0-.15.07.07.22-.09.32-.71-.15-.94,0,.06.55-.3.56c-.08,0,0,.12,0,.12.34,0,.31,0,.37-.31.11-.46.79-.14,1.17-.25.05,0,.05-.06,0-.1s0-.25.17-.32a.06.06,0,0,0,0-.1c0-.07-.18-.3-.09-.41a2.35,2.35,0,0,1,.4,0,8.81,8.81,0,0,1,.89,0,.07.07,0,0,0,.06-.08c0-.1.34-.16.42-.18a.06.06,0,0,0,0-.08c-.18-.45.49-.29.77-.24a.07.07,0,0,0,.08-.09c0-.15-.38-.31,0-.36a.68.68,0,0,1,.31.07,2,2,0,0,0,.7.72C95.91,309.23,96.18,309.14,96,308.83Zm-.12.08c.08.12-.18,0-.22,0a1,1,0,0,1-.35-.38l.21.11A.86.86,0,0,1,95.85,308.91Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M89.11,311.72c0-.2-.06-.41.13-.44s0-.13,0-.13c-.25,0-.33.21-.3.47a1.16,1.16,0,0,0-.31-.11c-.16,0-.26,0-.32.13s0,.16,0,.25.12.08-.08.13a1,1,0,0,1-.23,0,.36.36,0,0,0-.33.11c-.12.1.18.15-.18.09a.86.86,0,0,0-.28,0c-.13,0-.2.07-.18.22s.15.15.15.19c0,.32-.34.05-.47,0s-.08,0-.08.05.1.21-.12.23c0,0-.19-.09-.24-.09s-.28.19-.47.17a.06.06,0,0,0,0,.09c0,.14.13.23-.16.35l-.33,0c-.08,0,0,.13,0,.14s.57.19.7,0-.09-.28-.05-.37.26-.08.29-.09a1.41,1.41,0,0,1,.22-.06s.07.07.12.07.11,0,.16,0,.06-.09.08-.1-.06-.08,0-.11.13.05.2.07.27.11.36,0-.1-.26-.08-.36.37,0,.51-.15,0,0,0-.07c-.09-.31.48-.07.65-.1s.07,0,.07-.06a1.65,1.65,0,0,1-.07-.2c0-.19.3-.17.41-.13.12.37.42.76.75.65,0,0,0,0,0,0C89.7,312.16,89.41,311.9,89.11,311.72Zm.12.31a.36.36,0,0,1,0-.09c.11.08.22.18.23.23S89.26,312.08,89.23,312Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M94.09,313.75a1.18,1.18,0,0,0-.56-.36l-.27-.14c-.12-.2-.29-.53-.07-.58a1.88,1.88,0,0,1,.53.16c.08,0,.07-.09,0-.11-.24-.1-.71-.4-.81,0a.65.65,0,0,0,0,.38.91.91,0,0,0-.36-.06c-.11,0-.21,0-.25.15s0,.1,0,.16.1.11.12.12h-.13c-.17,0-.65-.12-.76.09s.06.21.05.25l-.41.16s0,.11,0,.12a2.77,2.77,0,0,1-.5,0c-.27,0-1-.08-.86.35,0,0,0,0,0,.11l0,.1s0,0-.06.06-.12,0-.16.07.07.22-.09.32-.7-.15-.94,0,.06.56-.3.56c-.08,0,0,.12,0,.13.34,0,.3,0,.37-.31.1-.46.78-.15,1.16-.25,0,0,0-.07,0-.1s0-.25.17-.32a.07.07,0,0,0,0-.1c0-.08-.19-.3-.1-.41s.36,0,.41-.05a8.61,8.61,0,0,1,.88,0,.07.07,0,0,0,.06-.09c0-.09.34-.15.43-.17a.06.06,0,0,0,0-.08c-.18-.46.5-.29.78-.25a.06.06,0,0,0,.07-.08c0-.16-.38-.31,0-.37a.71.71,0,0,1,.31.08,2.3,2.3,0,0,0,.7.72C94,314.15,94.3,314.06,94.09,313.75Zm-.12.08c.08.11-.18,0-.21,0a.92.92,0,0,1-.35-.38l.2.11A.86.86,0,0,1,94,313.83Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M98.31,310.26c0-.2,0-.41.13-.44s0-.13,0-.13c-.25,0-.33.2-.29.46a2.15,2.15,0,0,0-.31-.1c-.16,0-.27,0-.32.13s0,.16,0,.25.12.08-.08.13a1,1,0,0,1-.22,0,.35.35,0,0,0-.34.11c-.12.1.18.15-.17.09a1,1,0,0,0-.29,0c-.13,0-.2.07-.17.22s.15.15.15.19c0,.32-.35,0-.48,0s-.08,0-.08,0,.11.21-.12.23c0,0-.18-.09-.23-.09s-.28.19-.47.17-.07.05-.06.09.13.23-.15.35l-.33,0c-.09,0,0,.13,0,.14s.57.19.7,0-.09-.29,0-.37.25-.08.28-.09a1.41,1.41,0,0,1,.22-.06s.08.07.12.07.11,0,.16,0,.07-.09.09-.1-.07-.08,0-.11.13,0,.2.07.27.11.36,0-.1-.26-.08-.36.37-.05.52-.15a.07.07,0,0,0,0-.07c-.09-.31.47-.07.65-.1a.07.07,0,0,0,.06-.07,2,2,0,0,0-.07-.19c0-.19.3-.17.42-.13.11.37.41.75.74.65,0,0,0,0,0-.05C98.91,310.69,98.62,310.44,98.31,310.26Zm.12.31a.39.39,0,0,1,0-.09.81.81,0,0,1,.23.23C98.68,310.9,98.46,310.62,98.43,310.57Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M95.14,317.13a1.23,1.23,0,0,0-.56-.36l-.28-.14c-.12-.2-.29-.53-.07-.57s.39.11.54.15.06-.09,0-.11c-.24-.1-.71-.4-.81,0a.62.62,0,0,0,.06.39.82.82,0,0,0-.36-.07c-.12,0-.22,0-.26.15a.27.27,0,0,0,0,.16c0,.09.09.11.11.12H93.4c-.17,0-.64-.12-.75.09s0,.22,0,.25-.35.13-.4.17,0,.11,0,.11a4,4,0,0,1-.5,0c-.27,0-1-.08-.86.34,0,.05,0,0,0,.11s0,.09,0,.11,0,0-.06,0-.12,0-.15.07.07.22-.1.32-.7-.15-.94,0,.07.55-.3.56c-.08,0,0,.12,0,.12.34,0,.3,0,.37-.31.11-.46.79-.14,1.17-.25,0,0,0-.06,0-.1s0-.25.17-.32a.07.07,0,0,0,0-.1c0-.07-.19-.3-.1-.41a2.48,2.48,0,0,1,.41,0,8.75,8.75,0,0,1,.89,0,.06.06,0,0,0,0-.08c0-.1.34-.16.43-.18a.07.07,0,0,0,0-.08c-.19-.45.49-.29.77-.24a.07.07,0,0,0,.08-.09c0-.15-.39-.31,0-.36a.68.68,0,0,1,.31.07,2.19,2.19,0,0,0,.7.72C95.07,317.53,95.34,317.44,95.14,317.13Zm-.13.08c.09.12-.18,0-.21,0a.92.92,0,0,1-.35-.38,1.08,1.08,0,0,0,.21.11A.89.89,0,0,1,95,317.21Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.48,314c0-.2-.06-.41.12-.44s0-.13,0-.13c-.24,0-.32.21-.29.47a1.67,1.67,0,0,0-.31-.11c-.16,0-.26,0-.32.13s0,.16,0,.25.13.08-.07.13a2,2,0,0,1-.23,0,.34.34,0,0,0-.33.1c-.12.1.18.15-.18.09a.65.65,0,0,0-.28,0c-.13,0-.2.06-.18.21s.15.15.15.19c0,.32-.34,0-.47,0s-.08,0-.08,0,.1.21-.12.23c0,0-.19-.09-.24-.09s-.28.19-.47.18-.07,0-.05.08.13.23-.16.35l-.34,0c-.07,0,0,.13,0,.14s.58.2.71,0-.09-.28,0-.37c0,.06.26-.07.29-.08a.71.71,0,0,1,.22-.07s.07.07.11.07.12,0,.17,0,.06-.1.08-.11-.06-.07,0-.11.13,0,.2.07.27.11.36,0-.1-.25-.08-.35.37-.06.51-.16,0,0,0-.07c-.09-.31.48-.07.65-.1s.07,0,.06-.06a1.5,1.5,0,0,0-.07-.2c0-.18.31-.16.42-.13.12.38.42.76.74.66a.07.07,0,0,0,0-.06C99.07,314.39,98.78,314.13,98.48,314Zm.11.31,0-.08a.81.81,0,0,1,.23.22C98.84,314.59,98.63,314.32,98.59,314.26Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M102.3,311.38a.11.11,0,0,0,0-.08c0-.19-.28-.05-.31.07s0,.17,0,.25.12.08-.08.13a1.64,1.64,0,0,1-.22,0c-.2,0-.22,0-.34.1s.18.15-.18.1a.66.66,0,0,0-.28,0c-.13,0-.2.06-.18.21s.15.15.15.2c0,.31-.34,0-.47,0a.06.06,0,0,0-.08.05c0,.15.1.21-.12.22,0,0-.19-.09-.24-.09s-.28.19-.47.18-.07,0,0,.08.13.23-.16.35c0,0-.33,0-.33,0s0,.14,0,.14.57.2.7,0-.09-.28,0-.36.25-.08.28-.09a.55.55,0,0,1,.22-.06s.07.06.12.06.11,0,.16,0,.06-.09.08-.11-.06-.07,0-.11.13,0,.2.07.27.12.36,0-.1-.25-.08-.35.37-.06.51-.16,0,0,0-.07c-.1-.31.47-.06.65-.1a.06.06,0,0,0,.06-.06.91.91,0,0,1,0-.4A.29.29,0,0,0,102.3,311.38Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "M109.51,281.24l-22,12.69a.34.34,0,0,0,0,.65L122,314.45a1.21,1.21,0,0,0,1.14,0l22-12.68a.35.35,0,0,0,0-.66l-34.42-19.87A1.27,1.27,0,0,0,109.51,281.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.6,256.65a2.11,2.11,0,0,1,2.2.19,5.19,5.19,0,0,1,1.31,1.1,3,3,0,0,1,.28.34h0a7.44,7.44,0,0,1,1.15,2.15,5.37,5.37,0,0,1,.3,1.68,2.19,2.19,0,0,1-.86,2l-1,.58a1.47,1.47,0,0,0,.42-.37,2.6,2.6,0,0,0,.44-1.58,6.75,6.75,0,0,0-3-5.28,2.57,2.57,0,0,0-1.6-.4,1.3,1.3,0,0,0-.58.2h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,256.65a2.11,2.11,0,0,1,2.2.19,5.19,5.19,0,0,1,1.31,1.1,3,3,0,0,1,.28.34h0a7.44,7.44,0,0,1,1.15,2.15,5.37,5.37,0,0,1,.3,1.68,2.19,2.19,0,0,1-.86,2l-1,.58a1.47,1.47,0,0,0,.42-.37,2.6,2.6,0,0,0,.44-1.58,6.75,6.75,0,0,0-3-5.28,2.57,2.57,0,0,0-1.6-.4,1.3,1.3,0,0,0-.58.2h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.61,257.23a1.3,1.3,0,0,1,.58-.2,2.57,2.57,0,0,1,1.6.4,6.75,6.75,0,0,1,3,5.28,2.6,2.6,0,0,1-.44,1.58,1.47,1.47,0,0,1-.42.37l0,0a1.53,1.53,0,0,1-.83.2,2.78,2.78,0,0,1-1.31-.42,6.72,6.72,0,0,1-3.06-5.28A2.15,2.15,0,0,1,121.61,257.23Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.61,257.23a1.3,1.3,0,0,1,.58-.2,2.57,2.57,0,0,1,1.6.4,6.75,6.75,0,0,1,3,5.28,2.6,2.6,0,0,1-.44,1.58,1.47,1.47,0,0,1-.42.37l0,0a1.53,1.53,0,0,1-.83.2,2.78,2.78,0,0,1-1.31-.42,6.72,6.72,0,0,1-3.06-5.28A2.15,2.15,0,0,1,121.61,257.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79,259.53c-.68-.39-1.23-.07-1.23.71a2.7,2.7,0,0,0,1.23,2.13c.67.39,1.23.08,1.23-.71A2.75,2.75,0,0,0,123.79,259.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.78,270.54v-8.92H101v8.93h0a1.18,1.18,0,0,0,.7,1,3.75,3.75,0,0,0,3.36,0A1.19,1.19,0,0,0,105.78,270.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,269.13a1.18,1.18,0,0,0,.7,1,3.72,3.72,0,0,0,3.36,0,1.18,1.18,0,0,0,.7-1v1.43a1.19,1.19,0,0,1-.7,1,3.75,3.75,0,0,1-3.36,0,1.18,1.18,0,0,1-.7-1h0v-1.43Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,269.13a1.18,1.18,0,0,0,.7,1,3.72,3.72,0,0,0,3.36,0,1.18,1.18,0,0,0,.7-1v1.43a1.19,1.19,0,0,1-.7,1,3.75,3.75,0,0,1-3.36,0,1.18,1.18,0,0,1-.7-1h0v-1.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.47,270.54v-8.92h4.76v8.93h0a1.2,1.2,0,0,1-.7,1,3.77,3.77,0,0,1-3.37,0A1.2,1.2,0,0,1,111.47,270.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,269.13a1.2,1.2,0,0,1-.7,1,3.74,3.74,0,0,1-3.37,0,1.19,1.19,0,0,1-.69-1v1.43a1.2,1.2,0,0,0,.69,1,3.77,3.77,0,0,0,3.37,0,1.2,1.2,0,0,0,.7-1h0v-1.43Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,269.13a1.2,1.2,0,0,1-.7,1,3.74,3.74,0,0,1-3.37,0,1.19,1.19,0,0,1-.69-1v1.43a1.2,1.2,0,0,0,.69,1,3.77,3.77,0,0,0,3.37,0,1.2,1.2,0,0,0,.7-1h0v-1.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,273.56v-8.93l-4.76,0v8.92h0a1.18,1.18,0,0,0,.7,1,3.72,3.72,0,0,0,3.36,0A1.18,1.18,0,0,0,111,273.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25,272.14a1.15,1.15,0,0,0,.7,1,3.69,3.69,0,0,0,3.36,0,1.18,1.18,0,0,0,.7-1v1.43a1.18,1.18,0,0,1-.7,1,3.72,3.72,0,0,1-3.36,0,1.18,1.18,0,0,1-.7-1h0v-1.43Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.57,260c-.1,1.21.66,2.45,2.27,3.38l5.5,3.18a12.18,12.18,0,0,0,11,0,3.9,3.9,0,0,0,2.3-3.17v-8.33a2.89,2.89,0,0,0-.44-1.49A3.48,3.48,0,0,0,118,252h-.26a19.11,19.11,0,0,1-6.11-.69,12.34,12.34,0,0,0-8.81.88,3.86,3.86,0,0,0-2.29,3.18v3.74a1.15,1.15,0,0,0,0,.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.56,255.42a2.86,2.86,0,0,0,.44,1.49,3.47,3.47,0,0,0,3.19,1.62l.27,0a19.4,19.4,0,0,1,6.11.69,12.37,12.37,0,0,0,8.8-.87,3.88,3.88,0,0,0,2.3-3.19,2.89,2.89,0,0,0-.44-1.49A3.48,3.48,0,0,0,118,252h-.26a19.11,19.11,0,0,1-6.11-.69,12.34,12.34,0,0,0-8.81.88A3.86,3.86,0,0,0,100.56,255.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.98 263.56 108.88 264.66 108.88 263.56 106.98 262.46 106.98 263.56",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,265.69a12.18,12.18,0,0,1-11,0l-5.51-3.18a3.87,3.87,0,0,1-2.27-3.19v1a3.87,3.87,0,0,0,2.27,3.19l5.51,3.18a12.18,12.18,0,0,0,11,0,3.9,3.9,0,0,0,2.3-3.17v-1A3.91,3.91,0,0,1,119.37,265.69Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,255.1v-5.41l15.6.05v5.41h0a3.9,3.9,0,0,1-2.3,3.18,12.18,12.18,0,0,1-11,0A3.89,3.89,0,0,1,106.06,255.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,249.74l-15.6-.05s0,.05,0,1.2a3.84,3.84,0,0,0,2.27,3.19,12.18,12.18,0,0,0,11,0c1.53-.88,2.3-2,2.3-3.18S121.67,249.74,121.67,249.74Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,246.55a12.18,12.18,0,0,0-11,0c-3,1.75-3.06,4.6,0,6.37a12.18,12.18,0,0,0,11,0C122.43,251.17,122.44,248.31,119.39,246.55Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39,246.55a12.18,12.18,0,0,0-11,0c-3,1.75-3.06,4.6,0,6.37a12.18,12.18,0,0,0,11,0C122.43,251.17,122.44,248.31,119.39,246.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,249.26v-9.69l6.75,0v9.69h0a1.7,1.7,0,0,1-1,1.37,5.25,5.25,0,0,1-4.76,0A1.7,1.7,0,0,1,110.49,249.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.24,239.59l-6.75,0V241a1.71,1.71,0,0,0,1,1.38,5.27,5.27,0,0,0,4.77,0,1.66,1.66,0,0,0,1-1.37C117.23,240.51,117.24,239.59,117.24,239.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,238.21a5.25,5.25,0,0,0-4.76,0c-1.32.76-1.33,2,0,2.76a5.27,5.27,0,0,0,4.77,0C117.56,240.21,117.57,239,116.25,238.21Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,238.21a5.25,5.25,0,0,0-4.76,0c-1.32.76-1.33,2,0,2.76a5.27,5.27,0,0,0,4.77,0C117.56,240.21,117.57,239,116.25,238.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58,238.59a3.8,3.8,0,0,0-3.43,0,1,1,0,0,0,0,2,3.77,3.77,0,0,0,3.43,0A1,1,0,0,0,115.58,238.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,240a2,2,0,0,0-.38.29,1.65,1.65,0,0,0,.38.29,3.77,3.77,0,0,0,3.43,0,1.65,1.65,0,0,0,.38-.29,1.72,1.72,0,0,0-.38-.29A3.8,3.8,0,0,0,112.15,240Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,240.12c0,.13-.09.26-.27.3s-.35,0-.38-.16.09-.27.27-.31S113.08,240,113.1,240.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.53,239.93a.13.13,0,0,1-.1.16.13.13,0,0,1-.06-.26A.13.13,0,0,1,113.53,239.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,291.76v2.33L122.6,312v-2.33c0-1.29-1.28-3.08-2.87-4L94.55,291.08a2.55,2.55,0,0,0-2.33-.38A1.14,1.14,0,0,0,91.67,291.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,281l0,0h0a2.49,2.49,0,0,1,2.35.36l25.18,14.54c1.59.92,2.88,2.71,2.88,4v2.34l-17,9.79v-2.33c0-1.29-1.28-3.08-2.87-4L94.55,291.08a2.55,2.55,0,0,0-2.33-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.69,285.7a13.71,13.71,0,0,1,12.38,0c2,1.15,2.81,2.7,2.49,4.19h0L128.22,296l-7.61,4.4L110,294.29h0a13.15,13.15,0,0,1-7.27-1.43C99.28,290.87,99.28,287.67,102.69,285.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.63,283.67V281.2c0-1.29-.85-2.59-2.56-3.57a13.64,13.64,0,0,0-12.38,0c-1.7,1-2.56,2.28-2.56,3.57h0v2.47h0c0,1.31.82,2.62,2.55,3.62a13.64,13.64,0,0,0,12.38,0c1.73-1,2.58-2.31,2.56-3.62Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.63,283.67V281.2c0-1.29-.85-2.59-2.56-3.57a13.64,13.64,0,0,0-12.38,0c-1.7,1-2.56,2.28-2.56,3.57h0v2.47h0c0,1.31.82,2.62,2.55,3.62a13.64,13.64,0,0,0,12.38,0c1.73-1,2.58-2.31,2.56-3.62Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.69,277.63a13.64,13.64,0,0,1,12.38,0c3.42,2,3.42,5.17,0,7.14a13.71,13.71,0,0,1-12.38,0C99.28,282.8,99.28,279.6,102.69,277.63Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.61 295.06 120.61 292.37 128.22 287.97 128.22 290.66 120.61 295.06",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.61 295.06 120.61 292.37 128.22 287.97 128.22 290.66 120.61 295.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.61 295.06 109.68 288.75 109.95 286.21 120.61 292.37 120.61 295.06",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.61 295.06 109.68 288.75 109.95 286.21 120.61 292.37 120.61 295.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.22 287.97 117.57 281.82 109.95 286.21 120.61 292.37 128.22 287.97",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,281.06v-1.85a3.26,3.26,0,0,0-1.92-2.68,10.25,10.25,0,0,0-9.28,0,3.26,3.26,0,0,0-1.92,2.68h0v1.85h0a3.24,3.24,0,0,0,1.92,2.72,10.25,10.25,0,0,0,9.28,0,3.22,3.22,0,0,0,1.92-2.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.24,276.53a10.25,10.25,0,0,1,9.28,0c2.57,1.48,2.57,3.88,0,5.36a10.25,10.25,0,0,1-9.28,0C101.68,280.41,101.68,278,104.24,276.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.88,
    cy: 279.21,
    rx: 6.19,
    ry: 3.57,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,278.4a9.64,9.64,0,0,0-8.75,0,3.73,3.73,0,0,0-1.64,1.67,3.78,3.78,0,0,0,1.64,1.67,9.7,9.7,0,0,0,8.75,0,3.7,3.7,0,0,0,1.63-1.67A3.65,3.65,0,0,0,113.26,278.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.84,279.4a2.42,2.42,0,0,1,2.22,0,.67.67,0,0,1,0,1.28,2.48,2.48,0,0,1-2.22,0A.68.68,0,0,1,107.84,279.4Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.65,280.7a.76.76,0,0,1,.69,0,.21.21,0,0,1,0,.4.83.83,0,0,1-.69,0A.21.21,0,0,1,110.65,280.7Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,279.73c0,.17-.24.31-.54.31s-.54-.14-.54-.31.24-.3.54-.3S110,279.56,110,279.73Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,280.8c0,.05-.07.09-.16.09s-.17,0-.17-.09.07-.1.17-.1S111.28,280.75,111.28,280.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56,295.41v3.89l6.74,3.89V299.3a7.46,7.46,0,0,0-3.37-5.84,2.34,2.34,0,0,0-2.4-.22A2.39,2.39,0,0,0,117.56,295.41Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56,295.41v3.89l6.74,3.89V299.3a7.46,7.46,0,0,0-3.37-5.84,2.34,2.34,0,0,0-2.4-.22A2.39,2.39,0,0,0,117.56,295.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.59,288.59l.06,0a2.38,2.38,0,0,1,2.37.25,7.43,7.43,0,0,1,3.37,5.83v3.89l-8.09,4.67V299.3a7.46,7.46,0,0,0-3.37-5.84,2.41,2.41,0,0,0-2.3-.27Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.59,288.59l.06,0a2.38,2.38,0,0,1,2.37.25,7.43,7.43,0,0,1,3.37,5.83v3.89l-8.09,4.67V299.3a7.46,7.46,0,0,0-3.37-5.84,2.41,2.41,0,0,0-2.3-.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.93,296c-.74-.43-1.34-.08-1.34.78a3,3,0,0,0,1.34,2.34c.75.43,1.35.08,1.35-.78A3,3,0,0,0,120.93,296Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.39,267.16a21.77,21.77,0,0,1,4.52,4.64A19.08,19.08,0,0,1,124,281.85a14.52,14.52,0,0,1-4,10.55,2.44,2.44,0,0,1,2.3.28,7.46,7.46,0,0,1,3.37,5.84h0a21.83,21.83,0,0,0,3.24-8,34.82,34.82,0,0,0,.8-7.58,25.4,25.4,0,0,0-2.27-10.75,23.37,23.37,0,0,0-3-4.8,20.28,20.28,0,0,0-5-5.11,3.14,3.14,0,0,0-1.75-.58C116.83,263,115.25,266.22,116.39,267.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,262a2.31,2.31,0,0,1,1-.26,3,3,0,0,1,.4-.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.85,258.94a1.87,1.87,0,0,1,.8-.28,2.7,2.7,0,0,1,.93,0,4.07,4.07,0,0,1,1.18.48c2.83,1.67,6.11,5.9,7.58,8.9a26.85,26.85,0,0,1,2.74,11.76c0,10.31-4,15.56-4,15.56l-5.39,3.11a21.83,21.83,0,0,0,3.24-8,34.82,34.82,0,0,0,.8-7.58,25.33,25.33,0,0,0-2.28-10.76,23.08,23.08,0,0,0-3-4.79,20.28,20.28,0,0,0-5-5.11,2.65,2.65,0,0,0-2.91-.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62,260.68a2.13,2.13,0,0,1,2.2.19,5.36,5.36,0,0,1,1.31,1.1c.1.11.19.22.28.34v0a7.41,7.41,0,0,1,1.16,2.14,5.36,5.36,0,0,1,.29,1.69,2.17,2.17,0,0,1-.85,1.95l-1,.59a1.64,1.64,0,0,0,.41-.38,2.59,2.59,0,0,0,.44-1.57,6.73,6.73,0,0,0-3-5.29,2.54,2.54,0,0,0-1.59-.4,1.48,1.48,0,0,0-.59.2h0Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62,260.68a2.13,2.13,0,0,1,2.2.19,5.36,5.36,0,0,1,1.31,1.1c.1.11.19.22.28.34v0a7.41,7.41,0,0,1,1.16,2.14,5.36,5.36,0,0,1,.29,1.69,2.17,2.17,0,0,1-.85,1.95l-1,.59a1.64,1.64,0,0,0,.41-.38,2.59,2.59,0,0,0,.44-1.57,6.73,6.73,0,0,0-3-5.29,2.54,2.54,0,0,0-1.59-.4,1.48,1.48,0,0,0-.59.2h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,261.26a1.48,1.48,0,0,1,.59-.2,2.54,2.54,0,0,1,1.59.4,6.73,6.73,0,0,1,3,5.29,2.59,2.59,0,0,1-.44,1.57,1.64,1.64,0,0,1-.41.38l0,0a1.56,1.56,0,0,1-.84.2,2.82,2.82,0,0,1-1.31-.41,6.77,6.77,0,0,1-3-5.29A2.15,2.15,0,0,1,114.62,261.26Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,261.26a1.48,1.48,0,0,1,.59-.2,2.54,2.54,0,0,1,1.59.4,6.73,6.73,0,0,1,3,5.29,2.59,2.59,0,0,1-.44,1.57,1.64,1.64,0,0,1-.41.38l0,0a1.56,1.56,0,0,1-.84.2,2.82,2.82,0,0,1-1.31-.41,6.77,6.77,0,0,1-3-5.29A2.15,2.15,0,0,1,114.62,261.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.8,
    cy: 264.98,
    rx: 1,
    ry: 1.74,
    transform: "translate(-116.84 93.9) rotate(-30)",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.2,217.09a173.44,173.44,0,0,0,7.31,34.57H412.42c-2.08-10.85-3.19-22,0-34.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,236.13c.19.45,0,.76-1.54.52-3-.47-8.42-4.62-9.75-5.41s-1.57.94-1,2.15,0,4.35.85,6.36a8.75,8.75,0,0,0,4.11,4.78c2.45,1.58,7.89,3,10.39,5.22,2,2.71,6.49,9.07,9.2,12.64,4.37,5.76,6.83,10.13,11,6.52,3.23-2.77,6.56-6.08,8.19-7.75,4.39-4.53,11.69-15.08,11.69-15.08l4.49-15.57c.11,0-2.29.05-3,0-4.86.33-6.29.74-9.32,4.05-2.39,2.63-11.27,16.42-14.45,20.63L381.64,245c-2.63-2.57-3-6-4.59-8.2",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,230.4c-3.72.34-5.72,1.2-9.41,6.06s-12.34,17.68-12.34,17.68l-8.3-8.19s-5.79,3.87-7.4,9.91c0,0,7.61,9.75,10.5,12.79s5.12,3.29,9.05,0,15.3-15.79,15.3-15.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.78,254.14c1.69,2.44,2.78,6.42,2.49,8.4,0,0,2.34-2.7-1.61-9.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.63,255.78a3.21,3.21,0,0,1,.6-1.84l9.46-13.85v-12h7.05v12l9.46,13.85a3.29,3.29,0,0,1,.61,1.84s0,.06,0,.09h0c0,.07,0,.14,0,.21a4.07,4.07,0,0,1-.05.49c-.27,1.77-1.58,3.5-3.92,4.85-5.31,3.07-13.91,3.07-19.22,0-2.67-1.54-4-3.56-4-5.58Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.63,255.78a3.21,3.21,0,0,1,.6-1.84l9.46-13.85v-12h7.05v12l9.46,13.85a3.29,3.29,0,0,1,.61,1.84s0,.06,0,.09h0c0,.07,0,.14,0,.21a4.07,4.07,0,0,1-.05.49c-.27,1.77-1.58,3.5-3.92,4.85-5.31,3.07-13.91,3.07-19.22,0-2.67-1.54-4-3.56-4-5.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,255.11l2.46-3.59,3.5-5.2h12l3.51,5.2,2.46,3.6a1.87,1.87,0,0,1,.11.61,1.51,1.51,0,0,1-.06.52v0c-.29,1.42-1.45,2.79-3.46,3.88-4.72,2.54-12.37,2.54-17.09,0-2-1.09-3.16-2.46-3.46-3.87h0a1.82,1.82,0,0,1-.07-.57h0A1.94,1.94,0,0,1,355.26,255.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.65 229.15 364.14 228.99 364.19 240.39 358.32 249.57 364.65 240.53 364.65 229.15",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.69,230.26s.71.64,3.53.64,3.52-.62,3.52-.62V228.1h-7.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.69,228.57a7.66,7.66,0,0,0,3.53.64,7.84,7.84,0,0,0,3.52-.62v-.49h-7.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.21,244.59a13.13,13.13,0,0,1,6.42.59c2.38,1,2.38,2.59,0,3.57a13.32,13.32,0,0,1-8.77,0c-2.46-1-2.46-2.58,0-3.57a10.63,10.63,0,0,1,2.35-.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,225.8a9.3,9.3,0,0,1,6.16,0c1.67.69,1.67,1.81,0,2.51a9.42,9.42,0,0,1-6.16,0C362.43,227.61,362.43,226.49,364.16,225.8Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,225.8a9.3,9.3,0,0,1,6.16,0c1.67.69,1.67,1.81,0,2.51a9.42,9.42,0,0,1-6.16,0C362.43,227.61,362.43,226.49,364.16,225.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.67,227.11c-.3.24-1.31.75-3.86.46-2.26-.26-1.95-1.4-.14-1.53A8.66,8.66,0,0,1,369.67,227.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.24,226.14a8.41,8.41,0,0,1,4,0c1.08.31,1.08.83,0,1.14a8.41,8.41,0,0,1-4,0C364.11,227,364.11,226.45,365.24,226.14Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.24,226.14a8.41,8.41,0,0,1,4,0c1.08.31,1.08.83,0,1.14a8.41,8.41,0,0,1-4,0C364.11,227,364.11,226.45,365.24,226.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.09,248.38c3,1.48,7.86.6,9.19-.69s-.53-2.6-2-3.1a9.51,9.51,0,0,1,2.31.59c2.38,1,2.38,2.59,0,3.57a13.32,13.32,0,0,1-8.77,0A5,5,0,0,1,362.09,248.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,228.31a2.46,2.46,0,0,1-1.14-.79c1.51,1.18,5.19,1,6.73.5s1.58-1.55,1-2c1.26.7,1.12,1.68-.4,2.32A9.42,9.42,0,0,1,364.16,228.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.24,226.14a7.41,7.41,0,0,1,2-.24v1.62a7.84,7.84,0,0,1-2-.24C364.11,227,364.11,226.45,365.24,226.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,225.8a9.58,9.58,0,0,1,5-.35c-.16,0-3.27-.35-4.91.49-1.43.73-1.36,1.38-1,1.82C362.53,227.11,362.83,226.33,364.16,225.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.48,241.28V228.75a8,8,0,0,0,1.55-.33v12.11l9.55,13.95c.61.91.17,2.23-.34,3.31a8.09,8.09,0,0,1-2.74,2.61,15.21,15.21,0,0,1-5.68,2.05s3.92-2.05,4.69-3.59c.58-1.15.07-2.89-.77-4.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      mixBlendMode: "hard-light"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.05,236.75c-1.56-2.22-3.46-2.94-5.26-4.86s-2.44-3.28-3.29-1.92,1.08,4.13,1.39,4.79c.16.33.77.92,1,1.37",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.19,230.11c-4.57-1.14-6.59,1.41-8.11,4.2-2.43,4.46-3.89,13.58-4.1,30.24-.13,10.71-3.86,23.66-4.52,33.83-1,15.27-1.48,27.16-1.48,27.16a194.42,194.42,0,0,1,27.24-1.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.51,385.48s2.73-18.75,1.59-29.74c-1-9.43-2.37-13.38-2.56-15.52,0,0-1.59-22.14-1.16-40.89.21-8.89-.25-18.69-6.57-29.17l-.23-.42c-.56,3.44-5.86,5.67-10.58,6.19-4.55.51-10.23-.4-17-2.7-1.51,8.89-3.23,25.84-5,44.31-.86,9-.71,16.62-.86,22.42-.2,7.88.51,38.73.51,38.73V380c-.05,1.44-.4,2.44-1.4,4.72a28.19,28.19,0,0,1-5.19,8c-.68.68-5.35,4.5-6,5.32-2,2.21,2,3.62,5,3.32,3.18-.31,8.13-1.35,9.59-3.23,1-1.25,1.81-5.72,2.81-7,3.36-4.28,4.75-6.12,4.82-7.52.12-2.53-.71-3.56-1-5,.36-3,6.41-18.57,6.81-27.26a90.84,90.84,0,0,0-.73-11.5l5.32-30.22c1.18,8.5,3.42,27.64,4.23,33.74,1.12,8.39,5.26,22.6,7.88,33.75a58.77,58.77,0,0,1,1.71,8.79s.06,1,.06,1c0,1.24.13,14.45.52,17.25.83,5.85,6,5.29,7,.61.84-4,.37-16.39.4-17.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.68,385.4c1.45.08.31,5.69.56,9.33.28,3.91,1.46,6.79,1.72,10a13,13,0,0,1-1.49,8.13c-1.09,2.3-6.31,5.33-8.13,1.93a18.61,18.61,0,0,1-1.78-10.84c.35-3.75.67-6.48.84-9.34.15-2.51-1.59-8.48.31-8.78l.06,1c.63,1.38,7.07,2.53,7.93-.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,386.59c.39,1.84-.24,6.81-.24,6.81a6.62,6.62,0,0,1-3.69,2.74l-1-7Z",
    style: {
      fill: "#263238"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.74 396.14 402.62 393.91 401.32 388.37 408.15 392.12 408.74 396.14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.84,379.91v-1.3c-.85.38-2.92,7.09-5.58,11.65-2.42,4.16-7,6.37-8.55,8.17-2.05,2.4,1.66,5.7,7.84,4.6,3.06-.55,7.73-2.35,9.05-4.36s1.86-5.77,2.94-7.24,3.55-3.13,4.12-4.84a9.34,9.34,0,0,0,.15-4.74c-.43-1.58-.79-3.48-1.33-3.33l-.07,1.19c-.44.82-1.95,1.74-5.05,1.81C404.89,381.55,403.47,381.28,402.84,379.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.94,354.67a64.36,64.36,0,0,0-.52-14.25l4.47-29.73s3,28.3,3.55,32.68,8.66,51.7,8.66,51.7c4.17,2.48,9.52,1.69,13-.16,0-19.13-.6-38.3-1.29-43.6a91.67,91.67,0,0,0-2.48-10.73s-.45-27.91-.42-38.51-.78-17.68-2.79-22.45a68,68,0,0,0-5.56-9.93s-1.55,5.22-13.82,5.23-13.62-3.09-13.62-3.09-3.59,12.54-4.79,31.5c-1,15.28-1.19,22.22-1.48,29-.24,5.81-.4,12.51-.53,24.23-.1,8.84-1.35,28.3-1.35,28.3s6,3.14,15.88-.44C415.86,384.45,418.33,362.31,418.94,354.67Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.94,354.67a64.36,64.36,0,0,0-.52-14.25l4.47-29.73s3,28.3,3.55,32.68,8.66,51.7,8.66,51.7c4.17,2.48,9.52,1.69,13-.16,0-19.13-.6-38.3-1.29-43.6a91.67,91.67,0,0,0-2.48-10.73s-.45-27.91-.42-38.51-.78-17.68-2.79-22.45a68,68,0,0,0-5.56-9.93s-1.55,5.22-13.82,5.23-13.62-3.09-13.62-3.09-3.59,12.54-4.79,31.5c-1,15.28-1.19,22.22-1.48,29-.24,5.81-.4,12.51-.53,24.23-.1,8.84-1.35,28.3-1.35,28.3s6,3.14,15.88-.44C415.86,384.45,418.33,362.31,418.94,354.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.89,310.69l-2.43-18a15.43,15.43,0,0,1-9.39-4.55s1.37,4.36,7.13,6.8l3.25,15.77-2.37,25.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,231.36l5.78.61c3.84.94,5.57,2.63,6,6a26.52,26.52,0,0,1-.2,11.08c-1.22,4.78-4.45,16.49-4.45,16.49s7.46,9.71,8.8,26.4c-13.63,8.9-34.54,4.11-40.19-1.27.48-5.09,3.74-19.06,4.14-23.6,0,0-.29-7.09-.86-10.16-4.31-4.71-3.76-9.21-1.82-12.84,3.57-6.7,9-12.59,10.7-12.59Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,231.36l5.78.61c3.84.94,5.57,2.63,6,6a26.52,26.52,0,0,1-.2,11.08c-1.22,4.78-4.45,16.49-4.45,16.49s7.46,9.71,8.8,26.4c-13.63,8.9-34.54,4.11-40.19-1.27.48-5.09,3.74-19.06,4.14-23.6,0,0-.29-7.09-.86-10.16-4.31-4.71-3.76-9.21-1.82-12.84,3.57-6.7,9-12.59,10.7-12.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.12,227.3c-1.71,0-1.91.29-3.38,2.26-.88,1.17-6.42,10.31-6.42,10.31s4.41-5.8,7.74-7.55a7.18,7.18,0,0,1,2.05-.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,231.36s-4.76,12.52-5.85,21,2.64,32.2,4.24,49.27c1,11,2.58,27.27,2.58,27.27a56.73,56.73,0,0,0,9.85-.84c5.6-1.06,7.72-2.53,8.68-3.68,0,0-2.77-27.82-4.13-38.63-1.28-10.18-6.75-20.21-6.75-20.21l6.57-27.23s-.32-4.59-4.64-5.87C435.39,231.23,429,231.36,429,231.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.37,256.8s-.52-2.6-1.3-8.21c-.9-6.47-.6-10.52.37-12.57L442,247.36l-4.39,18.18h0a69.17,69.17,0,0,1,6.29,17.39h0c-4.3-12.19-9-15.84-9-15.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.74,246.74c0-.53.05-1.67.14-3.1.45-7,.66-13.35-1.71-13.86l-.21,1c1.73.37,1.15,9.42.94,12.83-.1,1.46-.17,2.62-.14,3.2Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,227.75c0-2.31,5.39-5.78,8.18-10.66s1.39-12.86-2.42-14.09a10.85,10.85,0,0,1-.15-1.1,9.24,9.24,0,0,0-1-2.64,11.59,11.59,0,0,0-7.93-5.18c-12.08-1.77-17.64,2.93-19.86,8.09a12.63,12.63,0,0,0-.94,5.5,6.31,6.31,0,0,0,4.89,5.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.26,200.45c-2.37,1-4.62,4.65-4.58,14.79,0,8.58,2.66,10.76,4,11.39s3.93.32,6.45-.07v4.94s-1.89,1.85-1.23,3,3.12,2.16,6.93,1c4.32-1.35,5.3-4.24,5.3-4.24l.09-10.8s1.45,1.53,4-.71c2.1-1.85,2.86-5,1.28-6.75s-3.62-1.88-5.46.06l-1.32-.69c-2.34-.28-5.82-.67-8.33-2C412.89,207.1,412.22,203.49,412.26,200.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,211.65l0,4.77a2.24,2.24,0,0,1-2.3-2.31A2.47,2.47,0,0,1,429,211.65Z",
    style: {
      fill: "#263238"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M412,212.32a1.14,1.14,0,1,1-1.18-1.15A1.16,1.16,0,0,1,412,212.32Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M421.13,212.83a1.25,1.25,0,0,1-1.18,1.31,1.26,1.26,0,0,1-1.27-1.23,1.23,1.23,0,1,1,2.45-.08Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M409,210.2,412,209a1.52,1.52,0,0,0-2-.9A1.63,1.63,0,0,0,409,210.2Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "414.82 211.39 414.97 218.43 411.19 217.58 414.82 211.39",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27,219.86,415.59,221a1.87,1.87,0,0,0,2.35,1.41A2.1,2.1,0,0,0,419.27,219.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.23,222.48a2,2,0,0,1,1.95-1.93h.15a2,2,0,0,1-1.39,1.85A1.74,1.74,0,0,1,417.23,222.48Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.12,226.56c2.66-.31,8.15-1.84,9-4.07a5.83,5.83,0,0,1-2,2.83c-1.65,1.43-7.07,2.9-7.07,2.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.14,227.33c.7-.14,1.32.16,1.89,1.13s1.81,3,1.81,3,.65,6.74,0,8.41c-.56,1.45-6.73,6.91-6.73,6.91a63,63,0,0,1,1.67,8c.06,2-3.71,9.53-4.15,13.39,0,0-1.33-12.14-.75-16.49a77,77,0,0,1,6.22-20.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.3,269a5.27,5.27,0,0,1-3,.88l.08-.68a4.4,4.4,0,0,0,2.33-.65,8.79,8.79,0,0,1-1.73-1.87c-1-1.53-2.55-12-1.59-14.32.79-1.93,3.1-6.13,4.85-6.13h0c1.76.07,3.73,4.5,4.37,6.52.75,2.39-1.69,12.69-2.81,14.13a8.49,8.49,0,0,1-1.88,1.71,4.43,4.43,0,0,0,2.27.84l0,.7h-.08A5.54,5.54,0,0,1,429.3,269ZM426,252.66c-.88,2.14.61,12.27,1.53,13.69a7.84,7.84,0,0,0,1.8,1.86,8.27,8.27,0,0,0,2-1.7c1-1.34,3.38-11.3,2.69-13.51-.85-2.7-2.71-6-3.74-6h0C429.18,247,427.07,250.07,426,252.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,269.54a1,1,0,0,0,1,1,1,1,0,0,0,1.05-1,1,1,0,0,0-1-1.06A1,1,0,0,0,425.3,269.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.21,269.79a1,1,0,1,0,1.06-1A1,1,0,0,0,431.21,269.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,256.94l.58,0a.23.23,0,0,0,.21-.24,11.5,11.5,0,0,1,.18-3.93c1-2.5,3.14-5.63,4.06-5.59s2.77,3.34,3.58,5.91a11.87,11.87,0,0,1-.15,3.93.23.23,0,0,0,.18.26l.58.09a.23.23,0,0,0,.26-.2,11.72,11.72,0,0,0,.12-4.39c-.43-1.38-2.47-6.55-4.52-6.64s-4.52,4.9-5.07,6.24a11.63,11.63,0,0,0-.26,4.38A.24.24,0,0,0,425.2,256.94Z",
    style: {
      fill: "#7AC1FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,289.86l1.29.75h0c0-.07.09-.13.13-.19a1.94,1.94,0,0,1,.3-.33,1,1,0,0,1,.18-.13L444,283.84l3.15-1.81,1.27-.73,18.34-10.57a.63.63,0,0,1,.56-.09l-1.25-.73a.56.56,0,0,0-.23-.06.76.76,0,0,0-.38.12L448,280.06l-2.08,1.2L442.82,283l-.08.05-10.63,6.13-.17.13A1.74,1.74,0,0,0,431.5,289.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.86,321.51h0l-1.34-.78a.62.62,0,0,1-.23-.55V290.71a1.72,1.72,0,0,1,.26-.85l1.29.75h0a1.73,1.73,0,0,0-.25.85V321A.5.5,0,0,0,432.86,321.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65,271.22l0,29.43a1.92,1.92,0,0,1-.87,1.5l-33.49,19.33a.51.51,0,0,1-.76-.44V291.46a1.73,1.73,0,0,1,.25-.85,1.79,1.79,0,0,1,.61-.64L444,283.83l3.15-1.8,19.6-11.3a.65.65,0,0,1,.57-.09l0,0h0A.6.6,0,0,1,467.65,271.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.23,273.38c-7.15-29.25-8.91-36.58-19.55-40.08-2.54,3,.16,14.44,1.84,19,0,0,7.69,18.78,9.12,25.48,1.25,5.89,2.67,13.3,2.58,18.37a3.68,3.68,0,0,1-1,2.41c-1.63,1.77-1.64,3.19-2.69,5.15-.83,1.53-1.74,2.1-1.48,2.45a2,2,0,0,0,2.69.2,10.44,10.44,0,0,0,2-1.95,22.55,22.55,0,0,1-1.59,6.72l-1.81,1s.55,1.89,4.94.63c5-1.43,6.74-2,7.27-10.45a64.82,64.82,0,0,0,.09-9.32C460.92,285.1,460.38,278.08,459.23,273.38Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.33,232s8.66,1.84,10.76,5.06c2.43,3.71,4.73,9.69,8.81,24.2s4.58,20.66,5.33,30.47c0,0-2.52,6.16-10.85,3.18,0,0-3.19-13.34-4.88-20.1a123,123,0,0,0-7.1-19.51S434,242.05,437.33,232Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.64,315c-.41.25-.58-.5-.67-1.61l0-2.05s-1.56,1.41-1.94-3.33c-.42-5.2,1.91-6.16,1.91-6.16s0-.86,0-2.57.36-2.13.76-2.42l.58-.3v18.08S431,314.73,430.64,315Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.64,315c-.41.25-.58-.5-.67-1.61l0-2.05s-1.56,1.41-1.94-3.33c-.42-5.2,1.91-6.16,1.91-6.16s0-.86,0-2.57.36-2.13.76-2.42l.58-.3v18.08S431,314.73,430.64,315Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.2,298.65l1.35-.61c0,.58.29,2.53.85,2.2l.58-.36c0-2.27.17-4,.71-4.31l1.17-.71-.07,16.62-1.18.71c-.5.3-.61-1.35-.63-3l-.29.17c-1,.61-1.14,1.53-1.14,3.08l-1.5,1Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.2,298.65l1.35-.61c0,.58.29,2.53.85,2.2l.58-.36c0-2.27.17-4,.71-4.31l1.17-.71-.07,16.62-1.18.71c-.5.3-.61-1.35-.63-3l-.29.17c-1,.61-1.14,1.53-1.14,3.08l-1.5,1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.16,387.64a4.41,4.41,0,0,1-.08,2.29c-.22.79-2.69,3.2-6.51,4.27s-8.22.44-10.37.68-4.22,1.09-6.74,1.27-4.95.07-7.09-1.93a5.46,5.46,0,0,1-.38-2.57C271.44,391.3,302.16,387.64,302.16,387.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,381.14c1.38,1.35,4.72,1.15,8.27,1.35,3.34.19,7.24-.33,9.33.82s2.46,3.77-1.13,6.62a15.34,15.34,0,0,1-3.33,2.35c-3.76,1.48-7.71.71-10.22.89-3.27.24-5.22,1.33-8.18,1.17-3.83-.2-6-1.57-6.51-2.69s.3-9.29,1.88-8.85c0,0,.23,2.73,6.8,1.24C282.53,383.39,282.77,381.75,282.76,381.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9,392.28s1.27-8.5-3.53-9.75l-.63,0s.1-.58,2-.73c3.66-.29,6,.17,7.49,1.74a4.76,4.76,0,0,1,1,4C301.72,389.2,299.83,391.1,295.9,392.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,387.26s.23-3.47-2.14-4.81a1.34,1.34,0,0,0-1.42-.05s2.28.74,2.36,4.87c0,0,.08.29.6.28C292,387.55,292.4,387.55,292.43,387.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.67,382.3s0-.12.64-.13a1.07,1.07,0,0,1,.67.2s1.75,1.13,1.49,4.76a.65.65,0,0,1-.68.45.52.52,0,0,1-.61-.46S288.44,383.3,286.67,382.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.64,382s.15-.19.59-.11.65.33.65.33a6.59,6.59,0,0,1,.61,4.59s0,.51-.75.44-.51-.62-.51-.62S285.64,382.81,284.64,382Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,334.13c.32,7.61,2,47.89,2,47.89s-5,7.41-13.34,3.82l-2.83-47.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,402.06a4.42,4.42,0,0,1-.15,2.28c-.24.79-2.79,3.12-6.64,4.08s-8.23.19-10.38.36-4.26,1-6.77,1.06-5-.07-7-2.14a5.55,5.55,0,0,1-.3-2.57C292.13,404.79,323,402.06,323,402.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.76,395c1.33,1.38,4.68,1.29,8.22,1.6,3.34.29,7.24-.12,9.3,1.1s2.35,3.84-1.33,6.58a15.4,15.4,0,0,1-3.4,2.25c-3.8,1.36-7.73.47-10.24.58-3.28.14-5.26,1.17-8.21.92-3.82-.32-6-1.76-6.43-2.88s.58-9.29,2.15-8.8c0,0,.15,2.74,6.75,1.45C303.46,397.22,303.74,395.59,303.76,395Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,406.51s1.53-8.46-3.23-9.85l-.63,0s.12-.58,2-.67c3.66-.18,6,.35,7.43,2A4.73,4.73,0,0,1,323,402C322.46,403.61,320.52,405.44,316.55,406.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.23,401.39s.34-3.47-2-4.87a1.33,1.33,0,0,0-1.42-.1s2.26.81,2.22,4.94c0,0,.07.29.59.3C312.81,401.66,313.2,401.67,313.23,401.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,396.25s0-.11.64-.1a1,1,0,0,1,.67.21s1.7,1.19,1.34,4.81a.67.67,0,0,1-.69.43.53.53,0,0,1-.6-.49S309.36,397.3,307.63,396.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,395.92s.15-.2.59-.1.64.35.64.35a6.59,6.59,0,0,1,.47,4.6s-.05.52-.76.43-.49-.64-.49-.64S306.58,396.73,305.61,395.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2,348.91c.89,7.89,3.38,35.48,4,46.88,0,0-3.94,5.42-12.74,3.08L284,351.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,442.33a1,1,0,0,0,.95-.95V380.22a.95.95,0,0,0-1.9,0v61.16A1,1,0,0,0,250.09,442.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.26,420.07a1,1,0,0,0,.88-.6L231.89,372a.95.95,0,1,0-1.76-.69l-18.76,47.46a1,1,0,0,0,.54,1.23A.84.84,0,0,0,212.26,420.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,414.37a.93.93,0,0,0,.69-.3l34.89-36.92,34.83,36.76a1,1,0,0,0,1.35,0,.94.94,0,0,0,0-1.34l-35.52-37.5a1,1,0,0,0-.69-.3h0a1,1,0,0,0-.69.3l-35.58,37.65a1,1,0,0,0,.69,1.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.93,420.07a.91.91,0,0,0,.35-.07.94.94,0,0,0,.53-1.23l-18.75-47.46a.95.95,0,0,0-1.77.69L287,419.47A1,1,0,0,0,287.93,420.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.39,359.25c.68-3.83-2.45-6.83-8.33-10.8a139,139,0,0,0-17-9.57c-4.92-2.25-9.95-2.05-16.25,1.19-8.75,4.5-35.07,20.46-35.07,20.46s39.36,22.22,46.93,21.23,26.5-13.31,28-17.64S288.39,359.25,288.39,359.25Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.84,377.08c5.65,5.12,11.56.71,20.9-5.35,10.57-6.86,12.65-12.48,12.65-12.48s0,4.21-.79,6.18-2.5,4.21-10.13,9.47-13.14,7.89-18.27,8.86l-4-.56",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.74,371.73c10.57-6.86,12.65-12.48,12.65-12.48s0,4.21-.79,6.18-2.5,4.21-10.13,9.47-13.14,7.89-18.27,8.86l-4-.56-.31-6.12C260.49,382.2,266.4,377.79,275.74,371.73Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.55,412.9l-2.48,6.54a1.11,1.11,0,0,0,0,.17v.12a.78.78,0,0,0,.37.41,1.67,1.67,0,0,0,1.51,0,.68.68,0,0,0,.3-.31h0l0-.09,2.3-6.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64,412.9l2.47,6.54a.55.55,0,0,1,0,.17v.12a.81.81,0,0,1-.38.41,1.67,1.67,0,0,1-1.51,0,.66.66,0,0,1-.29-.31h0l0-.09-2.3-6.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,436.64v5.41a.53.53,0,0,0,.32.45,1.7,1.7,0,0,0,1.55,0,.55.55,0,0,0,.32-.45v-5.41A2.3,2.3,0,0,0,249,436.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,344s31.58-9.53,37.06-11,16-4,19.1-2.66,4.64,3,4.92,7.42c.06.83,0,4.9,0,4.9s-16,6.5-28.49,6.5S224.06,344,224.06,344Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,340.09c-2,6.76-2.6,13.37,2.13,18.25,3.45,3.54,17.72,16.2,30.23,12.36,14-4.28,30.67-16.42,30.67-16.42s10.79.33,10.85-2.84c0-.77,3.41-1.73,3.37-2.57-.44-9.3-6.7-13.18-16-11.49-9.79,1.78-31.68,8-31.68,8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,345c1,3.47,3.71,9.17,8.69,12.38s12.82,2.48,12.82,2.48-9.52,6.73-16.72,9.9-11.71,4.39-23.41,0-16.17-5.91-18.27-10.52-1.9-14.57-1.9-14.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.83,369.77c7.2-3.17,16.72-9.9,16.72-9.9a29.12,29.12,0,0,1-5.27-.12c-6,2.27-12.26,4.49-15.3,5-6.66,1.09-8-3.49-10.68-11.93l-12.9-4.06s2.55,12.67,4.82,21.31C250.32,374.08,254.81,372.86,261.83,369.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.51,288.57c-4.24-.43-9,.89-11,7.63s-3.05,23.4-1.74,24.93,13.09,3.81,13.09,3.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.6 285.06 242.57 297.91 230.99 297.32 232.34 282.29 244.6 285.06",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.34,292.81c3.81-6.09,12.46-4.49,12.46-4.49l-.13,1.45c.53,2.16,6.24,2.92,11.91,1.58l.11-.51,7.79,2c3.72,2.15,9.18,9.81,8.4,24-.61,11.07-2,29.18,1.17,36.11-5.78,7.36-22.62,2.38-28.49,1.24-12.21-2.38-14.12-8.94-14.12-8.94S215.85,323,216,313.33C216.12,305.14,216.93,296.65,219.34,292.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.48,292.82a15.13,15.13,0,0,1,5.21,5.81,27.81,27.81,0,0,1,2.66,7.41,37.72,37.72,0,0,1,.83,7.85c0,2.64-.19,5.25-.32,7.87-.31,5.23-.57,10.46-.59,15.7,0,2.61,0,5.23.26,7.84a27.07,27.07,0,0,0,1.52,7.66,27,27,0,0,1-1.77-7.64c-.28-2.61-.38-5.24-.41-7.86-.06-5.25.2-10.49.47-15.73.15-2.62.35-5.23.37-7.84a40.59,40.59,0,0,0-.75-7.77,27.42,27.42,0,0,0-2.5-7.37A14.93,14.93,0,0,0,251.48,292.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,354.2h0c3.25.63,9.87,2.44,16.11,2.68-4.61-14.76-6.51-21.74-9.53-30.72-2.84-8.46-11.68-15.69-22.95-18.14-.1,1.75-.16,3.53-.19,5.31,0,1.5,0,3.32.11,5.31.18,4,.55,8.66.94,13,.66,7.35,1.39,13.64,1.39,13.64S220.35,351.81,232.56,354.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.17,269.29s3,4.61,2.69,5.06-2.58.86-2.58.86Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,256.54c6.15,1.3,7.92,4,8.5,13.76.6,10.2-.44,13.41-1.78,14.78-.9.93-5.93,1.1-8.46.4-3.18-.88-10.35-3.42-13.71-8.55-3.95-6-5-14.22-.76-17.57C234.48,254.63,242.24,256,244.74,256.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.46,285.08c-.75.77-4.32,1-7,.68l.13-1.33s2.9.63,4.39.81a5.55,5.55,0,0,0,2.47-.18Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,260.76h0a14,14,0,0,1-5.93,1.87,12.24,12.24,0,0,1-1,4.85c-.38,1.08-1.74,4.48-3.09,2.57-1-1.39-1.87-2.65-3.81-2.36-3.2.48-3.63,4.56-1.62,7s3.9,1.53,3.9,1.53-.1,5.39-2.49,8.44c0,0-2.72.88-7.71-.18-3.07-.66-7.42-4.5-9.24-8.56-3.87-8.6-4.14-16.34,1.35-18.66.6-4,3.72-5.74,7.28-6.56,4.93-1.13,10,2.06,14.73.14,1-.41,1.95-1,3-1.34a2,2,0,0,1,1.77.05,2.14,2.14,0,0,1,.72,1.36,3.78,3.78,0,0,1-.25,2.83,8.21,8.21,0,0,1,2.25-.77,2.8,2.8,0,0,1,2.24.56,2.89,2.89,0,0,1,.86,2A6.07,6.07,0,0,1,254.6,260.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.57,289.78l3.87,1.92a.13.13,0,0,1,0,.24l-4.26.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.43,291.94h0l-4.26.85.22-1.59.53.07,3.47.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.41,291.94a.13.13,0,0,0,0-.24l-.75-.38h0a.75.75,0,0,1-.14.75l-.05.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,290.18l.4.06.48.06,19.11,2.49a2.21,2.21,0,0,0,.42-3l-19.1-2.49-.91-.12C305.14,287.29,304.76,290.29,304.16,290.18Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,290.18l.4.06.48.06,19.11,2.49a2.08,2.08,0,0,0,.81-1.51l-20.08-2.73c0-.05,0-.07-.05-.05C304.76,289.33,304.5,290.24,304.16,290.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,290.39l.89.11c.25.05.49-.48.63-1.1.19-.83.09-1.85-.25-1.9l-.65-.09-.24,0c.34.06.44,1.08.25,1.91-.13.59-.36,1.1-.6,1.1h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89,290.42c.6.09,1-2.91.39-3l-.89-.12c.59.1.21,3.11-.38,3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,290.18l.88.12c.58.1,1-2.79.43-3h0l-.88-.11C305.14,287.29,304.76,290.29,304.16,290.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,291.84a.13.13,0,0,1-.08.1A.13.13,0,0,0,328.51,291.84Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,290l1.82.22c.26.05.49-.47.64-1.09.19-.82.09-1.84-.24-1.91h0l-1.83-.23c-.74-.09-1.12,1.39-.93,2.32A.77.77,0,0,0,302.34,290Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11,289.28a2.37,2.37,0,0,0-.08-2.08.55.55,0,0,0-.43-.25c-.66.07-1,1.44-.81,2.32a.78.78,0,0,0,.53.68C302.6,290,302.91,289.75,303.11,289.28Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306,290.41c-.18.2-.35.4-.54.59a5.44,5.44,0,0,0-1.35,2.94c-.53,2.79.17,2.53-2.66,4.11s-15.68,9-15.68,9c-2.84-1.28-13.48-6.59-17.5-8.61-7.42-3.75-8.94-6.18-16.23-5.39-2,4.24-1.62,12.56,4.47,16.84,5.39,3.79,19.55,7.36,25.51,9.11.64.21,1.21.38,1.73.51l.1,0c3.56.9,4.57.12,7.39-1.91,2.16-1.57,4.31-3.17,6.45-4.78q2.28-1.71,4.55-3.45c1.45-1.11,3-2.07,4.39-3.19a73.57,73.57,0,0,1,6.93-4.85c3.55-2.19,7.23-4.74,7.72-9.25a18.44,18.44,0,0,0-.07-3.56l-.3-3.67a1,1,0,0,0-.18-.6c-.29-.37-.88-.2-1.3,0-3,1.64-5.12,4.59-8.11,6.28a2.07,2.07,0,0,1-1.7.27Z",
    style: {
      fill: "#b16668"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M255.15,383.2c-3.22-.16-5.73-2.52-13.38-5.71-14.13-5.88-24.72-10.59-28.76-18s-6.9-28.76-5.89-38a12.48,12.48,0,0,1,.7-3.06l-1-.15,2.58-2.19h0c2.64-2.16,6.93-.24,10.17,1.53,9.25,5,16.48,9.92,22.2,27.58,4.3,13.28,7.13,25.39,13.07,31.87",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.82,318.43l-1-.15,2.58-2.19h0c2.64-2.16,6.93-.24,10.17,1.53,9.25,5,16.48,9.92,22.2,27.58,4.3,13.28,7.13,25.39,13.07,31.87l.31,6.12c-3.22-.16-5.73-2.52-13.38-5.71-14.13-5.88-24.72-10.59-28.76-18s-6.9-28.76-5.89-38A12.48,12.48,0,0,1,207.82,318.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,319.9c9.25,5,16.48,9.92,22.2,27.58s8.84,33.26,20.11,36.28c0,0-5.1,2-20.71-4.57-5-2.11-11-5.94-15-8.16-7.76-4.35-12.47-7.92-13.21-9.26-4.1-7.36-6.9-28.75-5.89-38S212.26,317.38,216.89,319.9Z",
    style: {
      fill: "#7AC1FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,286.6c.35,1.71,4,2.91,6.33,3.23s5.76-1.2,5.76-1.2,4.09,1.77,5.36,3.66c0,0-2.37-.36-6.5,1.39s-8.24.65-11.77-1.39a3.48,3.48,0,0,1-2-3.58s1.88-3.84,2.93-3.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.48,292.82c3.59-.36,7.37.23,13.46,3.16,4.77,2.29,20.44,10.2,20.44,10.2l13.43-6.63a10,10,0,0,1,3.71,5.09c1.3,3.65-.61,8.82-.61,8.82l-13.26,7.65c-1.81,1.05-3.25.74-6.47-.37s-24.65-8.64-24.65-8.64a14.27,14.27,0,0,1-7.19-9C248.52,296.47,251.48,292.82,251.48,292.82Z",
    style: {
      fill: "#ebebeb"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratoryAmico);
export default __webpack_public_path__ + "static/media/Laboratory-amico.8e9fae13ac4658daf545a4b47a547e9f.svg";
export { ForwardRef as ReactComponent };